/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages', [
    'ui.router',

    'BlurAdmin.pages.dashboard',
    'BlurAdmin.pages.ui',
    'BlurAdmin.pages.components',
    'BlurAdmin.pages.mail',
    'BlurAdmin.pages.form',
    'BlurAdmin.pages.tables',
    'BlurAdmin.pages.charts',
    'BlurAdmin.pages.maps',
    'BlurAdmin.pages.profile',
    'BlurAdmin.pages.login',
    'BlurAdmin.pages.registro',
    'BlurAdmin.pages.evaluadores',
    'BlurAdmin.pages.evaluados',
    'BlurAdmin.pages.evaluaciones',
    'BlurAdmin.pages.evaluacion',
    'BlurAdmin.pages.evaluador',
    'BlurAdmin.pages.creditos',
    'BlurAdmin.pages.confirmapago',
    'BlurAdmin.pages.reestablecer',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
    $urlRouterProvider.otherwise('/dashboard');

    baSidebarServiceProvider.addStaticItem({
      title: 'Panel Inicio',
      icon: 'ion-android-home',
      stateRef: 'dashboard'
    });
    baSidebarServiceProvider.addStaticItem({
      title: 'Mis Clientes',
      icon: 'ion-ios-people',
      stateRef: 'clientes'
    });
    baSidebarServiceProvider.addStaticItem({
      title: 'Mis Evaluaciones',
      icon: 'ion-clipboard',
      stateRef: 'evaluaciones'
    });
    baSidebarServiceProvider.addStaticItem({
      title: 'Mi Red',
      icon: 'ion-person',
      stateRef: 'mired'
    });
/*
    baSidebarServiceProvider.addStaticItem({
      title: 'Menu Level 1',
      icon: 'ion-ios-more',
      subMenu: [{
        title: 'Menu Level 1.1',
        disabled: true
      }, {
        title: 'Menu Level 1.2',
        subMenu: [{
          title: 'Menu Level 1.2.1',
          disabled: true
        }]
      }]
    });
*/
  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts', [
      'BlurAdmin.pages.charts.amCharts',
      'BlurAdmin.pages.charts.chartJs',
      'BlurAdmin.pages.charts.chartist',
      'BlurAdmin.pages.charts.morris'
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts', {
          url: '/charts',
          abstract: true,
          template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
          title: 'Charts',

        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components', [
    'BlurAdmin.pages.components.timeline',
    'BlurAdmin.pages.components.tree',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('components', {
          url: '/components',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Components',

        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.confirmapago', ['permission','permission.ui','satellizer','ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('confirmapago', {
          url: '/confirmapago/:id',
          title: 'Confirma Pago',
          templateUrl: 'app/pages/confirmapago/confirmapago.html',
          controller: 'ConfirmapagoPageCtrl',
          params: {
              'id': null,
            }
        });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.creditos', ['permission','permission.ui','satellizer','ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('creditos', {
          url: '/creditos',
          title: 'PAGES_TITLES.CREDS',
          templateUrl: 'app/pages/creditos/creditos.html',
          controller: 'CreditosPageCtrl',
          params: {
              'id_orden': null,
            }
        });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard', ['permission','permission.ui'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard', {
          url: '/dashboard',
          templateUrl: 'app/pages/dashboard/dashboard.html',
          title: 'PAGES_TITLES.HOME',
          controller: 'DashboardPageCtrl',
          data: {
              permissions: {
                except: ['anonymous'],
                redirectTo: 'login'
              }
            },/*
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 0,
          },*/
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.evaluacion', ['permission','permission.ui','satellizer','ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('evaluacion', {
          url: '/evaluacion',
          title: 'PAGES_TITLES.EVAL',
          templateUrl: 'app/pages/evaluacion/evaluacion.html',
          controller: 'EvaluacionPageCtrl',
          params: {
              'id': null,
            }
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.evaluaciones', ['permission','permission.ui','satellizer','ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('evaluaciones', {
          url: '/evaluaciones',
          title: 'PAGES_TITLES.EVALS',
          templateUrl: 'app/pages/evaluaciones/evaluaciones.html',
          controller: 'EvaluacionesPageCtrl',/*
          sidebarMeta: {
            icon: 'ion-clipboard',
            order: 300,
          },*/
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.evaluador', ['permission','permission.ui','satellizer','ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('evaluador', {
          url: '/evaluador',
          title: 'PAGES_TITLES.EVALUATOR',
          templateUrl: 'app/pages/evaluador/evaluador.html',
          controller: 'EvaluadorPageCtrl',
          params: {
              'id': null,
            }
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.evaluadores', ['permission','permission.ui','satellizer','ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('mired', {
          url: '/mi-red',
          title: 'PAGES_TITLES.NET',
          templateUrl: 'app/pages/evaluadores/evaluadores.html',
          controller: 'EvaluadoresPageCtrl',
          data: {
              permissions: {
                only: ['master','admin'],
                redirectTo: 'dashboard'
              }
            },/*
          sidebarMeta: {
            icon: 'ion-person',
            order: 100,
          },*/
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.evaluados', ['permission','permission.ui','satellizer','ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('clientes', {
          url: '/clientes',
          title: 'PAGES_TITLES.CLIENTS',
          templateUrl: 'app/pages/evaluados/evaluados.html',
          controller: 'EvaluadosPageCtrl',
          data: {
              permissions: {
                except: ['anonymous','evaluado'],
                redirectTo: 'login'
              }
            },/*
          sidebarMeta: {
            icon: 'ion-ios-people',
            order: 200,
          },*/
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form', ['ui.select', 'ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('form', {
          url: '/form',
          template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Form Elements',

        })
        .state('form.inputs', {
          url: '/inputs',
          templateUrl: 'app/pages/form/inputs/inputs.html',
          title: 'Form Inputs',
          sidebarMeta: {
            order: 0,
          },
        })
        .state('form.layouts', {
          url: '/layouts',
          templateUrl: 'app/pages/form/layouts/layouts.html',
          title: 'Form Layouts',
          sidebarMeta: {
            order: 100,
          },
        })
        .state('form.wizard',
        {
          url: '/wizard',
          templateUrl: 'app/pages/form/wizard/wizard.html',
          controller: 'WizardCtrl',
          controllerAs: 'vm',
          title: 'Form Wizard',
          sidebarMeta: {
            order: 200,
          },
        });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.login', ['permission','permission.ui','satellizer','ui.router','uiRouterStyles'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('login', {
          url: '/login',
          templateUrl: 'app/pages/login/auth.html',
          title: 'PAGES_TITLES.LOGIN',
          controller: 'AuthCtrl',
          data: {
              permissions: {
                except: ['master','evaluador','evaluado'],
                redirectTo: 'dashboard'
              },
              css: 'app/auth.css',
            },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('maps', {
          url: '/maps',
          templateUrl: 'app/pages/maps/maps.html',
          abstract: true,
          title: 'Maps',

        })
        .state('maps.gmap', {
          url: '/gmap',
          templateUrl: 'app/pages/maps/google-maps/google-maps.html',
          controller: 'GmapPageCtrl',
          title: 'Google Maps',
          sidebarMeta: {
            order: 0,
          },
        })
        .state('maps.leaflet', {
          url: '/leaflet',
          templateUrl: 'app/pages/maps/leaflet/leaflet.html',
          controller: 'LeafletPageCtrl',
          title: 'Leaflet Maps',
          sidebarMeta: {
            order: 100,
          },
        })
        .state('maps.bubble', {
          url: '/bubble',
          templateUrl: 'app/pages/maps/map-bubbles/map-bubbles.html',
          controller: 'MapBubblePageCtrl',
          title: 'Bubble Maps',
          sidebarMeta: {
            order: 200,
          },
        })
        .state('maps.line', {
          url: '/line',
          templateUrl: 'app/pages/maps/map-lines/map-lines.html',
          controller: 'MapLinesPageCtrl',
          title: 'Line Maps',
          sidebarMeta: {
            order: 300,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('perfil', {
          url: '/perfil',
          title: 'Perfil',
          templateUrl: 'app/pages/profile/profile.html',
          controller: 'ProfilePageCtrl',
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.registro', ['permission','permission.ui','satellizer','ui.router','uiRouterStyles'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('registro', {
          url: '/registro',
          templateUrl: 'app/pages/registro/reg.html',
          title: 'PAGES_TITLES.REGISTER',
          controller: 'RegCtrl',
          data: {
              permissions: {
                except: ['master','evaluador','evaluado'],
                redirectTo: 'dashboard'
              },
              css: 'app/auth.css',
            },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reestablecer', ['permission','permission.ui','satellizer','ui.router','uiRouterStyles'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('reestablecer', {
          url: '/reestablecer',
          templateUrl: 'app/pages/reestablecer/reestablecer.html',
          title: 'PAGES_TITLES.RESETPASS',
          controller: 'ReestablecerCtrl',
          data: {
              permissions: {
                except: ['master','evaluador','evaluado'],
                redirectTo: 'dashboard'
              },
              css: 'app/auth.css',
            },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('tables', {
          url: '/tables',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          controller: 'TablesPageCtrl',
          title: 'Tables',

        }).state('tables.basic', {
          url: '/basic',
          templateUrl: 'app/pages/tables/basic/tables.html',
          title: 'Basic Tables',
          sidebarMeta: {
            order: 0,
          },
        }).state('tables.smart', {
          url: '/smart',
          templateUrl: 'app/pages/tables/smart/tables.html',
          title: 'Smart Tables',
          sidebarMeta: {
            order: 100,
          },
        });
    $urlRouterProvider.when('/tables','/tables/basic');
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author k.danovsky
 * created on 12.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui', [
    'BlurAdmin.pages.ui.typography',
    'BlurAdmin.pages.ui.buttons',
    'BlurAdmin.pages.ui.icons',
    'BlurAdmin.pages.ui.modals',
    'BlurAdmin.pages.ui.grid',
    'BlurAdmin.pages.ui.alerts',
    'BlurAdmin.pages.ui.progressBars',
    'BlurAdmin.pages.ui.notifications',
    'BlurAdmin.pages.ui.tabs',
    'BlurAdmin.pages.ui.slider',
    'BlurAdmin.pages.ui.panels',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui', {
          url: '/ui',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'UI Features',/*
          sidebarMeta: {
            icon: 'ion-clipboard',
            order: 400,
          },*/
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts', [])
      .config(routeConfig).config(amChartConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.amCharts', {
          url: '/amCharts',
          templateUrl: 'app/pages/charts/amCharts/charts.html',
          title: 'amCharts',
          sidebarMeta: {
            order: 0,
          },
        });
  }

  function amChartConfig(baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    AmCharts.themes.blur = {

      themeName: "blur",

      AmChart: {
        color: layoutColors.defaultText,
        backgroundColor: "#FFFFFF"
      },

      AmCoordinateChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmStockChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmSlicedChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark],
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3
      },

      AmRectangularChart: {
        zoomOutButtonColor: '#FFFFFF',
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lens.png"
      },

      AxisBase: {
        axisColor: "#FFFFFF",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#FFFFFF"
      },

      ChartScrollbar: {
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.12,
        graphFillAlpha: 0.5,
        graphLineAlpha: 0,
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.4,
        gridAlpha: 0.15
      },

      ChartCursor: {
        cursorColor: layoutColors.primary,
        color: "#FFFFFF",
        cursorAlpha: 0.5
      },

      AmLegend: {
        color: "#FFFFFF"
      },

      AmGraph: {
        lineAlpha: 0.9
      },
      GaugeArrow: {
        color: "#FFFFFF",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
      },

      GaugeAxis: {
        tickColor: "#FFFFFF",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: '#FFFFFF',
        axisAlpha: 1,
        bandAlpha: 0.8
      },

      TrendLine: {
        lineColor: layoutColors.danger,
        lineAlpha: 0.8
      },

      // ammap
      AreasSettings: {
        alpha: 0.8,
        color: layoutColors.info,
        colorSolid: layoutColors.primaryDark,
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#FFFFFF",
        outlineColor: "#FFFFFF",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverColor: layoutColors.primary,
        rollOverOutlineColor: "#FFFFFF",
        selectedOutlineColor: "#FFFFFF",
        selectedColor: "#f15135",
        unlistedAreasOutlineColor: "#FFFFFF",
        unlistedAreasOutlineAlpha: 0.5
      },

      LinesSettings: {
        color: "#FFFFFF",
        alpha: 0.8
      },

      ImagesSettings: {
        alpha: 0.8,
        labelColor: "#FFFFFF",
        color: "#FFFFFF",
        labelRollOverColor: layoutColors.primaryDark
      },

      ZoomControl: {
        buttonFillAlpha: 0.8,
        buttonIconColor: layoutColors.defaultText,
        buttonRollOverColor: layoutColors.danger,
        buttonFillColor: layoutColors.primaryDark,
        buttonBorderColor: layoutColors.primaryDark,
        buttonBorderAlpha: 0,
        buttonCornerRadius: 0,
        gridColor: "#FFFFFF",
        gridBackgroundColor: "#FFFFFF",
        buttonIconAlpha: 0.6,
        gridAlpha: 0.6,
        buttonSize: 20
      },

      SmallMap: {
        mapColor: "#000000",
        rectangleColor: layoutColors.danger,
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.7,
        borderThickness: 1,
        borderAlpha: 0.8
      },

      // the defaults below are set using CSS syntax, you can use any existing css property
      // if you don't use Stock chart, you can delete lines below
      PeriodSelector: {
        color: "#FFFFFF"
      },

      PeriodButton: {
        color: "#FFFFFF",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
      },

      PeriodButtonSelected: {
        color: "#FFFFFF",
        backgroundColor: "#b9cdf5",
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
      },

      PeriodInputField: {
        color: "#FFFFFF",
        background: "transparent",
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      },

      DataSetSelector: {
        color: "#FFFFFF",
        selectedBackgroundColor: "#b9cdf5",
        rollOverBackgroundColor: "#a8b0e4"
      },

      DataSetCompareList: {
        color: "#FFFFFF",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(0, 0, 0, .3)"
      },

      DataSetSelect: {
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      }

    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/17/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.chartist', {
          url: '/chartist',
          templateUrl: 'app/pages/charts/chartist/chartist.html',
          title: 'Chartist',
          sidebarMeta: {
            order: 100,
          },
        });
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.charts.chartJs', [])
        .config(routeConfig).config(chartJsConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('charts.chartJs', {
                url: '/chartJs',
                templateUrl: 'app/pages/charts/chartJs/chartJs.html',
                title: 'Chart.js',
                sidebarMeta: {
                    order: 200
                }
            });
    }

    function chartJsConfig(ChartJsProvider, baConfigProvider) {
        var layoutColors = baConfigProvider.colors;
        // Configure all charts
        ChartJsProvider.setOptions({
            chartColors: [
                layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight],
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 2500
            },
            scale: {
                gridLines: {
                    color: layoutColors.border
                },
                scaleLabel: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    fontColor: layoutColors.defaultText,
                    showLabelBackdrop: false
                }
            }
        });
        // Configure all line charts
        ChartJsProvider.setOptions('Line', {
            datasetFill: false
        });
        // Configure all radar charts
        ChartJsProvider.setOptions('radar', {
            scale: {
                pointLabels: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    maxTicksLimit: 5,
                    display: false
                }
            }
        });
        // Configure all bar charts
        ChartJsProvider.setOptions('bar', {
            tooltips: {
                enabled: false
            }
        });
    }

})();
/**
 * @author a.demeshko
 * created on 12/18/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris', [])
    .config(routeConfig).config(function(baConfigProvider){
      var layoutColors = baConfigProvider.colors;
      Morris.Donut.prototype.defaults.backgroundColor = 'transparent';
      Morris.Donut.prototype.defaults.labelColor = layoutColors.defaultText;
      Morris.Grid.prototype.gridDefaults.gridLineColor = layoutColors.borderDark;
      Morris.Grid.prototype.gridDefaults.gridTextColor = layoutColors.defaultText;
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.morris', {
          url: '/morris',
          templateUrl: 'app/pages/charts/morris/morris.html',
          title: 'Morris',
          sidebarMeta: {
            order: 300,
          }
        });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.mail', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('mail', {
          url: '/mail',
          abstract: true,
          templateUrl: 'app/pages/components/mail/mail.html',
          controller: "MailTabCtrl",
          controllerAs: "tabCtrl",
          title: 'Mail',
          sidebarMeta: {
            order: 0,
          },
        }).state('mail.label', {
          url: '/:label',
          templateUrl: 'app/pages/components/mail/list/mailList.html',
          title: 'Mail',
          controller: "MailListCtrl",
          controllerAs: "listCtrl"
        }).state('mail.detail', {
          url: '/:label/:id',
          templateUrl: 'app/pages/components/mail/detail/mailDetail.html',
          title: 'Mail',
          controller: "MailDetailCtrl",
          controllerAs: "detailCtrl"
        });
    $urlRouterProvider.when('/mail','/mail/recibidos');
  }

})();

/**
 * @author a.demeshko
 * created on 1/12/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('components.timeline', {
        url: '/timeline',
        templateUrl: 'app/pages/components/timeline/timeline.html',
          title: 'Timeline',
          sidebarMeta: {
            icon: 'ion-ios-pulse',
            order: 100,
          },
      });
  }
})();
/**
 * @author a.demeshko
 * created on 12.21.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree', [])
    .config(routeConfig)
    .config(function(){
      $.jstree.defaults.core.themes.url = true;
      $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('components.tree', {
          url: '/tree',
          templateUrl: 'app/pages/components/tree/tree.html',
          title: 'Tree View',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.alerts', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.alerts', {
          url: '/alerts',
          templateUrl: 'app/pages/ui/alerts/alerts.html',
          title: 'Alerts',
          sidebarMeta: {
            order: 500,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.buttons', {
          url: '/buttons',
          templateUrl: 'app/pages/ui/buttons/buttons.html',
          controller: 'ButtonPageCtrl',
          title: 'Buttons',
          sidebarMeta: {
            order: 100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.grid', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.grid', {
          url: '/grid',
          templateUrl: 'app/pages/ui/grid/grid.html',
          title: 'Grid',
          sidebarMeta: {
            order: 400,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.icons', {
          url: '/icons',
          templateUrl: 'app/pages/ui/icons/icons.html',
          controller: 'IconsPageCtrl',
          title: 'Icons',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.modals', {
          url: '/modals',
          templateUrl: 'app/pages/ui/modals/modals.html',
          controller: 'ModalsPageCtrl',
          title: 'Modals',
          sidebarMeta: {
            order: 300,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.notifications', {
          url: '/notifications',
          templateUrl: 'app/pages/ui/notifications/notifications.html',
          controller: 'NotificationsPageCtrl',
          title: 'Notifications',
          sidebarMeta: {
            order: 700,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.panels', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.panels', {
          url: '/panels',
          templateUrl: 'app/pages/ui/panels/panels.html',
          controller: 'NotificationsPageCtrl',
          title: 'Panels',
          sidebarMeta: {
            order: 1100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.progressBars', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.progressBars', {
          url: '/progressBars',
          templateUrl: 'app/pages/ui/progressBars/progressBars.html',
          title: 'Progress Bars',
          sidebarMeta: {
            order: 600,
          },
        });
  }

})();

/**
 * @author a.demeshko
 * created on 12/22/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.slider', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.slider', {
          url: '/slider',
          templateUrl: 'app/pages/ui/slider/slider.html',
          title: 'Sliders',
          sidebarMeta: {
            order: 1000,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 21.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.tabs', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.tabs', {
          url: '/tabs',
          templateUrl: 'app/pages/ui/tabs/tabs.html',
          title: 'Tabs & Accordions',
          sidebarMeta: {
            order: 800,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.typography', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.typography', {
          url: '/typography',
          templateUrl: 'app/pages/ui/typography/typography.html',
          title: 'Typography',
          sidebarMeta: {
            order: 0,
          },
        });
  }

})();

'use strict';

angular.module('BlurAdmin', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'ngRoute',
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',
  'satellizer',
  'permission',
  'permission.ui',
  'platanus.rut',
  'ngFileUpload',
  'matchMedia',
  'pascalprecht.translate',
  'ngPageTitle',

  'BlurAdmin.theme',
  'BlurAdmin.pages'
])

.run(function($auth,$rootScope,$state,PermRoleStore,$http,$uibModal,$window) {
    // Define anonymous role
    PermRoleStore.defineRole('anonymous', function (stateParams) {
      // If the returned value is *truthy* then the user has the role, otherwise they don't
      if (!$auth.isAuthenticated()) {
        return true; // Is anonymous
      }
      return false;
    }); 
    PermRoleStore.defineRole('master', function (stateParams) {
      // If the returned value is *truthy* then the user has the role, otherwise they don't
      //var usuario = JSON.parse(localStorage.getItem('user')); 
      if ($auth.isAuthenticated()) {
          if($rootScope.currentUser.type == 0){
            return true; // Is loggedin
          }
        }
      return false;
    });
    PermRoleStore.defineRole('evaluador', function (stateParams) {
      // If the returned value is *truthy* then the user has the role, otherwise they don't
      //var usuario = JSON.parse(localStorage.getItem('user')); 
      if ($auth.isAuthenticated()) {
          if($rootScope.currentUser.type == 1){
            return true; // Is loggedin
          }
        }
      return false;
    });
    PermRoleStore.defineRole('evaluado', function (stateParams) {
      // If the returned value is *truthy* then the user has the role, otherwise they don't
      //var usuario = JSON.parse(localStorage.getItem('user')); 
      if ($auth.isAuthenticated()) {
          if($rootScope.currentUser.type == 2){
            return true; // Is loggedin
          }
        }
      return false;
    });
    PermRoleStore.defineRole('admin', function (stateParams) {
      // If the returned value is *truthy* then the user has the role, otherwise they don't
      //var usuario = JSON.parse(localStorage.getItem('user')); 
      if ($auth.isAuthenticated()) {
          if($rootScope.currentUser.type == 999){
            return true; // Is loggedin
          }
        }
      return false;
    });

    $rootScope.currentUser = JSON.parse(localStorage.getItem('user'));

    if($rootScope.currentUser){
      if($rootScope.currentUser.cambia_pass == 1){
          //openmodal('app/pages/login/pass.html', 'lg');
          $uibModal.open({
            animation: true,
            templateUrl: 'app/pages/login/pass.html',
            size: 'lg',
            backdrop  : 'static',
            keyboard  : false,
            resolve: {
              items: function () {
                return $rootScope.items;
              }
            }
          });
      }
    }

    if ( !localStorage.getItem('metric') ) {
      localStorage.setItem('metric','mt');
    }
    if ( !localStorage.getItem('lang') ) {
      var lang = $window.navigator.language || $window.navigator.userLanguage;
      localStorage.setItem('lang',lang.substr(0,2));
      $window.location.reload()
    }

    $rootScope.logout = function() {
 
      $auth.logout().then(function() {
           // Remove the authenticated user from local storage
          localStorage.removeItem('user');
           // Remove the current user info from rootscope
          $rootScope.currentUser = null;
          $state.go('login');
      });
    }

    var perfil = function(){
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/datosusuario',
          method: "GET",
          params: {'id_usuario':$rootScope.currentUser.id},
      }).success(function(datos) {
          if(!datos.datos){
            $rootScope.currentUser.img_url = "defecto.png";
          }
          else if(!datos.datos.img_url){
            $rootScope.currentUser.img_url = "defecto.png";
          }
          else if(datos.datos.img_url){
            $rootScope.currentUser.img_url = datos.datos.img_url;
          }
      });
    }
    if($rootScope.currentUser){
      perfil();
    }
})

.service('mensajesglobal', function () {
  var data = {};

  return {
      getdata: function () {
        return data;
      },
      setdata: function(message,type,errors) {
        data['message'] = message;
        data['type'] = type;
        data['errors'] = errors;
      },
      cleardata: function() {
        data = {};
      }
  };
})

.service('calcularedad', function () {
  return {
      getage: function (date) {
        var ageDifMs = Date.now() - new Date(date);
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        return Math.abs(ageDate.getUTCFullYear() - 1970);
      },
  };
})

.filter('explotaentrenamiento', function () {
  return function (input,separador) {
        return input.split(separador);
      }
})

.filter("asDate", function () {
    return function (input) {
        return new Date(input);
    }
})

.filter("redondea", function () {
    return function (input,decimales) {
      if(decimales == 0){
        return Math.round(input);
      }
      else{
        return Math.round(input * Math.pow(10,decimales)) / Math.pow(10,decimales);
      }
    }
})

.filter("metricunits", function () {
    return function (input) {
        var metric = localStorage.getItem('metric')
        if(metric == 'mt'){
          return input;
        }
        else{
          switch (input){
            case 'Cm': return 'in';
            case 'Kg': return 'pounds';
          }
        }
    }
})

.filter("metricconvert", function () {
    return function (input,tipo) {
        var metric = localStorage.getItem('metric')
        if(metric == 'mt'){
          return input;
        }
        else if(metric == 'en'){
          switch (tipo){
            case 'peso': return Math.round(input*2.2 * Math.pow(10,2)) / Math.pow(10,2);
            case 'long': return Math.round(input/2.54 * Math.pow(10,2)) / Math.pow(10,2);
          }
        }
    }
})

.config(function($stateProvider, $urlRouterProvider, $authProvider) {
  $authProvider.loginUrl = 'http://apiintplus.rfit.cl/api/web/authenticate';
})

.config(function ($translateProvider) {

  $translateProvider.useStaticFilesLoader({
    prefix: '/assets/langs/',
    suffix: '.json'
  });
  var lang = localStorage.getItem('lang');
  $translateProvider.preferredLanguage(lang);
})

.config(chartJsConfig)

function chartJsConfig(ChartJsProvider, baConfigProvider) {
  var layoutColors = baConfigProvider.colors;
  // Configure all charts
  ChartJsProvider.setOptions({
      chartColors: [
          layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight],
      responsive: true,
      maintainAspectRatio: false,
      animation: {
          duration: 2500
      },
      scale: {
          gridLines: {
              color: layoutColors.border
          },
          scaleLabel: {
              fontColor: layoutColors.defaultText
          },
          ticks: {
              fontColor: layoutColors.defaultText,
              showLabelBackdrop: false
          }
      }
  });
  // Configure all line charts
  ChartJsProvider.setOptions('Line', {
      datasetFill: false
  });
  // Configure all radar charts
  ChartJsProvider.setOptions('radar', {
      scale: {
          pointLabels: {
              fontColor: layoutColors.defaultText
          },
          ticks: {
              maxTicksLimit: 5,
              display: false
          }
      }
  });
  // Configure all bar charts
  ChartJsProvider.setOptions('bar', {
      tooltips: {
          enabled: false
      }
  });
}


;
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
  'use strict';

angular.module('BlurAdmin.pages.confirmapago')

.controller('ConfirmapagoPageCtrl', function($scope, $state, $stateParams, $location, $http, $rootScope,$timeout, $filter, calcularedad, mensajesglobal) {

    $scope.init = function () {
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/obtieneorden',
          method: "GET",
          params: {'orden_id':$stateParams.id},
      }).success(function(datos) {
          $scope.datospago = datos.orden;
          if($scope.datospago.estado == "Pagado"){
            $scope.datospago.colorpanel = 'success';
          }
          else if($scope.datospago.estado == "En Espera de Pago"){
            $scope.datospago.colorpanel = 'danger';
          }
          $timeout(function () { $state.go('creditos'); }, 5000);
      });

    };

})

})();
(function () {
  'use strict';

angular.module('BlurAdmin.pages.creditos')

.controller('CreditosPageCtrl', function($scope, $state, $stateParams, $location, $http, $rootScope,$timeout, $filter, calcularedad, mensajesglobal) {
    $scope.formulario = {};
    $scope.compra = {};
    $scope.muestrapanel = false;
    $scope.messagedata = false;
    $scope.cargacompra = false;
    $scope.init = function () {
      $scope.loading = false;
      $scope.messagedata = false;
      $scope.creditosactual = $rootScope.rootusercreditos;
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/creditos',
          method: "GET",
          params: {'id_usuario':$rootScope.currentUser.id},
      }).success(function(datos) {
          $scope.usercreditos = datos.creditos;
      });
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/listadoperfil',
          method: "GET",
          params: {
            'parent_user_id':$rootScope.currentUser.id,
            'type':1
          },
      }).success(function(data) {
          $scope.datos = data.lista;
          $scope.bool = data.bool;
          $scope.loading = false;
      });
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/ordenes',
          method: "GET",
          params: {
            'id_usuario':$rootScope.currentUser.id,
          },
      }).success(function(data) {
          $scope.ordenes = data.ordenes;
          $scope.bool = data.bool;
          $scope.loading = false;
      });
    };

    $scope.creditosfunct = function(tipo){
      $scope.tipo = tipo;
      if(tipo == "suma"){
        $scope.titulopanel = "Agregar";
        $scope.iconocreditos = "plus";
        $scope.color = "success";
      }
      else if(tipo == "resta"){
        $scope.titulopanel = "Quitar";
        $scope.iconocreditos = "minus";
        $scope.color = "danger";
      }
      $scope.muestrapanel = true;
    }

    $scope.ver = function(tipo){
      console.log(tipo);
    }

    $scope.cambiacreditos = function(formulario){
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/cambiacreditos',
          method: "POST",
          params: {
            'id_usuario':formulario.id_usuario,
            'parent_id':$rootScope.currentUser.id,
            'creditos':formulario.creditos,
            'tipo':$scope.tipo,
          },
      }).success(function(data) {
          $scope.tipo = false;
          $scope.creditos = data.creditos;
          $scope.usercreditos = data.creditosuser;
          mensajesglobal.setdata("Créditos Actualizados con éxito","success");
          $scope.messagedata = mensajesglobal.getdata();
          mensajesglobal.cleardata();
          $scope.muestrapanel = false;
          $timeout(function () { $scope.messagedata = {}; }, 3000);
      }).error(function(data){
          mensajesglobal.setdata(data.error.message,"danger");
          $scope.messagedata = mensajesglobal.getdata();
          mensajesglobal.cleardata();
          $scope.muestrapanel = false;
          $timeout(function () { $scope.messagedata = {}; }, 5000);
      });
    }

    $scope.compracreditos = function(cantidad){
      $scope.cargacompra = true;
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/pago',
          method: "POST",
          params: {
            'id_usuario':$rootScope.currentUser.id,
            'email':$rootScope.currentUser.email,
            'creditos':cantidad,
          },
      }).success(function(data) {
        $scope.cargacompra = false;
        $scope.orden = data.data;
        console.log($scope.orden);
      });
    }

    $scope.selectcreditos = [
      {label: '10 Créditos', value: 10},
      {label: '30 Créditos', value: 30},
      {label: '50 Créditos', value: 50},
      {label: '100 Créditos', value: 100},
      {label: '500 Créditos', value: 500}
    ];

})

})();
(function () {
  'use strict';

angular.module('BlurAdmin.pages.dashboard')

.controller('DashboardPageCtrl', function($scope, $state, $location, $http, $auth, $rootScope) {
    $scope.formulario = {};
    $scope.loading = false;
    $scope.smartTablePageSize = 10;
    $scope.init = function () {
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/getdash',
          method: "GET",
          params: {
            'id_usuario':$rootScope.currentUser.id,
            'type':$rootScope.currentUser.type,
          },
      }).success(function(data) {
          $scope.infonicio = data;
          $rootScope.currentUser.creditos = data.data.creditos;
          console.log($rootScope.currentUser.creditos);
      });
    };

    $scope.sacaregiones = function (dato) {
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/busquedaregiones',
          method: "GET",
          params: {
            'especialidad':dato.especialidad
          },
      }).success(function(data) {
          $scope.regiones = data.regiones;
      });
    };

    $scope.sacacomunas = function (dato,datoe) {
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/busquedacomunas',
          method: "GET",
          params: {
            'region':dato.region,
            'especialidad':datoe.especialidad
          },
      }).success(function(data) {
          $scope.comunas = data.comunas;
      });
    };

    $scope.buscar = function (busca) {
      $scope.loading = true;
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/busqueda',
          method: "GET",
          params: {
            'region':busca.region.region,
            'especialidad':busca.especialidad.especialidad,
            'comuna':busca.comuna.comuna
          },
      }).success(function(data) {
          $scope.loading = false;
          $scope.busqueda = data.resultado;
      });
    };

    $scope.limpiar = function () {
      $scope.formulario = {};
    };

    $scope.especialidades = [
      {label: 'Entrenador', value: 'Entrenador'},
      {label: 'Preparador Físico', value: 'Preparador Físico'},
      {label: 'Prof. Educ. Física', value: 'Prof. Educ. Física'},
      {label: 'Kinesiólogo', value: 'Kinesiólogo'},
      {label: 'Nutricionista', value: 'Nutricionista'},
      {label: 'Cirujano Plástico', value: 'Cirujano Plástico'},
      {label: 'Bariatra', value: 'Bariatra'},
      {label: 'Masoterapeuta', value: 'Masoterapeuta'},
      {label: 'Masajista', value: 'Masajista'}
    ];

})

})();
(function () {
  'use strict';

angular.module('BlurAdmin.pages.dashboard')

.controller('DashboardPageCtrl', function($scope, $state, $location, $http, $auth, $rootScope,$uibModal) {
    $scope.formulario = {};
    $scope.loading = false;
    $scope.smartTablePageSize = 10;
    $scope.init = function () {
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/getdash',
          method: "GET",
          params: {
            'id_usuario':$rootScope.currentUser.id,
            'type':$rootScope.currentUser.type,
          },
      }).success(function(data) {
          $scope.infonicio = data;
          $rootScope.currentUser.creditos = data.data.creditos;
      });
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/regiones',
          method: "GET",
      }).success(function(data) {
          $scope.regiones = data.regiones;
      });
    };

    $scope.sacacomunas = function (dato,datoe) {
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/comunas',
          method: "GET",
          params: {
            'region_id':dato.region_id,
          },
      }).success(function(data) {
          $scope.comunas = data.comunas;
      });
    };

    $scope.buscar = function (busca) {
      $scope.loading = true;
      $scope.bool = true;
      var para = {
            'region':busca.region.region_nombre,
            'comuna':busca.comuna.comuna_nombre
          };
      if(busca.especialidad){
        para['especialidad'] = busca.especialidad.label;
      };
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/busqueda',
          method: "GET",
          params: para,
      }).success(function(data) {
          $scope.loading = false;
          $scope.busqueda = data.resultado;
      }).error(function(data){
          $scope.loading = false;
          $scope.errorbusqueda = data.error;
          $scope.bool = false;
      });
    };

    $scope.limpiar = function () {
      $scope.formulario = {};
    };


    $scope.openmo = function(titulo,to,too,id,id_conv,mensaje){
      return $uibModal.open({
        animation: false,
        templateUrl: 'app/pages/components/mail/composeBox/compose.html',
        controller: 'composeBoxCtrl',
        controllerAs: 'boxCtrl',
        size: 'compose',
        resolve: {
          subject: function () {
            return titulo;
          },
          to: function () {
            return to + ' ' + too;
          },
          id_usuario: function () {
            return id;
          },
          id_conversacion: function () {
            return id_conv;
          },
          text: function () {
            return mensaje;
          }
        }
      });
    };
    $scope.especialidades = [
      {label: 'Entrenador', value: 'Entrenador'},
      {label: 'Preparador Físico', value: 'Preparador Físico'},
      {label: 'Prof. Educ. Física', value: 'Prof. Educ. Física'},
      {label: 'Kinesiólogo', value: 'Kinesiólogo'},
      {label: 'Nutricionista', value: 'Nutricionista'},
      {label: 'Cirujano Plástico', value: 'Cirujano Plástico'},
      {label: 'Bariatra', value: 'Bariatra'},
      {label: 'Masoterapeuta', value: 'Masoterapeuta'},
      {label: 'Masajista', value: 'Masajista'}
    ];

})

})();
(function () {
  'use strict';

angular.module('BlurAdmin.pages.evaluaciones')

.controller('EvaluacionPageCtrl', function($scope, $state, $stateParams, $location, $http, $rootScope, baConfig, calcularedad, $timeout, mensajesglobal,screenSize, $translate) {

    $scope.tiempoent = 60;
    $scope.evaluacion_id = $stateParams.id;
    $scope.cargaenvio = false;
    $scope.messagedata = false;

    $scope.init = function () {
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/getevaluacion',
          method: "GET",
          params: {'id':$scope.evaluacion_id},
      }).success(function(respuesta) {
          $scope.datoevaluacion = respuesta.evaluacion;
          $scope.datoevaluado = respuesta.evaluado;
          $scope.datoevaluado.edad = calcularedad.getage($scope.datoevaluado.nacimiento);
          $scope.data = [respuesta.evaluacion.pgrasa, respuesta.evaluacion.masamuscular, respuesta.evaluacion.pmresidual];
          $scope.datapliegue = [respuesta.evaluacion.triceps, respuesta.evaluacion.subescapular, respuesta.evaluacion.abdominal, respuesta.evaluacion.cuadriceps];
          $scope.datamacronutrientes = [respuesta.evaluacion.proteinas, respuesta.evaluacion.carbohidratos, respuesta.evaluacion.lipidos];
          $scope.datoevaluacion.refcintura = respuesta.evaluacion.grasaideal.split(",");
          $scope.datoevaluacion.refmasamuscular = respuesta.evaluacion.muscideal.split(",");
          volumen_entreno(respuesta.evaluacion.nentrena);
          gasto_calorico(respuesta.evaluacion.edad_metabolica,respuesta.evaluacion.pmuscular,respuesta.evaluacion.imc);
          calc_rcalorico(respuesta.evaluado.sexo,respuesta.evaluacion.peso);
          saca_entrenamiento(respuesta.evaluacion.nentrada,localStorage.getItem('lang'));

          $http({
              url: 'http://apiintplus.rfit.cl/api/web/historico',
              method: "GET",
              params: {'id_usuario':respuesta.evaluado.id_usuario},
          }).success(function(respuesta_h) {
              $scope.historico = respuesta_h;
          }).error(function(respuesta_h){
              mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
          });

      }).error(function(respuesta){
          mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
          $state.go('evaluaciones');
      });

      if (screenSize.is('xs, sm')) {
             $scope.movil = true;
      }
      else {
             $scope.movil = false;
      }
    };

    $scope.enviarevalua = function (id,email) {
      $scope.cargaenvio = true;
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/enviarevalua',
          method: "POST",
          params: {
            'id':id,
            'email':email,
            'lang': localStorage.getItem('lang')
          },
      }).success(function(respuesta) {
          $scope.cargaenvio = false;
          mensajesglobal.setdata("Evaluación enviada correctamente.","success");
          $scope.messagedata = mensajesglobal.getdata();
          mensajesglobal.cleardata();
          $timeout(function () { $scope.messagedata = {}; }, 3000);
      }).error(function(respuesta){
          $scope.cargaenvio = false;
          console.log(respuesta);
          mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
          $scope.messagedata = mensajesglobal.getdata();
          mensajesglobal.cleardata();
          $timeout(function () { $scope.messagedata = {}; }, 3000);
      });
    };

    var layoutColors = baConfig.colors;

    $scope.labelspliegue =[$translate.instant('Triceps'),$translate.instant('Subescapular'),$translate.instant('Abdominal'),$translate.instant('Cuadriceps')];
    $scope.optionspliegue = {
      scales: {
            yAxes: [{
                ticks: {
                    beginAtZero:true
                }
            }]
        }
    };

    
    $scope.labels =[$translate.instant('% Grasa'), $translate.instant('% Masa Muscular'), $translate.instant('% Masa Residual')];
    $scope.series = ['Porcentaje'];
    $scope.options = {
      elements: {
        arc: {
          borderWidth: 0
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontColor: layoutColors.defaultText
        }
      }
    };

    $scope.optionsradar = {
        scale: {
            ticks: {
                beginAtZero: true,
                max: 100
            }
        }
    };

//Entrenamiento

    $scope.labelsentrenamiento =[$translate.instant('Calentamiento'),$translate.instant('Aérobico'),$translate.instant('Incremento')];
    $scope.standardSelectItems = [
      {label: '40 ' + $translate.instant('minutos'), value: 40},
      {label: '50 ' + $translate.instant('minutos'), value: 50},
      {label: '60 ' + $translate.instant('minutos'), value: 60},
      {label: '70 ' + $translate.instant('minutos'), value: 70},
      {label: '80 ' + $translate.instant('minutos'), value: 80},
      {label: '90 ' + $translate.instant('minutos'), value: 90}
    ];

    $scope.tiempo = function(tiempo){
      $scope.tiempoent = tiempo.value;
      console.log($scope.tiempoent);
    }
    
    function volumen_entreno(nivel){
      if(nivel == "Básico"){
        $scope.n1 = 10;
        $scope.n2 = 70;
        $scope.n3 = 20;
        $scope.pot = 1;
        $scope.dataentrenamiento = [$scope.n1, $scope.n2, $scope.n3];
      }
      else if(nivel == "Intermedio"){
        $scope.n1 = 5;
        $scope.n2 = 50;
        $scope.n3 = 45;
        $scope.pot = 2;
        $scope.dataentrenamiento = [$scope.n1, $scope.n2, $scope.n3];
      }
      else if(nivel == "Avanzado"){
        $scope.n1 = 5;
        $scope.n2 = 30;
        $scope.n3 = 65;
        $scope.pot = 3;
        $scope.dataentrenamiento = [$scope.n1, $scope.n2, $scope.n3];
      }
    }

    function gasto_calorico(edad_met,pmuscular,imc){
      $scope.prom = ((220-edad_met)*0.65+(220-edad_met)*0.7+(220-edad_met)*0.71+(220-edad_met)*0.77+(220-edad_met)*0.78+(220-edad_met)*0.85)/6;
    }

//Requerimiento Nutricional

    $scope.labelsmacronutrientes =[$translate.instant('Proteínas'),$translate.instant('Carbohidratos'),$translate.instant('Lípidos')];

    function calc_rcalorico(sexo,peso){
      if(sexo == "Masculino"){
        var ecalorico = peso*24;
      }
      else if(sexo == "Femenino"){
        var ecalorico = peso*24*0.9;
      }
      $scope.rcalorico = ecalorico*(Math.pow(1.05,$scope.pot));
    }

//Entrenamiento

    function saca_entrenamiento(nentrena,lang){
      var url = '';
      if(lang == 'es'){
        url = 'sacaentrenamiento';
      } else if(lang == 'en'){
        url = 'gettraining';
      }
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/' + url,
          method: "GET",
          params: {'nentrena':nentrena},
      }).success(function(respuesta) {
          $scope.rutina = respuesta.data;
      }).error(function(respuesta){
          mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
      });
    }

})

})();
(function () {
  'use strict';

angular.module('BlurAdmin.pages.evaluaciones')

.controller('EvaluacionesPageCtrl', function($scope, $state, $stateParams, $location, $http, $auth, $rootScope, $uibModal, $filter, $uibModalStack, mensajesglobal, $timeout, calcularedad) {

    $scope.init = function () {
      $scope.bool = true;
      $scope.messagedata = mensajesglobal.getdata();
      mensajesglobal.cleardata();
      $timeout(function () { $scope.messagedata = {}; }, 3000);
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/listaevaluaciones',
          method: "GET",
          params: {
            'id_usuario':$rootScope.currentUser.id,
            'type':$rootScope.currentUser.type,
          },
      }).success(function(data) {
          $scope.datos = data.datos;
          $scope.bool = data.bool;
      });
    };

    $scope.openmodal = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.elimina = function (id){
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/eliminaevaluacion',
          method: "POST",
          params: {'id':id},
      }).success(function(respuesta) {
          mensajesglobal.setdata("Se eliminó el registro correctamente.","success");
          $state.reload();
      }).error(function(respuesta){
          mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
          $state.reload();
      });
    };

    $scope.ver = function (id){
      $state.go('evaluacion', { 'id':id });
    };

})


})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.evaluaciones')
      .controller('FormEvaluacionesCtrl', FormEvaluacionesCtrl);

  /** @ngInject */
  function FormEvaluacionesCtrl($scope,$http,$rootScope,$uibModalStack,$state,$uibModal,mensajesglobal,calcularedad) {
    var vm = this;
    $scope.activeBio = false;
    $scope.activePliegues = false;
    $scope.activeCuello = false;
    $scope.activeInicio = true;
    $scope.regex = '^[^,]*[^ ,][^,]*$';

    $scope.openmodalevaluados = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };

    $scope.tipoevalua = function(tipo){
      if(tipo=='bio'){
        $scope.activeBio = true;
        $scope.activePliegues = false;
        $scope.activeCinta = false;
      }
      else if(tipo == 'pliegues'){
        $scope.activePliegues = true;
        $scope.activeBio = false;
        $scope.activeCinta = false;
      }      
      else if(tipo == 'cinta'){
        $scope.activePliegues = false;
        $scope.activeBio = false;
        $scope.activeCinta = true;
      }
      $scope.activeInicio = false;
    };

    $scope.calculaedad = function(fecha){
      $scope.formulario.evaluado.edad = calcularedad.getage(fecha);
    };

    $scope.init = function(){
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/listadoperfil',
          method: "GET",
          params: {
            'parent_user_id':$rootScope.currentUser.id,
            'type':2
          },
      }).success(function(respuesta) {
          $scope.evaluados = respuesta.lista;
      }).error(function(respuesta){
      });
    };

    $scope.enviardatos2 = function(datos) {
      var metric = localStorage.getItem('metric')
      if(metric == 'mt'){
        console.log('metric');
        var multw = 1;
        var multl = 1;
      }
      else if(metric == 'en'){
        console.log('imp');
        var multw = 2.2;
        var multl = 2.54;
      }
      if(!datos.pgrasa && datos.triceps && datos.cuadriceps && datos.subescapular && datos.abdominal){
        var data = {
            'id_evaluado':datos.evaluado.id_usuario,
            'id_evaluador':$rootScope.currentUser.id,
            'peso':datos.peso/multw,
            'estatura':datos.estatura*multl,
            'fuma':datos.fuma,
            'alcohol':datos.alcohol,
            'triceps':datos.triceps*multl,
            'cuadriceps':datos.cuadriceps*multl,
            'subescapular':datos.subescapular*multl,
            'abdominal':datos.abdominal*multl,
            'pbrazo':datos.pbrazod*multl,
            'ppierna':datos.ppiernad*multl,
            'pcadera':datos.pcadera*multl,
            'pcintura':datos.pcintura*multl,
            'ecrono':datos.evaluado.edad,
            'sexo':datos.evaluado.sexo,
            'presion_s':datos.psistolica,
            'presion_d':datos.pdiastolica,
            'hace':datos.hace,
            'frecentrena':datos.frecuencia
          }
      }
      else if(!datos.pgrasa && datos.cuello){
        var data = {
            'id_evaluado':datos.evaluado.id_usuario,
            'id_evaluador':$rootScope.currentUser.id,
            'peso':datos.peso/multw,
            'estatura':datos.estatura*multl,
            'fuma':datos.fuma,
            'alcohol':datos.alcohol,
            'pbrazo':datos.pbrazod*multl,
            'ppierna':datos.ppiernad*multl,
            'pcadera':datos.pcadera*multl,
            'pcintura':datos.pcintura*multl,
            'ecrono':datos.evaluado.edad,
            'sexo':datos.evaluado.sexo,
            'presion_s':datos.psistolica,
            'presion_d':datos.pdiastolica,
            'hace':datos.hace,
            'frecentrena':datos.frecuencia,
            'cuello':datos.cuello
          }
      }
      else if(datos.pgrasa){
        var data = {
            'id_evaluado':datos.evaluado.id_usuario,
            'id_evaluador':$rootScope.currentUser.id,
            'peso':datos.peso/multw,
            'estatura':datos.estatura*multl,
            'fuma':datos.fuma,
            'alcohol':datos.alcohol,
            'pgrasa': datos.pgrasa,
            'pbrazo':datos.pbrazod*multl,
            'ppierna':datos.ppiernad*multl,
            'pcadera':datos.pcadera*multl,
            'pcintura':datos.pcintura*multl,
            'ecrono':datos.evaluado.edad,
            'sexo':datos.evaluado.sexo,
            'presion_s':datos.psistolica,
            'presion_d':datos.pdiastolica,
            'hace':datos.hace,
            'frecentrena':datos.frecuencia
          }
      }
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/ingresaevaluacion',
          method: "POST",
          params: data,
      }).success(function(respuesta) {
          $uibModalStack.dismissAll();
          mensajesglobal.setdata("El ingreso se realizó correctamente.","success",respuesta);
          $state.reload();
      }).error(function(respuesta){
          $uibModalStack.dismissAll();
          if(respuesta.error.message){
            mensajesglobal.setdata(respuesta.error.message,"danger");
          }
          else{
            mensajesglobal.setdata("Hubo un error en el ingreso, por favor intenta nuevamente. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning",respuesta);
          }
          $state.reload();
      });
    };
    
    $scope.formulario = {};
    $scope.haces = [
      {label: '1 a 3 semanas', value: '1'},
      {label: '1 a 3 meses', value: '2'},
      {label: '4 a 6 meses', value: '3'},
      {label: '7 a 11 meses', value: '4'},
      {label: '1 año', value: '5'},
      {label: 'Más de 1 año', value: '6'}
    ];
    $scope.frecuencia = [
      {label: '2 veces a la semana', value: '2'},
      {label: '3 veces a la semana', value: '3'},
      {label: '4 veces a la semana', value: '4'},
      {label: '5 veces a la semana', value: '5'},
      {label: '6 veces a la semana', value: '6'},
      {label: '7 veces a la semana', value: '7'}
    ];
    $scope.sinos = [
      {label: 'Si', value: 'Si'},
      {label: 'No', value: 'No'}
    ];
    $scope.trabajos = [
      {label: 'Dependiente', value: 'Dependiente'},
      {label: 'Independiente', value: 'Independiente'}
    ];
    $scope.especialidades = [
      {label: 'Entrenador', value: 'Entrenador'},
      {label: 'Preparador Físico', value: 'Preparador Físico'},
      {label: 'Prof. Educ. Física', value: 'Prof. Educ. Física'},
      {label: 'Kinesiólogo', value: 'Kinesiólogo'},
      {label: 'Nutricionista', value: 'Nutricionista'},
      {label: 'Cirujano Plástico', value: 'Cirujano Plástico'},
      {label: 'Bariatra', value: 'Bariatra'},
      {label: 'Masoterapeuta', value: 'Masoterapeuta'},
      {label: 'Masajista', value: 'Masajista'}
    ];

  }

})();
(function () {
  'use strict';

angular.module('BlurAdmin.pages.evaluador')

.controller('EvaluadorPageCtrl', function($scope, $state, $stateParams, $location, $http, $rootScope,$timeout, $filter, $uibModal, calcularedad, mensajesglobal) {

    $scope.init = function () {
      $scope.loading = false;
      $scope.tipo = false;
      $scope.messagedata = false;
      $scope.creditosactual = $rootScope.rootusercreditos;
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/datosusuario',
          method: "GET",
          params: {'id_usuario':$stateParams.id},
      }).success(function(respuesta) {
          $scope.viewevaluador = respuesta;
          $scope.viewevaluador.datos.edad = calcularedad.getage($scope.viewevaluador.datos.nacimiento);
          $scope.loading = true;
      }).error(function(respuesta){
          mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
          $state.go('mired');
      });
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/listadoperfil',
          method: "GET",
          params: {
            'parent_user_id':$stateParams.id,
            'type':2,
          },
      }).success(function(data) {
          $scope.datosclientes = data.lista;
          $scope.boolevaluado = data.bool;
      });
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/listaevaluaciones',
          method: "GET",
          params: {
            'id_usuario':$stateParams.id,
            'type':$rootScope.currentUser.type,
          },
      }).success(function(data) {
          $scope.datosevaluaciones = data.datos;
          $scope.contador = data.count;
          $scope.boolevaluaciones = data.bool;
      });
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/creditos',
          method: "GET",
          params: {
            'id_usuario':$stateParams.id
          },
      }).success(function(data) {
          $scope.creditosusuario = data.creditos;
      });
    };

    $scope.creditos = function(tipo){
      $scope.tipo = tipo;
      console.log($scope.tipo);
    }

    $scope.cambiacreditos = function(creditos,tipo){
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/cambiacreditos',
          method: "POST",
          params: {
            'id_usuario':$stateParams.id,
            'parent_id':$rootScope.currentUser.id,
            'creditos':creditos,
            'tipo':$scope.tipo,
          },
      }).success(function(data) {
          $scope.tipo = false;
          $scope.creditosusuario = data.creditos;
          $rootScope.currentUser.creditos = data.creditosuser;
          mensajesglobal.setdata("Créditos Actualizados con éxito","success");
          $scope.messagedata = mensajesglobal.getdata();
          mensajesglobal.cleardata();
          $timeout(function () { $scope.messagedata = {}; }, 3000);
      });
    }

    $scope.ver = function (page, size, id){
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/datosusuario',
          method: "GET",
          params: {'id_usuario':id},
      }).success(function(respuesta) {
          $scope.datoevaluado = respuesta.datos;
          $scope.phonecode = respuesta.pais.phonecode;
          $scope.viewevaluador.pais = respuesta.pais.name;
          $scope.datoevaluado.edad = calcularedad.getage($scope.datoevaluado.nacimiento);
          $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            scope: $scope,
            resolve: {
              items: function () {
                return $scope.items;
              }
            }
          });
      });
    }

    $scope.verevaluacion = function (id){
      $state.go('evaluacion', { 'id':id });
    };

})

})();
(function () {
  'use strict';

angular.module('BlurAdmin.pages.evaluadores')

.controller('EvaluadoresPageCtrl', function($scope, $state, $location, $http, $auth, $rootScope, $uibModal, mensajesglobal, $timeout) {

    $scope.init = function () {
      $scope.bool = true;
      $scope.loading = true;
      $scope.messagedata = mensajesglobal.getdata();
      mensajesglobal.cleardata();
      $timeout(function () { $scope.messagedata = {}; }, 3000);
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/listadoperfil',
          method: "GET",
          params: {
            'parent_user_id':$rootScope.currentUser.id,
            'type':1
          },
      }).success(function(data) {
          $scope.datos = data.lista;
          $scope.bool = data.bool;
          $scope.loading = false;
      });
    };

    $scope.openmodal = function (page, size, id) {
      $scope.editid = id;
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          editid: function () {
            return $scope.editid;
          }
        }
      });
    };

    $scope.openmo = function(titulo,to,too,id,id_conv,mensaje){
      console.log(id);
      return $uibModal.open({
        animation: false,
        templateUrl: 'app/pages/components/mail/composeBox/compose.html',
        controller: 'composeBoxCtrl',
        controllerAs: 'boxCtrl',
        size: 'compose',
        resolve: {
          subject: function () {
            return titulo;
          },
          to: function () {
            return to + ' ' + too;
          },
          id_usuario: function () {
            return id;
          },
          id_conversacion: function () {
            return id_conv;
          },
          text: function () {
            return mensaje;
          }
        }
      });
    };

    $scope.elimina = function (id){
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/eliminausuario',
          method: "POST",
          params: {'id_usuario':id},
      }).success(function(respuesta) {
          mensajesglobal.setdata("Se eliminó el registro correctamente.","success");
          $state.reload();
      }).error(function(respuesta){
          mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
          $state.reload();
      });
    };

    $scope.ver = function (id){
      $state.go('evaluador', { 'id':id });
    }

})

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.evaluadores')
      .controller('FormEvaluadoresCtrl', FormEvaluadoresCtrl);

  /** @ngInject */
  function FormEvaluadoresCtrl($scope,$http,$rootScope,$uibModalStack,$state,$timeout,mensajesglobal, Upload) {
    var vm = this;
    $scope.viewevaluador = {};
    $scope.viewevaluador.img_url = "defecto.png";
    $scope.enviando = false;

    $scope.initedit = function () {
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/datosusuario',
          method: "GET",
          params: {'id_usuario':$scope.editid},
      }).success(function(respuesta) {
          $scope.viewevaluador = respuesta.datos;
          $scope.selectedphonecode = respuesta.pais.phonecode;
          $scope.viewevaluador.pais = respuesta.pais.name;
          if(!$scope.viewevaluador){
            $scope.viewevaluador = {};
            $scope.viewevaluador.img_url = "defecto.png";
          }
          else if(!$scope.viewevaluador.img_url){
            $scope.viewevaluador = {};
            $scope.viewevaluador.img_url = "defecto.png";
          }
          $scope.viewevaluador.nacimiento = new Date(respuesta.datos.nacimiento.replace(/-/g, '\/'));
          $scope.viewevaluador.dia = $scope.viewevaluador.nacimiento.getDate();
          $scope.viewevaluador.mes = $scope.viewevaluador.nacimiento.getMonth()+1;
          $scope.viewevaluador.ano = $scope.viewevaluador.nacimiento.getFullYear();
          if($scope.viewevaluador.dia<10){$scope.viewevaluador.dia = '0'+$scope.viewevaluador.dia;}
          if($scope.viewevaluador.mes<10){$scope.viewevaluador.mes = '0'+$scope.viewevaluador.mes;}
      }).error(function(respuesta){
          mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
          $state.go('mired');
      });
    };

    $scope.editarevaluador = function (datos) {
      if(datos.dia && datos.mes && datos.year){
        datos.nacimiento = datos.dia + '-' + datos.mes + '-' + datos.year;
        $scope.formulario.nacimiento = new Date(datos.year + '/' + datos.mes + '/' + datos.dia);
        $scope.formulario.nacimiento = fecha($scope.formulario.nacimiento);
      }
      $scope.para = {'id_usuario':$scope.editid,'img_url':$scope.viewevaluador.img_url};
      angular.forEach(datos, function(value, key) {
        if(key != 'dia' && key != 'mes' && key != 'year'){
          if(key == 'region'){$scope.para[key] = value.region_nombre;}
          else{ $scope.para[key] = value; }
        }
      });
      $scope.enviando = true;
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/editaperfil',
          method: "POST",
          params: $scope.para,
      }).success(function(respuesta) {
          $scope.enviando = false;
          $uibModalStack.dismissAll();
          mensajesglobal.setdata("El cambio se realizó correctamente.","success");
          $state.reload();
      }).error(function(respuesta){
          $scope.enviando = false;
          mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
          $state.go('mired');
      });
    };

    $scope.enviardatos = function(datos) {
      datos.nacimiento = datos.dia + '-' + datos.mes + '-' + datos.year;
      $scope.formulario.nacimiento = new Date(datos.year + '/' + datos.mes + '/' + datos.dia);
      $scope.formulario.nacimiento = fecha($scope.formulario.nacimiento);
      $scope.enviando = true;
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/creacuenta',
          method: "POST",
          params: {
            'parent_user_id':$rootScope.currentUser.id,
            'email':datos.email,
            'type':1,
            'lang': localStorage.getItem('lang')
          },
      }).success(function(respuesta) {
          $http({
              url: 'http://apiintplus.rfit.cl/api/web/ingresoperfil',
              method: "POST",
              params: {
                'id_usuario':respuesta.data.id,
                'nombre':datos.nombre,
                'apellido':datos.apellido,
                'rut':datos.rut,
                'sexo':datos.sexo,
                'email':datos.email,
                'telefono':datos.telefono,
                'direccion':datos.direccion,
                'region':datos.region.name,
                'comuna':datos.comuna.name,
                'nacimiento':$scope.formulario.nacimiento,
                'especialidad':datos.especialidad,
                'trabajo':datos.trabajo,
                'empresa':datos.empresa,
                'img_url':$scope.viewevaluador.img_url
              },
          }).success(function(respuesta2) {
              $scope.enviando = false;
              $uibModalStack.dismissAll();
              mensajesglobal.setdata("El ingreso se realizó correctamente.","success",respuesta2);
              $state.reload();
          }).error(function(respuesta2){
              $scope.enviando = false;
              $uibModalStack.dismissAll();
              mensajesglobal.setdata("Hubo un error en el ingreso, por favor intenta nuevamente. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning",respuesta2);
              $state.reload();
          });
      }).error(function(respuesta){
          $uibModalStack.dismissAll();
          mensajesglobal.setdata("Hubo un error en el ingreso, por favor intenta nuevamente. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning",respuesta);
          $state.reload();
      });
    };

    //Foto Perfil
    $scope.removePicture = function () {
      $scope.viewevaluador.img_url = 'defecto.png';
      $scope.noPicture = true;
    };

    $scope.uploadFiles = function(file, errFiles) {
        $scope.f = file;
        $scope.errFile = errFiles && errFiles[0];
        if (file) {
            file.upload = Upload.upload({
                url: 'http://apiintplus.rfit.cl/api/web/img',
                method: 'POST',
                file: file,
                data: {
                    'id_usuario': $scope.editid,
                }
            });
            file.upload.then(function (response) {
                $scope.viewevaluador.img_url = response.data.url;
                $timeout(function () {
                    file.result = response.data;
                });
            }, function (response) {
                if (response.status > 0)
                    $scope.errorMsg = response.status + ': ' + response.data;
            }, function (evt) {
                file.progress = Math.min(100, parseInt(100.0 * 
                                         evt.loaded / evt.total));
            });
        }
        else if(errFiles){
          $scope.errorimagen = "La imagen debe ser máximo de 300KB"
        }
    }

    $http({
        url: 'http://apiintplus.rfit.cl/api/web/countries',
        method: "GET",
    }).success(function(respuesta) {
        $scope.countries = respuesta.countries;
    }).error(function(respuesta){
        $scope.enviando = false;
        mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
        $state.go('mired');
    });

    $scope.sacastates = function (region_id,phone_code) {
      $scope.states = false;
      $scope.cities = false;
      $scope.selectedphonecode = phone_code;
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/states',
          method: "GET",
          params: {'country_id':region_id},
      }).success(function(respuesta) {
          $scope.states = respuesta.states;
      }).error(function(respuesta){
          mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
          $state.go('mired');
      });
    };

    $scope.sacacities = function (state_id) {
      $scope.cities = false;
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/cities',
          method: "GET",
          params: {'state_id':state_id},
      }).success(function(respuesta) {
          $scope.cities = respuesta.cities;
      }).error(function(respuesta){
          mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
          $state.go('mired');
      });
    };

    function fecha(today){
      var dd = today.getDate();
      var mm = today.getMonth()+1; //January is 0!

      var yyyy = today.getFullYear();
      if(dd<10){
          dd='0'+dd;
      } 
      if(mm<10){
          mm='0'+mm;
      } 
      var today = yyyy+'-'+mm+'-'+dd;
      return today;
    }
    
    $scope.open = open;
    $scope.opened = false;
    $scope.format = 'dd-MM-yyyy';
    $scope.options = {
        showWeeks: false,
        format: 'dd-MM-yyyy',
    };
    $scope.formulario = {};
    $scope.sexos = [
      {label: 'Femenino', value: 'Femenino'},
      {label: 'Masculino', value: 'Masculino'}
    ];
    $scope.trabajos = [
      {label: 'Dependiente', value: 'Dependiente'},
      {label: 'Independiente', value: 'Independiente'}
    ];
    $scope.especialidades = [
      {label: 'Entrenador', value: 'Entrenador'},
      {label: 'Preparador Físico', value: 'Preparador Físico'},
      {label: 'Prof. Educ. Física', value: 'Prof. Educ. Física'},
      {label: 'Kinesiólogo', value: 'Kinesiólogo'},
      {label: 'Nutricionista', value: 'Nutricionista'},
      {label: 'Cirujano Plástico', value: 'Cirujano Plástico'},
      {label: 'Bariatra', value: 'Bariatra'},
      {label: 'Masoterapeuta', value: 'Masoterapeuta'},
      {label: 'Masajista', value: 'Masajista'}
    ];
    $scope.dias = [];
    $scope.meses = [];
    for (var i = 1; i <= 31; i++) {
      var j = ('0' + i).slice(-2);
      $scope.dias.push({label: j, value: j});
      if(i <= 12){
        $scope.meses.push({label: j, value: j});
      }
    }


    $scope.opencal = function() {
      if($scope.opened){
        $scope.opened = false;
      }
      else{
        $scope.opened = true;
      }
    };

    $scope.ver = function(dato){
      console.log(dato);
    }

  }

})();
(function () {
  'use strict';

angular.module('BlurAdmin.pages.evaluados')

.controller('EvaluadosPageCtrl', function($scope, $state, $location, $http, $auth, $rootScope, $uibModal, $filter, $uibModalStack,$timeout,calcularedad,mensajesglobal) {

    $scope.init = function () {
      $scope.bool = true;
      $scope.loading = true;
      $scope.messagedata = mensajesglobal.getdata();
      mensajesglobal.cleardata();
      $timeout(function () { $scope.messagedata = {}; }, 3000);
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/listadoperfil',
          method: "GET",
          params: {
            'parent_user_id':$rootScope.currentUser.id,
            'type':2
          },
      }).success(function(data) {
          $scope.datos = data.lista;
          $scope.bool = data.bool;
          $scope.loading = false;
      });
    };

    $scope.ver = function (page, size, id){
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/datosusuario',
          method: "GET",
          params: {'id_usuario':id},
      }).success(function(respuesta) {
          $scope.datoevaluado = respuesta.datos;
          $scope.selectedphonecode = respuesta.pais.phonecode;
          $scope.datoevaluado.pais = respuesta.pais.name;
          $scope.datoevaluado.edad = calcularedad.getage($scope.datoevaluado.nacimiento);
          $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            scope: $scope,
            resolve: {
              items: function () {
                return $scope.items;
              }
            }
          });
      });
    }

    $scope.openmodal = function (page, size, id) {
      $scope.editid = id;
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          editid: function () {
            return $scope.editid;
          }
        }
      });
    };

    $scope.openmo = function(titulo,to,too,id,id_conv,mensaje){
      return $uibModal.open({
        animation: false,
        templateUrl: 'app/pages/components/mail/composeBox/compose.html',
        controller: 'composeBoxCtrl',
        controllerAs: 'boxCtrl',
        size: 'compose',
        resolve: {
          subject: function () {
            return titulo;
          },
          to: function () {
            return to + ' ' + too;
          },
          id_usuario: function () {
            return id;
          },
          id_conversacion: function () {
            return id_conv;
          },
          text: function () {
            return mensaje;
          }
        }
      });
    };

    $scope.elimina = function (id){
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/eliminausuario',
          method: "POST",
          params: {'id_usuario':id},
      }).success(function(respuesta) {
          mensajesglobal.setdata("Se eliminó el registro correctamente.","success");
          $state.reload();
      }).error(function(respuesta){
          mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
          $state.reload();
      });
    };

    function fecha(today){
      var dd = today.getDate();
      var mm = today.getMonth()+1; //January is 0!

      var yyyy = today.getFullYear();
      if(dd<10){
          dd='0'+dd;
      } 
      if(mm<10){
          mm='0'+mm;
      } 
      var today = yyyy+'-'+mm+'-'+dd;
      return today;
    }

})

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.evaluados')
      .controller('FormEvaluadosCtrl', FormEvaluadosCtrl);

  /** @ngInject */
  function FormEvaluadosCtrl($scope,$http,$rootScope,$uibModalStack,$state,$filter,$timeout,mensajesglobal,Upload) {
    var vm = this;
    $scope.viewevaluador = {};
    $scope.viewevaluador.img_url = "defecto.png";
    $scope.enviando = false;
    $scope.formulario = {};
    $scope.initedit = function () {
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/datosusuario',
          method: "GET",
          params: {'id_usuario':$scope.editid},
      }).success(function(respuesta) {
          $scope.selectedphonecode = respuesta.pais.phonecode;
          $scope.viewevaluador = respuesta.datos;
          $scope.viewevaluador.pais = respuesta.pais.name;
          $scope.viewevaluador.img_url = respuesta.datos.img_url;
          $scope.viewevaluador.nacimiento = new Date(respuesta.datos.nacimiento.replace(/-/g, '\/'));
          $scope.viewevaluador.dia = $scope.viewevaluador.nacimiento.getDate();
          $scope.viewevaluador.mes = $scope.viewevaluador.nacimiento.getMonth()+1;
          $scope.viewevaluador.ano = $scope.viewevaluador.nacimiento.getFullYear();
          if($scope.viewevaluador.dia<10){$scope.viewevaluador.dia = '0'+$scope.viewevaluador.dia;}
          if($scope.viewevaluador.mes<10){$scope.viewevaluador.mes = '0'+$scope.viewevaluador.mes;}
      }).error(function(respuesta){
          mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
          $state.go('mired');
      });
    };

    $scope.editarevaluado = function (datos) {
      if(datos.dia && datos.mes && datos.year){
        datos.nacimiento = datos.dia + '-' + datos.mes + '-' + datos.year;
        $scope.formulario.nacimiento = new Date(datos.year + '/' + datos.mes + '/' + datos.dia);
        $scope.formulario.nacimiento = fecha($scope.formulario.nacimiento);
      }
      $scope.para = {'id_usuario':$scope.editid,'img_url':$scope.viewevaluador.img_url};
      angular.forEach(datos, function(value, key) {
        if(key != 'dia' && key != 'mes' && key != 'year'){
          if(key == 'region'){$scope.para[key] = value.region_nombre;}
          else{ $scope.para[key] = value; }
        }
      });
      $scope.enviando = true;
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/editaperfil',
          method: "POST",
          params: $scope.para,
      }).success(function(respuesta) {
          $scope.enviando = false;
          $uibModalStack.dismissAll();
          mensajesglobal.setdata("El cambio se realizó correctamente.","success");
          $state.reload();
      }).error(function(respuesta){
          $scope.enviando = false;
          mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
          $state.go('mired');
      });
    };

    $scope.enviardatos = function(datos) {
      datos.nacimiento = datos.dia + '-' + datos.mes + '-' + datos.year;
      $scope.formulario.nacimiento = new Date(datos.year + '/' + datos.mes + '/' + datos.dia);
      $scope.formulario.nacimiento = fecha($scope.formulario.nacimiento);
      $scope.enviando = true;
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/creacuenta',
          method: "POST",
          params: {
            'parent_user_id':$rootScope.currentUser.id,
            'email':datos.email,
            'type':2,
            'lang': localStorage.getItem('lang')
          },
      }).success(function(respuesta) {
          $http({
              url: 'http://apiintplus.rfit.cl/api/web/ingresoperfil',
              method: "POST",
              params: {
                'id_usuario':respuesta.data.id,
                'nombre':datos.nombre,
                'apellido':datos.apellido,
                'rut':datos.rut,
                'sexo':datos.sexo,
                'email':datos.email,
                'telefono':datos.telefono,
                'direccion':datos.direccion,
                'comuna':datos.comuna.name,
                'nacimiento':$scope.formulario.nacimiento,
                'region':datos.region.name,
                'img_url':$scope.viewevaluador.img_url
              },
          }).success(function(respuesta2) {
              $scope.enviando = false;
              $uibModalStack.dismissAll();
              mensajesglobal.setdata("El ingreso se realizó correctamente.","success",respuesta2);
              $state.reload();
          }).error(function(respuesta2){
              $scope.enviando = false;
              $uibModalStack.dismissAll();
              mensajesglobal.setdata("Hubo un error en el ingreso, por favor intenta nuevamente. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning",respuesta2);
              $state.reload();
          });
      }).error(function(respuesta){
          $uibModalStack.dismissAll();
          mensajesglobal.setdata("Hubo un error en el ingreso, por favor intenta nuevamente. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning",respuesta);
          $state.reload();
      });
    };

    //Foto Perfil
    $scope.removePicture = function () {
      $scope.viewevaluador.img_url = 'defecto.png';
      $scope.noPicture = true;
    };

    $scope.uploadFiles = function(file, errFiles) {
        $scope.f = file;
        $scope.errFile = errFiles && errFiles[0];
        if (file) {
            file.upload = Upload.upload({
                url: 'http://apiintplus.rfit.cl/api/web/img',
                method: 'POST',
                file: file,
                data: {
                    'id_usuario': $scope.editid,
                }
            });
            file.upload.then(function (response) {
                $scope.viewevaluador.img_url = response.data.url;
                $timeout(function () {
                    file.result = response.data;
                });
            }, function (response) {
                if (response.status > 0)
                    $scope.errorMsg = response.status + ': ' + response.data;
            }, function (evt) {
                file.progress = Math.min(100, parseInt(100.0 * 
                                         evt.loaded / evt.total));
            });
        }
        else if(errFiles){
          $scope.errorimagen = "La imagen debe ser máximo de 300KB"
        }
    }

    $http({
        url: 'http://apiintplus.rfit.cl/api/web/countries',
        method: "GET",
    }).success(function(respuesta) {
        $scope.countries = respuesta.countries;
    }).error(function(respuesta){
        $scope.enviando = false;
        mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
        $state.go('mired');
    });

    $scope.sacastates = function (region_id,phone_code) {
      $scope.states = false;
      $scope.cities = false;
      $scope.selectedphonecode = phone_code;
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/states',
          method: "GET",
          params: {'country_id':region_id},
      }).success(function(respuesta) {
          $scope.states = respuesta.states;
      }).error(function(respuesta){
          mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
          $state.go('mired');
      });
    };

    $scope.sacacities = function (state_id) {
      $scope.cities = false;
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/cities',
          method: "GET",
          params: {'state_id':state_id},
      }).success(function(respuesta) {
          $scope.cities = respuesta.cities;
      }).error(function(respuesta){
          mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
          $state.go('mired');
      });
    };

    function fecha(today){
      var dd = today.getDate();
      var mm = today.getMonth()+1; //January is 0!

      var yyyy = today.getFullYear();
      if(dd<10){
          dd='0'+dd;
      } 
      if(mm<10){
          mm='0'+mm;
      } 
      var today = yyyy+'-'+mm+'-'+dd;
      return today;
    }
    
    $scope.open = open;
    $scope.opened = false;
    $scope.format = 'dd-MM-yyyy';
    $scope.options = {
        showWeeks: false,
        format: 'dd-MM-yyyy',
    };
    $scope.formulario = {};
    $scope.sexos = [
      {label: 'Femenino', value: 'Femenino'},
      {label: 'Masculino', value: 'Masculino'}
    ];
    $scope.dias = [];
    $scope.meses = [];
    for (var i = 1; i <= 31; i++) {
      var j = ('0' + i).slice(-2);
      $scope.dias.push({label: j, value: j});
      if(i <= 12){
        $scope.meses.push({label: j, value: j});
      }
    }
    
    $scope.opencal = function() {
      if($scope.opened){
        $scope.opened = false;
      }
      else{
        $scope.opened = true;
      }
    };

  }

})();
(function () {
  'use strict';

angular.module('BlurAdmin.pages.login')

.controller('AuthCtrl', function($window, $scope, $state, $location, $http, $auth, $rootScope, $uibModal,$uibModalStack,mensajesglobal,$timeout) {

    $scope.loginData = {}
    $scope.loginError = false;
    $scope.loginErrorText;

    $scope.logins = function() {			
        var credentials = {
            email: $scope.loginData.email,
            password: $scope.loginData.password
        }
        $auth.login(credentials).then(function() {
            $rootScope.$pageFinishedLoading = false;
            // Return an $http request for the authenticated user
            $http.get('http://apiintplus.rfit.cl/api/web/authenticate/user').success(function(response){
                //console.log(response.user);
                // Stringify the retured data
                var user = JSON.stringify(response.user);
                // Set the stringified user data into local storage
                localStorage.setItem('user', user);
                // Getting current user data from local storage
                $rootScope.currentUser = response.user;
                $window.location.reload();
                // $rootScope.currentUser = localStorage.setItem('user');;
                //console.log($rootScope.currentUser);
                console.log("Entro1");
            })
            .error(function(){
                $rootScope.$pageFinishedLoading = true;
                $scope.loginError = true;
                $scope.loginErrorText = error.data.error;
                console.log($scope.loginErrorText);
                console.log("Entro2");
            })
        }).catch(function(response) {
            console.log(response.data.error);
            mensajesglobal.setdata("Hubo un error en el ingreso:","warning",response.data.error);
            $scope.messagedata = mensajesglobal.getdata();
            mensajesglobal.cleardata();
            $timeout(function () { $scope.messagedata = {}; }, 5000);
        });
    }

    $scope.compara = function(datos) {
        if(datos.pass1 != datos.pass2){
            $scope.show = true;
        }
        else{
            $scope.show = false;
        }
    }

    $scope.enviapass = function(datos) {
        if(datos.pass1 == datos.pass2){
            $http({
              url: 'http://apiintplus.rfit.cl/api/web/actualizapass',
              method: "POST",
              params: {
                'id_usuario':$rootScope.currentUser.id,
                'password':datos.pass1,
              },
            }).success(function(respuesta) {
                $uibModalStack.dismissAll();
                $rootScope.logout();
            }).error(function(respuesta){
                mensajesglobal.setdata("Hubo un error en el ingreso, por favor intenta nuevamente. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning",respuesta);
            });
        }
    }

    $scope.reestablecer = function() {
        $http({
          url: 'http://apiintplus.rfit.cl/api/web/reestablecepass',
          method: "POST",
          params: {
            'email':$scope.loginData.email,
          },
        }).success(function(respuesta) {
            $uibModalStack.dismissAll();
            $rootScope.logout();
        }).error(function(respuesta){
            mensajesglobal.setdata("Hubo un error en el ingreso, por favor intenta nuevamente. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning",respuesta);
        });
    }

    $scope.openmodal = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };

    var vm = this;
    $scope.passwordinput = "password";

    $scope.verpass = function () {
      if($scope.passwordinput == "password"){
        $scope.passwordinput = "text";
      }
      else{
        $scope.passwordinput = "password";
      }
    };

    $('body').removeClass('mobile');
 
})

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);

  /** @ngInject */
  function ProfilePageCtrl($scope, fileReader, $filter, $uibModal, $rootScope, $http, $state, $timeout, Upload, mensajesglobal) {
    $scope.picture = $filter('appImage')('theme/no-photo.png');

    $scope.removePicture = function () {
      $scope.datos.img_url = 'defecto.png';
      $scope.noPicture = true;
    };

    $scope.uploadFiles = function(file, errFiles) {
        $scope.f = file;
        $scope.errFile = errFiles && errFiles[0];
        if (file) {
            file.upload = Upload.upload({
                url: 'http://apiintplus.rfit.cl/api/web/img',
                method: 'POST',
                file: file,
                data: {
                    'id_usuario': $rootScope.currentUser.id,
                }
            });
            file.upload.then(function (response) {
                $scope.datos.img_url = response.data.url;
                $rootScope.currentUser.img_url = response.data.url;
                $timeout(function () {
                    file.result = response.data;
                });
            }, function (response) {
                if (response.status > 0)
                    $scope.errorMsg = response.status + ': ' + response.data;
            }, function (evt) {
                file.progress = Math.min(100, parseInt(100.0 * 
                                         evt.loaded / evt.total));
            });
        }
        else if(errFiles){
          $scope.errorimagen = "La imagen debe ser máximo de 5 MB"
        }
    }

    $scope.showModal = function (item) {
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      }).result.then(function (link) {
          item.href = link;
        });
    };

    $scope.init = function(datos) {
      $scope.messagedata = mensajesglobal.getdata();
      mensajesglobal.cleardata();
      $timeout(function () { $scope.messagedata = {}; }, 3000);
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/datosusuario',
          method: "GET",
          params: {
            'id_usuario':$rootScope.currentUser.id,
          },
      }).success(function(respuesta) {
        $scope.datos = respuesta.datos;
        $scope.datos.pais = respuesta.pais.name;
        $scope.datos.nacimiento = new Date(respuesta.datos.nacimiento.replace(/-/g, '\/'));
        $scope.datos.dia = $scope.datos.nacimiento.getDate();
        $scope.datos.mes = $scope.datos.nacimiento.getMonth()+1;
        $scope.datos.ano = $scope.datos.nacimiento.getFullYear();
        if($scope.datos.dia<10){$scope.datos.dia = '0'+$scope.datos.dia;}
        if($scope.datos.mes<10){$scope.datos.mes = '0'+$scope.datos.mes;}
        if(!$scope.datos){
          $scope.datos = {};
          $scope.datos.img_url = "defecto.png";
        }
        else if(!$scope.datos.img_url){
          $scope.datos = {};
          $scope.datos.img_url = "defecto.png";
        }
      }).error(function(respuesta){

      });
    }

    $scope.enviardatosusuario = function(datos) {
      if(datos.dia && datos.mes && datos.year){
        datos.nacimiento = datos.dia + '-' + datos.mes + '-' + datos.year;
        $scope.formulario.nacimiento = new Date(datos.year + '/' + datos.mes + '/' + datos.dia);
        $scope.formulario.nacimiento = fecha($scope.formulario.nacimiento);
      }
      $scope.para = {'id_usuario':$rootScope.currentUser.id,'email':$rootScope.currentUser.email};
      angular.forEach(datos, function(value, key) {
        if(key != 'dia' && key != 'mes' && key != 'year' && key != 'email'){
          if(key == 'region'){$scope.para[key] = value.region_nombre;}
          else{ $scope.para[key] = value; }
        }
      });
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/editaperfil',
          method: "POST",
          params: $scope.para,
      }).success(function(respuesta) {
          mensajesglobal.setdata("Sus datos se modificaron correctamente.","success",respuesta);
          $state.reload();
      }).error(function(respuesta){
          mensajesglobal.setdata("Hubo un error en el ingreso, por favor intenta nuevamente. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning",respuesta);
          $state.reload();
      });
    };

    function fecha(today){
      var dd = today.getDate();
      var mm = today.getMonth()+1; //January is 0!

      var yyyy = today.getFullYear();
      if(dd<10){
          dd='0'+dd;
      } 
      if(mm<10){
          mm='0'+mm;
      } 
      var today = yyyy+'-'+mm+'-'+dd;
      return today;
    }

    $scope.open = open;
    $scope.opened = false;
    $scope.format = 'dd-MM-yyyy';
    $scope.options = {
        showWeeks: false,
        format: 'dd-MM-yyyy',
    };
    $scope.formulario = {};
    $scope.sexos = [
      {label: 'Femenino', value: 'Femenino'},
      {label: 'Masculino', value: 'Masculino'}
    ];
    $scope.trabajos = [
      {label: 'Dependiente', value: 'Dependiente'},
      {label: 'Independiente', value: 'Independiente'}
    ];
    $scope.especialidades = [
      {label: 'Entrenador', value: 'Entrenador'},
      {label: 'Preparador Físico', value: 'Preparador Físico'},
      {label: 'Prof. Educ. Física', value: 'Prof. Educ. Física'},
      {label: 'Kinesiólogo', value: 'Kinesiólogo'},
      {label: 'Nutricionista', value: 'Nutricionista'},
      {label: 'Cirujano Plástico', value: 'Cirujano Plástico'},
      {label: 'Bariatra', value: 'Bariatra'},
      {label: 'Masoterapeuta', value: 'Masoterapeuta'},
      {label: 'Masajista', value: 'Masajista'}
    ];
    $scope.dias = [];
    $scope.meses = [];
    for (var i = 1; i <= 31; i++) {
      var j = ('0' + i).slice(-2);
      $scope.dias.push({label: j, value: j});
      if(i <= 12){
        $scope.meses.push({label: j, value: j});
      }
    }

    $scope.opencal = function() {
      if($scope.opened){
        $scope.opened = false;
      }
      else{
        $scope.opened = true;
      }
    };


    $http({
        url: 'http://apiintplus.rfit.cl/api/web/countries',
        method: "GET",
    }).success(function(respuesta) {
        $scope.countries = respuesta.countries;
    }).error(function(respuesta){
        $scope.enviando = false;
        mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
        $state.go('mired');
    });

    $scope.sacastates = function (region_id,phone_code) {
      $scope.states = false;
      $scope.cities = false;
      $scope.selectedphonecode = phone_code;
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/states',
          method: "GET",
          params: {'country_id':region_id},
      }).success(function(respuesta) {
          $scope.states = respuesta.states;
      }).error(function(respuesta){
          mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
          $state.go('mired');
      });
    };

    $scope.sacacities = function (state_id) {
      $scope.cities = false;
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/cities',
          method: "GET",
          params: {'state_id':state_id},
      }).success(function(respuesta) {
          $scope.cities = respuesta.cities;
      }).error(function(respuesta){
          mensajesglobal.setdata("Hubo un error en la operación, por favor intente nuevamente en unos minutos. Si el problema persiste por favor comunícate a contacto@rfit.cl.","warning");
          $state.go('mired');
      });
    };

  }

})();

(function () {
  'use strict';

angular.module('BlurAdmin.pages.registro')

.controller('RegCtrl', function($scope, $state, $location, $http, $auth, $rootScope,$timeout,mensajesglobal) {
    $scope.enviando = true;
    $scope.registra = function(mail,pass,type) {
      $scope.enviando = false;
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/registro',
          method: "POST",
          params: {
            'email':mail,
            'password':pass,
            'type':type,
            'lang': localStorage.getItem('lang')
          },
      }).success(function(datos) {
          $scope.enviando = true;
          mensajesglobal.setdata("Cuenta creada correctamente. Hemos enviado los datos a tu correo. Serás redirigido a la pantalla de login.","success");
          $scope.messagedata = mensajesglobal.getdata();
          mensajesglobal.cleardata();
          $timeout(function () { $scope.messagedata = {}; $state.go('login'); }, 5000);
      }).error(function(datos){
          $scope.enviando = true;
          mensajesglobal.setdata("Hubo un error en el ingreso, por favor intenta nuevamente.","warning",datos);
          $scope.messagedata = mensajesglobal.getdata();
          mensajesglobal.cleardata();
          $timeout(function () { $scope.messagedata = {}; }, 5000);
      });
    };

    function logins(mail,pass) {
  
        var credentials = {
            email: mail,
            password: pass
        }
        $auth.login(credentials).then(function() {
            // Return an $http request for the authenticated user
            $http.get('http://apiintplus.rfit.cl/api/web/authenticate/user').success(function(response){
                // Stringify the retured data
                var user = JSON.stringify(response.user);

                // Set the stringified user data into local storage
                localStorage.setItem('user', user);

                // Getting current user data from local storage
                $rootScope.currentUser = response.user;
                // $rootScope.currentUser = localStorage.setItem('user');;
                console.log($rootScope.currentUser);
                $state.go('dashboard');
                
            })
            .error(function(){
                $scope.loginError = true;
                $scope.loginErrorText = error.data.error;
                console.log($scope.loginErrorText);
                console.log("Entro2");
            })
        });
    }
    $('body').removeClass('mobile');
 
})

})();
(function () {
  'use strict';

angular.module('BlurAdmin.pages.reestablecer')

.controller('ReestablecerCtrl', function($window, $scope, $state, $location, $http, $auth, $rootScope, $uibModal,$uibModalStack,mensajesglobal,$timeout) {

    $scope.loginData = {}
    $scope.loginError = false;
    $scope.loginErrorText;
    $scope.enviando = true;
    $scope.reestablecer = function() {
        $scope.enviando = false;
        $http({
          url: 'http://apiintplus.rfit.cl/api/web/reestablecepass',
          method: "POST",
          params: {
            'email':$scope.loginData.email,
            'lang': localStorage.getItem('lang')
          },
        }).success(function(respuesta) {
            $scope.enviando = true;
            mensajesglobal.setdata("Se reseteo su contraseña.","success",respuesta.message);
            $scope.messagedata = mensajesglobal.getdata();
            mensajesglobal.cleardata();
            $timeout(function () { $scope.messagedata = {}; $state.go('login');}, 5000);
        }).error(function(respuesta){
            $scope.enviando = true;
            mensajesglobal.setdata("Hubo un error en el ingreso:","warning",respuesta.error.message);
            $scope.messagedata = mensajesglobal.getdata();
            mensajesglobal.cleardata();
            $timeout(function () { $scope.messagedata = {}; }, 5000);
        });
    }

    var vm = this;

    $('body').removeClass('mobile');
 
})

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables')
      .controller('TablesPageCtrl', TablesPageCtrl);

  /** @ngInject */
  function TablesPageCtrl($scope, $filter, editableOptions, editableThemes) {

    $scope.smartTablePageSize = 10;

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30'
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21'
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43'
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13'
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22'
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33'
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38'
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48'
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48'
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40'
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32'
      },
      {
        "id": 16,
        "firstName": "Francisca",
        "lastName": "Brady",
        "username": "@Gibson",
        "email": "franciscagibson@comtours.com",
        "age": 11
      },
      {
        "id": 17,
        "firstName": "Tillman",
        "lastName": "Figueroa",
        "username": "@Snow",
        "email": "tillmansnow@comtours.com",
        "age": 34
      },
      {
        "id": 18,
        "firstName": "Jimenez",
        "lastName": "Morris",
        "username": "@Bryant",
        "email": "jimenezbryant@comtours.com",
        "age": 45
      },
      {
        "id": 19,
        "firstName": "Sandoval",
        "lastName": "Jacobson",
        "username": "@Mcbride",
        "email": "sandovalmcbride@comtours.com",
        "age": 32
      },
      {
        "id": 20,
        "firstName": "Griffin",
        "lastName": "Torres",
        "username": "@Charles",
        "email": "griffincharles@comtours.com",
        "age": 19
      },
      {
        "id": 21,
        "firstName": "Cora",
        "lastName": "Parker",
        "username": "@Caldwell",
        "email": "coracaldwell@comtours.com",
        "age": 27
      },
      {
        "id": 22,
        "firstName": "Cindy",
        "lastName": "Bond",
        "username": "@Velez",
        "email": "cindyvelez@comtours.com",
        "age": 24
      },
      {
        "id": 23,
        "firstName": "Frieda",
        "lastName": "Tyson",
        "username": "@Craig",
        "email": "friedacraig@comtours.com",
        "age": 45
      },
      {
        "id": 24,
        "firstName": "Cote",
        "lastName": "Holcomb",
        "username": "@Rowe",
        "email": "coterowe@comtours.com",
        "age": 20
      },
      {
        "id": 25,
        "firstName": "Trujillo",
        "lastName": "Mejia",
        "username": "@Valenzuela",
        "email": "trujillovalenzuela@comtours.com",
        "age": 16
      },
      {
        "id": 26,
        "firstName": "Pruitt",
        "lastName": "Shepard",
        "username": "@Sloan",
        "email": "pruittsloan@comtours.com",
        "age": 44
      },
      {
        "id": 27,
        "firstName": "Sutton",
        "lastName": "Ortega",
        "username": "@Black",
        "email": "suttonblack@comtours.com",
        "age": 42
      },
      {
        "id": 28,
        "firstName": "Marion",
        "lastName": "Heath",
        "username": "@Espinoza",
        "email": "marionespinoza@comtours.com",
        "age": 47
      },
      {
        "id": 29,
        "firstName": "Newman",
        "lastName": "Hicks",
        "username": "@Keith",
        "email": "newmankeith@comtours.com",
        "age": 15
      },
      {
        "id": 30,
        "firstName": "Boyle",
        "lastName": "Larson",
        "username": "@Summers",
        "email": "boylesummers@comtours.com",
        "age": 32
      },
      {
        "id": 31,
        "firstName": "Haynes",
        "lastName": "Vinson",
        "username": "@Mckenzie",
        "email": "haynesmckenzie@comtours.com",
        "age": 15
      },
      {
        "id": 32,
        "firstName": "Miller",
        "lastName": "Acosta",
        "username": "@Young",
        "email": "milleryoung@comtours.com",
        "age": 55
      },
      {
        "id": 33,
        "firstName": "Johnston",
        "lastName": "Brown",
        "username": "@Knight",
        "email": "johnstonknight@comtours.com",
        "age": 29
      },
      {
        "id": 34,
        "firstName": "Lena",
        "lastName": "Pitts",
        "username": "@Forbes",
        "email": "lenaforbes@comtours.com",
        "age": 25
      },
      {
        "id": 35,
        "firstName": "Terrie",
        "lastName": "Kennedy",
        "username": "@Branch",
        "email": "terriebranch@comtours.com",
        "age": 37
      },
      {
        "id": 36,
        "firstName": "Louise",
        "lastName": "Aguirre",
        "username": "@Kirby",
        "email": "louisekirby@comtours.com",
        "age": 44
      },
      {
        "id": 37,
        "firstName": "David",
        "lastName": "Patton",
        "username": "@Sanders",
        "email": "davidsanders@comtours.com",
        "age": 26
      },
      {
        "id": 38,
        "firstName": "Holden",
        "lastName": "Barlow",
        "username": "@Mckinney",
        "email": "holdenmckinney@comtours.com",
        "age": 11
      },
      {
        "id": 39,
        "firstName": "Baker",
        "lastName": "Rivera",
        "username": "@Montoya",
        "email": "bakermontoya@comtours.com",
        "age": 47
      },
      {
        "id": 40,
        "firstName": "Belinda",
        "lastName": "Lloyd",
        "username": "@Calderon",
        "email": "belindacalderon@comtours.com",
        "age": 21
      },
      {
        "id": 41,
        "firstName": "Pearson",
        "lastName": "Patrick",
        "username": "@Clements",
        "email": "pearsonclements@comtours.com",
        "age": 42
      },
      {
        "id": 42,
        "firstName": "Alyce",
        "lastName": "Mckee",
        "username": "@Daugherty",
        "email": "alycedaugherty@comtours.com",
        "age": 55
      },
      {
        "id": 43,
        "firstName": "Valencia",
        "lastName": "Spence",
        "username": "@Olsen",
        "email": "valenciaolsen@comtours.com",
        "age": 20
      },
      {
        "id": 44,
        "firstName": "Leach",
        "lastName": "Holcomb",
        "username": "@Humphrey",
        "email": "leachhumphrey@comtours.com",
        "age": 28
      },
      {
        "id": 45,
        "firstName": "Moss",
        "lastName": "Baxter",
        "username": "@Fitzpatrick",
        "email": "mossfitzpatrick@comtours.com",
        "age": 51
      },
      {
        "id": 46,
        "firstName": "Jeanne",
        "lastName": "Cooke",
        "username": "@Ward",
        "email": "jeanneward@comtours.com",
        "age": 59
      },
      {
        "id": 47,
        "firstName": "Wilma",
        "lastName": "Briggs",
        "username": "@Kidd",
        "email": "wilmakidd@comtours.com",
        "age": 53
      },
      {
        "id": 48,
        "firstName": "Beatrice",
        "lastName": "Perry",
        "username": "@Gilbert",
        "email": "beatricegilbert@comtours.com",
        "age": 39
      },
      {
        "id": 49,
        "firstName": "Whitaker",
        "lastName": "Hyde",
        "username": "@Mcdonald",
        "email": "whitakermcdonald@comtours.com",
        "age": 35
      },
      {
        "id": 50,
        "firstName": "Rebekah",
        "lastName": "Duran",
        "username": "@Gross",
        "email": "rebekahgross@comtours.com",
        "age": 40
      },
      {
        "id": 51,
        "firstName": "Earline",
        "lastName": "Mayer",
        "username": "@Woodward",
        "email": "earlinewoodward@comtours.com",
        "age": 52
      },
      {
        "id": 52,
        "firstName": "Moran",
        "lastName": "Baxter",
        "username": "@Johns",
        "email": "moranjohns@comtours.com",
        "age": 20
      },
      {
        "id": 53,
        "firstName": "Nanette",
        "lastName": "Hubbard",
        "username": "@Cooke",
        "email": "nanettecooke@comtours.com",
        "age": 55
      },
      {
        "id": 54,
        "firstName": "Dalton",
        "lastName": "Walker",
        "username": "@Hendricks",
        "email": "daltonhendricks@comtours.com",
        "age": 25
      },
      {
        "id": 55,
        "firstName": "Bennett",
        "lastName": "Blake",
        "username": "@Pena",
        "email": "bennettpena@comtours.com",
        "age": 13
      },
      {
        "id": 56,
        "firstName": "Kellie",
        "lastName": "Horton",
        "username": "@Weiss",
        "email": "kellieweiss@comtours.com",
        "age": 48
      },
      {
        "id": 57,
        "firstName": "Hobbs",
        "lastName": "Talley",
        "username": "@Sanford",
        "email": "hobbssanford@comtours.com",
        "age": 28
      },
      {
        "id": 58,
        "firstName": "Mcguire",
        "lastName": "Donaldson",
        "username": "@Roman",
        "email": "mcguireroman@comtours.com",
        "age": 38
      },
      {
        "id": 59,
        "firstName": "Rodriquez",
        "lastName": "Saunders",
        "username": "@Harper",
        "email": "rodriquezharper@comtours.com",
        "age": 20
      },
      {
        "id": 60,
        "firstName": "Lou",
        "lastName": "Conner",
        "username": "@Sanchez",
        "email": "lousanchez@comtours.com",
        "age": 16
      }
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist')
    .controller('chartistCtrl', chartistCtrl);

  /** @ngInject */
  function chartistCtrl($scope, $timeout, baConfig) {

    $scope.simpleLineOptions = {
      color: baConfig.colors.defaultText,
      fullWidth: true,
      height: "300px",
      chartPadding: {
        right: 40
      }
    };

    $scope.simpleLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      series: [
        [20, 20, 12, 45, 50],
        [10, 45, 30, 14, 12],
        [34, 12, 12, 40, 50],
        [10, 43, 25, 22, 16],
        [3, 6, 30, 33, 43]
      ]
    };

    $scope.areaLineData = {
      labels: [1, 2, 3, 4, 5, 6, 7, 8],
      series: [
        [5, 9, 7, 8, 5, 3, 5, 4]
      ]
    };

    $scope.areaLineOptions = {
      fullWidth: true,
      height: "300px",
      low: 0,
      showArea: true
    };

    $scope.biLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      series: [
        [1, 2, 3, 1, -2, 0, 1],
        [-2, -1, -2, -1, -2.5, -1, -2],
        [0, 0, 0, 1, 2, 2.5, 2],
        [2.5, 2, 1, 0.5, 1, 0.5, -1]
      ]
    };

    $scope.biLineOptions = {
      height: "300px",
      high: 3,
      low: -3,
      showArea: true,
      showLine: false,
      showPoint: false,
      fullWidth: true,
      axisX: {
        showGrid: false
      }
    };

    $scope.simpleBarData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      series: [
        [15, 24, 43, 27, 5, 10, 23, 44, 68, 50, 26, 8],
        [13, 22, 49, 22, 4, 6, 24, 46, 57, 48, 22, 4]
      ]
    };

    $scope.simpleBarOptions = {
      fullWidth: true,
      height: "300px"
    };

    $scope.multiBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [5, 4, 3, 7],
        [3, 2, 9, 5],
        [1, 5, 8, 4],
        [2, 3, 4, 6],
        [4, 1, 2, 1]
      ]
    };

    $scope.multiBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value.split(/\s+/).map(function (word) {
            return word[0];
          }).join('');
        }
      },
      axisY: {
        offset: 20
      }
    };

    $scope.multiBarResponsive = [
      ['screen and (min-width: 400px)', {
        reverseData: true,
        horizontalBars: true,
        axisX: {
          labelInterpolationFnc: Chartist.noop
        },
        axisY: {
          offset: 60
        }
      }],
      ['screen and (min-width: 700px)', {
        stackBars: false,
        reverseData: false,
        horizontalBars: false,
        seriesBarDistance: 15
      }]
    ];

    $scope.stackedBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [800000, 1200000, 1400000, 1300000],
        [200000, 400000, 500000, 300000],
        [100000, 200000, 400000, 600000]
      ]
    };

    $scope.stackedBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisY: {
        labelInterpolationFnc: function (value) {
          return (value / 1000) + 'k';
        }
      }
    };

    $scope.simplePieData = {
      series: [5, 3, 4]
    };

    $scope.simplePieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelInterpolationFnc: function (value) {
        return Math.round(value / 12 * 100) + '%';
      }
    };

    $scope.labelsPieData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.labelsPieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.simpleDonutData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.simpleDonutOptions = {
      fullWidth: true,
      donut: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.donutResponsive = getResponsive(5, 40);

    $scope.pieResponsive = getResponsive(20, 80);

    function getResponsive(padding, offset){
      return [
        ['screen and (min-width: 1550px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 1200px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 600px)', {
          chartPadding: 0,
          labelOffset: 0,
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }]
      ];
    }

    $timeout(function(){
      new Chartist.Line('#line-chart', $scope.simpleLineData, $scope.simpleLineOptions);
      new Chartist.Line('#area-chart', $scope.areaLineData, $scope.areaLineOptions);
      new Chartist.Line('#bi-chart', $scope.biLineData, $scope.biLineOptions);

      new Chartist.Bar('#simple-bar', $scope.simpleBarData, $scope.simpleBarOptions);
      new Chartist.Bar('#multi-bar', $scope.multiBarData, $scope.multiBarOptions, $scope.multiBarResponsive);
      new Chartist.Bar('#stacked-bar', $scope.stackedBarData, $scope.stackedBarOptions);

      new Chartist.Pie('#simple-pie', $scope.simplePieData, $scope.simplePieOptions, $scope.pieResponsive);
      new Chartist.Pie('#label-pie', $scope.labelsPieData, $scope.labelsPieOptions);
      new Chartist.Pie('#donut', $scope.simpleDonutData, $scope.simpleDonutOptions, $scope.donutResponsive);
    });
  }
})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs1DCtrl', chartJs1DCtrl);

  /** @ngInject */
  function chartJs1DCtrl($scope, baConfig) {
    var layoutColors = baConfig.colors;

    $scope.data = [20, 40, 5];
    $scope.labels =["% Grasa", "% Masa Muscular", "% Masa Residual"];
    $scope.series = ['Porcentaje'];
    $scope.options = {
      elements: {
        arc: {
          borderWidth: 0
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontColor: layoutColors.defaultText
        }
      }
    };

    console.log($scope.options);

    $scope.changeData = function () {
      $scope.data = shuffle($scope.data);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs2DCtrl', chartJs2DCtrl);

  /** @ngInject */
  function chartJs2DCtrl($scope) {
    $scope.labels =["May", "Jun", "Jul"];
    $scope.data = [
      [65, 59, 90],
      [28, 48, 40]
    ];
    $scope.series = ['Product A', 'Product B'];


    $scope.changeData = function () {
      $scope.data[0] = shuffle($scope.data[0]);
      $scope.data[1] = shuffle($scope.data[1]);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJsWaveCtrl', chartJsWaveCtrl);

  /** @ngInject */
  function chartJsWaveCtrl($scope, $interval, stopableInterval) {
    $scope.labels =["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    $scope.data = [1, 9, 3, 4, 5, 6, 7, 8, 2].map(function(e){
      return Math.sin(e) * 25 +25;
    });

    stopableInterval.start($interval, function(){
      var tempArray = [];
      var lastElement = $scope.data[$scope.data.length-1];
      for(var i = $scope.data.length-1; i > 0; i--){
       tempArray[i] = $scope.data[i-1];
      }
      tempArray[0] = lastElement;
      $scope.data = tempArray;
    }, 400)
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris')
    .controller('morrisCtrl', morrisCtrl);

  /** @ngInject */
  function morrisCtrl($scope, $window, baConfig) {
    var layoutColors = baConfig.colors;
    $scope.colors = [layoutColors.primary, layoutColors.warning, layoutColors.danger, layoutColors.info, layoutColors.success, layoutColors.primaryDark];
    $scope.lineData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.areaData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.barData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.donutData = [
      {label: "Download Sales", value: 12},
      {label: "In-Store Sales", value: 30},
      {label: "Mail-Order Sales", value: 20}
    ];

    angular.element($window).bind('resize', function () {
      //$window.Morris.Grid.prototype.redraw();
    });
  }

})();
/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.mail')
    .service('mailMessages', mailMessages);

  /** @ngInject */
  function mailMessages($rootScope,$sce,$http, $translate) {

    var messages = [];
    var messagesenv = [];
    $http({
        url: 'http://apiintplus.rfit.cl/api/web/listarecibidos',
        method: "GET",
        params: {
          'id_usuario':$rootScope.currentUser.id
        },
    }).success(function(data) {
        messages = data.mensajes;
    });
    $http({
        url: 'http://apiintplus.rfit.cl/api/web/listarenviados',
        method: "GET",
        params: {
          'id_usuario':$rootScope.currentUser.id
        },
    }).success(function(data) {
        messagesenv = data.mensajes;
    });
    var tabs = [{
      label: 'recibidos',
      name: $translate.instant('Recibidos'),
    }, {
      label: 'enviados',
      name: $translate.instant('Enviados'),
    }];

    return{
      updaterecibidos : function(mensajes){
        messages = mensajes;
      },
      updateenviados : function(){
        $http({
            url: 'http://apiintplus.rfit.cl/api/web/listarenviados',
            method: "GET",
            params: {
              'id_usuario':$rootScope.currentUser.id
            },
        }).success(function(data) {
            messagesenv = data.mensajes;
        });
      },
      getTabs : function(){
        return tabs
      },
      getMessagesByLabel : function(label){
        return messages.filter(function(m){
          return m.labels.indexOf(label) != -1;
        });
      },
      getMessageById : function(id){
        return messages.filter(function(m){
          return m.id == id;
        })[0];
      },
      getMessageByIdd : function(id){
        return messagesenv.filter(function(m){
          return m.id == id;
        })[0];
      }
    }

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.mail')
      .controller('MailTabCtrl', MailTabCtrl);

  /** @ngInject */
  function MailTabCtrl(composeModal, mailMessages) {

    var vm = this;
    vm.navigationCollapsed = true;
    vm.showCompose = function(subject, to, too, id_usuario, id_conversacion, text){
      composeModal.open({
        subject : subject,
        to: to + ' ' + too,
        id_usuario: id_usuario,
        id_conversacion: id_conversacion,
        text: text
      })
    };

    vm.tabs = mailMessages.getTabs();
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline')
      .controller('TimelineCtrl', TimelineCtrl);

  /** @ngInject */
  function TimelineCtrl() {
    var timelineBlocks = $('.cd-timeline-block'),
        offset = 0.8;

    //hide timeline blocks which are outside the viewport
    hideBlocks(timelineBlocks, offset);

    //on scolling, show/animate timeline blocks when enter the viewport
    $(window).on('scroll', function () {
      if (!window.requestAnimationFrame) {
        setTimeout(function () {
          showBlocks(timelineBlocks, offset);
        }, 100);
      } else {
        window.requestAnimationFrame(function () {
          showBlocks(timelineBlocks, offset);
        });
      }
    });

    function hideBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top > $(window).scrollTop() + $(window).height() * offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
      });
    }

    function showBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
      });
    }
  }
})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree')
    .controller('treeCtrl', treeCtrl);

  /** @ngInject */
  function treeCtrl($scope, $timeout) {

    $scope.ignoreChanges = false;
    var newId = 0;
    $scope.ignoreChanges = false;
    $scope.newNode = {};

    $scope.basicConfig = {
      core: {
        multiple: false,
        check_callback: true,
        worker: true
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      'plugins': ['types'],
      'version': 1
    };

    $scope.dragConfig = {
      'core': {
        'check_callback': true,
        'themes': {
          'responsive': false
        }
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      "plugins": ["dnd", 'types']
    };

    $scope.addNewNode = function () {
      $scope.ignoreChanges = true;
      var selected = this.basicTree.jstree(true).get_selected()[0];
      if (selected)
        $scope.treeData.push({
          id: (newId++).toString(),
          parent: selected,
          text: "New node " + newId,
          state: {opened: true}
        });
      $scope.basicConfig.version++;
    };


    $scope.refresh = function () {
      $scope.ignoreChanges = true;
      newId = 0;
      $scope.treeData = getDefaultData();
      $scope.basicConfig.version++;
    };

    $scope.expand = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = true;
      });
      $scope.basicConfig.version++;
    };

    $scope.collapse = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = false;
      });
      $scope.basicConfig.version++;
    };

    $scope.readyCB = function() {
      $timeout(function() {
        $scope.ignoreChanges = false;
      });
    };


    $scope.applyModelChanges = function() {
      return !$scope.ignoreChanges;
    };

    $scope.treeData = getDefaultData();
    $scope.dragData = [
      {
        "id": "nd1",
        "parent": "#",
        "type": "folder",
        "text": "Node 1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd2",
        "parent": "#",
        "type": "folder",
        "text": "Node 2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd3",
        "parent": "#",
        "type": "folder",
        "text": "Node 3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd4",
        "parent": "#",
        "type": "folder",
        "text": "Node 4",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd5",
        "parent": "nd1",
        "text": "Node 1.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd6",
        "parent": "nd1",
        "text": "Node 1.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd7",
        "parent": "nd1",
        "text": "Node 1.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd8",
        "parent": "nd2",
        "text": "Node 2.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd9",
        "parent": "nd2",
        "text": "Node 2.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd10",
        "parent": "nd2",
        "text": "Node 2.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd11",
        "parent": "nd3",
        "text": "Node 3.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd12",
        "parent": "nd3",
        "text": "Node 3.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd13",
        "parent": "nd3",
        "text": "Node 3.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd14",
        "parent": "nd4",
        "text": "Node 4.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd15",
        "parent": "nd4",
        "text": "Node 4.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd16",
        "parent": "nd4",
        "text": "Node 4.3",
        "state": {
          "opened": true
        }
      }
    ];

    function getDefaultData() {
      return [
        {
          "id": "n1",
          "parent": "#",
          "type": "folder",
          "text": "Node 1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n2",
          "parent": "#",
          "type": "folder",
          "text": "Node 2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n3",
          "parent": "#",
          "type": "folder",
          "text": "Node 3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n5",
          "parent": "n1",
          "text": "Node 1.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n6",
          "parent": "n1",
          "text": "Node 1.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n7",
          "parent": "n1",
          "text": "Node 1.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n8",
          "parent": "n1",
          "text": "Node 1.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n9",
          "parent": "n2",
          "text": "Node 2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n10",
          "parent": "n2",
          "text": "Node 2.2 (Custom icon)",
          "icon": "ion-help-buoy",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n12",
          "parent": "n3",
          "text": "Node 3.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n13",
          "parent": "n3",
          "type": "folder",
          "text": "Node 3.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n14",
          "parent": "n13",
          "text": "Node 3.2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n15",
          "parent": "n13",
          "text": "Node 3.2.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n16",
          "parent": "n3",
          "text": "Node 3.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n17",
          "parent": "n3",
          "text": "Node 3.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n18",
          "parent": "n3",
          "text": "Node 3.5",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n19",
          "parent": "n3",
          "text": "Node 3.6",
          "state": {
            "opened": true
          }
        }
      ]
    }


  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/pages/dashboard/blurFeed/blurFeed.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('BlurFeedCtrl', BlurFeedCtrl);

  /** @ngInject */
  function BlurFeedCtrl($scope) {
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl',
      templateUrl: 'app/pages/dashboard/dashboardCalendar/dashboardCalendar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

  /** @ngInject */
  function DashboardCalendarCtrl(baConfig) {
    var dashboardColors = baConfig.colors.dashboard;
    var $element = $('#calendar').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      defaultDate: '2016-03-08',
      selectable: true,
      selectHelper: true,
      select: function (start, end) {
        var title = prompt('Event Title:');
        var eventData;
        if (title) {
          eventData = {
            title: title,
            start: start,
            end: end
          };
          $element.fullCalendar('renderEvent', eventData, true); // stick? = true
        }
        $element.fullCalendar('unselect');
      },
      editable: true,
      eventLimit: true, // allow "more" link when too many events
      events: [
        {
          title: 'All Day Event',
          start: '2016-03-01',
          color: dashboardColors.silverTree
        },
        {
          title: 'Long Event',
          start: '2016-03-07',
          end: '2016-03-10',
          color: dashboardColors.blueStone
        },
        {
          title: 'Dinner',
          start: '2016-03-14T20:00:00',
          color: dashboardColors.surfieGreen
        },
        {
          title: 'Birthday Party',
          start: '2016-04-01T07:00:00',
          color: dashboardColors.gossipDark
        }
      ]
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardLineChart', dashboardLineChart);

  /** @ngInject */
  function dashboardLineChart() {
    return {
      restrict: 'E',
      controller: 'DashboardLineChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardLineChart/dashboardLineChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardLineChartCtrl', DashboardLineChartCtrl);

  /** @ngInject */
  function DashboardLineChartCtrl(baConfig, layoutPaths, baUtil) {
    var layoutColors = baConfig.colors;
    var graphColor = baConfig.theme.blur ? '#000000' : layoutColors.primary;
    var chartData = [
      { date: new Date(2012, 11), value: 0, value0: 0 },
      { date: new Date(2013, 0), value: 15000, value0: 19000},
      { date: new Date(2013, 1), value: 30000, value0: 20000},

      { date: new Date(2013, 2), value: 25000, value0: 22000},
      { date: new Date(2013, 3), value: 21000, value0: 25000},
      { date: new Date(2013, 4), value: 24000, value0: 29000},
      { date: new Date(2013, 5), value: 31000, value0: 26000},
      { date: new Date(2013, 6), value: 40000, value0: 25000},
      { date: new Date(2013, 7), value: 37000, value0: 20000},
      { date: new Date(2013, 8), value: 18000, value0: 22000},
      { date: new Date(2013, 9), value: 5000, value0: 26000},
      { date: new Date(2013, 10), value: 40000, value0: 30000},
      { date: new Date(2013, 11), value: 20000, value0: 25000},
      { date: new Date(2014, 0), value: 5000, value0: 13000},

      { date: new Date(2014, 1), value: 3000, value0: 13000},
      { date: new Date(2014, 2), value: 1800, value0: 13000},
      { date: new Date(2014, 3), value: 10400, value0: 13000},
      { date: new Date(2014, 4), value: 25500, value0: 13000},
      { date: new Date(2014, 5), value: 2100, value0: 13000},
      { date: new Date(2014, 6), value: 6500, value0: 13000},
      { date: new Date(2014, 7), value: 1100, value0: 13000},
      { date: new Date(2014, 8), value: 17200, value0: 13000},
      { date: new Date(2014, 9), value: 26900, value0: 13000},
      { date: new Date(2014, 10), value: 14100, value0: 13000},
      { date: new Date(2014, 11), value: 35300, value0: 13000},
      { date: new Date(2015, 0), value: 54800, value0: 13000},
      { date: new Date(2015, 1), value: 49800, value0: 13000}
    ];

    var chart = AmCharts.makeChart('amchart', {
      type: 'serial',
      theme: 'blur',
      marginTop: 15,
      marginRight: 15,
      dataProvider: chartData,
      categoryField: 'date',
      categoryAxis: {
        parseDates: true,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText
      },
      valueAxes: [
        {
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }
      ],
      graphs: [
        {
          id: 'g0',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.3),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value0',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        },
        {
          id: 'g1',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.5),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        }
      ],
      chartCursor: {
        categoryBalloonDateFormat: 'MM YYYY',
        categoryBalloonColor: '#4285F4',
        categoryBalloonAlpha: 0.7,
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5
      },
      dataDateFormat: 'MM YYYY',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      zoomOutButton: {
        backgroundColor: '#fff',
        backgroundAlpha: 0
      },
      zoomOutText: '',
      pathToImages: layoutPaths.images.amChart
    });

    function zoomChart() {
      chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    }

    chart.addListener('rendered', zoomChart);
    zoomChart();
    if (chart.zoomChart) {
      chart.zoomChart();
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/pages/dashboard/dashboardMap/dashboardMap.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl(baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var map = AmCharts.makeChart('amChartMap', {
      type: 'map',
      theme: 'blur',
      zoomControl: { zoomControlEnabled: false, panControlEnabled: false },

      dataProvider: {
        map: 'worldLow',
        zoomLevel: 3.5,
        zoomLongitude: 10,
        zoomLatitude: 52,
        areas: [
          { title: 'Austria', id: 'AT', color: layoutColors.primary, customData: '1 244', groupId: '1'},
          { title: 'Ireland', id: 'IE', color: layoutColors.primary, customData: '1 342', groupId: '1'},
          { title: 'Denmark', id: 'DK', color: layoutColors.primary, customData: '1 973', groupId: '1'},
          { title: 'Finland', id: 'FI', color: layoutColors.primary, customData: '1 573', groupId: '1'},
          { title: 'Sweden', id: 'SE', color: layoutColors.primary, customData: '1 084', groupId: '1'},
          { title: 'Great Britain', id: 'GB', color: layoutColors.primary, customData: '1 452', groupId: '1'},
          { title: 'Italy', id: 'IT', color: layoutColors.primary, customData: '1 321', groupId: '1'},
          { title: 'France', id: 'FR', color: layoutColors.primary, customData: '1 112', groupId: '1'},
          { title: 'Spain', id: 'ES', color: layoutColors.primary, customData: '1 865', groupId: '1'},
          { title: 'Greece', id: 'GR', color: layoutColors.primary, customData: '1 453', groupId: '1'},
          { title: 'Germany', id: 'DE', color: layoutColors.primary, customData: '1 957', groupId: '1'},
          { title: 'Belgium', id: 'BE', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Luxembourg', id: 'LU', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Netherlands', id: 'NL', color: layoutColors.primary, customData: '1 213', groupId: '1'},
          { title: 'Portugal', id: 'PT', color: layoutColors.primary, customData: '1 291', groupId: '1'},
          { title: 'Lithuania', id: 'LT', color: layoutColors.successLight, customData: '567', groupId: '2'},
          { title: 'Latvia', id: 'LV', color: layoutColors.successLight, customData: '589', groupId: '2'},
          { title: 'Czech Republic ', id: 'CZ', color: layoutColors.successLight, customData: '785', groupId: '2'},
          { title: 'Slovakia', id: 'SK', color: layoutColors.successLight, customData: '965', groupId: '2'},
          { title: 'Estonia', id: 'EE', color: layoutColors.successLight, customData: '685', groupId: '2'},
          { title: 'Hungary', id: 'HU', color: layoutColors.successLight, customData: '854', groupId: '2'},
          { title: 'Cyprus', id: 'CY', color: layoutColors.successLight, customData: '754', groupId: '2'},
          { title: 'Malta', id: 'MT', color: layoutColors.successLight, customData: '867', groupId: '2'},
          { title: 'Poland', id: 'PL', color: layoutColors.successLight, customData: '759', groupId: '2'},
          { title: 'Romania', id: 'RO', color: layoutColors.success, customData: '302', groupId: '3'},
          { title: 'Bulgaria', id: 'BG', color: layoutColors.success, customData: '102', groupId: '3'},
          { title: 'Slovenia', id: 'SI', color: layoutColors.danger, customData: '23', groupId: '4'},
          { title: 'Croatia', id: 'HR', color: layoutColors.danger, customData: '96', groupId: '4'}
        ]
      },

      areasSettings: {
        rollOverOutlineColor: layoutColors.border,
        rollOverColor: layoutColors.primaryDark,
        alpha: 0.8,
        unlistedAreasAlpha: 0.2,
        unlistedAreasColor: layoutColors.defaultText,
        balloonText: '[[title]]: [[customData]] users'
      },


      legend: {
        width: '100%',
        marginRight: 27,
        marginLeft: 27,
        equalWidths: false,
        backgroundAlpha: 0.3,
        backgroundColor: layoutColors.border,
        borderColor: layoutColors.border,
        borderAlpha: 1,
        top: 362,
        left: 0,
        horizontalGap: 10,
        data: [
          {
            title: 'over 1 000 users',
            color: layoutColors.primary
          },
          {
            title: '500 - 1 000 users',
            color: layoutColors.successLight
          },
          {
            title: '100 - 500 users',
            color: layoutColors.success
          },
          {
            title: '0 - 100 users',
            color: layoutColors.danger
          }
        ]
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

  /** @ngInject */
  function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil) {
    var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    $scope.charts = [{
      color: pieColor,
      description: 'Créditos',
      stats: '540',
      icon: 'person',
    }, {
      color: pieColor,
      description: 'Evaluaciones',
      stats: '100',
      icon: 'money',
    }, {
      color: pieColor,
      description: 'Partners',
      stats: '4',
      icon: 'face',
    }, {
      color: pieColor,
      description: 'Clientes',
      stats: '10',
      icon: 'refresh',
    }
    ];

    function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }

    function loadPieCharts() {
      $('.chart').each(function () {
        var chart = $(this);
        chart.easyPieChart({
          easing: 'easeOutBounce',
          onStep: function (from, to, percent) {
            $(this.el).find('.percent').text(Math.round(percent));
          },
          barColor: chart.attr('rel'),
          trackColor: 'rgba(0,0,0,0)',
          size: 84,
          scaleLength: 0,
          animation: 2000,
          lineWidth: 9,
          lineCap: 'round',
        });
      });

      $('.refresh-data').on('click', function () {
        updatePieCharts();
      });
    }

    function updatePieCharts() {
      $('.pie-charts .chart').each(function(index, chart) {
        $(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
      });
    }

    $timeout(function () {
      loadPieCharts();
      updatePieCharts();
    }, 1000);
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardTodo', dashboardTodo);

  /** @ngInject */
  function dashboardTodo() {
    return {
      restrict: 'EA',
      controller: 'DashboardTodoCtrl',
      templateUrl: 'app/pages/dashboard/dashboardTodo/dashboardTodo.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardTodoCtrl', DashboardTodoCtrl);

  /** @ngInject */
  function DashboardTodoCtrl($scope, baConfig) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    var colors = [];
    for (var key in dashboardColors) {
      colors.push(dashboardColors[key]);
    }

    function getRandomColor() {
      var i = Math.floor(Math.random() * (colors.length - 1));
      return colors[i];
    }

    $scope.todoList = [
      { text: 'Check me out' },
      { text: 'Lorem ipsum dolor sit amet, possit denique oportere at his, etiam corpora deseruisse te pro' },
      { text: 'Ex has semper alterum, expetenda dignissim' },
      { text: 'Vim an eius ocurreret abhorreant, id nam aeque persius ornatus.' },
      { text: 'Simul erroribus ad usu' },
      { text: 'Ei cum solet appareat, ex est graeci mediocritatem' },
      { text: 'Get in touch with akveo team' },
      { text: 'Write email to business cat' },
      { text: 'Have fun with blur admin' },
      { text: 'What do you think?' },
    ];

    $scope.todoList.forEach(function(item) {
      item.color = getRandomColor();
    });

    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if (clickPlus || event.which === 13) {
        $scope.todoList.unshift({
          text: $scope.newTodoText,
          color: getRandomColor(),
        });
        $scope.newTodoText = '';
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('popularApp', popularApp);

  /** @ngInject */
  function popularApp() {
    return {
      restrict: 'E',
      templateUrl: 'app/pages/dashboard/popularApp/popularApp.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/dashboard/trafficChart/trafficChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper) {

      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      $scope.doughnutData = {
          labels: [
              'Other',
              'Search engines',
              'Referral Traffic',
              'Direct Traffic',
              'Ad Campaigns'
          ],
          datasets: [
              {
                  data: [2000, 1500, 1000, 1200, 400],
                  backgroundColor: [
                      dashboardColors.white,
                      dashboardColors.blueStone,
                      dashboardColors.surfieGreen,
                      dashboardColors.silverTree,
                      dashboardColors.gossip

                  ],
                  hoverBackgroundColor: [
                      colorHelper.shade(dashboardColors.white, 15),
                      colorHelper.shade(dashboardColors.blueStone, 15),
                      colorHelper.shade(dashboardColors.surfieGreen, 15),
                      colorHelper.shade(dashboardColors.silverTree, 15),
                      colorHelper.shade(dashboardColors.gossip, 15)
                  ],
                  percentage: [87, 22, 70, 38, 17]
              }]
      };

      var ctx = document.getElementById('chart-area').getContext('2d');
      window.myDoughnut = new Chart(ctx, {
          type: 'doughnut',
          data: $scope.doughnutData,
          options: {
              cutoutPercentage: 64,
              responsive: true,
              elements: {
                  arc: {
                      borderWidth: 0
                  }
              }
          }
      });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/pages/dashboard/weather/weather.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('WizardCtrl', WizardCtrl);

  /** @ngInject */
  function WizardCtrl($scope) {
   var vm = this;
   console.log(vm);
    vm.personalInfo = {};
    vm.productInfo = {};
    vm.shipment = {};

    vm.arePersonalInfoPasswordsEqual = function () {
      return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
    };
  }

})();


/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('GmapPageCtrl', GmapPageCtrl);

  /** @ngInject */
  function GmapPageCtrl($timeout,$http,$rootScope,$scope) {
    function initialize() {

      var mapCanvas = document.getElementById('google-maps');

      var geocoder = new google.maps.Geocoder();
      var geocoderRequest = { address: "Carlos Condell 696" };
      geocoder.geocode(geocoderRequest, function(results, status){
        console.log(results[0].geometry.location.lng());
        var homelat = results[0].geometry.location.lat();
        var homelng = results[0].geometry.location.lng();
        var mapOptions = {
          center: new google.maps.LatLng(homelat, homelng),
          zoom: 10,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        };
        $scope.map = new google.maps.Map(mapCanvas, mapOptions);
      });
      

      $http({
          url: 'http://apiintplus.rfit.cl/api/web/datosusuario',
          method: "GET",
          params: {'id_usuario':$rootScope.currentUser.id},
      }).success(function(respuesta) {
        $http({
            url: 'http://apiintplus.rfit.cl/api/web/profesionales_region',
            method: "GET",
            params: {
              'region':respuesta.datos.region,
            },
        }).success(function(data) {

          var datotes = data.profesionales;
          var i;
          var geocoder = new google.maps.Geocoder();
          for (i = 0; i < datotes.length; i++) {
            var geocoderRequest = { address: datotes[i].direccion + ',' + datotes[i].comuna + ',Chile' };
            var titulo = datotes[i].nombre + " " + datotes[i].apellido;
            console.log(titulo);
            geocoder.geocode(geocoderRequest, function(results, status){
              var prolat = results[0].geometry.location.lat();
              var prolng = results[0].geometry.location.lng();
              var marker = new google.maps.Marker({
                  position: new google.maps.LatLng(prolat, prolng),
                  map: $scope.map,
                  title: titulo,
                  icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'
              });
              console.log(titulo);
            });
          }

        });
 
      });
      
    }

    $timeout(function(){
      initialize();
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('LeafletPageCtrl', LeafletPageCtrl);

  /** @ngInject */
  function LeafletPageCtrl($timeout) {
    function initialize() {
      L.Icon.Default.imagePath = 'assets/img/theme/vendor/leaflet/dist/images';
      var map = L.map(document.getElementById('leaflet-map')).setView([51.505, -0.09], 13);
      L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      L.marker([51.5, -0.09]).addTo(map)
          .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
          .openPopup();
    }

    $timeout(function(){
      initialize();
    }, 100);

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('MapBubblePageCtrl', MapBubblePageCtrl);

  /** @ngInject */
  function MapBubblePageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    var latlong = {};
    latlong['AD'] = {'latitude': 42.5, 'longitude': 1.5};
    latlong['AE'] = {'latitude': 24, 'longitude': 54};
    latlong['AF'] = {'latitude': 33, 'longitude': 65};
    latlong['AG'] = {'latitude': 17.05, 'longitude': -61.8};
    latlong['AI'] = {'latitude': 18.25, 'longitude': -63.1667};
    latlong['AL'] = {'latitude': 41, 'longitude': 20};
    latlong['AM'] = {'latitude': 40, 'longitude': 45};
    latlong['AN'] = {'latitude': 12.25, 'longitude': -68.75};
    latlong['AO'] = {'latitude': -12.5, 'longitude': 18.5};
    latlong['AP'] = {'latitude': 35, 'longitude': 105};
    latlong['AQ'] = {'latitude': -90, 'longitude': 0};
    latlong['AR'] = {'latitude': -34, 'longitude': -64};
    latlong['AS'] = {'latitude': -14.3333, 'longitude': -170};
    latlong['AT'] = {'latitude': 47.3333, 'longitude': 13.3333};
    latlong['AU'] = {'latitude': -27, 'longitude': 133};
    latlong['AW'] = {'latitude': 12.5, 'longitude': -69.9667};
    latlong['AZ'] = {'latitude': 40.5, 'longitude': 47.5};
    latlong['BA'] = {'latitude': 44, 'longitude': 18};
    latlong['BB'] = {'latitude': 13.1667, 'longitude': -59.5333};
    latlong['BD'] = {'latitude': 24, 'longitude': 90};
    latlong['BE'] = {'latitude': 50.8333, 'longitude': 4};
    latlong['BF'] = {'latitude': 13, 'longitude': -2};
    latlong['BG'] = {'latitude': 43, 'longitude': 25};
    latlong['BH'] = {'latitude': 26, 'longitude': 50.55};
    latlong['BI'] = {'latitude': -3.5, 'longitude': 30};
    latlong['BJ'] = {'latitude': 9.5, 'longitude': 2.25};
    latlong['BM'] = {'latitude': 32.3333, 'longitude': -64.75};
    latlong['BN'] = {'latitude': 4.5, 'longitude': 114.6667};
    latlong['BO'] = {'latitude': -17, 'longitude': -65};
    latlong['BR'] = {'latitude': -10, 'longitude': -55};
    latlong['BS'] = {'latitude': 24.25, 'longitude': -76};
    latlong['BT'] = {'latitude': 27.5, 'longitude': 90.5};
    latlong['BV'] = {'latitude': -54.4333, 'longitude': 3.4};
    latlong['BW'] = {'latitude': -22, 'longitude': 24};
    latlong['BY'] = {'latitude': 53, 'longitude': 28};
    latlong['BZ'] = {'latitude': 17.25, 'longitude': -88.75};
    latlong['CA'] = {'latitude': 54, 'longitude': -100};
    latlong['CC'] = {'latitude': -12.5, 'longitude': 96.8333};
    latlong['CD'] = {'latitude': 0, 'longitude': 25};
    latlong['CF'] = {'latitude': 7, 'longitude': 21};
    latlong['CG'] = {'latitude': -1, 'longitude': 15};
    latlong['CH'] = {'latitude': 47, 'longitude': 8};
    latlong['CI'] = {'latitude': 8, 'longitude': -5};
    latlong['CK'] = {'latitude': -21.2333, 'longitude': -159.7667};
    latlong['CL'] = {'latitude': -30, 'longitude': -71};
    latlong['CM'] = {'latitude': 6, 'longitude': 12};
    latlong['CN'] = {'latitude': 35, 'longitude': 105};
    latlong['CO'] = {'latitude': 4, 'longitude': -72};
    latlong['CR'] = {'latitude': 10, 'longitude': -84};
    latlong['CU'] = {'latitude': 21.5, 'longitude': -80};
    latlong['CV'] = {'latitude': 16, 'longitude': -24};
    latlong['CX'] = {'latitude': -10.5, 'longitude': 105.6667};
    latlong['CY'] = {'latitude': 35, 'longitude': 33};
    latlong['CZ'] = {'latitude': 49.75, 'longitude': 15.5};
    latlong['DE'] = {'latitude': 51, 'longitude': 9};
    latlong['DJ'] = {'latitude': 11.5, 'longitude': 43};
    latlong['DK'] = {'latitude': 56, 'longitude': 10};
    latlong['DM'] = {'latitude': 15.4167, 'longitude': -61.3333};
    latlong['DO'] = {'latitude': 19, 'longitude': -70.6667};
    latlong['DZ'] = {'latitude': 28, 'longitude': 3};
    latlong['EC'] = {'latitude': -2, 'longitude': -77.5};
    latlong['EE'] = {'latitude': 59, 'longitude': 26};
    latlong['EG'] = {'latitude': 27, 'longitude': 30};
    latlong['EH'] = {'latitude': 24.5, 'longitude': -13};
    latlong['ER'] = {'latitude': 15, 'longitude': 39};
    latlong['ES'] = {'latitude': 40, 'longitude': -4};
    latlong['ET'] = {'latitude': 8, 'longitude': 38};
    latlong['EU'] = {'latitude': 47, 'longitude': 8};
    latlong['FI'] = {'latitude': 62, 'longitude': 26};
    latlong['FJ'] = {'latitude': -18, 'longitude': 175};
    latlong['FK'] = {'latitude': -51.75, 'longitude': -59};
    latlong['FM'] = {'latitude': 6.9167, 'longitude': 158.25};
    latlong['FO'] = {'latitude': 62, 'longitude': -7};
    latlong['FR'] = {'latitude': 46, 'longitude': 2};
    latlong['GA'] = {'latitude': -1, 'longitude': 11.75};
    latlong['GB'] = {'latitude': 54, 'longitude': -2};
    latlong['GD'] = {'latitude': 12.1167, 'longitude': -61.6667};
    latlong['GE'] = {'latitude': 42, 'longitude': 43.5};
    latlong['GF'] = {'latitude': 4, 'longitude': -53};
    latlong['GH'] = {'latitude': 8, 'longitude': -2};
    latlong['GI'] = {'latitude': 36.1833, 'longitude': -5.3667};
    latlong['GL'] = {'latitude': 72, 'longitude': -40};
    latlong['GM'] = {'latitude': 13.4667, 'longitude': -16.5667};
    latlong['GN'] = {'latitude': 11, 'longitude': -10};
    latlong['GP'] = {'latitude': 16.25, 'longitude': -61.5833};
    latlong['GQ'] = {'latitude': 2, 'longitude': 10};
    latlong['GR'] = {'latitude': 39, 'longitude': 22};
    latlong['GS'] = {'latitude': -54.5, 'longitude': -37};
    latlong['GT'] = {'latitude': 15.5, 'longitude': -90.25};
    latlong['GU'] = {'latitude': 13.4667, 'longitude': 144.7833};
    latlong['GW'] = {'latitude': 12, 'longitude': -15};
    latlong['GY'] = {'latitude': 5, 'longitude': -59};
    latlong['HK'] = {'latitude': 22.25, 'longitude': 114.1667};
    latlong['HM'] = {'latitude': -53.1, 'longitude': 72.5167};
    latlong['HN'] = {'latitude': 15, 'longitude': -86.5};
    latlong['HR'] = {'latitude': 45.1667, 'longitude': 15.5};
    latlong['HT'] = {'latitude': 19, 'longitude': -72.4167};
    latlong['HU'] = {'latitude': 47, 'longitude': 20};
    latlong['ID'] = {'latitude': -5, 'longitude': 120};
    latlong['IE'] = {'latitude': 53, 'longitude': -8};
    latlong['IL'] = {'latitude': 31.5, 'longitude': 34.75};
    latlong['IN'] = {'latitude': 20, 'longitude': 77};
    latlong['IO'] = {'latitude': -6, 'longitude': 71.5};
    latlong['IQ'] = {'latitude': 33, 'longitude': 44};
    latlong['IR'] = {'latitude': 32, 'longitude': 53};
    latlong['IS'] = {'latitude': 65, 'longitude': -18};
    latlong['IT'] = {'latitude': 42.8333, 'longitude': 12.8333};
    latlong['JM'] = {'latitude': 18.25, 'longitude': -77.5};
    latlong['JO'] = {'latitude': 31, 'longitude': 36};
    latlong['JP'] = {'latitude': 36, 'longitude': 138};
    latlong['KE'] = {'latitude': 1, 'longitude': 38};
    latlong['KG'] = {'latitude': 41, 'longitude': 75};
    latlong['KH'] = {'latitude': 13, 'longitude': 105};
    latlong['KI'] = {'latitude': 1.4167, 'longitude': 173};
    latlong['KM'] = {'latitude': -12.1667, 'longitude': 44.25};
    latlong['KN'] = {'latitude': 17.3333, 'longitude': -62.75};
    latlong['KP'] = {'latitude': 40, 'longitude': 127};
    latlong['KR'] = {'latitude': 37, 'longitude': 127.5};
    latlong['KW'] = {'latitude': 29.3375, 'longitude': 47.6581};
    latlong['KY'] = {'latitude': 19.5, 'longitude': -80.5};
    latlong['KZ'] = {'latitude': 48, 'longitude': 68};
    latlong['LA'] = {'latitude': 18, 'longitude': 105};
    latlong['LB'] = {'latitude': 33.8333, 'longitude': 35.8333};
    latlong['LC'] = {'latitude': 13.8833, 'longitude': -61.1333};
    latlong['LI'] = {'latitude': 47.1667, 'longitude': 9.5333};
    latlong['LK'] = {'latitude': 7, 'longitude': 81};
    latlong['LR'] = {'latitude': 6.5, 'longitude': -9.5};
    latlong['LS'] = {'latitude': -29.5, 'longitude': 28.5};
    latlong['LT'] = {'latitude': 55, 'longitude': 24};
    latlong['LU'] = {'latitude': 49.75, 'longitude': 6};
    latlong['LV'] = {'latitude': 57, 'longitude': 25};
    latlong['LY'] = {'latitude': 25, 'longitude': 17};
    latlong['MA'] = {'latitude': 32, 'longitude': -5};
    latlong['MC'] = {'latitude': 43.7333, 'longitude': 7.4};
    latlong['MD'] = {'latitude': 47, 'longitude': 29};
    latlong['ME'] = {'latitude': 42.5, 'longitude': 19.4};
    latlong['MG'] = {'latitude': -20, 'longitude': 47};
    latlong['MH'] = {'latitude': 9, 'longitude': 168};
    latlong['MK'] = {'latitude': 41.8333, 'longitude': 22};
    latlong['ML'] = {'latitude': 17, 'longitude': -4};
    latlong['MM'] = {'latitude': 22, 'longitude': 98};
    latlong['MN'] = {'latitude': 46, 'longitude': 105};
    latlong['MO'] = {'latitude': 22.1667, 'longitude': 113.55};
    latlong['MP'] = {'latitude': 15.2, 'longitude': 145.75};
    latlong['MQ'] = {'latitude': 14.6667, 'longitude': -61};
    latlong['MR'] = {'latitude': 20, 'longitude': -12};
    latlong['MS'] = {'latitude': 16.75, 'longitude': -62.2};
    latlong['MT'] = {'latitude': 35.8333, 'longitude': 14.5833};
    latlong['MU'] = {'latitude': -20.2833, 'longitude': 57.55};
    latlong['MV'] = {'latitude': 3.25, 'longitude': 73};
    latlong['MW'] = {'latitude': -13.5, 'longitude': 34};
    latlong['MX'] = {'latitude': 23, 'longitude': -102};
    latlong['MY'] = {'latitude': 2.5, 'longitude': 112.5};
    latlong['MZ'] = {'latitude': -18.25, 'longitude': 35};
    latlong['NA'] = {'latitude': -22, 'longitude': 17};
    latlong['NC'] = {'latitude': -21.5, 'longitude': 165.5};
    latlong['NE'] = {'latitude': 16, 'longitude': 8};
    latlong['NF'] = {'latitude': -29.0333, 'longitude': 167.95};
    latlong['NG'] = {'latitude': 10, 'longitude': 8};
    latlong['NI'] = {'latitude': 13, 'longitude': -85};
    latlong['NL'] = {'latitude': 52.5, 'longitude': 5.75};
    latlong['NO'] = {'latitude': 62, 'longitude': 10};
    latlong['NP'] = {'latitude': 28, 'longitude': 84};
    latlong['NR'] = {'latitude': -0.5333, 'longitude': 166.9167};
    latlong['NU'] = {'latitude': -19.0333, 'longitude': -169.8667};
    latlong['NZ'] = {'latitude': -41, 'longitude': 174};
    latlong['OM'] = {'latitude': 21, 'longitude': 57};
    latlong['PA'] = {'latitude': 9, 'longitude': -80};
    latlong['PE'] = {'latitude': -10, 'longitude': -76};
    latlong['PF'] = {'latitude': -15, 'longitude': -140};
    latlong['PG'] = {'latitude': -6, 'longitude': 147};
    latlong['PH'] = {'latitude': 13, 'longitude': 122};
    latlong['PK'] = {'latitude': 30, 'longitude': 70};
    latlong['PL'] = {'latitude': 52, 'longitude': 20};
    latlong['PM'] = {'latitude': 46.8333, 'longitude': -56.3333};
    latlong['PR'] = {'latitude': 18.25, 'longitude': -66.5};
    latlong['PS'] = {'latitude': 32, 'longitude': 35.25};
    latlong['PT'] = {'latitude': 39.5, 'longitude': -8};
    latlong['PW'] = {'latitude': 7.5, 'longitude': 134.5};
    latlong['PY'] = {'latitude': -23, 'longitude': -58};
    latlong['QA'] = {'latitude': 25.5, 'longitude': 51.25};
    latlong['RE'] = {'latitude': -21.1, 'longitude': 55.6};
    latlong['RO'] = {'latitude': 46, 'longitude': 25};
    latlong['RS'] = {'latitude': 44, 'longitude': 21};
    latlong['RU'] = {'latitude': 60, 'longitude': 100};
    latlong['RW'] = {'latitude': -2, 'longitude': 30};
    latlong['SA'] = {'latitude': 25, 'longitude': 45};
    latlong['SB'] = {'latitude': -8, 'longitude': 159};
    latlong['SC'] = {'latitude': -4.5833, 'longitude': 55.6667};
    latlong['SD'] = {'latitude': 15, 'longitude': 30};
    latlong['SE'] = {'latitude': 62, 'longitude': 15};
    latlong['SG'] = {'latitude': 1.3667, 'longitude': 103.8};
    latlong['SH'] = {'latitude': -15.9333, 'longitude': -5.7};
    latlong['SI'] = {'latitude': 46, 'longitude': 15};
    latlong['SJ'] = {'latitude': 78, 'longitude': 20};
    latlong['SK'] = {'latitude': 48.6667, 'longitude': 19.5};
    latlong['SL'] = {'latitude': 8.5, 'longitude': -11.5};
    latlong['SM'] = {'latitude': 43.7667, 'longitude': 12.4167};
    latlong['SN'] = {'latitude': 14, 'longitude': -14};
    latlong['SO'] = {'latitude': 10, 'longitude': 49};
    latlong['SR'] = {'latitude': 4, 'longitude': -56};
    latlong['ST'] = {'latitude': 1, 'longitude': 7};
    latlong['SV'] = {'latitude': 13.8333, 'longitude': -88.9167};
    latlong['SY'] = {'latitude': 35, 'longitude': 38};
    latlong['SZ'] = {'latitude': -26.5, 'longitude': 31.5};
    latlong['TC'] = {'latitude': 21.75, 'longitude': -71.5833};
    latlong['TD'] = {'latitude': 15, 'longitude': 19};
    latlong['TF'] = {'latitude': -43, 'longitude': 67};
    latlong['TG'] = {'latitude': 8, 'longitude': 1.1667};
    latlong['TH'] = {'latitude': 15, 'longitude': 100};
    latlong['TJ'] = {'latitude': 39, 'longitude': 71};
    latlong['TK'] = {'latitude': -9, 'longitude': -172};
    latlong['TM'] = {'latitude': 40, 'longitude': 60};
    latlong['TN'] = {'latitude': 34, 'longitude': 9};
    latlong['TO'] = {'latitude': -20, 'longitude': -175};
    latlong['TR'] = {'latitude': 39, 'longitude': 35};
    latlong['TT'] = {'latitude': 11, 'longitude': -61};
    latlong['TV'] = {'latitude': -8, 'longitude': 178};
    latlong['TW'] = {'latitude': 23.5, 'longitude': 121};
    latlong['TZ'] = {'latitude': -6, 'longitude': 35};
    latlong['UA'] = {'latitude': 49, 'longitude': 32};
    latlong['UG'] = {'latitude': 1, 'longitude': 32};
    latlong['UM'] = {'latitude': 19.2833, 'longitude': 166.6};
    latlong['US'] = {'latitude': 38, 'longitude': -97};
    latlong['UY'] = {'latitude': -33, 'longitude': -56};
    latlong['UZ'] = {'latitude': 41, 'longitude': 64};
    latlong['VA'] = {'latitude': 41.9, 'longitude': 12.45};
    latlong['VC'] = {'latitude': 13.25, 'longitude': -61.2};
    latlong['VE'] = {'latitude': 8, 'longitude': -66};
    latlong['VG'] = {'latitude': 18.5, 'longitude': -64.5};
    latlong['VI'] = {'latitude': 18.3333, 'longitude': -64.8333};
    latlong['VN'] = {'latitude': 16, 'longitude': 106};
    latlong['VU'] = {'latitude': -16, 'longitude': 167};
    latlong['WF'] = {'latitude': -13.3, 'longitude': -176.2};
    latlong['WS'] = {'latitude': -13.5833, 'longitude': -172.3333};
    latlong['YE'] = {'latitude': 15, 'longitude': 48};
    latlong['YT'] = {'latitude': -12.8333, 'longitude': 45.1667};
    latlong['ZA'] = {'latitude': -29, 'longitude': 24};
    latlong['ZM'] = {'latitude': -15, 'longitude': 30};
    latlong['ZW'] = {'latitude': -20, 'longitude': 30};

    var mapData = [
      {'code': 'AF', 'name': 'Afghanistan', 'value': 32358260, 'color': layoutColors.primaryDark},
      {'code': 'AL', 'name': 'Albania', 'value': 3215988, 'color': layoutColors.warning},
      {'code': 'DZ', 'name': 'Algeria', 'value': 35980193, 'color': layoutColors.danger},
      {'code': 'AO', 'name': 'Angola', 'value': 19618432, 'color': layoutColors.danger},
      {'code': 'AR', 'name': 'Argentina', 'value': 40764561, 'color': layoutColors.success},
      {'code': 'AM', 'name': 'Armenia', 'value': 3100236, 'color': layoutColors.warning},
      {'code': 'AU', 'name': 'Australia', 'value': 22605732, 'color': layoutColors.warningDark},
      {'code': 'AT', 'name': 'Austria', 'value': 8413429, 'color': layoutColors.warning},
      {'code': 'AZ', 'name': 'Azerbaijan', 'value': 9306023, 'color': layoutColors.warning},
      {'code': 'BH', 'name': 'Bahrain', 'value': 1323535, 'color': layoutColors.primaryDark},
      {'code': 'BD', 'name': 'Bangladesh', 'value': 150493658, 'color': layoutColors.primaryDark},
      {'code': 'BY', 'name': 'Belarus', 'value': 9559441, 'color': layoutColors.warning},
      {'code': 'BE', 'name': 'Belgium', 'value': 10754056, 'color': layoutColors.warning},
      {'code': 'BJ', 'name': 'Benin', 'value': 9099922, 'color': layoutColors.danger},
      {'code': 'BT', 'name': 'Bhutan', 'value': 738267, 'color': layoutColors.primaryDark},
      {'code': 'BO', 'name': 'Bolivia', 'value': 10088108, 'color': layoutColors.success},
      {'code': 'BA', 'name': 'Bosnia and Herzegovina', 'value': 3752228, 'color': layoutColors.warning},
      {'code': 'BW', 'name': 'Botswana', 'value': 2030738, 'color': layoutColors.danger},
      {'code': 'BR', 'name': 'Brazil', 'value': 196655014, 'color': layoutColors.success},
      {'code': 'BN', 'name': 'Brunei', 'value': 405938, 'color': layoutColors.primaryDark},
      {'code': 'BG', 'name': 'Bulgaria', 'value': 7446135, 'color': layoutColors.warning},
      {'code': 'BF', 'name': 'Burkina Faso', 'value': 16967845, 'color': layoutColors.danger},
      {'code': 'BI', 'name': 'Burundi', 'value': 8575172, 'color': layoutColors.danger},
      {'code': 'KH', 'name': 'Cambodia', 'value': 14305183, 'color': layoutColors.primaryDark},
      {'code': 'CM', 'name': 'Cameroon', 'value': 20030362, 'color': layoutColors.danger},
      {'code': 'CA', 'name': 'Canada', 'value': 34349561, 'color': layoutColors.primary},
      {'code': 'CV', 'name': 'Cape Verde', 'value': 500585, 'color': layoutColors.danger},
      {'code': 'CF', 'name': 'Central African Rep.', 'value': 4486837, 'color': layoutColors.danger},
      {'code': 'TD', 'name': 'Chad', 'value': 11525496, 'color': layoutColors.danger},
      {'code': 'CL', 'name': 'Chile', 'value': 17269525, 'color': layoutColors.success},
      {'code': 'CN', 'name': 'China', 'value': 1347565324, 'color': layoutColors.primaryDark},
      {'code': 'CO', 'name': 'Colombia', 'value': 46927125, 'color': layoutColors.success},
      {'code': 'KM', 'name': 'Comoros', 'value': 753943, 'color': layoutColors.danger},
      {'code': 'CD', 'name': 'Congo, Dem. Rep.', 'value': 67757577, 'color': layoutColors.danger},
      {'code': 'CG', 'name': 'Congo, Rep.', 'value': 4139748, 'color': layoutColors.danger},
      {'code': 'CR', 'name': 'Costa Rica', 'value': 4726575, 'color': layoutColors.primary},
      {'code': 'CI', 'name': 'Cote d\'Ivoire', 'value': 20152894, 'color': layoutColors.danger},
      {'code': 'HR', 'name': 'Croatia', 'value': 4395560, 'color': layoutColors.warning},
      {'code': 'CU', 'name': 'Cuba', 'value': 11253665, 'color': layoutColors.primary},
      {'code': 'CY', 'name': 'Cyprus', 'value': 1116564, 'color': layoutColors.warning},
      {'code': 'CZ', 'name': 'Czech Rep.', 'value': 10534293, 'color': layoutColors.warning},
      {'code': 'DK', 'name': 'Denmark', 'value': 5572594, 'color': layoutColors.warning},
      {'code': 'DJ', 'name': 'Djibouti', 'value': 905564, 'color': layoutColors.danger},
      {'code': 'DO', 'name': 'Dominican Rep.', 'value': 10056181, 'color': layoutColors.primary},
      {'code': 'EC', 'name': 'Ecuador', 'value': 14666055, 'color': layoutColors.success},
      {'code': 'EG', 'name': 'Egypt', 'value': 82536770, 'color': layoutColors.danger},
      {'code': 'SV', 'name': 'El Salvador', 'value': 6227491, 'color': layoutColors.primary},
      {'code': 'GQ', 'name': 'Equatorial Guinea', 'value': 720213, 'color': layoutColors.danger},
      {'code': 'ER', 'name': 'Eritrea', 'value': 5415280, 'color': layoutColors.danger},
      {'code': 'EE', 'name': 'Estonia', 'value': 1340537, 'color': layoutColors.warning},
      {'code': 'ET', 'name': 'Ethiopia', 'value': 84734262, 'color': layoutColors.danger},
      {'code': 'FJ', 'name': 'Fiji', 'value': 868406, 'color': layoutColors.warningDark},
      {'code': 'FI', 'name': 'Finland', 'value': 5384770, 'color': layoutColors.warning},
      {'code': 'FR', 'name': 'France', 'value': 63125894, 'color': layoutColors.warning},
      {'code': 'GA', 'name': 'Gabon', 'value': 1534262, 'color': layoutColors.danger},
      {'code': 'GM', 'name': 'Gambia', 'value': 1776103, 'color': layoutColors.danger},
      {'code': 'GE', 'name': 'Georgia', 'value': 4329026, 'color': layoutColors.warning},
      {'code': 'DE', 'name': 'Germany', 'value': 82162512, 'color': layoutColors.warning},
      {'code': 'GH', 'name': 'Ghana', 'value': 24965816, 'color': layoutColors.danger},
      {'code': 'GR', 'name': 'Greece', 'value': 11390031, 'color': layoutColors.warning},
      {'code': 'GT', 'name': 'Guatemala', 'value': 14757316, 'color': layoutColors.primary},
      {'code': 'GN', 'name': 'Guinea', 'value': 10221808, 'color': layoutColors.danger},
      {'code': 'GW', 'name': 'Guinea-Bissau', 'value': 1547061, 'color': layoutColors.danger},
      {'code': 'GY', 'name': 'Guyana', 'value': 756040, 'color': layoutColors.success},
      {'code': 'HT', 'name': 'Haiti', 'value': 10123787, 'color': layoutColors.primary},
      {'code': 'HN', 'name': 'Honduras', 'value': 7754687, 'color': layoutColors.primary},
      {'code': 'HK', 'name': 'Hong Kong, China', 'value': 7122187, 'color': layoutColors.primaryDark},
      {'code': 'HU', 'name': 'Hungary', 'value': 9966116, 'color': layoutColors.warning},
      {'code': 'IS', 'name': 'Iceland', 'value': 324366, 'color': layoutColors.warning},
      {'code': 'IN', 'name': 'India', 'value': 1241491960, 'color': layoutColors.primaryDark},
      {'code': 'ID', 'name': 'Indonesia', 'value': 242325638, 'color': layoutColors.primaryDark},
      {'code': 'IR', 'name': 'Iran', 'value': 74798599, 'color': layoutColors.primaryDark},
      {'code': 'IQ', 'name': 'Iraq', 'value': 32664942, 'color': layoutColors.primaryDark},
      {'code': 'IE', 'name': 'Ireland', 'value': 4525802, 'color': layoutColors.warning},
      {'code': 'IL', 'name': 'Israel', 'value': 7562194, 'color': layoutColors.primaryDark},
      {'code': 'IT', 'name': 'Italy', 'value': 60788694, 'color': layoutColors.warning},
      {'code': 'JM', 'name': 'Jamaica', 'value': 2751273, 'color': layoutColors.primary},
      {'code': 'JP', 'name': 'Japan', 'value': 126497241, 'color': layoutColors.primaryDark},
      {'code': 'JO', 'name': 'Jordan', 'value': 6330169, 'color': layoutColors.primaryDark},
      {'code': 'KZ', 'name': 'Kazakhstan', 'value': 16206750, 'color': layoutColors.primaryDark},
      {'code': 'KE', 'name': 'Kenya', 'value': 41609728, 'color': layoutColors.danger},
      {'code': 'KP', 'name': 'Korea, Dem. Rep.', 'value': 24451285, 'color': layoutColors.primaryDark},
      {'code': 'KR', 'name': 'Korea, Rep.', 'value': 48391343, 'color': layoutColors.primaryDark},
      {'code': 'KW', 'name': 'Kuwait', 'value': 2818042, 'color': layoutColors.primaryDark},
      {'code': 'KG', 'name': 'Kyrgyzstan', 'value': 5392580, 'color': layoutColors.primaryDark},
      {'code': 'LA', 'name': 'Laos', 'value': 6288037, 'color': layoutColors.primaryDark},
      {'code': 'LV', 'name': 'Latvia', 'value': 2243142, 'color': layoutColors.warning},
      {'code': 'LB', 'name': 'Lebanon', 'value': 4259405, 'color': layoutColors.primaryDark},
      {'code': 'LS', 'name': 'Lesotho', 'value': 2193843, 'color': layoutColors.danger},
      {'code': 'LR', 'name': 'Liberia', 'value': 4128572, 'color': layoutColors.danger},
      {'code': 'LY', 'name': 'Libya', 'value': 6422772, 'color': layoutColors.danger},
      {'code': 'LT', 'name': 'Lithuania', 'value': 3307481, 'color': layoutColors.warning},
      {'code': 'LU', 'name': 'Luxembourg', 'value': 515941, 'color': layoutColors.warning},
      {'code': 'MK', 'name': 'Macedonia, FYR', 'value': 2063893, 'color': layoutColors.warning},
      {'code': 'MG', 'name': 'Madagascar', 'value': 21315135, 'color': layoutColors.danger},
      {'code': 'MW', 'name': 'Malawi', 'value': 15380888, 'color': layoutColors.danger},
      {'code': 'MY', 'name': 'Malaysia', 'value': 28859154, 'color': layoutColors.primaryDark},
      {'code': 'ML', 'name': 'Mali', 'value': 15839538, 'color': layoutColors.danger},
      {'code': 'MR', 'name': 'Mauritania', 'value': 3541540, 'color': layoutColors.danger},
      {'code': 'MU', 'name': 'Mauritius', 'value': 1306593, 'color': layoutColors.danger},
      {'code': 'MX', 'name': 'Mexico', 'value': 114793341, 'color': layoutColors.primary},
      {'code': 'MD', 'name': 'Moldova', 'value': 3544864, 'color': layoutColors.warning},
      {'code': 'MN', 'name': 'Mongolia', 'value': 2800114, 'color': layoutColors.primaryDark},
      {'code': 'ME', 'name': 'Montenegro', 'value': 632261, 'color': layoutColors.warning},
      {'code': 'MA', 'name': 'Morocco', 'value': 32272974, 'color': layoutColors.danger},
      {'code': 'MZ', 'name': 'Mozambique', 'value': 23929708, 'color': layoutColors.danger},
      {'code': 'MM', 'name': 'Myanmar', 'value': 48336763, 'color': layoutColors.primaryDark},
      {'code': 'NA', 'name': 'Namibia', 'value': 2324004, 'color': layoutColors.danger},
      {'code': 'NP', 'name': 'Nepal', 'value': 30485798, 'color': layoutColors.primaryDark},
      {'code': 'NL', 'name': 'Netherlands', 'value': 16664746, 'color': layoutColors.warning},
      {'code': 'NZ', 'name': 'New Zealand', 'value': 4414509, 'color': layoutColors.warningDark},
      {'code': 'NI', 'name': 'Nicaragua', 'value': 5869859, 'color': layoutColors.primary},
      {'code': 'NE', 'name': 'Niger', 'value': 16068994, 'color': layoutColors.danger},
      {'code': 'NG', 'name': 'Nigeria', 'value': 162470737, 'color': layoutColors.danger},
      {'code': 'NO', 'name': 'Norway', 'value': 4924848, 'color': layoutColors.warning},
      {'code': 'OM', 'name': 'Oman', 'value': 2846145, 'color': layoutColors.primaryDark},
      {'code': 'PK', 'name': 'Pakistan', 'value': 176745364, 'color': layoutColors.primaryDark},
      {'code': 'PA', 'name': 'Panama', 'value': 3571185, 'color': layoutColors.primary},
      {'code': 'PG', 'name': 'Papua New Guinea', 'value': 7013829, 'color': layoutColors.warningDark},
      {'code': 'PY', 'name': 'Paraguay', 'value': 6568290, 'color': layoutColors.success},
      {'code': 'PE', 'name': 'Peru', 'value': 29399817, 'color': layoutColors.success},
      {'code': 'PH', 'name': 'Philippines', 'value': 94852030, 'color': layoutColors.primaryDark},
      {'code': 'PL', 'name': 'Poland', 'value': 38298949, 'color': layoutColors.warning},
      {'code': 'PT', 'name': 'Portugal', 'value': 10689663, 'color': layoutColors.warning},
      {'code': 'PR', 'name': 'Puerto Rico', 'value': 3745526, 'color': layoutColors.primary},
      {'code': 'QA', 'name': 'Qatar', 'value': 1870041, 'color': layoutColors.primaryDark},
      {'code': 'RO', 'name': 'Romania', 'value': 21436495, 'color': layoutColors.warning},
      {'code': 'RU', 'name': 'Russia', 'value': 142835555, 'color': layoutColors.warning},
      {'code': 'RW', 'name': 'Rwanda', 'value': 10942950, 'color': layoutColors.danger},
      {'code': 'SA', 'name': 'Saudi Arabia', 'value': 28082541, 'color': layoutColors.primaryDark},
      {'code': 'SN', 'name': 'Senegal', 'value': 12767556, 'color': layoutColors.danger},
      {'code': 'RS', 'name': 'Serbia', 'value': 9853969, 'color': layoutColors.warning},
      {'code': 'SL', 'name': 'Sierra Leone', 'value': 5997486, 'color': layoutColors.danger},
      {'code': 'SG', 'name': 'Singapore', 'value': 5187933, 'color': layoutColors.primaryDark},
      {'code': 'SK', 'name': 'Slovak Republic', 'value': 5471502, 'color': layoutColors.warning},
      {'code': 'SI', 'name': 'Slovenia', 'value': 2035012, 'color': layoutColors.warning},
      {'code': 'SB', 'name': 'Solomon Islands', 'value': 552267, 'color': layoutColors.warningDark},
      {'code': 'SO', 'name': 'Somalia', 'value': 9556873, 'color': layoutColors.danger},
      {'code': 'ZA', 'name': 'South Africa', 'value': 50459978, 'color': layoutColors.danger},
      {'code': 'ES', 'name': 'Spain', 'value': 46454895, 'color': layoutColors.warning},
      {'code': 'LK', 'name': 'Sri Lanka', 'value': 21045394, 'color': layoutColors.primaryDark},
      {'code': 'SD', 'name': 'Sudan', 'value': 34735288, 'color': layoutColors.danger},
      {'code': 'SR', 'name': 'Suriname', 'value': 529419, 'color': layoutColors.success},
      {'code': 'SZ', 'name': 'Swaziland', 'value': 1203330, 'color': layoutColors.danger},
      {'code': 'SE', 'name': 'Sweden', 'value': 9440747, 'color': layoutColors.warning},
      {'code': 'CH', 'name': 'Switzerland', 'value': 7701690, 'color': layoutColors.warning},
      {'code': 'SY', 'name': 'Syria', 'value': 20766037, 'color': layoutColors.primaryDark},
      {'code': 'TW', 'name': 'Taiwan', 'value': 23072000, 'color': layoutColors.primaryDark},
      {'code': 'TJ', 'name': 'Tajikistan', 'value': 6976958, 'color': layoutColors.primaryDark},
      {'code': 'TZ', 'name': 'Tanzania', 'value': 46218486, 'color': layoutColors.danger},
      {'code': 'TH', 'name': 'Thailand', 'value': 69518555, 'color': layoutColors.primaryDark},
      {'code': 'TG', 'name': 'Togo', 'value': 6154813, 'color': layoutColors.danger},
      {'code': 'TT', 'name': 'Trinidad and Tobago', 'value': 1346350, 'color': layoutColors.primary},
      {'code': 'TN', 'name': 'Tunisia', 'value': 10594057, 'color': layoutColors.danger},
      {'code': 'TR', 'name': 'Turkey', 'value': 73639596, 'color': layoutColors.warning},
      {'code': 'TM', 'name': 'Turkmenistan', 'value': 5105301, 'color': layoutColors.primaryDark},
      {'code': 'UG', 'name': 'Uganda', 'value': 34509205, 'color': layoutColors.danger},
      {'code': 'UA', 'name': 'Ukraine', 'value': 45190180, 'color': layoutColors.warning},
      {'code': 'AE', 'name': 'United Arab Emirates', 'value': 7890924, 'color': layoutColors.primaryDark},
      {'code': 'GB', 'name': 'United Kingdom', 'value': 62417431, 'color': layoutColors.warning},
      {'code': 'US', 'name': 'United States', 'value': 313085380, 'color': layoutColors.primary},
      {'code': 'UY', 'name': 'Uruguay', 'value': 3380008, 'color': layoutColors.success},
      {'code': 'UZ', 'name': 'Uzbekistan', 'value': 27760267, 'color': layoutColors.primaryDark},
      {'code': 'VE', 'name': 'Venezuela', 'value': 29436891, 'color': layoutColors.success},
      {'code': 'PS', 'name': 'West Bank and Gaza', 'value': 4152369, 'color': layoutColors.primaryDark},
      {'code': 'VN', 'name': 'Vietnam', 'value': 88791996, 'color': layoutColors.primaryDark},
      {'code': 'YE', 'name': 'Yemen, Rep.', 'value': 24799880, 'color': layoutColors.primaryDark},
      {'code': 'ZM', 'name': 'Zambia', 'value': 13474959, 'color': layoutColors.danger},
      {'code': 'ZW', 'name': 'Zimbabwe', 'value': 12754378, 'color': layoutColors.danger}
    ];

    var map;
    var minBulletSize = 3;
    var maxBulletSize = 70;
    var min = Infinity;
    var max = -Infinity;

    // get min and max values
    for (var i = 0; i < mapData.length; i++) {
      var value = mapData[i].value;
      if (value < min) {
        min = value;
      }
      if (value > max) {
        max = value;
      }
    }

    // build map
    AmCharts.theme = AmCharts.themes.blur;
    map = new AmCharts.AmMap();

    map.addTitle('Population of the World in 2011', 14);
    map.addTitle('source: Gapminder', 11);
    map.areasSettings = {
      unlistedAreasColor: '#000000',
      unlistedAreasAlpha: 0.1
    };
    map.imagesSettings.balloonText = '<span style="font-size:14px;"><b>[[title]]</b>: [[value]]</span>';
    map.pathToImages = layoutPaths.images.amMap;

    var dataProvider = {
      mapVar: AmCharts.maps.worldLow,
      images: []
    };

    // it's better to use circle square to show difference between values, not a radius
    var maxSquare = maxBulletSize * maxBulletSize * 2 * Math.PI;
    var minSquare = minBulletSize * minBulletSize * 2 * Math.PI;

    // create circle for each country
    for (var i = 0; i < mapData.length; i++) {
      var dataItem = mapData[i];
      var value = dataItem.value;
      // calculate size of a bubble
      var square = (value - min) / (max - min) * (maxSquare - minSquare) + minSquare;
      if (square < minSquare) {
        square = minSquare;
      }
      var size = Math.sqrt(square / (Math.PI * 2));
      var id = dataItem.code;

      dataProvider.images.push({
        type: 'circle',
        width: size,
        height: size,
        color: dataItem.color,
        longitude: latlong[id].longitude,
        latitude: latlong[id].latitude,
        title: dataItem.name,
        value: value
      });
    }

    map.dataProvider = dataProvider;
    map.export = {
      enabled: true
    };

    $timeout(function() {
      map.write('map-bubbles');
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.maps')
      .controller('MapLinesPageCtrl', MapLinesPageCtrl);

  /** @ngInject */
  function MapLinesPageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    // svg path for target icon
    var targetSVG = 'M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z';
// svg path for plane icon
    var planeSVG = 'M19.671,8.11l-2.777,2.777l-3.837-0.861c0.362-0.505,0.916-1.683,0.464-2.135c-0.518-0.517-1.979,0.278-2.305,0.604l-0.913,0.913L7.614,8.804l-2.021,2.021l2.232,1.061l-0.082,0.082l1.701,1.701l0.688-0.687l3.164,1.504L9.571,18.21H6.413l-1.137,1.138l3.6,0.948l1.83,1.83l0.947,3.598l1.137-1.137V21.43l3.725-3.725l1.504,3.164l-0.687,0.687l1.702,1.701l0.081-0.081l1.062,2.231l2.02-2.02l-0.604-2.689l0.912-0.912c0.326-0.326,1.121-1.789,0.604-2.306c-0.452-0.452-1.63,0.101-2.135,0.464l-0.861-3.838l2.777-2.777c0.947-0.947,3.599-4.862,2.62-5.839C24.533,4.512,20.618,7.163,19.671,8.11z';
    $timeout(function() {
      var map = AmCharts.makeChart( 'map-lines', {
        type: 'map',
        theme: 'blur',
        dataProvider: {
          map: 'worldLow',
          linkToObject: 'london',
          images: [ {
            id: 'london',
            svgPath: targetSVG,
            title: 'London',
            latitude: 51.5002,
            longitude: -0.1262,
            scale: 1.5,
            zoomLevel: 2.74,
            zoomLongitude: -20.1341,
            zoomLatitude: 49.1712,

            lines: [ {
              latitudes: [ 51.5002, 50.4422 ],
              longitudes: [ -0.1262, 30.5367 ]
            }, {
              latitudes: [ 51.5002, 46.9480 ],
              longitudes: [ -0.1262, 7.4481 ]
            }, {
              latitudes: [ 51.5002, 59.3328 ],
              longitudes: [ -0.1262, 18.0645 ]
            }, {
              latitudes: [ 51.5002, 40.4167 ],
              longitudes: [ -0.1262, -3.7033 ]
            }, {
              latitudes: [ 51.5002, 46.0514 ],
              longitudes: [ -0.1262, 14.5060 ]
            }, {
              latitudes: [ 51.5002, 48.2116 ],
              longitudes: [ -0.1262, 17.1547 ]
            }, {
              latitudes: [ 51.5002, 44.8048 ],
              longitudes: [ -0.1262, 20.4781 ]
            }, {
              latitudes: [ 51.5002, 55.7558 ],
              longitudes: [ -0.1262, 37.6176 ]
            }, {
              latitudes: [ 51.5002, 38.7072 ],
              longitudes: [ -0.1262, -9.1355 ]
            }, {
              latitudes: [ 51.5002, 54.6896 ],
              longitudes: [ -0.1262, 25.2799 ]
            }, {
              latitudes: [ 51.5002, 64.1353 ],
              longitudes: [ -0.1262, -21.8952 ]
            }, {
              latitudes: [ 51.5002, 40.4300 ],
              longitudes: [ -0.1262, -74.0000 ]
            } ],

            images: [ {
              label: 'Flights from London',
              svgPath: planeSVG,
              left: 100,
              top: 45,
              labelShiftY: 5,
              labelShiftX: 5,
              color: layoutColors.defaultText,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 20
            }, {
              label: 'show flights from Vilnius',
              left: 106,
              top: 70,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 11,
              linkToObject: 'vilnius'
            } ]
          },

            {
              id: 'vilnius',
              svgPath: targetSVG,
              title: 'Vilnius',
              latitude: 54.6896,
              longitude: 25.2799,
              scale: 1.5,
              zoomLevel: 4.92,
              zoomLongitude: 15.4492,
              zoomLatitude: 50.2631,

              lines: [ {
                latitudes: [ 54.6896, 50.8371 ],
                longitudes: [ 25.2799, 4.3676 ]
              }, {
                latitudes: [ 54.6896, 59.9138 ],
                longitudes: [ 25.2799, 10.7387 ]
              }, {
                latitudes: [ 54.6896, 40.4167 ],
                longitudes: [ 25.2799, -3.7033 ]
              }, {
                latitudes: [ 54.6896, 50.0878 ],
                longitudes: [ 25.2799, 14.4205 ]
              }, {
                latitudes: [ 54.6896, 48.2116 ],
                longitudes: [ 25.2799, 17.1547 ]
              }, {
                latitudes: [ 54.6896, 44.8048 ],
                longitudes: [ 25.2799, 20.4781 ]
              }, {
                latitudes: [ 54.6896, 55.7558 ],
                longitudes: [ 25.2799, 37.6176 ]
              }, {
                latitudes: [ 54.6896, 37.9792 ],
                longitudes: [ 25.2799, 23.7166 ]
              }, {
                latitudes: [ 54.6896, 54.6896 ],
                longitudes: [ 25.2799, 25.2799 ]
              }, {
                latitudes: [ 54.6896, 51.5002 ],
                longitudes: [ 25.2799, -0.1262 ]
              }, {
                latitudes: [ 54.6896, 53.3441 ],
                longitudes: [ 25.2799, -6.2675 ]
              } ],

              images: [ {
                label: 'Flights from Vilnius',
                svgPath: planeSVG,
                left: 100,
                top: 45,
                labelShiftY: 5,
                labelShiftX: 5,
                color: layoutColors.defaultText,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 20
              }, {
                label: 'show flights from London',
                left: 106,
                top: 70,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 11,
                linkToObject: 'london'
              } ]
            }, {
              svgPath: targetSVG,
              title: 'Brussels',
              latitude: 50.8371,
              longitude: 4.3676
            }, {
              svgPath: targetSVG,
              title: 'Prague',
              latitude: 50.0878,
              longitude: 14.4205
            }, {
              svgPath: targetSVG,
              title: 'Athens',
              latitude: 37.9792,
              longitude: 23.7166
            }, {
              svgPath: targetSVG,
              title: 'Reykjavik',
              latitude: 64.1353,
              longitude: -21.8952
            }, {
              svgPath: targetSVG,
              title: 'Dublin',
              latitude: 53.3441,
              longitude: -6.2675
            }, {
              svgPath: targetSVG,
              title: 'Oslo',
              latitude: 59.9138,
              longitude: 10.7387
            }, {
              svgPath: targetSVG,
              title: 'Lisbon',
              latitude: 38.7072,
              longitude: -9.1355
            }, {
              svgPath: targetSVG,
              title: 'Moscow',
              latitude: 55.7558,
              longitude: 37.6176
            }, {
              svgPath: targetSVG,
              title: 'Belgrade',
              latitude: 44.8048,
              longitude: 20.4781
            }, {
              svgPath: targetSVG,
              title: 'Bratislava',
              latitude: 48.2116,
              longitude: 17.1547
            }, {
              svgPath: targetSVG,
              title: 'Ljubljana',
              latitude: 46.0514,
              longitude: 14.5060
            }, {
              svgPath: targetSVG,
              title: 'Madrid',
              latitude: 40.4167,
              longitude: -3.7033
            }, {
              svgPath: targetSVG,
              title: 'Stockholm',
              latitude: 59.3328,
              longitude: 18.0645
            }, {
              svgPath: targetSVG,
              title: 'Bern',
              latitude: 46.9480,
              longitude: 7.4481
            }, {
              svgPath: targetSVG,
              title: 'Kiev',
              latitude: 50.4422,
              longitude: 30.5367
            }, {
              svgPath: targetSVG,
              title: 'Paris',
              latitude: 48.8567,
              longitude: 2.3510
            }, {
              svgPath: targetSVG,
              title: 'New York',
              latitude: 40.43,
              longitude: -74
            }
          ]
        },

        areasSettings: {
          unlistedAreasColor: layoutColors.info
        },

        imagesSettings: {
          color: layoutColors.warningLight,
          selectedColor: layoutColors.warning
        },

        linesSettings: {
          color: layoutColors.warningLight,
          alpha: 0.8
        },


        backgroundZoomsToTop: true,
        linesAboveImages: true,

        export: {
          'enabled': true
        },
        pathToImages: layoutPaths.images.amMap
      } );
    }, 100);

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $rootScope, $http, $translate, $state) {

    $scope.init = function () {
      $scope.selectedlang = localStorage.getItem('lang');
      $scope.selectedmet = localStorage.getItem('metric');
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/recibidosnl',
          method: "GET",
          params: {
            'id_usuario':$rootScope.currentUser.id
          },
      }).success(function(data) {
          $scope.mensajes = data.mensajes;
          $scope.labelmensaje = 'recibidos';
      });
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/cuentarecibidos',
          method: "GET",
          params: {
            'id_usuario':$rootScope.currentUser.id
          },
      }).success(function(data) {
          $scope.cantidadmensajes = data.mensajes;
      });
    };

    $scope.set_lang = function(lang) {
      if( lang != localStorage.getItem('lang') ){
        localStorage.setItem('lang', lang);
        $scope.selectedlang = localStorage.getItem('lang');
        location.reload();
      }
    }

    $scope.set_metric = function(metric) {
      localStorage.setItem('metric', metric);
      $scope.selectedmet = localStorage.getItem('metric');
      $state.go('dashboard');
    }

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons')
      .controller('ButtonPageCtrl', ButtonPageCtrl);

  /** @ngInject */
  function ButtonPageCtrl($scope, $timeout) {
    $scope.progressFunction = function() {
      return $timeout(function() {}, 3000);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons')
      .controller('IconsPageCtrl', IconsPageCtrl);

  /** @ngInject */
  function IconsPageCtrl($scope) {
    $scope.icons = {
      kameleonIcons: [
        {
          name: 'Beach',
          img: 'Beach'
        },
        {
          name: 'Bus',
          img: 'Bus'
        },
        {
          name: 'Cheese',
          img: 'Cheese'
        },
        {
          name: 'Desert',
          img: 'Desert'
        },
        {
          name: 'Images',
          img: 'Images'
        },
        {
          name: 'Magician',
          img: 'Magician'
        },
        {
          name: 'Makeup',
          img: 'Makeup'
        },
        {
          name: 'Programming',
          img: 'Programming'
        },
        {
          name: 'Shop',
          img: 'Shop'
        },
        {
          name: 'Surfer',
          img: 'Surfer'
        },
        {
          name: 'Phone Booth',
          img: 'Phone-Booth'
        },
        {
          name: 'Ninja',
          img: 'Ninja'
        },
        {
          name: 'Apartment',
          img: 'Apartment'
        },
        {
          name: 'Batman',
          img: 'Batman'
        },
        {
          name: 'Medal',
          img: 'Medal-2'
        },
        {
          name: 'Money',
          img: 'Money-Increase'
        },
        {
          name: 'Street View',
          img: 'Street-View'
        },
        {
          name: 'Student',
          img: 'Student-3'
        },
        {
          name: 'Bell',
          img: 'Bell'
        },
        {
          name: 'Woman',
          img: 'Boss-5'
        },
        {
          name: 'Euro',
          img: 'Euro-Coin'
        },
        {
          name: 'Chessboard',
          img: 'Chessboard'
        },
        {
          name: 'Burglar',
          img: 'Burglar'
        },
        {
          name: 'Dna',
          img: 'Dna'
        },
        {
          name: 'Clipboard Plan',
          img: 'Clipboard-Plan'
        },
        {
          name: 'Boss',
          img: 'Boss-3'
        },
        {
          name: 'Key',
          img: 'Key'
        },
        {
          name: 'Surgeon',
          img: 'Surgeon'
        },
        {
          name: 'Hacker',
          img: 'Hacker'
        },
        {
          name: 'Santa',
          img: 'Santa'
        }
      ],
      kameleonRoundedIcons: [
        {
          color: 'success',
          img: 'Apartment',
          name: 'Apartment'
        },
        {
          color: 'warning',
          img: 'Bus',
          name: 'Bus'
        },
        {
          color: 'primary',
          img: 'Checklist',
          name: 'Checklist'
        },
        {
          color: 'warning',
          img: 'Desert',
          name: 'Desert'
        },
        {
          color: 'danger',
          img: 'Laptop-Signal',
          name: 'Laptop Signal'
        },
        {
          color: 'info',
          img: 'Love-Letter',
          name: 'Love Letter'
        },
        {
          color: 'success',
          img: 'Makeup',
          name: 'Makeup'
        },
        {
          color: 'primary',
          img: 'Santa',
          name: 'Santa'
        },
        {
          color: 'success',
          img: 'Surfer',
          name: 'Surfer'
        },
        {
          color: 'info',
          img: 'Vector',
          name: 'Vector'
        },
        {
          color: 'warning',
          img: 'Money-Increase',
          name: 'Money Increase'
        },
        {
          color: 'info',
          img: 'Alien',
          name: 'Alien'
        },
        {
          color: 'danger',
          img: 'Online-Shopping',
          name: 'Online Shopping'
        },
        {
          color: 'warning',
          img: 'Euro-Coin',
          name: 'Euro'
        },
        {
          color: 'info',
          img: 'Boss-3',
          name: 'Boss'
        }
      ],
      ionicons: ['ion-ionic', 'ion-arrow-right-b', 'ion-arrow-down-b', 'ion-arrow-left-b', 'ion-arrow-up-c', 'ion-arrow-right-c', 'ion-arrow-down-c', 'ion-arrow-left-c', 'ion-arrow-return-right', 'ion-arrow-return-left', 'ion-arrow-swap', 'ion-arrow-shrink', 'ion-arrow-expand', 'ion-arrow-move', 'ion-arrow-resize', 'ion-chevron-up', 'ion-chevron-right', 'ion-chevron-down', 'ion-chevron-left', 'ion-navicon-round', 'ion-navicon', 'ion-drag', 'ion-log-in', 'ion-log-out', 'ion-checkmark-round', 'ion-checkmark', 'ion-checkmark-circled', 'ion-close-round', 'ion-plus-round', 'ion-minus-round', 'ion-information', 'ion-help', 'ion-backspace-outline', 'ion-help-buoy', 'ion-asterisk', 'ion-alert', 'ion-alert-circled', 'ion-refresh', 'ion-loop', 'ion-shuffle', 'ion-home', 'ion-search', 'ion-flag', 'ion-star', 'ion-heart', 'ion-heart-broken', 'ion-gear-a', 'ion-gear-b', 'ion-toggle-filled', 'ion-toggle', 'ion-settings', 'ion-wrench', 'ion-hammer', 'ion-edit', 'ion-trash-a', 'ion-trash-b', 'ion-document', 'ion-document-text', 'ion-clipboard', 'ion-scissors', 'ion-funnel', 'ion-bookmark', 'ion-email', 'ion-email-unread', 'ion-folder', 'ion-filing', 'ion-archive', 'ion-reply', 'ion-reply-all', 'ion-forward'],
      fontAwesomeIcons: ['fa fa-adjust', 'fa fa-anchor', 'fa fa-archive', 'fa fa-area-chart', 'fa fa-arrows', 'fa fa-arrows-h', 'fa fa-arrows-v', 'fa fa-asterisk', 'fa fa-at', 'fa fa-automobile', 'fa fa-ban', 'fa fa-bank', 'fa fa-bar-chart', 'fa fa-bar-chart-o', 'fa fa-barcode', 'fa fa-bars', 'fa fa-bed', 'fa fa-beer', 'fa fa-bell', 'fa fa-bell-o', 'fa fa-bell-slash', 'fa fa-bell-slash-o', 'fa fa-bicycle', 'fa fa-binoculars', 'fa fa-birthday-cake', 'fa fa-bolt', 'fa fa-bomb', 'fa fa-book', 'fa fa-bookmark', 'fa fa-bookmark-o', 'fa fa-briefcase', 'fa fa-bug', 'fa fa-building', 'fa fa-building-o', 'fa fa-bullhorn'],
      socicon: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', ',', ';', ':', '+', '@', '=', '-', '^', '?', '$', '*', '&', '(', '#', '.', '_', ']', ')', '\'', '"', '}', '{']
    }
  }

})();

/**
 * @author a.demeshko
 * created on 18.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
    .controller('ModalsPageCtrl', ModalsPageCtrl);

  /** @ngInject */
  function ModalsPageCtrl($scope, $uibModal, baProgressModal) {
    $scope.open = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.openProgressDialog = baProgressModal.open;
  }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
      .controller('NotificationsPageCtrl', NotificationsPageCtrl);

  /** @ngInject */
  function NotificationsPageCtrl($scope, toastr, toastrConfig) {
    var defaultConfig = angular.copy(toastrConfig);
    $scope.types = ['success', 'error', 'info', 'warning'];

    $scope.quotes = [
      {
        title: 'Come to Freenode',
        message: 'We rock at <em>#angularjs</em>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Looking for bootstrap?',
        message: 'Try ui-bootstrap out!'
      },
      {
        title: 'Wants a better router?',
        message: 'We have you covered with ui-router'
      },
      {
        title: 'Angular 2',
        message: 'Is gonna rock the world'
      },
      {
        title: null,
        message: 'Titles are not always needed'
      },
      {
        title: null,
        message: 'Toastr rock!'
      },
      {
        title: 'What about nice html?',
        message: '<strong>Sure you <em>can!</em></strong>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Ionic is <em>cool</em>',
        message: 'Best mobile framework ever',
        options: {
          allowHtml: true
        }
      }
    ];

    var openedToasts = [];
    $scope.options = {
      autoDismiss: false,
      positionClass: 'toast-top-right',
      type: 'info',
      timeOut: '5000',
      extendedTimeOut: '2000',
      allowHtml: false,
      closeButton: false,
      tapToDismiss: true,
      progressBar: false,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
      title: "Some title here",
      msg: "Type your message here"
    };


    $scope.clearLastToast = function () {
      var toast = openedToasts.pop();
      toastr.clear(toast);
    };

    $scope.clearToasts = function () {
      toastr.clear();
    };

    $scope.openRandomToast = function () {
      var type = Math.floor(Math.random() * $scope.types.length);
      var quote = Math.floor(Math.random() * $scope.quotes.length);
      var toastType = $scope.types[type];
      var toastQuote = $scope.quotes[quote];
      openedToasts.push(toastr[toastType](toastQuote.message, toastQuote.title, toastQuote.options));
      $scope.optionsStr = "toastr." + toastType + "(\'" + toastQuote.message + "\', \'" + toastQuote.title + "', " + JSON.stringify(toastQuote.options || {}, null, 2) + ")";
    };

    $scope.openToast = function () {
      angular.extend(toastrConfig, $scope.options);
      openedToasts.push(toastr[$scope.options.type]($scope.options.msg, $scope.options.title));
      var strOptions = {};
      for (var o in  $scope.options) if (o != 'msg' && o != 'title')strOptions[o] = $scope.options[o];
      $scope.optionsStr = "toastr." + $scope.options.type + "(\'" + $scope.options.msg + "\', \'" + $scope.options.title + "\', " + JSON.stringify(strOptions, null, 2) + ")";
    };

    $scope.$on('$destroy', function iVeBeenDismissed() {
      angular.extend(toastrConfig, defaultConfig);
    })
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('AreaChartCtrl', AreaChartCtrl);

  /** @ngInject */
  function AreaChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var areaChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          lineColor: layoutColors.info,
          date: '2012-01-01',
          duration: 408
        },
        {
          date: '2012-01-02',
          duration: 482
        },
        {
          date: '2012-01-03',
          duration: 562
        },
        {
          date: '2012-01-04',
          duration: 379
        },
        {
          lineColor: layoutColors.warning,
          date: '2012-01-05',
          duration: 501
        },
        {
          date: '2012-01-06',
          duration: 443
        },
        {
          date: '2012-01-07',
          duration: 405
        },
        {
          date: '2012-01-08',
          duration: 309,
          lineColor: layoutColors.danger
        },
        {
          date: '2012-01-09',
          duration: 287
        },
        {
          date: '2012-01-10',
          duration: 485
        },
        {
          date: '2012-01-11',
          duration: 890
        },
        {
          date: '2012-01-12',
          duration: 810
        }
      ],
      balloon: {
        cornerRadius: 6,
        horizontalPadding: 15,
        verticalPadding: 10
      },
      valueAxes: [
        {
          duration: 'mm',
          durationUnits: {
            hh: 'h ',
            mm: 'min'
          },
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          bullet: 'square',
          bulletBorderAlpha: 1,
          bulletBorderThickness: 1,
          fillAlphas: 0.5,
          fillColorsField: 'lineColor',
          legendValueText: '[[value]]',
          lineColorField: 'lineColor',
          title: 'duration',
          valueField: 'duration'
        }
      ],

      chartCursor: {
        categoryBalloonDateFormat: 'YYYY MMM DD',
        cursorAlpha: 0,
        fullWidth: true
      },
      dataDateFormat: 'YYYY-MM-DD',
      categoryField: 'date',
      categoryAxis: {
        dateFormats: [
          {
            period: 'DD',
            format: 'DD'
          },
          {
            period: 'WW',
            format: 'MMM DD'
          },
          {
            period: 'MM',
            format: 'MMM'
          },
          {
            period: 'YYYY',
            format: 'YYYY'
          }
        ],
        parseDates: true,
        autoGridCount: false,
        gridCount: 50,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      pathToImages: layoutPaths.images.amChart
    });

    areaChart.addListener('dataUpdated', zoomAreaChart);

    function zoomAreaChart() {
      areaChart.zoomToDates(new Date(2012, 0, 3), new Date(2012, 0, 11));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('BarChartCtrl', BarChartCtrl);

  /** @ngInject */
  function BarChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var barChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          country: 'USA',
          visits: 3025,
          color: layoutColors.primary
        },
        {
          country: 'China',
          visits: 1882,
          color: layoutColors.danger

        },
        {
          country: 'Japan',
          visits: 1809,
          color: layoutColors.info
        },
        {
          country: 'Germany',
          visits: 1322,
          color: layoutColors.success
        },
        {
          country: 'UK',
          visits: 1122,
          color: layoutColors.warning
        },
        {
          country: 'France',
          visits: 1114,
          color: layoutColors.primaryLight
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          title: 'Visitors from country',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      startDuration: 1,
      graphs: [
        {
          balloonText: '<b>[[category]]: [[value]]</b>',
          fillColorsField: 'color',
          fillAlphas: 0.7,
          lineAlpha: 0.2,
          type: 'column',
          valueField: 'visits'
        }
      ],
      chartCursor: {
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        zoomable: false
      },
      categoryField: 'country',
      categoryAxis: {
        gridPosition: 'start',
        labelRotation: 45,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'top-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('combinedChartCtrl', combinedChartCtrl);

  /** @ngInject */
  function combinedChartCtrl($element, baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart(id, {
      "type": "serial",
      "theme": "none",
      "color": layoutColors.defaultText,
      "dataDateFormat": "YYYY-MM-DD",
      "precision": 2,
      "valueAxes": [{
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v1",
        "title": "Sales",
        "position": "left",
        "autoGridCount": false,
        "labelFunction": function(value) {
          return "$" + Math.round(value) + "M";
        }
      }, {
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v2",
        "title": "Market Days",
        "gridAlpha": 0,
        "position": "right",
        "autoGridCount": false
      }],
      "graphs": [{
        "id": "g3",
        color: layoutColors.defaultText,
        "valueAxis": "v1",
        "lineColor": layoutColors.primaryLight,
        "fillColors": layoutColors.primaryLight,
        "fillAlphas": 0.8,
        "lineAlpha": 0.8,
        "type": "column",
        "title": "Actual Sales",
        "valueField": "sales2",
        "clustered": false,
        "columnWidth": 0.5,
        "lineColorField" : layoutColors.defaultText,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g4",
        "valueAxis": "v1",
        color: layoutColors.defaultText,
        "lineColor": layoutColors.primary,
        "fillColors": layoutColors.primary,
        "fillAlphas": 0.9,
        "lineAlpha": 0.9,
        "type": "column",
        "title": "Target Sales",
        "valueField": "sales1",
        "clustered": false,
        "columnWidth": 0.3,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g1",
        "valueAxis": "v2",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        color: layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.danger,
        "type": "smoothedLine",
        "title": "Market Days",
        "useLineColorForBulletBorder": true,
        "valueField": "market1",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }, {
        "id": "g2",
        "valueAxis": "v2",
        color: layoutColors.defaultText,
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.warning,
        "type": "smoothedLine",
        "dashLength": 5,
        "title": "Market Days ALL",
        "useLineColorForBulletBorder": true,
        "valueField": "market2",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }],
      "chartScrollbar": {
        "graph": "g1",
        "oppositeAxis": false,
        "offset": 30,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 50,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      "chartCursor": {
        "pan": true,
        "cursorColor" : layoutColors.danger,
        "valueLineEnabled": true,
        "valueLineBalloonEnabled": true,
        "cursorAlpha": 0,
        "valueLineAlpha": 0.2
      },
      "categoryField": "date",
      "categoryAxis": {
        "axisColor": layoutColors.defaultText,
        "color": layoutColors.defaultText,
        "gridColor": layoutColors.defaultText,
        "parseDates": true,
        "dashLength": 1,
        "minorGridEnabled": true
      },
      "legend": {
        "useGraphSettings": true,
        "position": "top",
        "color": layoutColors.defaultText
      },
      "balloon": {
        "borderThickness": 1,
        "shadowAlpha": 0
      },
      "export": {
        "enabled": true
      },
      "dataProvider": [{
        "date": "2013-01-16",
        "market1": 71,
        "market2": 75,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-17",
        "market1": 74,
        "market2": 78,
        "sales1": 4,
        "sales2": 6
      }, {
        "date": "2013-01-18",
        "market1": 78,
        "market2": 88,
        "sales1": 5,
        "sales2": 2
      }, {
        "date": "2013-01-19",
        "market1": 85,
        "market2": 89,
        "sales1": 8,
        "sales2": 9
      }, {
        "date": "2013-01-20",
        "market1": 82,
        "market2": 89,
        "sales1": 9,
        "sales2": 6
      }, {
        "date": "2013-01-21",
        "market1": 83,
        "market2": 85,
        "sales1": 3,
        "sales2": 5
      }, {
        "date": "2013-01-22",
        "market1": 88,
        "market2": 92,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-23",
        "market1": 85,
        "market2": 90,
        "sales1": 7,
        "sales2": 6
      }, {
        "date": "2013-01-24",
        "market1": 85,
        "market2": 91,
        "sales1": 9,
        "sales2": 5
      }, {
        "date": "2013-01-25",
        "market1": 80,
        "market2": 84,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-26",
        "market1": 87,
        "market2": 92,
        "sales1": 4,
        "sales2": 8
      }, {
        "date": "2013-01-27",
        "market1": 84,
        "market2": 87,
        "sales1": 3,
        "sales2": 4
      }, {
        "date": "2013-01-28",
        "market1": 83,
        "market2": 88,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-29",
        "market1": 84,
        "market2": 87,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-30",
        "market1": 81,
        "market2": 85,
        "sales1": 4,
        "sales2": 7
      }],
      pathToImages: layoutPaths.images.amChart
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('FunnelChartCtrl', FunnelChartCtrl);

  /** @ngInject */
  function FunnelChartCtrl($scope, $element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var funnelChart = AmCharts.makeChart(id, {
      type: 'funnel',
      theme: 'blur',
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      dataProvider: [
        {
          title: 'Website visits',
          value: 300
        },
        {
          title: 'Downloads',
          value: 123
        },
        {
          title: 'Requested prices',
          value: 98
        },
        {
          title: 'Contaced',
          value: 72
        },
        {
          title: 'Purchased',
          value: 35
        },
        {
          title: 'Asked for support',
          value: 25
        },
        {
          title: 'Purchased more',
          value: 18
        }
      ],
      titleField: 'title',
      marginRight: 160,
      marginLeft: 15,
      labelPosition: 'right',
      funnelAlpha: 0.9,
      valueField: 'value',
      startX: 0,
      alpha: 0.8,
      neckWidth: '0%',
      startAlpha: 0,
      outlineThickness: 1,
      neckHeight: '0%',
      balloonText: '[[title]]:<b>[[value]]</b>',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',
      pathToImages: layoutPaths
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('ganttChartCtrl', ganttChartCtrl);

  /** @ngInject */
  function ganttChartCtrl($element) {
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart( id, {
      "type": "gantt",
      "theme": "light",
      "marginRight": 70,
      "period": "hh",
      "dataDateFormat":"YYYY-MM-DD",
      "balloonDateFormat": "JJ:NN",
      "columnWidth": 0.5,
      "valueAxis": {
        "type": "date",
        "minimum": 7,
        "maximum": 31
      },
      "brightnessStep": 10,
      "graph": {
        "fillAlphas": 1,
        "balloonText": "<b>[[task]]</b>: [[open]] [[value]]"
      },
      "rotate": true,
      "categoryField": "category",
      "segmentsField": "segments",
      "colorField": "color",
      "startDate": "2015-01-01",
      "startField": "start",
      "endField": "end",
      "durationField": "duration",
      "dataProvider": [
        {
        "category": "John",
        "segments": [ {
          "start": 7,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Smith",
        "segments": [ {
          "start": 10,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Ben",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Mike",
        "segments": [ {
          "start": 9,
          "duration": 6,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 4,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Lenny",
        "segments": [ {
          "start": 8,
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Scott",
        "segments": [ {
          "start": 15,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Julia",
        "segments": [ {
          "start": 9,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 1,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 8,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Bob",
        "segments": [ {
          "start": 9,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 7,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kendra",
        "segments": [ {
          "start": 11,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Tom",
        "segments": [ {
          "start": 9,
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 5,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kyle",
        "segments": [ {
          "start": 6,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Anita",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Jack",
        "segments": [ {
          "start": 8,
          "duration": 10,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Kim",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 3,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Aaron",
        "segments": [ {
          "start": 18,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Alan",
        "segments": [ {
          "start": 17,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Ruth",
        "segments": [ {
          "start": 13,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Simon",
        "segments": [ {
          "start": 10,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 17,
          "duration": 4,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      } ],
      "valueScrollbar": {
        "autoGridCount":true
      },
      "chartCursor": {
        "cursorColor":"#55bb76",
        "valueBalloonsEnabled": false,
        "cursorAlpha": 0,
        "valueLineAlpha":0.5,
        "valueLineBalloonEnabled": true,
        "valueLineEnabled": true,
        "zoomable":false,
        "valueZoomable":true
      },
      "export": {
        "enabled": true
      }
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('LineChartCtrl', LineChartCtrl);

  /** @ngInject */
  function LineChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var lineChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      marginTop: 0,
      marginRight: 15,
      dataProvider: [
        {
          year: '1990',
          value: -0.17
        },
        {
          year: '1991',
          value: -0.254
        },
        {
          year: '1992',
          value: 0.019
        },
        {
          year: '1993',
          value: -0.063
        },
        {
          year: '1994',
          value: 0.005
        },
        {
          year: '1995',
          value: 0.077
        },
        {
          year: '1996',
          value: 0.12
        },
        {
          year: '1997',
          value: 0.011
        },
        {
          year: '1998',
          value: 0.177
        },
        {
          year: '1999',
          value: -0.021
        },
        {
          year: '2000',
          value: -0.037
        },
        {
          year: '2001',
          value: 0.03
        },
        {
          year: '2002',
          value: 0.179
        },
        {
          year: '2003',
          value: 0.2
        },
        {
          year: '2004',
          value: 0.180
        },
        {
          year: '2005',
          value: 0.21
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          id: 'g1',
          balloonText: '[[value]]',
          bullet: 'round',
          bulletSize: 8,
          lineColor: layoutColors.danger,
          lineThickness: 1,
          negativeLineColor: layoutColors.warning,
          type: 'smoothedLine',
          valueField: 'value'
        }
      ],
      chartScrollbar: {
        graph: 'g1',
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 55,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      chartCursor: {
        categoryBalloonDateFormat: 'YYYY',
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5,
        fullWidth: true
      },
      dataDateFormat: 'YYYY',
      categoryField: 'year',
      categoryAxis: {
        minPeriod: 'YYYY',
        parseDates: true,
        minorGridAlpha: 0.1,
        minorGridEnabled: true,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });

    lineChart.addListener('rendered', zoomChart);
    if (lineChart.zoomChart) {
      lineChart.zoomChart();
    }

    function zoomChart() {
      lineChart.zoomToIndexes(Math.round(lineChart.dataProvider.length * 0.4), Math.round(lineChart.dataProvider.length * 0.55));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('PieChartCtrl', PieChartCtrl);

  /** @ngInject */
  function PieChartCtrl($element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var pieChart = AmCharts.makeChart(id, {
      type: 'pie',
      startDuration: 0,
      theme: 'blur',
      addClassNames: true,
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      legend: {
        position: 'right',
        marginRight: 100,
        autoMargins: false,
      },
      innerRadius: '40%',
      defs: {
        filter: [
          {
            id: 'shadow',
            width: '200%',
            height: '200%',
            feOffset: {
              result: 'offOut',
              in: 'SourceAlpha',
              dx: 0,
              dy: 0
            },
            feGaussianBlur: {
              result: 'blurOut',
              in: 'offOut',
              stdDeviation: 5
            },
            feBlend: {
              in: 'SourceGraphic',
              in2: 'blurOut',
              mode: 'normal'
            }
          }
        ]
      },
      dataProvider: [
        {
          country: 'Lithuania',
          litres: 501.9
        },
        {
          country: 'Czech Republic',
          litres: 301.9
        },
        {
          country: 'Ireland',
          litres: 201.1
        },
        {
          country: 'Germany',
          litres: 165.8
        },
        {
          country: 'Australia',
          litres: 139.9
        },
        {
          country: 'Austria',
          litres: 128.3
        },
        {
          country: 'UK',
          litres: 99
        },
        {
          country: 'Belgium',
          litres: 60
        }
      ],
      valueField: 'litres',
      titleField: 'country',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',

      autoMargins: false,
      marginTop: 10,
      alpha: 0.8,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      pullOutRadius: 0,
      pathToImages: layoutPaths.images.amChart,
      responsive: {
        enabled: true,
        rules: [
          // at 900px wide, we hide legend
          {
            maxWidth: 900,
            overrides: {
              legend: {
                enabled: false
              }
            }
          },

          // at 200 px we hide value axis labels altogether
          {
            maxWidth: 200,
            overrides: {
              valueAxes: {
                labelsEnabled: false
              },
              marginTop: 30,
              marginBottom: 30,
              marginLeft: 30,
              marginRight: 30
            }
          }
        ]
      }
    });

    pieChart.addListener('init', handleInit);

    pieChart.addListener('rollOverSlice', function (e) {
      handleRollOver(e);
    });

    function handleInit() {
      pieChart.legend.addListener('rollOverItem', handleRollOver);
    }

    function handleRollOver(e) {
      var wedge = e.dataItem.wedge.node;
      wedge.parentNode.appendChild(wedge);
    }
  }

})();

/**
 * @author a.demeshko
 * created on 24/12/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.mail')
    .controller('composeBoxCtrl', composeBoxCtrl);

  /** @ngInject */
  function composeBoxCtrl($scope, $state, subject, to, id_usuario, id_conversacion, text, $http, $rootScope,$uibModalStack,mailMessages) {
    var vm = this;
    vm.subject = subject;
    vm.to = to;
    vm.id_usuario = id_usuario;
    vm.id_conversacion = id_conversacion;
    vm.text = text;
    $scope.enviar = function (form){
      if(form.subject || form.text){
        $http({
            url: 'http://apiintplus.rfit.cl/api/web/enviarmensaje',
            method: "POST",
            params: {
              'id_usuario_remitente':$rootScope.currentUser.id,
              'id_usuario_receptor':form.id_usuario,
              'id_conversacion':form.id_conversacion,
              'titulo':form.subject,
              'mensaje':form.text,
            },
        }).success(function(data) {
          mailMessages.updateenviados();
          $uibModalStack.dismissAll();
          if($state.current.name != 'dashboard'){
            $state.go('mail.label', { 'label':'recibidos' });
          }
        });
      }
      else if(!form.subject && !form.text){
        $scope.malos = "rojoalerta";
        $scope.maloso = "rojoalerta";
      }
      else if(!form.text){
        $scope.maloso = "rojoalerta";
      }
      else if(!form.subject){
        $scope.malos = "rojoalerta";
      }
    }
  }
})();
/**
 * @author a.demeshko
 * created on 12/24/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.mail')
    .service('composeModal', composeModal);

  /** @ngInject */
  function composeModal($uibModal) {
      this.open = function(options){
        return $uibModal.open({
          animation: false,
          templateUrl: 'app/pages/components/mail/composeBox/compose.html',
          controller: 'composeBoxCtrl',
          controllerAs: 'boxCtrl',
          size: 'compose',
          resolve: {
            subject: function () {
              return options.subject;
            },
            to: function () {
              return options.to;
            },
            id_usuario: function () {
              return options.id_usuario;
            },
            id_conversacion: function () {
              return options.id_conversacion;
            },
            text: function () {
              return options.text;
            }
          }
        });
      }

  }

})();
/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.mail')
    .controller('MailDetailCtrl', MailDetailCtrl);

  /** @ngInject */
  function MailDetailCtrl($scope, $state, $rootScope, $stateParams, mailMessages, $http) {
    var vm = this;
    vm.label = $stateParams.label;
    if(vm.label =='recibidos'){vm.mail = mailMessages.getMessageById($stateParams.id);}
    else if(vm.label == 'enviados'){vm.mail = mailMessages.getMessageByIdd($stateParams.id);$scope.oculta = true;}
    if(vm.mail.estado == 'No Leído' && vm.label =='recibidos'){
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/cambiaestado',
          method: "POST",
          params: {
            'id_mensaje':vm.mail.id,
            'estado':'Leído'
          },
      }).success(function(data) {
      });
    }

    $scope.borrar = function(id){
      $http({
          url: 'http://apiintplus.rfit.cl/api/web/borrarmensaje',
          method: "POST",
          params: {
            'id':id
          },
      }).success(function(data) {
          $state.go('mail.label', { 'label':'recibidos' });
      });
    }

  }

})();

/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.mail')
    .controller('MailListCtrl', MailListCtrl);

  /** @ngInject */
  function MailListCtrl($scope, $stateParams,  mailMessages, $timeout, $http, $rootScope) {
    var vm = this;
    vm.label = $stateParams.label;
    $scope.init = function () {
    	$scope.loading = true;
    	$scope.bool = true;
	    if(vm.label == "recibidos"){
	    	var url = 'http://apiintplus.rfit.cl/api/web/listarecibidos';
	    }
	    else if(vm.label == "enviados"){
	    	var url = 'http://apiintplus.rfit.cl/api/web/listarenviados';
	    }
	    $http({
	        url: url,
	        method: "GET",
	        params: {
	          'id_usuario':$rootScope.currentUser.id
	        },
	    }).success(function(data) {
	        vm.messages = data.mensajes;
		    if(vm.label == "recibidos"){
		    	mailMessages.updaterecibidos(data.mensajes);
		    }
            $scope.loading = false;
            if(data.mensajes.length == 0){
            	$scope.bool = false;
        	}
	    });
		$http({
		  url: 'http://apiintplus.rfit.cl/api/web/cuentarecibidos',
		  method: "GET",
		  params: {
		    'id_usuario':$rootScope.currentUser.id
		  },
		}).success(function(data) {
	    	$scope.cantidadmensajes = data.mensajes;
		});
	}
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Your information has been saved successfully!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("You've got a new email!", 'Information');
    };

    $scope.showErrorMsg = function() {
      toastr.error("Your information hasn't been saved!", 'Error');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

/**
 * Created by n.poltoratsky
 * on 24.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.ui.modals')
        .controller('ProgressModalCtrl', ProgressModalCtrl);

    function ProgressModalCtrl($timeout, baProgressModal) {

        baProgressModal.setProgress(0);

        (function changeValue() {
            if (baProgressModal.getProgress() >= 100) {
                baProgressModal.close();
            } else {
                baProgressModal.setProgress(baProgressModal.getProgress() + 10);
                $timeout(changeValue, 300);
            }
        })();
    }

})();

/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerCtrl', datepickerCtrl);

    /** @ngInject */
    function datepickerCtrl($scope) {

        $scope.dt = new Date();
        $scope.options = {
            showWeeks: false
        };

    }
})();
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerpopupCtrl', datepickerpopupCtrl);

    /** @ngInject */
    function datepickerpopupCtrl($scope) {

        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
})();
/**
 * @author v.lugovsky
 * created on 22.04.2016
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSelectpickerPanelCtrl', OldSelectpickerPanelCtrl);

  /** @ngInject */
  function OldSelectpickerPanelCtrl() {
    var vm = this;

    vm.standardSelectItems = [
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
      { label: 'Option 4', value: 4 },
    ];

    vm.selectWithSearchItems = [
      { label: 'Hot Dog, Fries and a Soda', value: 1 },
      { label: 'Burger, Shake and a Smile', value: 2 },
      { label: 'Sugar, Spice and all things nice', value: 3 },
      { label: 'Baby Back Ribs', value: 4 },
    ];

    vm.groupedSelectItems = [
      { label: 'Group 1 - Option 1', value: 1, group: 'Group 1' },
      { label: 'Group 2 - Option 2', value: 2, group: 'Group 2' },
      { label: 'Group 1 - Option 3', value: 3, group: 'Group 1' },
      { label: 'Group 2 - Option 4', value: 4, group: 'Group 2' },
    ];

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        pre: function(scope, elem, attrs) {
          elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
        },
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel, refresh);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refresh);
          }

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
/**
 * @author v.lugovsky
 * created on 07.06.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSwitchPanelCtrl', OldSwitchPanelCtrl);

  /** @ngInject */
  function OldSwitchPanelCtrl() {
    var vm = this;

    vm.switcherValues = {
      primary: true,
      warning: true,
      danger: true,
      info: true,
      success: true
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 *
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('switch', switchDirective);

  /** @ngInject */
  function switchDirective($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        ngModel: '='
      },
      template: function(el, attrs) {
        return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
      },
      link: function (scope, elem, attr) {
        var input = $(elem).find('input');
        input.bootstrapSwitch({
          size: 'small',
          onColor: attr.color
        });
        input.on('switchChange.bootstrapSwitch', function(event, state) {
          scope.ngModel = state;
          scope.$apply();
        });

      }
    };
  }
})();

/**
 * @author p.maslava
 * created on 28.11.2016
 */

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .filter('groupSelectpickerOptions', GroupSelectpickerOptions);

  /** @ngInject */
  function GroupSelectpickerOptions() {
    return function (items, props) {
      var out = [];

      if (angular.isArray(items)) {
        var keys = Object.keys(props);

        items.forEach(function (item) {
          var itemMatches = false;

          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

      return out;
    };
  }
})();
/**
 * @author p.maslava
 * created on 28.11.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .controller('SelectpickerPanelCtrl', SelectpickerPanelCtrl);

  /** @ngInject */
  function SelectpickerPanelCtrl() {

    var vm = this;
    vm.disabled = undefined;


    vm.standardItem = {};
    vm.standardSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4}
    ];

    vm.withSearchItem = {};

    vm.selectWithSearchItems = [
      {label: 'Hot Dog, Fries and a Soda', value: 1},
      {label: 'Burger, Shake and a Smile', value: 2},
      {label: 'Sugar, Spice and all things nice', value: 3},
      {label: 'Baby Back Ribs', value: 4}
    ];
    vm.groupedItem = {};
    vm.groupedSelectItems = [
      {label: 'Group 1 - Option 1', value: 1, group: 'Group 1'},
      {label: 'Group 2 - Option 2', value: 2, group: 'Group 2'},
      {label: 'Group 1 - Option 3', value: 3, group: 'Group 1'},
      {label: 'Group 2 - Option 4', value: 4, group: 'Group 2'}
    ];

    vm.groupedByItem = {};
    vm.groupedBySelectItems = [
      {name: 'Adam', country: 'United States'},
      {name: 'Amalie', country: 'Argentina'},
      {name: 'Estefanía', country: 'Argentina'},
      {name: 'Adrian', country: 'Ecuador'},
      {name: 'Wladimir', country: 'Ecuador'},
      {name: 'Samantha', country: 'United States'},
      {name: 'Nicole', country: 'Colombia'},
      {name: 'Natasha', country: 'Ecuador'},
      {name: 'Michael', country: 'Colombia'},
      {name: 'Nicolás', country: 'Colombia'}
    ];
    vm.someGroupFn = function (item) {

      if (item.name[0] >= 'A' && item.name[0] <= 'M')
        return 'From A - M';
      if (item.name[0] >= 'N' && item.name[0] <= 'Z')
        return 'From N - Z';
    };

    vm.disableItem = {};
    vm.disableItems = [];

    vm.multipleItem = {};
    vm.multipleSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];
    vm.withDeleteItem = {};
    vm.withDeleteSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];

  }
})();



/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('SwitchDemoPanelCtrl', SwitchDemoPanelCtrl);

  /** @ngInject */
  function SwitchDemoPanelCtrl() {
    var vm = this;
    vm.switches = {
      s1: true,
      s2: false,
      s3: true,
      s4: true,
      s5: false
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('tagInput', tagInput);

  /** @ngInject */
  function tagInput() {
    return {
      restrict: 'A',
      link: function( $scope, elem, attr) {
        $(elem).tagsinput({
          tagClass:  'label label-' + attr.tagInput
        });
      }
    };
  }
})();
angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/confirmapago/confirmapago.html','<div ba-panel="" ba-panel-class="creditos-page heading-widget" ba-panel-title="Confirmaci\xF3n Pago" data-ng-init="init()"><div ba-panel="" ba-panel-title="Estado del Pago: <b>{{datospago.estado}}</b>" ba-panel-class="xsmall-panel light-text paneles panel-{{datospago.colorpanel}} text-center panel-confirmapago"><div class="form-group"><b>N\xFAmero Orden:</b> {{datospago.id}}</div><div class="form-group"><b>Forma de Pago:</b> {{datospago.forma_pago}}</div><div class="form-group"><b>Cr\xE9ditos Comprados:</b> {{datospago.creditos}}</div><div class="form-group"><b>Monto Compra:</b> {{datospago.monto | currency:CLP:0}}</div><div class="form-group"><b>Estado del Pago:</b> {{datospago.estado}}</div><div class="form-group"><b>Fecha de Transacci\xF3n:</b> {{datospago.created_at | asDate | date:\'dd-MM-yyyy\'}} a las {{datospago.created_at | asDate | date:\'H:mm:s\'}}</div><div class="form-group"><div class="cargando"><i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i><br>En 5 segundos ser\xE1 redirigido a la secci\xF3n de administraci\xF3n de cr\xE9ditos</div></div></div></div>');
$templateCache.put('app/pages/creditos/creditos.html','<div ba-panel="" ba-panel-class="creditos-page heading-widget" ba-panel-title="{{\'Administraci\xF3n de Cr\xE9ditos\'|translate}}" data-ng-init="init()"><div class="row"><div class="col-sm-6"><div ba-panel="" ba-panel-title="{{\'Cr\xE9ditos Disponibles\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success text-center"><div class="form-group"><b>{{\'Cr\xE9ditos Disponibles en la cuenta\'|translate}}:</b> <span class="dato max-text">{{usercreditos}}</span></div><div class="row" ng-if="false"><div class="col-sm-5"><div class="form-group"><label for="inputcompracreditos">\xBFCuantos cr\xE9ditos desea agregar?</label> <input type="number" class="form-control" id="inputcompracredito" placeholder="Cantidad Cr\xE9ditos (Min\xEDmo 1)" ng-model="compra.credito" name="compracredito" ng-min="1" ng-pattern="onlyNumbers"> <button type="button" class="btn btn-success btn-with-icon crea-orden" ng-click="compracreditos(compra.credito)" ng-disabled="!compra.credito"><i class="ion-plus"></i>Crear Orden de Compra</button></div></div><div class="col-sm-7"><div ng-show="cargacompra" class="cargando"><i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i><br>Espera mientras creamos tu orden</div><div ba-panel="" ba-panel-title="Orden Creada" ba-panel-class="xsmall-panel light-text paneles panel-success text-center" ng-show="orden.flow_pack && !cargacompra"><div class="form-group"><b>N\xFAmero Orden:</b> {{orden.orden_compra}}</div><div class="form-group"><b>Cr\xE9ditos:</b> {{compra.credito}}</div><div class="form-group"><b>Monto:</b> {{orden.monto | currency:CLP:0}}</div><form method="POST" action="https://www.flow.cl/app/kpf/pago.php" accept-charset="UTF-8"><input type="hidden" name="parameters" value="{{ orden.flow_pack }}"> <button type="submit" class="btn btn-success btn-with-icon"><i class="ion-plus"></i>Pagar</button></form></div></div></div></div></div><div class="col-sm-6"><div ba-panel="" ba-panel-title="{{\'Administrar Cr\xE9ditos\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="row"><div class="col-sm-12 text-center"><h5 class="bold" translate="">Aqu\xED puedes asignar o quitar cr\xE9ditos a los usuarios que has registrado en tu red</h5><button type="button" class="btn btn-success btn-with-icon" ng-click="creditosfunct(\'suma\')"><i class="ion-plus"></i>{{\'Agregar Cr\xE9ditos\'|translate}}</button> <button type="button" class="btn btn-danger btn-with-icon" ng-click="creditosfunct(\'resta\')"><i class="ion-minus"></i>{{\'Quitar Cr\xE9ditos\'|translate}}</button><div class="alert bg-{{messagedata.type}}" ng-show="messagedata.message">{{messagedata.message|translate}}<p class="mensaje-errores" ng-repeat="error in messagedata.errors.error.message" ng-show="messagedata.errors">{{error|translate}}</p></div><div ba-panel="" ba-panel-title="{{titulopanel|translate}} {{\'Cr\xE9ditos\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-{{color}} text-white panel-cambiacreditos" ng-show="muestrapanel"><div class="panel-asigna"><label for="inputusuario">{{\'Usuario\'|translate}}</label><ui-select ng-model="formulario.id_usuario" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="false" name="usuario"><ui-select-match placeholder="{{\'Seleccione usuario\'|translate}}"><span>{{$select.selected.nombre}} {{$select.selected.apellido}}</span></ui-select-match><ui-select-choices repeat="usuario.id_usuario as usuario in datos | filter: $select.search"><span ng-bind-html="usuario.nombre"></span> <span ng-bind-html="usuario.apellido"></span></ui-select-choices></ui-select><div class="form-group creditos"><label for="inputcreditos">{{\'\xBFCuantos cr\xE9ditos desea\'|translate}} <span class="text-lowercase">{{titulopanel|translate}}</span>?</label> <input type="number" class="form-control" id="inputcreditos" placeholder="{{\'Ingrese Cr\xE9ditos\'|translate}}" ng-model="formulario.creditos" name="creditos"></div><button type="button" class="btn btn-{{color}} btn-with-icon" ng-click="cambiacreditos(formulario)" ng-disabled="!formulario.creditos || !formulario.id_usuario"><i class="ion-{{iconocreditos}}"></i>{{titulopanel|translate}} {{\'Cr\xE9ditos\'|translate}}</button></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboard - copia.html','<div class="row" data-ng-init="init()"><div class="col-lg-3 col-md-6 col-sm-6" ng-show="!(currentUser.type == 2)"><div ba-panel=""><div class="description paneles-inicio"><div class="row"><div class="col-lg-4 icono"><i class="icono-inicio-info ion-android-star"></i></div><div class="col-lg-8"><div class="title-stats">Mis Cr\xE9ditos</div><div class="description-stats">{{infonicio.data.creditos}}</div><button type="button" class="btn btn-primary btn-xs" ui-sref="creditos">Administrar Cr\xE9ditos</button></div></div></div></div></div><div class="col-lg-3 col-md-6 col-sm-6" ng-show="!(currentUser.type == 2)"><div ba-panel=""><div class="description paneles-inicio"><div class="row"><div class="col-lg-4 icono"><i class="icono-inicio-info ion-person"></i></div><div class="col-lg-8"><div class="title-stats">Mis Clientes</div><div class="description-stats">{{infonicio.data.evaluados}}</div><button type="button" class="btn btn-primary btn-xs" ui-sref="clientes">Ir a Clientes</button></div></div></div></div></div><div class="col-lg-3 col-md-6 col-sm-6"><div ba-panel=""><div class="description paneles-inicio"><div class="row"><div class="col-lg-4 icono"><i class="icono-inicio-info ion-clipboard"></i></div><div class="col-lg-8"><div class="title-stats">Mis Evaluaciones</div><div class="description-stats">{{infonicio.data.evaluaciones}}</div><button type="button" class="btn btn-primary btn-xs" ui-sref="evaluaciones">Ir a Evaluaciones</button></div></div></div></div></div><div class="col-lg-3 col-md-6 col-sm-6" ng-show="currentUser.type == 0 || currentUser.type == 999"><div ba-panel=""><div class="description paneles-inicio"><div class="row"><div class="col-lg-4 icono"><i class="icono-inicio-info ion-person-stalker"></i></div><div class="col-lg-8"><div class="title-stats">Mi Red</div><div class="description-stats">{{infonicio.data.evaluadores}}</div><button type="button" class="btn btn-primary btn-xs" ui-sref="mired">Ir a Mi Red</button></div></div></div></div></div></div><div class="row"><div class="col-sm-12" ng-show="currentUser.type == 2"><div ba-panel="" ba-panel-title="Busca tu profesional" ba-panel-class="xsmall-panel light-text paneles panel-primary text-center"><div class="row"><div class="col-sm-3"><div class="form-group"><label for="inputespecialidad">\xBFQue tipo de profesional necesitas?</label><ui-select ng-model="formulario.especialidad" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="false" name="especialidad" required="" ng-change="sacaregiones(formulario.especialidad)"><ui-select-match placeholder="Seleccione la Especialidad"><span>{{$select.selected.especialidad}}</span></ui-select-match><ui-select-choices repeat="especialidad as especialidad in especialidades | filter: $select.search"><span ng-bind-html="especialidad.especialidad"></span></ui-select-choices></ui-select></div></div><div class="col-sm-3"><div class="form-group"><label for="inputregion">\xBFEn que regi\xF3n?</label><ui-select ng-model="formulario.region" class="btn-group bootstrap-select form-control select-index" ng-disabled="!regiones" append-to-body="true" search-enabled="false" name="region" required="" ng-change="sacacomunas(formulario.region,formulario.especialidad)"><ui-select-match placeholder="Seleccione la Regi\xF3n"><span>{{$select.selected.region}}</span></ui-select-match><ui-select-choices repeat="region as region in regiones | filter: $select.search"><span ng-bind-html="region.region"></span></ui-select-choices></ui-select></div></div><div class="col-sm-3"><div class="form-group"><label for="inputcomuna">\xBFEn que comuna?</label><ui-select ng-model="formulario.comuna" class="btn-group bootstrap-select form-control select-index" ng-disabled="!comunas" append-to-body="true" search-enabled="false" name="comuna" required=""><ui-select-match placeholder="Seleccione la Comuna"><span>{{$select.selected.comuna}}</span></ui-select-match><ui-select-choices repeat="comuna as comuna in comunas | filter: $select.search"><span ng-bind-html="comuna.comuna"></span></ui-select-choices></ui-select></div></div><div class="col-sm-3"><button type="button" class="btn btn-success btn-with-icon crea-orden" ng-disabled="!formulario.comuna" ng-click="buscar(formulario)"><i class="ion-search"></i>B\xFAsqueda</button><br><button type="button" class="btn btn-danger btn-with-icon crea-orden btn-xs" ng-click="limpiar()"><i class="ion-backspace"></i>Limpiar</button></div></div><div class="row"><div class="col-sm-12"><div ng-show="loading"><div class="table-empty cargando"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></div></div><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="xsmall-panel light-text paneles panel-success text-center" ng-show="busqueda && !loading"><div class="horizontal-scroll"><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="nombre">Nombre</th><th st-sort="especialidad">Especialidad</th><th st-sort="telefono">Tel\xE9fono</th><th st-sort="direccion">Direcci\xF3n</th><th st-sort="email">Email</th></tr></thead><tbody><tr ng-repeat="item in busqueda"><td><img ng-src="http://apiintplus.rfit.cl/assets/img/perfiles/{{item.img_url}}" width="20" height="20"></td><td>{{item.nombre}} {{item.apellido}}</td><td>{{item.especialidad}}</td><td>{{item.telefono}}</td><td>{{item.direccion}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div class="form-group select-page-size-wrap"><label>Filas por p\xE1gina<select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<div class="row" data-ng-init="init()"><div class="col-lg-3 col-md-6 col-sm-6" ng-show="!(currentUser.type == 2)"><div ba-panel=""><div class="description paneles-inicio"><div class="row"><div class="col-lg-4 icono"><i class="icono-inicio-info ion-android-star"></i></div><div class="col-lg-8"><div class="title-stats" translate="">Mis Cr\xE9ditos</div><div class="description-stats">{{infonicio.data.creditos}}</div><button type="button" class="btn btn-primary btn-xs" ui-sref="creditos" translate="">Administrar Cr\xE9ditos</button></div></div></div></div></div><div class="col-lg-3 col-md-6 col-sm-6" ng-show="!(currentUser.type == 2)"><div ba-panel=""><div class="description paneles-inicio"><div class="row"><div class="col-lg-4 icono"><i class="icono-inicio-info ion-person"></i></div><div class="col-lg-8"><div class="title-stats" translate="">Mis Clientes</div><div class="description-stats">{{infonicio.data.evaluados}}</div><button type="button" class="btn btn-primary btn-xs" ui-sref="clientes" translate="">Ir a Clientes</button></div></div></div></div></div><div class="col-lg-3 col-md-6 col-sm-6"><div ba-panel=""><div class="description paneles-inicio"><div class="row"><div class="col-lg-4 icono"><i class="icono-inicio-info ion-clipboard"></i></div><div class="col-lg-8"><div class="title-stats" translate="">Mis Evaluaciones</div><div class="description-stats">{{infonicio.data.evaluaciones}}</div><button type="button" class="btn btn-primary btn-xs" ui-sref="evaluaciones" translate="">Ir a Evaluaciones</button></div></div></div></div></div><div class="col-lg-3 col-md-6 col-sm-6" ng-show="currentUser.type == 0 || currentUser.type == 999"><div ba-panel=""><div class="description paneles-inicio"><div class="row"><div class="col-lg-4 icono"><i class="icono-inicio-info ion-person-stalker"></i></div><div class="col-lg-8"><div class="title-stats" translate="">Mi Red</div><div class="description-stats">{{infonicio.data.evaluadores}}</div><button type="button" class="btn btn-primary btn-xs" ui-sref="mired" translate="">Ir a Mi Red</button></div></div></div></div></div></div><div class="row"><div class="col-sm-12" ng-show="currentUser.type == 2"><div ba-panel="" ba-panel-title="{{ \'Busca tu profesional\' | translate }}" ba-panel-class="xsmall-panel light-text paneles panel-primary text-center"><div class="row"><div class="col-sm-3"><div class="form-group"><label for="inputregion">\xBFEn que regi\xF3n?</label><ui-select ng-model="formulario.region" class="btn-group bootstrap-select form-control select-index" ng-disabled="!regiones" append-to-body="true" search-enabled="false" name="region" required="" ng-change="sacacomunas(formulario.region)"><ui-select-match placeholder="Seleccione la Regi\xF3n"><span>{{$select.selected.region_nombre}}</span></ui-select-match><ui-select-choices repeat="region in regiones | filter: $select.search"><span ng-bind-html="region.region_nombre"></span></ui-select-choices></ui-select></div></div><div class="col-sm-3"><div class="form-group"><label for="inputcomuna">\xBFEn que comuna?</label><ui-select ng-model="formulario.comuna" class="btn-group bootstrap-select form-control select-index" ng-disabled="!comunas" append-to-body="true" search-enabled="false" name="comuna" required=""><ui-select-match placeholder="Seleccione la Comuna"><span>{{$select.selected.comuna_nombre}}</span></ui-select-match><ui-select-choices repeat="comuna in comunas | filter: $select.search"><span ng-bind-html="comuna.comuna_nombre"></span></ui-select-choices></ui-select></div></div><div class="col-sm-3"><div class="form-group"><label for="inputespecialidad">\xBFQue tipo de profesional necesitas?</label><ui-select ng-model="formulario.especialidad" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="false" name="especialidad" required=""><ui-select-match placeholder="Seleccione la Especialidad"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="especialidad in especialidades | filter: $select.search"><span ng-bind-html="especialidad.label"></span></ui-select-choices></ui-select></div></div><div class="col-sm-3"><button type="button" class="btn btn-success btn-with-icon crea-orden" ng-disabled="!formulario.comuna" ng-click="buscar(formulario)"><i class="ion-search"></i>B\xFAsqueda</button><br><button type="button" class="btn btn-danger btn-with-icon crea-orden btn-xs" ng-click="limpiar()"><i class="ion-backspace"></i>Limpiar</button></div></div><div class="row"><div class="col-sm-12"><div ng-show="loading"><div class="table-empty cargando"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></div></div><div ng-show="!bool && errorbusqueda" class="text-center"><h4>Lo sentimos, no hay profesionales registrados que cumplan los criterios de b\xFAsqueda.</h4></div><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="xsmall-panel light-text paneles panel-success text-center" ng-show="bool && busqueda && !loading"><div class="horizontal-scroll"><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="nombre">Nombre</th><th st-sort="especialidad">Especialidad</th><th st-sort="telefono">Tel\xE9fono</th><th st-sort="direccion">Direcci\xF3n</th><th></th></tr></thead><tbody ng-show="bool"><tr ng-repeat="item in busqueda"><td><img ng-src="http://apiintplus.rfit.cl/assets/img/perfiles/{{item.img_url}}" width="20" height="20"></td><td>{{item.nombre}} {{item.apellido}}</td><td>{{item.especialidad}}</td><td>{{item.telefono}}</td><td>{{item.direccion}}</td><td><button type="button" class="btn btn-primary btn-icon" ng-click="openmo(\'\',item.nombre, item.apellido, item.id_usuario,\'\',\'\')"><i class="ion-ios-email-outline"></i></button></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div class="form-group select-page-size-wrap"><label>Filas por p\xE1gina<select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/evaluacion/datos1.html','<div class="row"><div class="col-sm-4"><div class="form-group"><div class="userpic-wrapper"><img ng-src="http://apiintplus.rfit.cl/assets/img/perfiles/{{ datoevaluado.img_url }}"></div></div></div><div class="col-sm-8"><div ba-panel="" ba-panel-title="{{\'Datos del evaluado\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="row"><div class="col-sm-6"><div class="form-group"><b>{{\'Nombre\'|translate}}:</b> {{datoevaluado.nombre}} {{datoevaluado.apellido}}</div><div class="form-group"><b>{{\'Sexo\'|translate}}:</b> {{datoevaluado.sexo|translate}}</div><div class="form-group"><b>{{\'Email\'|translate}}:</b> {{datoevaluado.email}}</div><div class="form-group"><b>{{\'Tel\xE9fono\'|translate}}:</b> {{datoevaluado.telefono}}</div></div><div class="col-sm-6"><div class="form-group"><b>{{\'Regi\xF3n\'|translate}}:</b> {{datoevaluado.region}}</div><div class="form-group"><b>{{\'Direcci\xF3n\'|translate}}:</b> {{datoevaluado.direccion}}</div><div class="form-group"><b>{{\'Comuna\'|translate}}:</b> {{datoevaluado.comuna}}</div><div class="form-group"><b>{{\'Nacimiento\'|translate}}:</b> {{datoevaluado.nacimiento | date:\'dd-MM-yyyy\'}}</div><div class="form-group"><b>{{\'Edad\'|translate}}:</b> {{datoevaluado.edad}}</div></div></div></div></div></div>');
$templateCache.put('app/pages/evaluacion/datos2.html','<div class="row"><div class="col-sm-8"><div ba-panel="" ba-panel-title="{{\'Datos B\xE1sicos\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="row"><div class="col-sm-6"><div class="form-group"><b>{{\'Edad Cr\xF3nologica\'|translate}}:</b> <span class="dato">{{datoevaluacion.ecrono}}</span></div><div class="form-group"><b>{{\'Sexo\'|translate}}:</b> <span class="dato">{{datoevaluado.sexo|translate}}</span></div><div class="form-group"><b>{{\'Estatura\'|translate}}:</b> <span class="dato">{{datoevaluacion.estatura|metricconvert:\'long\'}} {{\'Cm\'|metricunits}}.</span></div><div class="form-group"><b>{{\'Peso\'|translate}}:</b> <span class="dato">{{datoevaluacion.peso|metricconvert:\'peso\'}} {{\'Kg\'|metricunits}}.</span></div><div class="form-group"><b>{{\'Alcohol\'|translate}}:</b> <span class="dato">{{datoevaluacion.alcohol|translate}}</span></div><div class="form-group"><b>{{\'Fuma\'|translate}}:</b> <span class="dato">{{datoevaluacion.fuma|translate}}</span></div></div><div class="col-sm-6"><div class="form-group"><b>{{\'Per\xEDmetro Cuello\'|translate}}:</b> <span class="dato">{{datoevaluacion.cuello|metricconvert:\'long\'}} {{\'Cm\'|metricunits}}.</span></div><div class="form-group"><b>{{\'Per\xEDmetro Cintura\'|translate}}:</b> <span class="dato">{{datoevaluacion.pcintura|metricconvert:\'long\'}} {{\'Cm\'|metricunits}}.</span></div><div class="form-group"><b>{{\'Per\xEDmetro Cadera\'|translate}}:</b> <span class="dato">{{datoevaluacion.pcadera|metricconvert:\'long\'}} {{\'Cm\'|metricunits}}.</span></div><div class="form-group"><b>{{\'Per\xEDmetro Brazo Derecho\'|translate}}:</b> <span class="dato">{{datoevaluacion.pbrazo|metricconvert:\'long\'}} {{\'Cm\'|metricunits}}.</span></div><div class="form-group"><b>{{\'Per\xEDmetro Pierna Derecha\'|translate}}:</b> <span class="dato">{{datoevaluacion.ppierna|metricconvert:\'long\'}} {{\'Cm\'|metricunits}}.</span></div><div class="form-group"><b>{{\'Presi\xF3n Diast\xF3lica\'|translate}}:</b> <span class="dato">{{datoevaluacion.presion_d}} mmHg.</span></div><div class="form-group"><b>{{\'Presi\xF3n Sist\xF3lica\'|translate}}:</b> <span class="dato">{{datoevaluacion.presion_s}} mmHg.</span></div></div></div></div></div><div class="col-sm-4"><div ba-panel="" ba-panel-title="{{\'Datos Fisiol\xF3gicos\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="form-group"><b>{{\'IMC\'|translate}}:</b> <span class="dato">{{datoevaluacion.imc}}</span></div><div class="form-group"><b>{{\'Edad Fisiol\xF3gica\'|translate}}:</b> <span class="dato">{{datoevaluacion.edad_metabolica}}</span></div><div class="form-group"><b>{{\'Porcentaje de Grasa\'|translate}}:</b> <span class="dato">{{datoevaluacion.pgrasa}}%</span></div><div class="form-group"><b>{{\'Grasa Visceral\'|translate}}:</b> <span class="dato">{{datoevaluacion.rango_grasa_viceral}}</span></div><div class="form-group"><b>{{\'Porcentaje Masa Muscular\'|translate}}:</b> <span class="dato">{{datoevaluacion.masamuscular}}%</span></div><div class="form-group"><b>{{\'IMB\'|translate}}:</b> <span class="dato">{{datoevaluacion.imb}} {{\'calor\xEDas\'|translate}}</span></div></div></div></div>');
$templateCache.put('app/pages/evaluacion/datos3.html','<div class="row"><div class="col-sm-6"><div ba-panel="" ba-panel-title="{{\'An\xE1lisis de Composici\xF3n Corporal\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="form-group"><b>{{\'Porcentaje de Grasa\'|translate}}:</b> <span class="dato">{{datoevaluacion.pgrasa}}%</span></div><div class="form-group"><b>{{\'Porcentaje Masa Muscular\'|translate}}:</b> <span class="dato">{{datoevaluacion.masamuscular}}%</span></div><div class="form-group"><b>{{\'Porcentaje Masa Residual\'|translate}}:</b> <span class="dato">{{datoevaluacion.pmresidual}}%</span></div><div class="form-group"><b>{{\'Peso Graso\'|translate}}:</b> <span class="dato">{{datoevaluacion.pgraso|metricconvert:\'peso\'}} {{\'Kg\'|metricunits}}.</span></div><div class="form-group"><b>{{\'Peso Muscular\'|translate}}:</b> <span class="dato">{{datoevaluacion.pmuscular|metricconvert:\'peso\'}} {{\'Kg\'|metricunits}}.</span></div><div class="form-group"><b>{{\'Masa residual y otros\'|translate}}:</b> <span class="dato">{{datoevaluacion.mresidual|metricconvert:\'peso\'}} {{\'Kg\'|metricunits}}.</span></div><div class="form-group"><b>{{\'Grasa visceral (puntos)\'|translate}}:</b> <span class="dato">{{datoevaluacion.rango_grasa_viceral}}</span></div><div class="form-group"><b>{{\'IMB\'|translate}}:</b> <span class="dato">{{datoevaluacion.imb}} {{\'calor\xEDas\'|translate}}</span></div><div class="form-group"><b>{{\'IMC\'|translate}}:</b> <span class="dato">{{datoevaluacion.imc}}</span></div></div></div><div class="col-sm-6 tabs-graficos"><uib-tabset><uib-tab heading="{{\'Gr\xE1fico Tipo 1\'|translate}}"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" chart-options="options" class="chart chart-doughnut" chart-data="data" chart-labels="labels"></canvas></div></uib-tab><uib-tab heading="{{\'Gr\xE1fico Tipo 2\'|translate}}"><div class="chartjs-canvas-holder-third-row"><canvas id="radar" class="chart chart-radar" chart-series="series" chart-data="data" chart-labels="labels" chart-options="optionsradar"></canvas></div></uib-tab></uib-tabset></div></div><div class="row"><div class="col-sm-12"><div ba-panel="" ba-panel-title="{{\'Per\xEDmetro Cintura\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="col-sm-5"><div ba-panel="" ba-panel-title="{{\'An\xE1lisis Per\xEDmetro Cintura\'|translate}}" ba-panel-class="with-scroll"><div class="form-group"><b>{{\'Perimetro Cintura Actual\'|translate}}:</b> <span class="dato">{{datoevaluacion.pcintura|metricconvert:\'long\'}} {{\'Cm\'|metricunits}}.</span></div></div></div><div class="col-sm-7"><div ba-panel="" ba-panel-title="{{\'Perimetro Cintura Referencia\'|translate}}" ba-panel-class="with-scroll"><table class="table text-center"><tr class="primary"><td>{{\'Aceptable\'|translate}}</td><td>{{\'Sobre lo Normal\'|translate}}</td><td>{{\'Riesgo\'|translate}}</td></tr><tr><td>{{datoevaluacion.refcintura[\'1\']|metricconvert:\'long\'}}</td><td>{{datoevaluacion.refcintura[\'1\']|metricconvert:\'long\'}} - {{datoevaluacion.refcintura[\'2\']|metricconvert:\'long\'}}</td><td>{{datoevaluacion.refcintura[\'2\']|metricconvert:\'long\'}}</td></tr></table></div></div></div></div></div><div class="row"><div class="col-sm-12"><div ba-panel="" ba-panel-title="{{\'Grasa Corporal\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="col-sm-5"><div ba-panel="" ba-panel-title="{{\'An\xE1lisis Grasa Corporal\'|translate}}" ba-panel-class="with-scroll"><div class="form-group"><b>{{\'Grasa Corporal Actual\'|translate}}:</b> <span class="dato">{{datoevaluacion.pgrasa}}%</span></div></div></div><div class="col-sm-7"><div ba-panel="" ba-panel-title="{{\'Grasa Corporal Referencia\'|translate}}" ba-panel-class="with-scroll"><table class="table text-center"><tr class="primary"><td>{{\'Aceptable\'|translate}}</td><td>{{\'En forma\'|translate}}</td><td>{{\'Elite\'|translate}}</td></tr><tr><td>{{datoevaluacion.gideal*1.2|redondea:2}}</td><td>{{datoevaluacion.gideal}}</td><td>{{datoevaluacion.gideal*0.8|redondea:2}}</td></tr></table></div></div></div></div></div><div class="row"><div class="col-sm-12"><div ba-panel="" ba-panel-title="{{\'Masa Muscular\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="col-sm-5"><div ba-panel="" ba-panel-title="{{\'An\xE1lisis Masa Muscular\'|translate}}" ba-panel-class="with-scroll"><div class="form-group"><b>{{\'Masa Muscular Actual\'|translate}}:</b> <span class="dato">{{datoevaluacion.masamuscular}}%</span></div></div></div><div class="col-sm-7"><div ba-panel="" ba-panel-title="{{\'Masa Muscular Referencia\'|translate}}" ba-panel-class="with-scroll"><table class="table text-center"><tr class="primary"><td>{{\'Aceptable\'|translate}}</td><td>{{\'Normal\'|translate}}</td><td>{{\'En forma\'|translate}}</td><td>{{\'Elite\'|translate}}</td></tr><tr><td>{{datoevaluacion.refmasamuscular[\'1\']}}</td><td>{{datoevaluacion.refmasamuscular[\'2\']}}</td><td>{{datoevaluacion.refmasamuscular[\'3\']}}</td><td>{{datoevaluacion.refmasamuscular[\'4\']}}</td></tr></table></div></div></div></div></div><div class="row"><div class="col-sm-12"><div ba-panel="" ba-panel-title="{{\'Grasa Visceral\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="col-sm-5"><div ba-panel="" ba-panel-title="{{\'An\xE1lisis Grasa Visceral\'|translate}}" ba-panel-class="with-scroll"><div class="form-group"><b>{{\'Grasa Visceral Actual\'|translate}}:</b> <span class="dato">{{datoevaluacion.rango_grasa_viceral|translate}}</span></div></div></div><div class="col-sm-7"><div ba-panel="" ba-panel-title="{{\'Grasa Visceral Referencia\'|translate}}" ba-panel-class="with-scroll"><table class="table text-center"><tr><td class="success">{{\'Bueno\'|translate}}</td><td class="warning">{{\'Malo\'|translate}}</td><td class="danger">{{\'Muy Malo\'|translate}}</td></tr><tr><td>{{\'Hasta\'|translate}} 9</td><td>{{\'Entre\'|translate}} 10 {{\'y\'|translate}} 14</td><td>{{\'Mayor a\'|translate}} 15</td></tr></table></div></div></div></div></div><div class="row" ng-show="datoevaluacion.triceps && datoevaluacion.abdominal && datoevaluacion.cuadriceps && datoevaluacion.subescapular"><div class="col-sm-12"><div ba-panel="" ba-panel-title="{{\'Pliegues\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="col-sm-5"><div ba-panel="" ba-panel-title="{{\'Datos Pligues\'|translate}}" ba-panel-class="with-scroll"><div class="form-group"><b>{{\'Triceps\'|translate}}:</b> <span class="dato">{{datoevaluacion.triceps}}</span></div><div class="form-group"><b>{{\'Subescapular\'|translate}}:</b> <span class="dato">{{datoevaluacion.subescapular}}</span></div><div class="form-group"><b>{{\'Abdominal\'|translate}}:</b> <span class="dato">{{datoevaluacion.abdominal}}</span></div><div class="form-group"><b>{{\'Cuadriceps\'|translate}}:</b> <span class="dato">{{datoevaluacion.cuadriceps}}</span></div></div></div><div class="col-sm-7"><div ba-panel="" ba-panel-title="{{\'Gr\xE1fico Pliegues\'|translate}}" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveBars" class="chart chart-bar" chart-options="optionspliegue" chart-data="[datapliegue]" chart-labels="labelspliegue"></canvas></div></div></div></div></div></div>');
$templateCache.put('app/pages/evaluacion/datos4.html','<div class="row"><div class="col-sm-12"><div ba-panel="" ba-panel-title="{{\'Gasto Metab\xF3lico Entrenamiento\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="row"><div class="col-sm-3"><b>{{\'Tiempo de entrenamiento\'|translate}}:</b></div><div class="col-sm-3"><div class="form-group"><ui-select ng-model="entrenamiento.tiempo" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false" ng-change="tiempo(entrenamiento.tiempo)"><ui-select-match placeholder="{{\'Seleccione\'|translate}}"><span translate="">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="standardItem in standardSelectItems | filter: $select.search"><span translate="">{{standardItem.label}}</span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-sm-12"><table class="table text-center"><tr class="primary"><th translate="">Tipo de Esfuerzo</th><th translate="">M\xEDnimo</th><th translate="">M\xE1ximo</th><th translate="">Promedio</th><th translate="">Volumen Entrenamiento (%)</th><th translate="">Volumen Entrenamiento (Minutos)</th></tr><tr><td translate="">Calentamiento</td><td>{{(220 - datoevaluacion.edad_metabolica)*0.65 | redondea:2}}</td><td>{{(220 - datoevaluacion.edad_metabolica)*0.7 | redondea:2}}</td><td>{{(((220 - datoevaluacion.edad_metabolica)*0.65)+((220 - datoevaluacion.edad_metabolica)*0.7))/2 | redondea:2}}</td><td>{{n1}}%</td><td>{{tiempoent*(n1/100)}}</td></tr><tr><td translate="">A\xE9robica</td><td>{{(220 - datoevaluacion.edad_metabolica)*0.71 | redondea:2}}</td><td>{{(220 - datoevaluacion.edad_metabolica)*0.77 | redondea:2}}</td><td>{{(((220 - datoevaluacion.edad_metabolica)*0.71)+((220 - datoevaluacion.edad_metabolica)*0.77))/2 | redondea:2}}</td><td>{{n2}}%</td><td>{{tiempoent*(n2/100)}}</td></tr><tr><td translate="">Incremento</td><td>{{(220 - datoevaluacion.edad_metabolica)*0.78 | redondea:2}}</td><td>{{(220 - datoevaluacion.edad_metabolica)*0.85 | redondea:2}}</td><td>{{(((220 - datoevaluacion.edad_metabolica)*0.78)+((220 - datoevaluacion.edad_metabolica)*0.85))/2 | redondea:2}}</td><td>{{n3}}%</td><td>{{tiempoent*(n3/100)}}</td></tr></table></div></div><hr><div class="row"><div class="col-sm-6"><div class="form-group"><b>{{\'Gasto Cal\xF3rico de la clase\'|translate}}:</b> {{((prom*datoevaluacion.pmuscular)+(datoevaluacion.imc*tiempoent))/10 | redondea:2}}</div><table class="table text-center"><tr class="primary min-text"><th translate="">Frecuencia Card\xEDaca M\xEDnima</th><th translate="">Frecuencia Card\xEDaca M\xE1xima</th></tr><tr><td>{{(220 - datoevaluacion.edad_metabolica)*0.65 | redondea:2}} PPM</td><td>{{(220 - datoevaluacion.edad_metabolica)*0.85 | redondea:2}} PPM</td></tr></table><div class="post-tabla"><div class="form-group"><i class="ion-clipboard"></i> <b>{{\'Scoring\'|translate}}:</b> {{datoevaluacion.scoring | redondea:2}}</div><div class="form-group"><i class="ion-clipboard"></i> <b>{{\'Nivel de Entrada\'|translate}}:</b> {{datoevaluacion.nentrada|translate}}</div><div class="form-group"><i class="ion-clipboard"></i> <b>{{\'Nivel de Entrenamiento\'|translate}}:</b> {{datoevaluacion.nentrena|translate}}</div></div><table class="table text-center"><tr class="primary"><th translate="">Nivel de Entrada</th><th>Scoring</th><th translate="">Nivel de la Clase</th></tr><tr ng-class="{bgcolorrangoa: datoevaluacion.nentrada == \'Alto Riesgo\'}"><td translate="">Alto Riesgo</td><td>3.6 - 7</td><td translate="">Nivel B\xE1sico</td></tr><tr ng-class="{bgcolorrangob: datoevaluacion.nentrada == \'Riesgo\'}"><td translate="">Riesgo</td><td>2.6 - 3.5</td><td translate="">Nivel B\xE1sico</td></tr><tr ng-class="{bgcolorrangoc: datoevaluacion.nentrada == \'Sedentario\'}"><td translate="">Sedentario</td><td>1.1 - 2.5</td><td translate="">Nivel B\xE1sico</td></tr><tr ng-class="{bgcolorrangod: datoevaluacion.nentrada == \'Normal sedentario\'}"><td translate="">Normal Sedentario</td><td>0.3 - 1</td><td translate="">Nivel Intermedio</td></tr><tr ng-class="{bgcolorrangoe: datoevaluacion.nentrada == \'Normal\'}"><td translate="">Normal</td><td>-0.5 - 0.2</td><td translate="">Nivel Intermedio</td></tr><tr ng-class="{bgcolorrangoe: datoevaluacion.nentrada == \'En forma\'}"><td translate="">En forma</td><td>-1.5 - -0.6</td><td translate="">Nivel Intermedio</td></tr><tr ng-class="{bgcolorrangof: datoevaluacion.nentrada == \'Deportivo\'}"><td translate="">Deportivo</td><td>-2.9 - -1.6</td><td translate="">Nivel Avanzado</td></tr><tr ng-class="{bgcolorrangof: datoevaluacion.nentrada == \'Atl\xE9tico\'}"><td translate="">Atl\xE9tico</td><td>-3.9 - -3</td><td translate="">Nivel Avanzado</td></tr><tr ng-class="{bgcolorrangof: datoevaluacion.nentrada == \'Elite\'}"><td translate="">Elite</td><td>-5 - -4</td><td translate="">Nivel Avanzado</td></tr></table></div><div class="col-sm-6"><div ba-panel="" ba-panel-title="{{\'Volumen de Entrenamiento\'|translate}}" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" chart-options="options" class="chart chart-doughnut" chart-data="dataentrenamiento" chart-labels="labelsentrenamiento"></canvas></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/evaluacion/datos5.html','<div class="row"><div class="col-sm-4"><div ba-panel="" ba-panel-title="{{\'Requerimiento Cal\xF3rico\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="row"><div class="col-sm-12"><div class="form-group"><b>{{\'M\xEDnimo\'|translate}}:</b> <span class="dato">{{rcalorico | redondea:0}}</span></div><div class="form-group"><b>{{\'Promedio\'|translate}}:</b> <span class="dato">{{rcalorico*1.05 | redondea:0}}</span></div><div class="form-group"><b>{{\'M\xE1ximo\'|translate}}:</b> <span class="dato">{{rcalorico*1.05*1.05 | redondea:0}}</span></div></div></div></div><div ba-panel="" ba-panel-title="{{\'Requerimiento Macronutrientes\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="row"><div class="col-sm-12"><div class="form-group"><b>{{\'Prote\xEDnas\'|translate}}:</b> <span class="dato">{{datoevaluacion.proteinas}}%</span></div><div class="form-group"><b>{{\'Carbohidratos\'|translate}}:</b> <span class="dato">{{datoevaluacion.carbohidratos}}%</span></div><div class="form-group"><b>{{\'L\xEDpidos y Otros\'|translate}}:</b> <span class="dato">{{datoevaluacion.lipidos}}%</span></div><div class="form-group min-text2">{{\'Tener ingestas cada 200 minutos (aproximadamente)\'|translate}}.<br>{{\'Consumir un promedio de 2 litros de agua\'|translate}}.</div></div></div></div></div><div class="col-sm-8"><div ba-panel="" ba-panel-title="{{\'Macronutrientes\'|translate}}" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" chart-options="options" class="chart chart-doughnut" chart-data="datamacronutrientes" chart-labels="labelsmacronutrientes"></canvas></div></div></div></div><div class="row"><div class="col-sm-6"><div ba-panel="" ba-panel-title="{{\'Sem\xE1foro Nutricional\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="row"><div class="col-sm-2"><i class="ion-close-circled semaforo danger"></i></div><div class="col-sm-10"><h3 class="titulos-semaforo" translate="">Prohibidos</h3>{{\'Frituras en general, bebidas alcoh\xF3licas, leche entera, embutidos, dulces, chocolates, mantequilla, carne de cerdo. Estos alimentos poseen un alto contenido cal\xF3rico, as\xED como tambi\xE9n un baj\xEDsimo valor biol\xF3gico. Se recomienda no consumirlos de ninguna forma.\'|translate}}</div></div><div class="row semaforo-central"><div class="col-sm-2"><i class="ion-alert-circled semaforo warning"></i></div><div class="col-sm-10"><h3 class="titulos-semaforo" translate="">Con Moderaci\xF3n</h3>{{\'Arroz, papas, pastas, huevo entero, carnes rojas, frutas, cereales integrales, frutos secos, sal. Estos alimentos nos entregan buena fuente de recursos energ\xE9ticos. Para enfrentar el gasto diario se recomienda consumir de 3 a 4 porciones al d\xEDa.\'|translate}}</div></div><div class="row"><div class="col-sm-2"><i class="ion-checkmark-circled semaforo success"></i></div><div class="col-sm-10"><h3 class="titulos-semaforo" translate="">Sin Restricci\xF3n</h3>{{\'Verduras, pescado, pollo y pavo sin piel, agua desmineralizada, jugos de fruta naturales sin az\xFAcar. Estos alimentos nos entregan una buena fuente de prote\xEDnas y vitaminas para el mejoramiento de nuestra salud y condici\xF3n f\xEDsica, recomendamos consumir de 5 a 6 porciones diarias.\'|translate}}</div></div></div></div><div class="col-sm-6"><div ba-panel="" ba-panel-title="{{\'Macronutrientes\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="form-group"><b>{{\'Prote\xEDnas\'|translate}}:</b> {{\'Se encuentran en carnes rojas, blancas, magras, l\xE1cteos descremados, ayudan a formar tejido muscular y aportan 4 calor\xEDas por gramo.\'|translate}}</div><div class="form-group"><b>{{\'Carbohidratos\'|translate}}:</b> {{\'Se encuentran en los derivados de trigo (pan, harinas, pastas, etc.), granos, cereales, frutas y verduras. Aportan 4 calor\xEDas por gramo.\'|translate}}</div><div class="form-group"><b>{{\'L\xEDpidos\'|translate}}:</b> {{\'Se encuentran en frutos secos, d\xE1ctiles, palta, salm\xF3n, aceite de oliva, etc. Aportan 9 calor\xEDas por gramo.\'|translate}}</div></div></div></div>');
$templateCache.put('app/pages/evaluacion/datos6.html','<div class="row"><div class="col-sm-12"><div ba-panel="" ba-panel-title="{{\'D\xEDa\'|translate}} {{$index + 1}}" ba-panel-class="xsmall-panel light-text paneles panel-success" ng-repeat="entreno in rutina"><div class="row"><div class="col-sm-6"><div class="form-group"><b>{{\'Calentamiento\'|translate}}:</b> <span class="dato">{{entreno.Calentamiento}}</span></div><div class="form-group"><b>{{\'Palanca a trabajar\'|translate}}:</b> <span class="dato">{{entreno.Palanca}}</span></div></div><div class="col-sm-6"><div class="form-group"><b>{{\'M\xFAsculos Involucrados\'|translate}}:</b> <span class="dato">{{entreno.Musculo}}</span></div><div class="form-group"><b>{{\'Total Ejercicios (Vol\xFAmen Ejecuciones)\'|translate}}:</b> <span class="dato">{{entreno.Total}}</span></div></div><div class="col-sm-12"><div class="form-group"><b>{{\'Trabajo Aer\xF3bico de Acuerdo al Nivel de Entrada\'|translate}}:</b> <span class="dato">{{entreno.Trabajo}}</span></div></div></div><div class="row"><div class="col-sm-12"><div ba-panel="" ba-panel-title="{{\'Ejercicios Sugeridos\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-primary"><table class="table table-striped tabla-first-left"><tr ng-repeat="entre in ( entreno.Ejercicios | explotaentrenamiento:\':\' ) track by $index"><td ng-repeat="entrena in ( entre | explotaentrenamiento:\'|\' ) track by $index">{{entrena}}</td></tr></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/evaluacion/datos7.html','<div class="row"><div class="col-sm-12"><div ba-panel="" ba-panel-title="{{\'Enviar Evaluaci\xF3n por Email\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="row"><div class="col-sm-5"><div class="form-group text-center"><label for="inputEmail" translate="">Email</label><div class="input-group"><input type="text" class="form-control with-danger-addon" ng-model="datoevaluado.email"> <span class="input-group-btn"><button class="btn btn-primary" type="button" ng-click="enviarevalua(evaluacion_id,datoevaluado.email)" ng-disabled="cargaenvio">{{\'Enviar\'|translate}}!</button></span></div></div></div><div class="col-sm-7"><div ng-show="cargaenvio" class="cargando-enviaevalua min-text"><i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>{{\'Espera mientras preparamos y enviamos la evaluaci\xF3n\'|translate}}</div></div></div><div class="alert bg-{{messagedata.type}}" ng-show="messagedata.message">{{messagedata.message|translate}}<p class="mensaje-errores" ng-repeat="error in messagedata.errors.error.message" ng-show="messagedata.errors">{{error|translate}}</p></div></div></div></div>');
$templateCache.put('app/pages/evaluacion/datos8.html','<div class="row"><div class="col-sm-12"><div ba-panel="" ba-panel-title="{{\'Datos B\xE1sicos\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="row"><div class="col-sm-12"><table><tr><td></td><td class="celda-historico head" ng-repeat="hist in historico.evaluaciones"><span class="dato">{{hist.created_at | date:\'dd/MM/yyyy\'}}</span></td></tr><tr><td class="celda-historico"><b>{{\'Per\xEDmetro Cintura\'|translate}}:</b></td><td class="celda-historico" ng-repeat="hist in historico.evaluaciones"><span class="dato">{{hist.pcintura|metricconvert:\'long\'}} {{\'Cm\'|metricunits}}.</span></td></tr><tr><td class="celda-historico"><b>{{\'Per\xEDmetro Cadera\'|translate}}:</b></td><td class="celda-historico" ng-repeat="hist in historico.evaluaciones"><span class="dato">{{hist.pcadera|metricconvert:\'long\'}} {{\'Cm\'|metricunits}}.</span></td></tr><tr><td class="celda-historico"><b>{{\'Per\xEDmetro Brazo\'|translate}}:</b></td><td class="celda-historico" ng-repeat="hist in historico.evaluaciones"><span class="dato">{{hist.pbrazo|metricconvert:\'long\'}} {{\'Cm\'|metricunits}}.</span></td></tr><tr><td class="celda-historico"><b>{{\'Per\xEDmetro Pierna\'|translate}}:</b></td><td class="celda-historico" ng-repeat="hist in historico.evaluaciones"><span class="dato">{{hist.ppierna|metricconvert:\'long\'}} {{\'Cm\'|metricunits}}.</span></td></tr><tr><td class="celda-historico"><b>{{\'Presi\xF3n Diast\xF3lica\'|translate}}:</b></td><td class="celda-historico" ng-repeat="hist in historico.evaluaciones"><span class="dato">{{hist.presion_d}} mmHg.</span></td></tr><tr><td class="celda-historico"><b>{{\'Presi\xF3n Sist\xF3lica\'|translate}}:</b></td><td class="celda-historico" ng-repeat="hist in historico.evaluaciones"><span class="dato">{{hist.presion_s}} mmHg.</span></td></tr><tr><td class="celda-historico"><b>{{\'Peso\'|translate}}:</b></td><td class="celda-historico" ng-repeat="hist in historico.evaluaciones"><span class="dato">{{hist.peso|metricconvert:\'peso\'}} {{\'Kg\'|metricunits}}.</span></td></tr><tr><td class="celda-historico"><b>{{\'Fuma\'|translate}}:</b></td><td class="celda-historico" ng-repeat="hist in historico.evaluaciones"><span class="dato">{{hist.fuma|translate}}</span></td></tr><tr><td class="celda-historico"><b>{{\'Alcohol\'|translate}}:</b></td><td class="celda-historico" ng-repeat="hist in historico.evaluaciones"><span class="dato">{{hist.alcohol|translate}}</span></td></tr></table></div></div></div></div><div class="col-sm-12"><div ba-panel="" ba-panel-title="{{\'Datos Fisiol\xF3gicos\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><table><tr><td></td><td class="celda-historico head" ng-repeat="hist in historico.evaluaciones"><span class="dato">{{hist.created_at | date:\'dd/MM/yyyy\'}}</span></td></tr><tr><td class="celda-historico"><b>{{\'IMC\'|translate}}:</b></td><td class="celda-historico" ng-repeat="hist in historico.evaluaciones"><span class="dato">{{hist.imc}}</span></td></tr><tr><td class="celda-historico"><b>{{\'Edad Fisiol\xF3gica\'|translate}}:</b></td><td class="celda-historico" ng-repeat="hist in historico.evaluaciones"><span class="dato">{{hist.edad_metabolica}}</span></td></tr><tr><td class="celda-historico"><b>{{\'Porcentaje de Grasa\'|translate}}:</b></td><td class="celda-historico" ng-repeat="hist in historico.evaluaciones"><span class="dato">{{hist.pgrasa}}%</span></td></tr><tr><td class="celda-historico"><b>{{\'Grasa Visceral\'|translate}}:</b></td><td class="celda-historico" ng-repeat="hist in historico.evaluaciones"><span class="dato">{{hist.rango_grasa_viceral|translate}}</span></td></tr><tr><td class="celda-historico"><b>{{\'Porcentaje Masa Muscular\'|translate}}:</b></td><td class="celda-historico" ng-repeat="hist in historico.evaluaciones"><span class="dato">{{hist.masamuscular}}%</span></td></tr><tr><td class="celda-historico"><b>{{\'IMB\'|translate}}:</b></td><td class="celda-historico" ng-repeat="hist in historico.evaluaciones"><span class="dato">{{hist.imb}} {{\'calor\xEDas\'|translate}}</span></td></tr></table></div></div></div>');
$templateCache.put('app/pages/evaluacion/entrenamientos.html','<table class="table text-center"><tr><td>Calentamiento</td><td>{{(220 - datoevaluacion.edad_metabolica)*0.65 | redondea:2}}</td><td>{{(220 - datoevaluacion.edad_metabolica)*0.7 | redondea:2}}</td><td>{{(((220 - datoevaluacion.edad_metabolica)*0.65)+((220 - datoevaluacion.edad_metabolica)*0.7))/2 | redondea:2}}</td><td>{{n1}}%</td><td>{{tiempoent*(n1/100)}}</td></tr><tr><td>A\xE9robica</td><td>{{(220 - datoevaluacion.edad_metabolica)*0.71 | redondea:2}}</td><td>{{(220 - datoevaluacion.edad_metabolica)*0.77 | redondea:2}}</td><td>{{(((220 - datoevaluacion.edad_metabolica)*0.71)+((220 - datoevaluacion.edad_metabolica)*0.77))/2 | redondea:2}}</td><td>{{n2}}%</td><td>{{tiempoent*(n2/100)}}</td></tr><tr><td>Incremento</td><td>{{(220 - datoevaluacion.edad_metabolica)*0.78 | redondea:2}}</td><td>{{(220 - datoevaluacion.edad_metabolica)*0.85 | redondea:2}}</td><td>{{(((220 - datoevaluacion.edad_metabolica)*0.78)+((220 - datoevaluacion.edad_metabolica)*0.85))/2 | redondea:2}}</td><td>{{n3}}%</td><td>{{tiempoent*(n3/100)}}</td></tr></table>');
$templateCache.put('app/pages/evaluacion/evaluacion.html','<div ba-panel="" ba-panel-class="evalua-page heading-widget" ba-panel-title="{{\'Evaluaci\xF3n\'|translate}}" data-ng-init="init()"><uib-tabset class="tabs-left" ng-show="!movil"><uib-tab heading="{{\'Cliente Evaluado\'|translate}}" class="icono cliente"><div ng-include="\'app/pages/evaluacion/datos1.html\'"></div></uib-tab><uib-tab heading="{{\'Datos Entrada\'|translate}}" class="icono datos-entrada"><div ng-include="\'app/pages/evaluacion/datos2.html\'"></div></uib-tab><uib-tab heading="{{\'Composici\xF3n Corporal\'|translate}}" class="icono comp-corporal"><div ng-include="\'app/pages/evaluacion/datos3.html\'"></div></uib-tab><uib-tab heading="{{\'Entrenamiento\'|translate}}" class="icono entrenamiento"><div ng-include="\'app/pages/evaluacion/datos4.html\'"></div></uib-tab><uib-tab heading="{{\'Requerimiento Nutricional\'|translate}}" class="icono req-nutri"><div ng-include="\'app/pages/evaluacion/datos5.html\'"></div></uib-tab><uib-tab heading="{{\'Entrenamiento Sugerido\'|translate}}" class="icono ent-sugerido"><div ng-include="\'app/pages/evaluacion/datos6.html\'"></div></uib-tab><uib-tab heading="{{\'Hist\xF3rico\'|translate}}" class="icono historico"><div ng-include="\'app/pages/evaluacion/datos8.html\'"></div></uib-tab><uib-tab heading="{{\'Enviar Evaluaci\xF3n\'|translate}}" class="icono enviar-evaluacion"><div ng-include="\'app/pages/evaluacion/datos7.html\'"></div></uib-tab></uib-tabset><uib-accordion ng-show="movil"><uib-accordion-group heading="{{\'Cliente Evaluado\'|translate}}" class="icono cliente"><div ng-include="\'app/pages/evaluacion/datos1.html\'"></div></uib-accordion-group><uib-accordion-group heading="{{\'Datos Entrada\'|translate}}" class="icono datos-entrada"><div ng-include="\'app/pages/evaluacion/datos2.html\'"></div></uib-accordion-group><uib-accordion-group heading="{{\'Composici\xF3n Corporal\'|translate}}" class="icono comp-corporal"><div ng-include="\'app/pages/evaluacion/datos3.html\'"></div></uib-accordion-group><uib-accordion-group heading="{{\'Entrenamiento\'|translate}}" class="icono entrenamiento"><div ng-include="\'app/pages/evaluacion/datos4.html\'"></div></uib-accordion-group><uib-accordion-group heading="{{\'Requerimiento Nutricional\'|translate}}" class="icono req-nutri"><div ng-include="\'app/pages/evaluacion/datos5.html\'"></div></uib-accordion-group><uib-accordion-group heading="{{\'Entrenamiento Sugerido\'|translate}}" class="icono ent-sugerido"><div ng-include="\'app/pages/evaluacion/datos6.html\'"></div></uib-accordion-group><uib-accordion-group heading="{{\'Hist\xF3rico\'|translate}}" class="icono historico"><div ng-include="\'app/pages/evaluacion/datos6.html\'"></div></uib-accordion-group><uib-accordion-group heading="{{\'Enviar Evaluaci\xF3n\'|translate}}" class="icono enviar-evaluacion"><div ng-include="\'app/pages/evaluacion/datos7.html\'"></div></uib-accordion-group></uib-accordion></div>');
$templateCache.put('app/pages/evaluaciones/addform.html','<div class="modal-content" ng-controller="FormEvaluacionesCtrl as vm" data-ng-init="init()"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel" translate="">Agregar Evaluaci\xF3n</h4></div><div class="modal-body"><div ba-panel="" ba-panel-title="{{\'Selecci\xF3n Evaluado y Tipo Evaluaci\xF3n\'|translate}}" ba-panel-class="with-scroll panel-success" ng-show="activeInicio"><div class="row"><div class="col-sm-12"><div class="form-group"><h5 class="text-center" translate="">Por favor selecciona el tipo de evaluaci\xF3n a realizar</h5></div></div></div><div class="row"><div class="col-sm-6"><div ba-panel="" ba-panel-title="{{\'Paso 1: Datos del usuario\'|translate}}" ba-panel-class="xsmall-panel light-text paneles"><div class="row"><div class="col-sm-10"><div class="form-group"><ui-select ng-model="formulario.evaluado" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="true" ng-change="calculaedad(formulario.evaluado.nacimiento)" required=""><ui-select-match placeholder="{{\'Seleccione persona a evaluar\'|translate}}"><span>{{$select.selected.nombre}} {{$select.selected.apellido}}</span></ui-select-match><ui-select-choices repeat="evaluado in evaluados | filter: $select.search"><span ng-bind-html="evaluado.nombre"></span> <span ng-bind-html="evaluado.apellido"></span></ui-select-choices></ui-select></div></div><div class="col-sm-2"><button title="{{\'Si la persona a evaluar no est\xE1 en la lista, ingresa sus datos primero aqu\xED\'|translate}}" type="button" class="btn btn-success btn-icon btn-accion" data-toggle="modal" ng-click="openmodalevaluados(\'app/pages/evaluados/addform.html\', \'lg\')"><i class="ion-plus-round"></i></button></div></div><div class="row"><div class="col-sm-12"><div class="form-group" ng-show="formulario.evaluado.edad"><h6 class="text-center" translate="">Para la evaluaci\xF3n se utilizar\xE1n estos datos, ya registrados</h6><p class="form-muestra"><b>{{\'Nombre\'|translate}}:</b> {{formulario.evaluado.nombre}} {{formulario.evaluado.apellido}}</p><p class="form-muestra"><b>{{\'Edad\'|translate}}:</b> {{formulario.evaluado.edad}}</p><p class="form-muestra"><b>{{\'Sexo\'|translate}}:</b> {{formulario.evaluado.sexo|translate}}</p><p class="form-muestra"><b>{{\'Email\'|translate}}:</b> {{formulario.evaluado.email}}</p></div></div></div></div></div><div class="col-sm-6"><div class="form-group"><div ba-panel="" ba-panel-title="{{\'Paso 2: Elija la forma de evaluaci\xF3n\'|translate}}" ba-panel-class="xsmall-panel light-text paneles"><div class="form-group evalua-seleccion"><button type="button" class="btn btn-success btn-with-icon" ng-click="tipoevalua(\'bio\')" ng-disabled="!formulario.evaluado"><i class="ion-ios-pulse-strong"></i>{{\'M\xE9todo Bioimpedanciometro\'|translate}}</button></div><div class="form-group evalua-seleccion"><button type="button" class="btn btn-success btn-with-icon" ng-click="tipoevalua(\'pliegues\')" ng-disabled="!formulario.evaluado"><i class="ion-android-search"></i>{{\'M\xE9todo 4 pliegues\'|translate}}</button></div><div class="form-group evalua-seleccion"><button type="button" class="btn btn-success btn-with-icon" ng-click="tipoevalua(\'cinta\')" ng-disabled="!formulario.evaluado"><i class="ion-android-search"></i>{{\'M\xE9todo Cinta M\xE9trica\'|translate}}</button></div></div></div></div></div><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div></div><div ba-panel="" ba-panel-title="{{\'Ingreso Datos de Evaluaci\xF3n\'|translate}}" ba-panel-class="with-scroll panel-success" ng-show="activeBio || activePliegues || activeCinta"><div ng-include="\'app/pages/evaluaciones/addform2.html\'"></div></div></div></div>');
$templateCache.put('app/pages/evaluaciones/addform2.html','<ba-wizard><ba-wizard-step title="{{\'Datos B\xE1sicos Evaluado\'|translate}}" form="vm.formevaluaciones1"><form name="vm.formevaluaciones1" novalidate=""><div class="row"><div class="col-sm-8"><div ba-panel="" ba-panel-title="{{\'Datos a completar\'|translate}}" ba-panel-class="xsmall-panel light-text paneles"><div class="row"><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluaciones1.peso.$invalid && (vm.formevaluaciones1.peso.$dirty || vm.formevaluaciones1.$submitted)}"><label for="inputPeso" translate="">Peso</label><div class="input-group"><input type="text" class="form-control with-success-addon" id="inputpeso" placeholder="{{\'Peso\'|translate}}" ng-model="formulario.peso" name="peso" ng-pattern="regex" required=""> <span class="input-group-addon addon-right input-group-addon-success text-white">{{\'Kg\'|metricunits}}.</span></div></div></div><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluaciones1.estatura.$invalid && (vm.formevaluaciones1.estatura.$dirty || vm.formevaluaciones1.$submitted)}"><label for="inputTelefono" translate="">Estatura</label><div class="input-group"><input type="text" class="form-control with-success-addon" id="inputpass" placeholder="{{\'Estatura\'|translate}}" ng-model="formulario.estatura" name="estatura" ng-pattern="regex" required=""> <span class="input-group-addon addon-right input-group-addon-success text-white">{{\'Cm\'|metricunits}}.</span></div></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluaciones1.fuma.$invalid && (vm.formevaluaciones1.fuma.$dirty || vm.formevaluaciones1.$submitted)}"><label for="inputfuma" translate="">\xBFEs fumador?</label><ui-select ng-model="formulario.fuma" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="false" name="fuma" required=""><ui-select-match placeholder="{{\'Seleccione una opci\xF3n\'|translate}}"><span translate="">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="fuma.label as fuma in sinos | filter: $select.search"><span translate="">{{fuma.label}}</span></ui-select-choices></ui-select></div></div><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluaciones1.alcohol.$invalid && (vm.formevaluaciones1.alcohol.$dirty || vm.formevaluaciones1.$submitted)}"><label for="inputalcohol" translate="">\xBFBebe alcohol?</label><ui-select ng-model="formulario.alcohol" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="false" name="alcohol" required=""><ui-select-match placeholder="{{\'Seleccione una opci\xF3n\'|translate}}"><span translate="">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="alcohol.label as alcohol in sinos | filter: $select.search"><span translate="">{{alcohol.label}}</span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluaciones1.hace.$invalid && (vm.formevaluaciones1.hace.$dirty || vm.formevaluaciones1.$submitted)}"><label for="input"><b translate="">\xBFSe ejercita?</b></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="si" ng-click="entrena = true"> <span translate="">Si</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="no" ng-click="entrena = false" checked=""> <span translate="">No</span></label></div></div><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluaciones1.hace.$invalid && (vm.formevaluaciones1.hace.$dirty || vm.formevaluaciones1.$submitted)}" ng-show="!entrena"><label for="inputalcohol" translate="">\xBFHace cuanto NO entrena?</label><ui-select ng-model="formulario.hace" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="false" name="hace" required=""><ui-select-match placeholder="{{\'Seleccione una opci\xF3n\'|translate}}"><span translate="">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="hace.value as hace in haces | filter: $select.search"><span translate="">{{hace.label}}</span></ui-select-choices></ui-select></div></div></div><div class="row" ng-show="entrena"><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluaciones1.hace.$invalid && (vm.formevaluaciones1.hace.$dirty || vm.formevaluaciones1.$submitted)}"><label for="inputalcohol" translate="">\xBFHace cuanto entrena?</label><ui-select ng-model="formulario.hace" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="false" name="hace" required=""><ui-select-match placeholder="{{\'Seleccione una opci\xF3n\'|translate}}"><span translate="">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="hace.value as hace in haces | filter: $select.search"><span translate="">{{hace.label}}</span></ui-select-choices></ui-select></div></div><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluaciones1.frecuencia.$invalid && (vm.formevaluaciones1.frecuencia.$dirty || vm.formevaluaciones1.$submitted)}"><label for="inputalcohol" translate="">\xBFCon que frecuencia?</label><ui-select ng-model="formulario.frecuencia" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="false" name="frecuencia"><ui-select-match placeholder="{{\'Seleccione una opci\xF3n\'|translate}}"><span translate="">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="frecuencia.value as frecuencia in frecuencia | filter: $select.search"><span translate="">{{frecuencia.label}}</span></ui-select-choices></ui-select></div></div></div></div></div><div class="col-sm-4"><div ba-panel="" ba-panel-title="{{\'Datos ya ingresados\'|translate}}" ba-panel-class="xsmall-panel light-text paneles"><div class="form-group"><p class="form-muestra"><b>{{\'Nombre\'|translate}}:</b> {{formulario.evaluado.nombre}} {{formulario.evaluado.apellido}}</p><p class="form-muestra"><b>{{\'Edad\'|translate}}:</b> {{formulario.evaluado.edad}}</p><p class="form-muestra"><b>{{\'Sexo\'|translate}}:</b> {{formulario.evaluado.sexo}}</p><p class="form-muestra"><b>{{\'Email\'|translate}}:</b> {{formulario.evaluado.email}}</p></div></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{\'Datos biom\xE9tricos\'|translate}}" form="vm.formevaluaciones2"><form name="vm.formevaluaciones2" novalidate=""><div class="row"><div class="col-sm-12"><div ba-panel="" ba-panel-title="{{\'4 Pliegues\'|translate}}" ba-panel-class="xsmall-panel light-text paneles" ng-show="activePliegues"><div class="row"><div class="col-sm-3"><div class="form-group has-feedback input-poco-espacio" ng-class="{\'has-error\': vm.formevaluaciones2.triceps.$invalid && (vm.formevaluaciones2.triceps.$dirty || vm.formevaluaciones2.$submitted)}"><label for="inputLastName" translate="">Triceps</label><div class="input-group"><input type="text" class="form-control with-success-addon" id="inputtriceps" placeholder="{{\'Triceps\'|translate}}" ng-model="formulario.triceps" name="triceps" ng-pattern="regex" ng-required="activePliegues"> <span class="input-group-addon addon-right input-group-addon-success text-white">{{\'mm\'|metricunits}}.</span></div></div></div><div class="col-sm-3"><div class="form-group has-feedback input-poco-espacio" ng-class="{\'has-error\': vm.formevaluaciones2.subescapular.$invalid && (vm.formevaluaciones2.subescapular.$dirty || vm.formevaluaciones2.$submitted)}"><label for="inputLastName" translate="">Subescapular</label><div class="input-group"><input type="text" class="form-control with-success-addon" id="inputsubescapular" placeholder="{{\'Subescapular\'|translate}}" ng-model="formulario.subescapular" ng-pattern="regex" name="subescapular" ng-required="activePliegues"> <span class="input-group-addon addon-right input-group-addon-success text-white">{{\'mm\'|metricunits}}.</span></div></div></div><div class="col-sm-3"><div class="form-group has-feedback input-poco-espacio" ng-class="{\'has-error\': vm.formevaluaciones2.abdominal.$invalid && (vm.formevaluaciones2.abdominal.$dirty || vm.formevaluaciones2.$submitted)}"><label for="inputLastName" translate="">Abdominal</label><div class="input-group"><input type="text" class="form-control with-success-addon" id="inputabdominal" placeholder="{{\'Abdominal\'|translate}}" ng-model="formulario.abdominal" ng-pattern="regex" name="abdominal" ng-required="activePliegues"> <span class="input-group-addon addon-right input-group-addon-success text-white">{{\'mm\'|metricunits}}.</span></div></div></div><div class="col-sm-3"><div class="form-group has-feedback input-poco-espacio" ng-class="{\'has-error\': vm.formevaluaciones2.cuadriceps.$invalid && (vm.formevaluaciones2.cuadriceps.$dirty || vm.formevaluaciones2.$submitted)}"><label for="inputLastName" translate="">Cuadriceps</label><div class="input-group"><input type="text" class="form-control with-success-addon" id="inputcuadriceps" placeholder="{{\'Cuadriceps\'|translate}}" ng-model="formulario.cuadriceps" ng-pattern="regex" name="cuadriceps" ng-required="activePliegues"> <span class="input-group-addon addon-right input-group-addon-success text-white">{{\'mm\'|metricunits}}.</span></div></div></div></div></div></div></div><div class="row"><div ba-panel="" ba-panel-title="{{\'Ingrese informaci\xF3n\'|translate}}" ba-panel-class="xsmall-panel light-text paneles"><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluaciones2.pcintura.$invalid && (vm.formevaluaciones2.pcintura.$dirty || vm.formevaluaciones2.$submitted)}"><label for="inputLastName" translate="">Per\xEDmetro de Cintura</label><div class="input-group"><input type="text" class="form-control with-success-addon" id="inputpcintura" placeholder="{{\'Per\xEDmetro de Cintura\'|translate}}" ng-model="formulario.pcintura" ng-pattern="regex" name="pcintura" required=""> <span class="input-group-addon addon-right input-group-addon-success text-white">{{\'Cm\'|metricunits}}.</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluaciones2.pcadera.$invalid && (vm.formevaluaciones2.pcadera.$dirty || vm.formevaluaciones2.$submitted)}"><label for="inputLastName" translate="">Per\xEDmetro de Cadera</label><div class="input-group"><input type="text" class="form-control with-success-addon" id="inputpcadera" placeholder="{{\'Per\xEDmetro de Cadera\'|translate}}" ng-model="formulario.pcadera" ng-pattern="regex" name="pcadera" required=""> <span class="input-group-addon addon-right input-group-addon-success text-white">{{\'Cm\'|metricunits}}.</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluaciones2.pbrazod.$invalid && (vm.formevaluaciones2.pbrazod.$dirty || vm.formevaluaciones2.$submitted)}"><label for="inputLastName" translate="">Per\xEDmetro de Brazo Derecho</label><div class="input-group"><input type="text" class="form-control with-success-addon" id="inputpbrazod" placeholder="{{\'Per\xEDmetro de Brazo Derecho\'|translate}}" ng-model="formulario.pbrazod" ng-pattern="regex" name="pbrazod" required=""> <span class="input-group-addon addon-right input-group-addon-success text-white">{{\'Cm\'|metricunits}}.</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluaciones2.ppiernad.$invalid && (vm.formevaluaciones2.ppiernad.$dirty || vm.formevaluaciones2.$submitted)}"><label for="inputLastName" translate="">Per\xEDmetro de Pierna Derecha</label><div class="input-group"><input type="text" class="form-control with-success-addon" id="inputppiernad" placeholder="{{\'Per\xEDmetro de Pierna Derecha\'|translate}}" ng-model="formulario.ppiernad" ng-pattern="regex" name="ppiernad" required=""> <span class="input-group-addon addon-right input-group-addon-success text-white">{{\'Cm\'|metricunits}}.</span></div></div></div><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluaciones2.pcuello.$invalid && (vm.formevaluaciones2.pcuello.$dirty || vm.formevaluaciones2.$submitted)}" ng-show="activeCinta"><label for="inputLastName" translate="">Per\xEDmetro de Cuello</label><div class="input-group"><input type="text" class="form-control with-success-addon" id="inputpcadera" placeholder="{{\'Per\xEDmetro de Cuello\'|translate}}" ng-model="formulario.cuello" ng-pattern="regex" name="pcuello" ng-required="activeCinta"> <span class="input-group-addon addon-right input-group-addon-success text-white">{{\'Cm\'|metricunits}}.</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluaciones2.pgrasa.$invalid && (vm.formevaluaciones2.pgrasa.$dirty || vm.formevaluaciones2.$submitted)}" ng-show="activeBio"><label for="inputFirstName" translate="">Porcentaje de Grasa</label><div class="input-group"><input type="text" class="form-control with-success-addon" id="inputpgrasa" placeholder="{{\'Porcentaje de Grasa\'|translate}}" ng-model="formulario.pgrasa" name="pgrasa" ng-required="activeBio"> <span class="input-group-addon addon-right input-group-addon-success text-white">%</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluaciones2.pdiastolica.$invalid && (vm.formevaluaciones2.pdiastolica.$dirty || vm.formevaluaciones2.$submitted)}"><label for="inputLastName" translate="">Presi\xF3n Diast\xF3lica</label><div class="input-group"><input type="text" class="form-control with-success-addon" id="inputpdiastolica" placeholder="{{\'Presi\xF3n Diast\xF3lica\'|translate}}" ng-model="formulario.pdiastolica" name="pdiastolica" required=""> <span class="input-group-addon addon-right input-group-addon-success text-white">mmHg.</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluaciones2.psistolica.$invalid && (vm.formevaluaciones2.psistolica.$dirty || vm.formevaluaciones2.$submitted)}"><label for="inputLastName" translate="">Presi\xF3n Sist\xF3lica</label><div class="input-group"><input type="text" class="form-control with-success-addon" id="inputpsistolica" placeholder="{{\'Presi\xF3n Sist\xF3lica\'|translate}}" ng-model="formulario.psistolica" name="psistolica" required=""> <span class="input-group-addon addon-right input-group-addon-success text-white">mmHg.</span></div></div></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{\'Enviar Formulario\'|translate}}" class="form-final" form="formevaluaciones3"><div ng-include="\'app/pages/evaluaciones/addform3.html\'"></div></ba-wizard-step></ba-wizard>');
$templateCache.put('app/pages/evaluaciones/addform3.html','<h4 translate="">Estos son los datos que ingresaste</h4><div class="row"><div class="col-sm-6"><div ba-panel="" ba-panel-title="{{\'Informaci\xF3n B\xE1sica\'|translate}}" ba-panel-class="xsmall-panel light-text paneles"><div class="form-group"><p class="input-group form-final-error form-final-error" ng-show="!formulario.evaluado.nombre"><span class="label-form-final"><b>{{\'Evaluado\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.evaluado.nombre"><span class="label-form-final"><b>{{\'Evaluado\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.evaluado.nombre}} {{formulario.evaluado.apellido}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.evaluado.edad"><span class="label-form-final"><b>{{\'Edad\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.evaluado.edad"><span class="label-form-final"><b>{{\'Edad\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.evaluado.edad}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.evaluado.sexo"><span class="label-form-final"><b>{{\'Sexo\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.evaluado.sexo"><span class="label-form-final"><b>{{\'Sexo\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.evaluado.sexo|translate}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.evaluado.email"><span class="label-form-final"><b>{{\'Email\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.evaluado.email"><span class="label-form-final"><b>{{\'Email\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.evaluado.email}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.peso"><span class="label-form-final"><b>{{\'Peso\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.peso"><span class="label-form-final"><b>{{\'Peso\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.peso}} {{\'Kg\'|metricunits}}.</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.estatura"><span class="label-form-final"><b>{{\'Estatura\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.estatura"><span class="label-form-final"><b>{{\'Estatura\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.estatura}} {{\'Cm\'|metricunits}}.</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.fuma"><span class="label-form-final"><b>{{\'Fuma\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.fuma"><span class="label-form-final"><b>{{\'Fuma\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.fuma|translate}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.alcohol"><span class="label-form-final"><b>{{\'Alcohol\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.alcohol"><span class="label-form-final"><b>{{\'Alcohol\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.alcohol|translate}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.hace"><span class="label-form-final"><b ng-show="!formulario.frecuencia" translate="">Hace cuanto no entrena:</b><b ng-show="formulario.frecuencia" translate="">Hace cuanto entrena:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.hace"><span class="label-form-final"><b ng-show="!formulario.frecuencia" translate="">Hace cuanto no entrena:</b><b ng-show="formulario.frecuencia" translate="">Hace cuanto entrena:</b></span> <span class="dato-form-final">{{formulario.hace}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-correcto" ng-show="formulario.frecuencia"><span class="label-form-final"><b>{{\'Frecuencia entrenamiento\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.frecuencia}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div></div></div><div class="col-sm-6"><div ba-panel="" ba-panel-title="{{\'Informaci\xF3n 4 Pliegues\'|translate}}" ba-panel-class="xsmall-panel light-text paneles" ng-show="activePliegues"><div class="form-group"><p class="input-group form-final-error form-final-error" ng-show="!formulario.triceps"><span class="label-form-final"><b>{{\'Triceps\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.triceps"><span class="label-form-final"><b>{{\'Triceps\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.triceps}} {{\'mm\'|metricunits}}.</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.subescapular"><span class="label-form-final"><b>{{\'Subescapular\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.subescapular"><span class="label-form-final"><b>{{\'Subescapular\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.subescapular}} {{\'mm\'|metricunits}}.</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.abdominal"><span class="label-form-final"><b>{{\'Abdominal\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.abdominal"><span class="label-form-final"><b>{{\'Abdominal\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.abdominal}} {{\'mm\'|metricunits}}.</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.cuadriceps"><span class="label-form-final"><b>{{\'Cuadriceps\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.cuadriceps"><span class="label-form-final"><b>{{\'Cuadriceps\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.cuadriceps}} {{\'mm\'|metricunits}}.</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div></div><div ba-panel="" ba-panel-title="{{\'Informaci\xF3n Biom\xE9trica\'|translate}}" ba-panel-class="xsmall-panel light-text paneles"><div class="form-group"><p class="input-group form-final-error form-final-error" ng-show="!formulario.pcintura"><span class="label-form-final"><b>{{\'Per\xEDmetro de Cintura\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.pcintura"><span class="label-form-final"><b>{{\'Per\xEDmetro de Cintura\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.pcintura}} {{\'Cm\'|metricunits}}.</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.pcadera"><span class="label-form-final"><b>{{\'Per\xEDmetro de Cadera\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.pcadera"><span class="label-form-final"><b>{{\'Per\xEDmetro de Cadera\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.pcadera}} {{\'Cm\'|metricunits}}.</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.cuello && activeCinta"><span class="label-form-final"><b>{{\'Per\xEDmetro de Cuello\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.cuello"><span class="label-form-final"><b>{{\'Per\xEDmetro de Cuello\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.cuello}} {{\'Cm\'|metricunits}}.</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.pbrazod"><span class="label-form-final"><b>{{\'Per\xEDmetro de Brazo Derecho\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.pbrazod"><span class="label-form-final"><b>{{\'Per\xEDmetro de Brazo Derecho\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.pbrazod}} {{\'Cm\'|metricunits}}.</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.ppiernad"><span class="label-form-final"><b>{{\'Per\xEDmetro de Pierna Derecha\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.ppiernad"><span class="label-form-final"><b>{{\'Per\xEDmetro de Pierna Derecha\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.ppiernad}} {{\'Cm\'|metricunits}}.</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.pgrasa && activebio"><span class="label-form-final"><b>{{\'Porcentaje de Grasa\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.pgrasa && activebio"><span class="label-form-final"><b>{{\'Porcentaje de Grasa\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.pgrasa}}%</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.pdiastolica"><span class="label-form-final"><b>{{\'Presi\xF3n Diast\xF3lica\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.pdiastolica"><span class="label-form-final"><b>{{\'Presi\xF3n Diast\xF3lica\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.pdiastolica}} mmHg.</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.psistolica"><span class="label-form-final"><b>{{\'Presi\xF3n Sist\xF3lica\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.psistolica"><span class="label-form-final"><b>{{\'Presi\xF3n Sist\xF3lica\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.psistolica}} mmHg.</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><h5>{{\'Si los datos est\xE1n correctos env\xEDalos\'|translate}}:</h5></div></div><div class="col-sm-6"><div class="form-group"><button type="button" class="btn btn-primary" ng-click="enviardatos2(formulario)" ng-disabled="form-evaluador.$invalid" translate="">Enviar Datos</button></div></div></div>');
$templateCache.put('app/pages/evaluaciones/evaluaciones.html','<div ba-panel="" ba-panel-class="numero-page heading-widget" ba-panel-title="{{\'Listado Evaluaciones\'|translate}}" data-ng-init="init()"><div class="horizontal-scroll"><div class="col-md-3"><div class="form-group select-page-size-wrap"><label>{{\'Filas por P\xE1gina\'|translate}}<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [2,5,10,15,20,25]"></select></label></div></div><div class="col-md-6"><div class="alert bg-{{messagedata.type}}" ng-show="messagedata.message">{{messagedata.message|translate}}<p class="mensaje-errores" ng-repeat="error in messagedata.errors.error.message" ng-show="messagedata.errors">{{error|translate}}</p></div></div><div class="col-md-3"><button type="button" class="btn btn-primary btn-with-icon boton-agregar-smart" data-toggle="modal" ng-click="openmodal(\'app/pages/evaluaciones/addform.html\', \'lg\')" ng-show="currentUser.type != 2"><i class="ion-plus-round"></i>{{ \'Agregar\' | translate }}</button></div><table class="table" st-table="datosmuestra" st-safe-src="datos"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="nombre" translate="">Nombre</th><th st-sort="apellido" translate="">Apellido</th><th st-sort="email" translate="">Email</th><th st-sort="fecha" translate="">Fecha Creaci\xF3n</th><th translate="">Acci\xF3n</th></tr><tr><th></th><th><input st-search="nombre" placeholder="{{\'Filtrar Por Nombre\'|translate}}" class="input-sm form-control search-input" type="search"></th><th><input st-search="apellido" placeholder="{{\'Filtrar por Apellido\'|translate}}" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" placeholder="{{\'Filtrar por Email\'|translate}}" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody ng-show="loading"><tr><td colspan="8" class="table-empty"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></td></tr></tbody><tbody ng-show="bool"><tr ng-repeat="dato in datosmuestra"><td>{{dato.ident}}</td><td>{{dato.nombre}}</td><td>{{dato.apellido}}</td><td><a class="email-link" ng-href="mailto:{{dato.email}}">{{dato.email}}</a></td><td>{{dato.created_at | asDate | date:\'dd-MM-yyyy\'}}</td><td><button title="{{\'Ver M\xE1s\'|translate}}" type="button" class="btn btn-primary btn-icon btn-accion" data-toggle="modal" ng-click="ver(dato.id)"><i class="ion-eye"></i></button><button title="{{\'Eliminar\'|translate}}" type="button" class="btn btn-danger btn-icon btn-accion" data-toggle="modal" ng-click="elimina(dato.id)" ng-show="currentUser.type != 2"><i class="ion-trash-b"></i></button></td></tr></tbody><tbody ng-show="!bool"><tr><td colspan="8" class="table-empty"><h3>{{\'A\xFAn no hay datos para mostrar\'|translate}}<span ng-show="currentUser.type != 2">, {{\'crea tu primera evaluaci\xF3n ahora\'|translate}}</span>.</h3><button type="button" class="btn btn-primary btn-with-icon" data-toggle="modal" ng-click="openmodal(\'app/pages/evaluaciones/addform.html\', \'lg\')" ng-show="currentUser.type != 2"><i class="ion-plus-round"></i>{{\'Agregar Evaluaci\xF3n\'|translate}}</button></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/evaluador/evaluador.html','<div class="modal-content" data-ng-init="init()"><div class="modal-header"><h4 class="modal-title" id="myModalLabel" translate="">Ficha Evaluador</h4></div><div ng-show="!loading" class="cargando"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></div><div class="modal-body" ng-show="loading"><uib-tabset><uib-tab heading="{{\'Datos Personales\'|translate}}"><div ng-include="\'app/pages/evaluador/evaluador1.html\'"></div></uib-tab><uib-tab heading="{{\'Datos Clientes\'|translate}}"><div ng-include="\'app/pages/evaluador/evaluador2.html\'"></div></uib-tab><uib-tab heading="{{\'Evaluaciones Realizadas\'|translate}}"><div ng-include="\'app/pages/evaluador/evaluador3.html\'"></div></uib-tab><uib-tab heading="{{\'Cr\xE9ditos\'|translate}}"><div ng-include="\'app/pages/evaluador/evaluador4.html\'"></div></uib-tab></uib-tabset></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/evaluador/evaluador1.html','<div class="row"><div class="col-sm-4"><div class="form-group"><div class="userpic-wrapper"><img ng-src="http://apiintplus.rfit.cl/assets/img/perfiles/{{ viewevaluador.datos.img_url }}"></div></div></div><div class="col-sm-4"><div class="form-group"><b>{{\'Nombre\'|translate}}:</b> {{viewevaluador.datos.nombre}} {{viewevaluador.datos.apellido}}</div><div class="form-group"><b>{{\'Sexo\'|translate}}:</b> {{viewevaluador.datos.sexo|translate}}</div><div class="form-group"><b>{{\'Email\'|translate}}:</b> {{viewevaluador.datos.email}}</div><div class="form-group"><b>{{\'Tel\xE9fono\'|translate}}:</b> +{{phonecode}} {{viewevaluador.datos.telefono}}</div><div class="form-group"><b>{{\'Nacimiento\'|translate}}:</b> {{viewevaluador.datos.nacimiento | asDate | date:\'dd-MM-yyyy\'}}</div><div class="form-group"><b>{{\'Edad\'|translate}}:</b> {{viewevaluador.datos.edad}}</div></div><div class="col-sm-4"><div class="form-group"><b>{{\'Pa\xEDs\'|translate}}:</b> {{viewevaluador.pais.name}}</div><div class="form-group"><b>{{\'Regi\xF3n\'|translate}}:</b> {{viewevaluador.datos.region}}</div><div class="form-group"><b>{{\'Direcci\xF3n\'|translate}}:</b> {{viewevaluador.datos.direccion}}</div><div class="form-group"><b>{{\'Comuna\'|translate}}:</b> {{viewevaluador.datos.comuna}}</div><div class="form-group"><b>{{\'Especialidad\'|translate}}:</b> {{viewevaluador.datos.especialidad|translate}}</div><div class="form-group"><b>{{\'Trabajo\'|translate}}:</b> {{viewevaluador.datos.trabajo|translate}}</div><div class="form-group" ng-show="viewevaluador.datos.empresa"><b>{{\'Empresa\'|translate}}:</b> {{viewevaluador.datos.empresa}}</div></div></div>');
$templateCache.put('app/pages/evaluador/evaluador2.html','<table class="table" st-table="datosmuestra" st-safe-src="datosclientes"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="nombre" translate="">Nombre</th><th translate="">Tel\xE9fono</th><th st-sort="email" translate="">Email</th><th translate="">Ver</th></tr></thead><tbody><tr ng-repeat="dato in datosmuestra"><td>{{dato.ident}}</td><td>{{dato.nombre}} {{dato.apellido}}</td><td>{{dato.telefono}}</td><td>{{dato.email}}</td><td><button title="{{\'Ver M\xE1s\'|translate}}" type="button" class="btn btn-primary btn-icon btn-accion" data-toggle="modal" ng-click="ver(\'app/pages/evaluados/view.html\', \'lg\', dato.id_usuario)"><i class="ion-eye"></i></button></td><td></td></tr></tbody><tbody ng-show="!boolevaluado"><tr><td colspan="6" class="table-empty"><h3 translate="">Este evaluador no ha ingresado ning\xFAn usuario</h3></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="5" st-displayed-pages="5"></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/evaluador/evaluador3.html','<table class="table" st-table="datosmuestra" st-safe-src="datosevaluaciones"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th translate="">Nombre Cliente</th><th translate="">Email</th><th translate="">Fecha Creaci\xF3n</th><th translate="">Ver</th></tr></thead><tbody><tr ng-repeat="dato in datosmuestra"><td>{{dato.ident}}</td><td>{{dato.nombre}} {{dato.apellido}}</td><td>{{dato.email}}</td><td>{{dato.created_at | asDate | date:\'dd-MM-yyyy\'}}</td><td><button title="{{\'Ver M\xE1s\'|translate}}" type="button" class="btn btn-primary btn-icon btn-accion" data-toggle="modal" ng-click="verevaluacion(dato.id)"><i class="ion-eye"></i></button></td><td></td></tr></tbody><tbody ng-show="!boolevaluaciones"><tr><td colspan="6" class="table-empty"><h3 translate="">Este evaluador no ha generado evaluaciones</h3></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="5" st-displayed-pages="5"></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/evaluador/evaluador4.html','<div ba-panel="" ba-panel-title="{{\'Cr\xE9ditos del Evaluador\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="row"><div class="col-sm-4"><div class="form-group"><b>{{\'Cr\xE9ditos Utilizados\'|translate}}:</b> <span class="dato">{{contador}}</span></div><div class="form-group"><b>{{\'Cr\xE9ditos Restantes\'|translate}}:</b> <span class="dato">{{creditosusuario}}</span></div></div><div class="col-sm-4"><button type="button" class="btn btn-success btn-with-icon" ng-click="creditos(\'suma\')"><i class="ion-plus"></i>{{\'Agregar Cr\xE9ditos\'|translate}}</button> <button type="button" class="btn btn-danger btn-with-icon" ng-click="creditos(\'resta\')"><i class="ion-minus"></i>{{\'Quitar Cr\xE9ditos\'|translate}}</button></div><div class="col-sm-4"><label for="input01">{{\'Tienes\'|translate}} {{currentUser.creditos}} {{\'cr\xE9ditos para compartir\'|translate}}</label><div class="form-group" ng-show="tipo"><input type="text" class="form-control" id="input01" placeholder="{{\'Cantidad de cr\xE9ditos\'|translate}}" ng-model="input.creditos"><div class="button-wrapper"><button type="button" class="btn btn-success btn-mm" ng-click="cambiacreditos(input.creditos)">{{\'Modificar\'|translate}}</button></div></div><div class="alert bg-{{messagedata.type}}" ng-show="messagedata.message">{{messagedata.message|translate}}<p class="mensaje-errores" ng-repeat="error in messagedata.errors.error.message" ng-show="messagedata.errors">{{error|translate}}</p></div></div></div></div>');
$templateCache.put('app/pages/evaluadores/addform - copia.html','<div class="modal-content" ng-controller="FormEvaluadoresCtrl as vm"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Agregar Evaluador</h4></div><div class="modal-body"><div ba-panel="" ba-panel-title="Datos de Evaluador" ba-panel-class="with-scroll panel-success"><ba-wizard><ba-wizard-step title="Datos Personales" form="vm.formevaluador2"><div class="form-group row clearfix"><div class="col-sm-4"><label for="inputFirstName" class="control-label">Imagen de Perfil</label><div class="aviso-imagen warning" ng-show="errorimagen"><i class="ion-alert-circled"></i> {{errorimagen}}</div></div><div class="col-sm-8"><div class="userpic img-forms"><div class="userpic-wrapper"><img ng-src="http://apiintplus.rfit.cl/assets/img/perfiles/{{ viewevaluador.img_url }}" ngf-accept="\'image/*\'" ngf-max-size="300KB" ngf-resize-if="$width > 300 || $height > 300" ngf-resize="{width: 300, height: 300, quality: .8, type: \'image/jpeg\', ratio: \'1:1\', centerCrop: true, restoreExif: false}" ngf-select="uploadFiles($file, $invalidFiles)"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div><form name="vm.formevaluador2" novalidate=""><div class="row"><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.nombre.$invalid && (vm.formevaluador2.nombre.$dirty || vm.formevaluador2.$submitted)}"><label for="inputFirstName">Nombre</label> <input type="text" class="form-control" id="inputnombre" placeholder="Nombre" ng-model="formulario.nombre" name="nombre" required=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.apellido.$invalid && (vm.formevaluador2.apellido.$dirty || vm.formevaluador2.$submitted)}"><label for="inputLastName">Apellido</label> <input type="text" class="form-control" id="inputapellido" placeholder="Apellido" ng-model="formulario.apellido" name="apellido" required=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.sexo.$invalid && (vm.formevaluador2.sexo.$dirty || vm.formevaluador2.$submitted)}"><label for="inputsexo">Sexo</label><ui-select ng-model="formulario.sexo" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="false" name="sexo" required=""><ui-select-match placeholder="Seleccione su Sexo"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="sexo.label as sexo in sexos | filter: $select.search"><span ng-bind-html="sexo.label"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.region.$invalid && (vm.formevaluador2.region.$dirty || vm.formevaluador2.$submitted)}"><label for="inputregion">Regi\xF3n</label> <input type="text" class="form-control" id="inputregion" placeholder="Regi\xF3n" ng-model="formulario.region" name="region" required=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.comuna.$invalid && (vm.formevaluador2.comuna.$dirty || vm.formevaluador2.$submitted)}"><label for="inputcomuna">Comuna</label> <input type="text" class="form-control" id="inputcomuna" placeholder="Comuna" ng-model="formulario.comuna" name="comuna" required=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.direccion.$invalid && (vm.formevaluador2.direccion.$dirty || vm.formevaluador2.$submitted)}"><label for="inputdireccion">Direcci\xF3n</label> <input type="text" class="form-control" id="inputdireccion" placeholder="Direcci\xF3n" ng-model="formulario.direccion" name="direccion" required=""></div></div><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.rut.$invalid && (vm.formevaluador2.rut.$dirty || vm.formevaluador2.$submitted)}"><label for="inputLastName">Rut</label> <input type="text" class="form-control" id="inputrut" placeholder="Rut" ng-model="formulario.rut" name="rut" ng-rut="" required=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.email.$invalid && (vm.formevaluador2.email.$dirty || vm.formevaluador2.$submitted)}"><label for="inputEmail">Email</label> <input type="email" class="form-control" id="inputemail" placeholder="Email" ng-model="formulario.email" name="email" required=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.telefono.$invalid && (vm.formevaluador2.telefono.$dirty || vm.formevaluador2.$submitted)}"><label for="inputTelefono">Tel\xE9fono</label><div class="input-group"><span class="input-group-addon input-group-addon-primary addon-left" id="basic-addon1">+56</span> <input type="number" class="form-control with-primary-addon" id="inputtelefono" placeholder="Tel\xE9fono" ng-model="formulario.telefono" name="telefono" ng-minlength="8" ng-maxlength="9" ng-pattern="onlyNumbers" required=""></div></div><div class="form-group has-feedback nacimiento-nuevo" ng-class="{\'has-error\': vm.formevaluador2.nacimiento.$invalid && (vm.formevaluador2.nacimiento.$dirty || vm.formevaluador2.$submitted)}"><label for="inputnacimiento">Fecha de Nacimiento</label><div class="row"><div class="col-sm-4"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.dia.$invalid && (vm.formevaluador2.dia.$dirty || vm.formevaluador2.$submitted)}"><ui-select ng-model="formulario.dia" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" name="dia" required=""><ui-select-match placeholder="D\xEDa"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="dia.label as dia in dias | filter: $select.search"><span ng-bind-html="dia.label"></span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.mes.$invalid && (vm.formevaluador2.mes.$dirty || vm.formevaluador2.$submitted)}"><ui-select ng-model="formulario.mes" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" name="mes" required=""><ui-select-match placeholder="Mes"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="mes.label as mes in meses | filter: $select.search"><span ng-bind-html="mes.label"></span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.year.$invalid && (vm.formevaluador2.year.$dirty || vm.formevaluador2.$submitted)}"><input type="number" class="form-control" id="inputyear" placeholder="A\xF1o" ng-model="formulario.year" name="year" ng-min="1950" ng-max="2017" ng-pattern="onlyNumbers" required=""></div></div></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.especialidad.$invalid && (vm.formevaluador2.especialidad.$dirty || vm.formevaluador2.$submitted)}"><label for="inputespecialidad">Especialidad</label><ui-select ng-model="formulario.especialidad" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" name="especialidad" required=""><ui-select-match placeholder="Seleccione su Especialidad"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="especialidad.label as especialidad in especialidades | filter: $select.search"><span ng-bind-html="especialidad.label"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.trabajo.$invalid && (vm.formevaluador2.trabajo.$dirty || vm.formevaluador2.$submitted)}"><label for="inputtrabajo">Trabajo</label><ui-select ng-model="formulario.trabajo" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false" name="trabajo" required=""><ui-select-match placeholder="Tipo de Trabajo"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="trabajo.label as trabajo in trabajos | filter: $select.search"><span ng-bind-html="trabajo.label"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.empresa.$invalid && (vm.formevaluador2.empresa.$dirty || vm.formevaluador2.$submitted)}" ng-show="formulario.trabajo == \'Dependiente\'"><label for="inputempresa">Empresa</label> <input type="text" class="form-control" id="inputempresa" placeholder="Empresa" ng-model="formulario.empresa" name="empresa"></div></div></div></form></ba-wizard-step><ba-wizard-step title="Enviar Formulario" class="form-final" form="formevaluador3"><h4>Estos son los datos que ingresaste</h4><div class="row"><div class="col-sm-6"><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.email"><span class="label-form-final"><b>Email:</b></span><span class="dato-form-final">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.email"><span class="label-form-final"><b>Email:</b></span> <span class="dato-form-final">{{formulario.email}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error form-final-error" ng-show="!formulario.nombre"><span class="label-form-final"><b>Nombre:</b></span> <span class="dato-form-final">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.nombre"><span class="label-form-final"><b>Nombre:</b></span> <span class="dato-form-final">{{formulario.nombre}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.apellido"><span class="label-form-final"><b>Apellido:</b></span> <span class="dato-form-final">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.apellido"><span class="label-form-final"><b>Apellido:</b></span> <span class="dato-form-final">{{formulario.apellido}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.rut"><span class="label-form-final"><b>Rut:</b></span> <span class="dato-form-final">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.rut"><span class="label-form-final"><b>Rut:</b></span> <span class="dato-form-final">{{formulario.rut | rut}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.sexo"><span class="label-form-final"><b>Sexo:</b></span> <span class="dato-form-final">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.sexo"><span class="label-form-final"><b>Sexo:</b></span> <span class="dato-form-final">{{formulario.sexo}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.telefono"><span class="label-form-final"><b>Tel\xE9fono:</b></span> <span class="dato-form-final">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.telefono"><span class="label-form-final"><b>Tel\xE9fono:</b></span> <span class="dato-form-final">{{formulario.telefono}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div></div><div class="col-sm-6"><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.region"><span class="label-form-final"><b>Regi\xF3n:</b></span> <span class="dato-form-final">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.region"><span class="label-form-final"><b>Regi\xF3n:</b></span> <span class="dato-form-final">{{formulario.region}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.comuna"><span class="label-form-final"><b>Comuna:</b></span> <span class="dato-form-final">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.comuna"><span class="label-form-final"><b>Comuna:</b></span> <span class="dato-form-final">{{formulario.comuna}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.direccion"><span class="label-form-final"><b>Direcci\xF3n:</b></span> <span class="dato-form-final">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.direccion"><span class="label-form-final"><b>Direcci\xF3n:</b></span> <span class="dato-form-final">{{formulario.direccion}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.dia || !formulario.mes || !formulario.year"><span class="label-form-final"><b>Fecha Nacimiento:</b></span> <span class="dato-form-final">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.dia && formulario.mes && formulario.year"><span class="label-form-final"><b>Fecha Nacimiento:</b></span> <span class="dato-form-final">{{formulario.dia}}-{{formulario.mes}}-{{formulario.year}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.especialidad"><span class="label-form-final"><b>Especialidad:</b></span> <span class="dato-form-final">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.especialidad"><span class="label-form-final"><b>Especialidad:</b></span> <span class="dato-form-final">{{formulario.especialidad}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.trabajo"><span class="label-form-final"><b>Trabajo:</b></span> <span class="dato-form-final">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.trabajo"><span class="label-form-final"><b>Trabajo:</b></span> <span class="dato-form-final">{{formulario.trabajo}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-correcto" ng-show="formulario.empresa"><span class="label-form-final"><b>Empresa:</b></span> <span class="dato-form-final">{{formulario.empresa}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><h5>Si los datos est\xE1n correctos env\xEDalos:</h5></div></div><div class="col-sm-6"><div class="form-group"><button type="button" class="btn btn-primary" ng-click="enviardatos(formulario)" ng-disabled="form-evaluador.$invalid || enviando">Enviar Datos</button><span ng-show="enviando"><i class="fa fa-spinner fa-pulse fa-fw"></i>Estamos procesando en ingreso</span></div></div></div></ba-wizard-step></ba-wizard></div></div></div>');
$templateCache.put('app/pages/evaluadores/addform.html','<div class="modal-content" ng-controller="FormEvaluadoresCtrl as vm"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel" translate="">Agregar Evaluador</h4></div><div class="modal-body"><div ba-panel="" ba-panel-title="{{\'Datos de Evaluador\'|translate}}" ba-panel-class="with-scroll panel-success"><ba-wizard><ba-wizard-step title="{{\'Datos Personales\'|translate}}" form="vm.formevaluador2"><div class="form-group row clearfix"><div class="col-sm-4"><label for="inputFirstName" class="control-label" translate="">Imagen de Perfil</label><div class="aviso-imagen warning" ng-show="errorimagen"><i class="ion-alert-circled"></i> {{errorimagen|translate}}</div></div><div class="col-sm-8"><div class="userpic img-forms"><div class="userpic-wrapper"><img ng-src="http://apiintplus.rfit.cl/assets/img/perfiles/{{ viewevaluador.img_url }}" ngf-accept="\'image/*\'" ngf-max-size="300KB" ngf-resize-if="$width > 300 || $height > 300" ngf-resize="{width: 300, height: 300, quality: .8, type: \'image/jpeg\', ratio: \'1:1\', centerCrop: true, restoreExif: false}" ngf-select="uploadFiles($file, $invalidFiles)"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div><form name="vm.formevaluador2" novalidate=""><div class="row"><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.nombre.$invalid && (vm.formevaluador2.nombre.$dirty || vm.formevaluador2.$submitted)}"><label for="inputFirstName" translate="">Nombre</label> <input type="text" class="form-control" id="inputnombre" placeholder="{{\'Nombre\'|translate}}" ng-model="formulario.nombre" name="nombre" required=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.apellido.$invalid && (vm.formevaluador2.apellido.$dirty || vm.formevaluador2.$submitted)}"><label for="inputLastName" translate="">Apellido</label> <input type="text" class="form-control" id="inputapellido" placeholder="{{\'Apellido\'|translate}}" ng-model="formulario.apellido" name="apellido" required=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.sexo.$invalid && (vm.formevaluador2.sexo.$dirty || vm.formevaluador2.$submitted)}"><label for="inputsexo" translate="">Sexo</label><ui-select ng-model="formulario.sexo" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="false" name="sexo" required=""><ui-select-match placeholder="{{\'Seleccione su Sexo\'|translate}}"><span translate="">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="sexo.label as sexo in sexos | filter: $select.search"><span translate="">{{sexo.label}}</span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.email.$invalid && (vm.formevaluador2.email.$dirty || vm.formevaluador2.$submitted)}"><label for="inputEmail" translate="">Email</label> <input type="email" class="form-control" id="inputemail" placeholder="{{\'Email\'|translate}}" ng-model="formulario.email" name="email" required=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.telefono.$invalid && (vm.formevaluador2.telefono.$dirty || vm.formevaluador2.$submitted)}"><label for="inputTelefono" translate="">Tel\xE9fono</label><div class="input-group"><span class="input-group-addon input-group-addon-primary addon-left" id="basic-addon1">+{{selectedphonecode}}</span> <input type="number" class="form-control with-primary-addon" id="inputtelefono" placeholder="{{\'Tel\xE9fono\'|translate}}" ng-model="formulario.telefono" name="telefono" ng-pattern="onlyNumbers" required=""></div></div><div class="form-group has-feedback nacimiento-nuevo" ng-class="{\'has-error\': vm.formevaluador2.nacimiento.$invalid && (vm.formevaluador2.nacimiento.$dirty || vm.formevaluador2.$submitted)}"><label for="inputnacimiento" translate="">Fecha de Nacimiento</label><div class="row"><div class="col-sm-4"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.dia.$invalid && (vm.formevaluador2.dia.$dirty || vm.formevaluador2.$submitted)}"><ui-select ng-model="formulario.dia" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" name="dia" required=""><ui-select-match placeholder="{{\'D\xEDa\'|translate}}"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="dia.label as dia in dias | filter: $select.search"><span ng-bind-html="dia.label"></span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.mes.$invalid && (vm.formevaluador2.mes.$dirty || vm.formevaluador2.$submitted)}"><ui-select ng-model="formulario.mes" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" name="mes" required=""><ui-select-match placeholder="{{\'Mes\'|translate}}"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="mes.label as mes in meses | filter: $select.search"><span ng-bind-html="mes.label"></span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group has-feedback year-form" ng-class="{\'has-error\': vm.formevaluador2.year.$invalid && (vm.formevaluador2.year.$dirty || vm.formevaluador2.$submitted)}"><input type="number" class="form-control" id="inputyear" placeholder="{{\'A\xF1o\'|translate}}" ng-model="formulario.year" name="year" ng-min="1930" ng-max="2005" ng-pattern="onlyNumbers" required=""></div><span class="min-text2" translate="">(Entre 1930 y 2005)</span></div></div></div></div><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.pais.$invalid && (vm.formevaluador2.pais.$dirty || vm.formevaluador2.$submitted)}"><label for="inputpais" translate="">Pa\xEDs</label><ui-select ng-model="formulario.pais" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="true" name="pais" required="" ng-change="sacastates(formulario.pais.id,formulario.pais.phonecode)"><ui-select-match placeholder="{{\'Seleccione su Pa\xEDs\'|translate}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="pais as pais in countries | filter: $select.search"><span ng-bind-html="pais.name"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.region.$invalid && (vm.formevaluador2.region.$dirty || vm.formevaluador2.$submitted)}"><label for="inputregion" translate="">Regi\xF3n</label><ui-select ng-model="formulario.region" class="btn-group bootstrap-select form-control select-index" ng-disabled="!states" append-to-body="true" search-enabled="true" name="region" required="" ng-change="sacacities(formulario.region.id)"><ui-select-match placeholder="{{\'Seleccione su Regi\xF3n\'|translate}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="region as region in states | filter: $select.search"><span ng-bind-html="region.name"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.comuna.$invalid && (vm.formevaluador2.comuna.$dirty || vm.formevaluador2.$submitted)}"><label for="inputcomuna" translate="">Comuna</label><ui-select ng-model="formulario.comuna" class="btn-group bootstrap-select form-control select-index" append-to-body="true" search-enabled="true" name="comuna" ng-disabled="!cities" required=""><ui-select-match placeholder="{{\'Seleccione su Comuna\'|translate}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="comuna as comuna in cities | filter: $select.search"><span ng-bind-html="comuna.name"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.direccion.$invalid && (vm.formevaluador2.direccion.$dirty || vm.formevaluador2.$submitted)}"><label for="inputdireccion" translate="">Direcci\xF3n</label> <input type="text" class="form-control" id="inputdireccion" placeholder="{{\'Direcci\xF3n\'|translate}}" ng-model="formulario.direccion" name="direccion" required=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.especialidad.$invalid && (vm.formevaluador2.especialidad.$dirty || vm.formevaluador2.$submitted)}"><label for="inputespecialidad" translate="">Especialidad</label><ui-select ng-model="formulario.especialidad" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" name="especialidad" required=""><ui-select-match placeholder="{{\'Seleccione su Especialidad\'|translate}}"><span translate="">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="especialidad.label as especialidad in especialidades | filter: $select.search"><span translate="">{{especialidad.label}}</span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.trabajo.$invalid && (vm.formevaluador2.trabajo.$dirty || vm.formevaluador2.$submitted)}"><label for="inputtrabajo" translate="">Trabajo</label><ui-select ng-model="formulario.trabajo" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false" name="trabajo" required=""><ui-select-match placeholder="{{\'Tipo de Trabajo\'|translate}}"><span translate="">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="trabajo.label as trabajo in trabajos | filter: $select.search"><span translate="">{{trabajo.label}}</span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.empresa.$invalid && (vm.formevaluador2.empresa.$dirty || vm.formevaluador2.$submitted)}" ng-show="formulario.trabajo == \'Dependiente\'"><label for="inputempresa" translate="">Empresa</label> <input type="text" class="form-control" id="inputempresa" placeholder="{{\'Empresa\'|translate}}" ng-model="formulario.empresa" name="empresa"></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{\'Enviar Formulario\'|translate}}" class="form-final" form="formevaluador3"><h4 translate="">Estos son los datos que ingresaste</h4><div class="row"><div class="col-sm-6"><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.email"><span class="label-form-final"><b>{{\'Email\'|translate}}:</b></span><span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.email"><span class="label-form-final"><b>{{\'Email\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.email}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error form-final-error" ng-show="!formulario.nombre"><span class="label-form-final"><b>{{\'Nombre\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.nombre"><span class="label-form-final"><b>{{\'Nombre\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.nombre}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.apellido"><span class="label-form-final"><b>{{\'Apellido\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.apellido"><span class="label-form-final"><b>{{\'Apellido\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.apellido}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.sexo"><span class="label-form-final"><b>{{\'Sexo\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.sexo"><span class="label-form-final"><b>{{\'Sexo\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.sexo|translate}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.telefono"><span class="label-form-final"><b>{{\'Tel\xE9fono\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.telefono"><span class="label-form-final"><b>{{\'Tel\xE9fono\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.telefono}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.dia || !formulario.mes || !formulario.year"><span class="label-form-final"><b>{{\'Fecha Nacimiento\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.dia && formulario.mes && formulario.year"><span class="label-form-final"><b>{{\'Fecha Nacimiento\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.dia}}-{{formulario.mes}}-{{formulario.year}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div></div><div class="col-sm-6"><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.pais"><span class="label-form-final"><b>{{\'Pa\xEDs\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.pais.name"><span class="label-form-final"><b>{{\'Pa\xEDs\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.pais.name}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.region.name"><span class="label-form-final"><b>{{\'Regi\xF3n\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.region.name"><span class="label-form-final"><b>{{\'Regi\xF3n\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.region.name}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.comuna.name"><span class="label-form-final"><b>{{\'Comuna\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.comuna.name"><span class="label-form-final"><b>{{\'Comuna\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.comuna.name}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.direccion"><span class="label-form-final"><b>{{\'Direcci\xF3n\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.direccion"><span class="label-form-final"><b>{{\'Direcci\xF3n\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.direccion}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.especialidad"><span class="label-form-final"><b>{{\'Especialidad\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.especialidad"><span class="label-form-final"><b>{{\'Especialidad\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.especialidad|translate}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.trabajo"><span class="label-form-final"><b>{{\'Trabajo\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.trabajo"><span class="label-form-final"><b>{{\'Trabajo\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.trabajo|translate}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-correcto" ng-show="formulario.empresa"><span class="label-form-final"><b>{{\'Empresa\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.empresa}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><h5>{{\'Si los datos est\xE1n correctos env\xEDalos\'|translate}}:</h5></div></div><div class="col-sm-6"><div class="form-group"><button type="button" class="btn btn-primary" ng-click="enviardatos(formulario)" ng-disabled="form-evaluador.$invalid || enviando" translate="">Enviar Datos</button><span ng-show="enviando"><i class="fa fa-spinner fa-pulse fa-fw"></i>{{\'Estamos procesando el ingreso\'|translate}}</span></div></div></div></ba-wizard-step></ba-wizard></div></div></div>');
$templateCache.put('app/pages/evaluadores/editform.html','<div class="modal-content" ng-controller="FormEvaluadoresCtrl as vm" ng-init="initedit()"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel" translate="">Editar Evaluador</h4></div><div class="modal-body"><div ba-panel="" ba-panel-title="{{\'Datos de Evaluador\'|translate}}" ba-panel-class="with-scroll panel-success"><form name="vm.formevaluador2" novalidate=""><div class="form-group row clearfix"><div class="col-sm-4"><label for="inputFirstName" class="control-label" translate="">Imagen de Perfil</label><div class="aviso-imagen warning" ng-show="errorimagen"><i class="ion-alert-circled"></i> {{errorimagen|translate}}</div></div><div class="col-sm-8"><div class="userpic img-forms"><div class="userpic-wrapper"><img ng-src="http://apiintplus.rfit.cl/assets/img/perfiles/{{ viewevaluador.img_url }}" ngf-accept="\'image/*\'" ngf-max-size="300KB" ngf-resize-if="$width > 300 || $height > 300" ngf-resize="{width: 300, height: 300, quality: .8, type: \'image/jpeg\', ratio: \'1:1\', centerCrop: true, restoreExif: false}" ngf-select="uploadFiles($file, $invalidFiles)"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.nombre.$invalid && (vm.formevaluador2.nombre.$dirty || vm.formevaluador2.$submitted)}"><label for="inputFirstName" translate="">Nombre</label> <input type="text" class="form-control" id="inputnombre" placeholder="{{viewevaluador.nombre}}" ng-model="formulario.nombre" name="nombre"></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.apellido.$invalid && (vm.formevaluador2.apellido.$dirty || vm.formevaluador2.$submitted)}"><label for="inputLastName" translate="">Apellido</label> <input type="text" class="form-control" id="inputapellido" placeholder="{{viewevaluador.apellido}}" ng-model="formulario.apellido" name="apellido"></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.sexo.$invalid && (vm.formevaluador2.sexo.$dirty || vm.formevaluador2.$submitted)}"><label for="inputsexo" translate="">Sexo</label><ui-select ng-model="formulario.sexo" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="false" name="sexo"><ui-select-match placeholder="{{viewevaluador.sexo}}"><span translate="">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="sexo.label as sexo in sexos | filter: $select.search"><span translate="">{{sexo.label}}</span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.pais.$invalid && (vm.formevaluador2.pais.$dirty || vm.formevaluador2.$submitted)}"><label for="inputpais" translate="">Pa\xEDs</label><ui-select ng-model="formulario.pais" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="true" name="pais" required="" ng-change="sacastates(formulario.pais.id,formulario.pais.phonecode)"><ui-select-match placeholder="{{viewevaluador.pais}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="pais as pais in countries | filter: $select.search"><span ng-bind-html="pais.name"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.region.$invalid && (vm.formevaluador2.region.$dirty || vm.formevaluador2.$submitted)}"><label for="inputregion" translate="">Regi\xF3n</label><ui-select ng-model="formulario.region" class="btn-group bootstrap-select form-control select-index" ng-disabled="!states" append-to-body="true" search-enabled="true" name="region" required="" ng-change="sacacities(formulario.region.id)"><ui-select-match placeholder="{{\'Seleccione su Regi\xF3n\'|translate}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="region as region in states | filter: $select.search"><span ng-bind-html="region.name"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.comuna.$invalid && (vm.formevaluador2.comuna.$dirty || vm.formevaluador2.$submitted)}"><label for="inputcomuna" translate="">Comuna</label><ui-select ng-model="formulario.comuna" class="btn-group bootstrap-select form-control select-index" append-to-body="true" search-enabled="true" name="comuna" ng-disabled="!cities" required=""><ui-select-match placeholder="{{\'Seleccione su Comuna\'|translate}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="comuna as comuna in cities | filter: $select.search"><span ng-bind-html="comuna.name"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.direccion.$invalid && (vm.formevaluador2.direccion.$dirty || vm.formevaluador2.$submitted)}"><label for="inputdireccion" translate="">Direcci\xF3n</label> <input type="text" class="form-control" id="inputdireccion" placeholder="{{viewevaluador.direccion}}" ng-model="formulario.direccion" name="direccion"></div></div><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.email.$invalid && (vm.formevaluador2.email.$dirty || vm.formevaluador2.$submitted)}"><label for="inputEmail" translate="">Email</label> <input type="email" class="form-control" id="inputemail" placeholder="{{viewevaluador.email}}" ng-model="formulario.email" name="email" disabled=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.telefono.$invalid && (vm.formevaluador2.telefono.$dirty || vm.formevaluador2.$submitted)}"><label for="inputTelefono" translate="">Tel\xE9fono</label><div class="input-group"><span class="input-group-addon input-group-addon-primary addon-left" id="basic-addon1">+{{selectedphonecode}}</span> <input type="number" class="form-control with-primary-addon" id="inputtelefono" placeholder="{{viewevaluador.telefono}}" ng-model="formulario.telefono" name="telefono" ng-pattern="onlyNumbers"></div></div><div class="form-group has-feedback nacimiento-nuevo" ng-class="{\'has-error\': vm.formevaluador2.nacimiento.$invalid && (vm.formevaluador2.nacimiento.$dirty || vm.formevaluador2.$submitted)}"><label for="inputnacimiento" translate="">Fecha de Nacimiento</label><div class="row"><div class="col-sm-4"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.dia.$invalid && (vm.formevaluador2.dia.$dirty || vm.formevaluador2.$submitted)}"><ui-select ng-model="formulario.dia" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" name="dia" ng-required="formulario.mes || formulario.year"><ui-select-match placeholder="{{viewevaluador.dia}}"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="dia.label as dia in dias | filter: $select.search"><span ng-bind-html="dia.label"></span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.mes.$invalid && (vm.formevaluador2.mes.$dirty || vm.formevaluador2.$submitted)}"><ui-select ng-model="formulario.mes" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" name="mes" ng-required="formulario.dia || formulario.year"><ui-select-match placeholder="{{viewevaluador.mes}}"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="mes.label as mes in meses | filter: $select.search"><span ng-bind-html="mes.label"></span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.year.$invalid && (vm.formevaluador2.year.$dirty || vm.formevaluador2.$submitted)}"><input type="number" class="form-control" id="inputyear" placeholder="{{viewevaluador.ano}}" ng-model="formulario.year" name="year" ng-min="1950" ng-max="2017" ng-pattern="onlyNumbers" ng-required="formulario.dia || formulario.mes"></div></div></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.especialidad.$invalid && (vm.formevaluador2.especialidad.$dirty || vm.formevaluador2.$submitted)}"><label for="inputespecialidad" translate="">Especialidad</label><ui-select ng-model="formulario.especialidad" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" name="especialidad"><ui-select-match placeholder="{{viewevaluador.especialidad|translate}}"><span translate="">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="especialidad.label as especialidad in especialidades | filter: $select.search"><span translate="">{{especialidad.label}}</span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.trabajo.$invalid && (vm.formevaluador2.trabajo.$dirty || vm.formevaluador2.$submitted)}"><label for="inputtrabajo" translate="">Trabajo</label><ui-select ng-model="formulario.trabajo" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false" name="trabajo" required=""><ui-select-match placeholder="{{viewevaluador.trabajo|translate}}"><span translate="">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="trabajo.label as trabajo in trabajos | filter: $select.search"><span translate="">{{trabajo.label}}</span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.empresa.$invalid && (vm.formevaluador2.empresa.$dirty || vm.formevaluador2.$submitted)}" ng-show="viewevaluador.empresa"><label for="inputempresa" translate="">Empresa</label> <input type="text" class="form-control" id="inputempresa" placeholder="{{viewevaluador.empresa}}" ng-model="formulario.empresa" name="empresa"></div></div></div></form><div class="form-group"><button type="button" class="btn btn-primary" ng-click="editarevaluador(formulario)" ng-disabled="form-evaluador.$invalid || enviando" translate="">Enviar Datos</button><span ng-show="enviando"><i class="fa fa-spinner fa-pulse fa-fw"></i>Estamos procesando en ingreso</span></div></div></div></div>');
$templateCache.put('app/pages/evaluadores/evaluadores.html','<div ba-panel="" ba-panel-class="numero-page heading-widget" ba-panel-title="{{\'Evaluadores Registrados\'|translate}}" data-ng-init="init()"><div class="horizontal-scroll"><div class="col-md-3"><div class="form-group select-page-size-wrap"><label>{{\'Filas por P\xE1gina\'|translate}}<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [2,5,10,15,20,25]"></select></label></div></div><div class="col-md-6"><div class="alert bg-{{messagedata.type}}" ng-show="messagedata.message">{{messagedata.message|translate}}<p class="mensaje-errores" ng-repeat="error in messagedata.errors.error.message" ng-show="messagedata.errors">{{error|translate}}</p></div></div><div class="col-md-3"><button type="button" class="btn btn-primary btn-with-icon boton-agregar-smart" data-toggle="modal" ng-click="openmodal(\'app/pages/evaluadores/addform.html\', \'lg\')"><i class="ion-plus-round"></i>{{\'Agregar\'|translate}}</button></div><table class="table" st-table="datosmuestra" st-safe-src="datos"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="nombre" translate="">Nombre</th><th st-sort="apellido" translate="">Apellido</th><th st-sort="especialidad" translate="">Especialidad</th><th st-sort="telefono" translate="">Telefono</th><th st-sort="email" translate="">Email</th><th st-sort="comuna" translate="">Ciudad</th><th translate="">Acci\xF3n</th></tr><tr><th></th><th><input st-search="nombre" placeholder="{{\'Filtrar Por Nombre\'|translate}}" class="input-sm form-control search-input" type="search"></th><th><input st-search="apellido" placeholder="{{\'Filtrar por Apellido\'|translate}}" class="input-sm form-control search-input" type="search"></th><th><input st-search="especialidad" placeholder="{{\'Filtrar por Especialidad\'|translate}}" class="input-sm form-control search-input" type="search"></th><th><input st-search="telefono" placeholder="{{\'Filtrar por Tel\xE9fono\'|translate}}" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" placeholder="{{\'Filtrar por Email\'|translate}}" class="input-sm form-control search-input" type="search"></th><th><input st-search="comuna" placeholder="{{\'Filtrar por Ciudad\'|translate}}" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody ng-show="loading"><tr><td colspan="8" class="table-empty"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></td></tr></tbody><tbody ng-show="bool"><tr ng-repeat="dato in datosmuestra"><td>{{dato.ident}}</td><td>{{dato.nombre}}</td><td>{{dato.apellido}}</td><td>{{dato.especialidad}}</td><td>{{dato.telefono}}</td><td><a href="" class="email-link" ng-click="openmo(\'\',dato.nombre, dato.apellido, dato.id_usuario,\'\',\'\')">{{dato.email}}</a></td><td>{{dato.comuna}}</td><td class="botones-accion"><button title="{{\'Ver M\xE1s\'|translate}}" type="button" class="btn btn-primary btn-icon btn-accion" data-toggle="modal" ng-click="ver(dato.id_usuario)"><i class="ion-eye"></i></button><button title="{{\'Editar\'|translate}}" type="button" class="btn btn-warning btn-icon btn-accion" data-toggle="modal" ng-click="openmodal(\'app/pages/evaluadores/editform.html\', \'lg\', dato.id_usuario)"><i class="ion-edit"></i></button><button title="{{\'Eliminar\'|translate}}" type="button" class="btn btn-danger btn-icon btn-accion" data-toggle="modal" ng-click="elimina(dato.id_usuario)"><i class="ion-trash-b"></i></button></td></tr></tbody><tbody ng-show="!bool"><tr><td colspan="8" class="table-empty"><h3 translate="">A\xFAn no hay datos para mostrar, ingresa tu primer evaluador ahora</h3><button type="button" class="btn btn-primary btn-with-icon" data-toggle="modal" ng-click="openmodal(\'app/pages/evaluadores/addform.html\', \'lg\')"><i class="ion-plus-round"></i>{{\'Agregar Evaluador\'|translate}}</button></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/evaluados/addform.html','<div class="modal-content" ng-controller="FormEvaluadosCtrl as vm"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel" translate="">Agregar Persona</h4></div><div class="modal-body"><div ba-panel="" ba-panel-title="{{\'Datos de Evaluado\'|translate}}" ba-panel-class="with-scroll panel-success"><ba-wizard><ba-wizard-step title="{{\'Datos Personales\'|translate}}" form="vm.formevaluador2"><div class="form-group row clearfix"><div class="col-sm-4"><label for="inputFirstName" class="control-label" translate="">Imagen de Perfil</label><div class="aviso-imagen warning" ng-show="errorimagen"><i class="ion-alert-circled"></i> {{errorimagen|translate}}</div></div><div class="col-sm-8"><div class="userpic img-forms"><div class="userpic-wrapper"><img ng-src="http://apiintplus.rfit.cl/assets/img/perfiles/{{ viewevaluador.img_url }}" ngf-accept="\'image/*\'" ngf-max-size="300KB" ngf-resize-if="$width > 300 || $height > 300" ngf-resize="{width: 300, height: 300, quality: .8, type: \'image/jpeg\', ratio: \'1:1\', centerCrop: true, restoreExif: false}" ngf-select="uploadFiles($file, $invalidFiles)"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div><form name="vm.formevaluador2" novalidate=""><div class="row"><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.nombre.$invalid && (vm.formevaluador2.nombre.$dirty || vm.formevaluador2.$submitted)}"><label for="inputFirstName" translate="">Nombre</label> <input type="text" class="form-control" id="inputnombre" placeholder="{{\'Nombre\'|translate}}" ng-model="formulario.nombre" name="nombre" required=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.apellido.$invalid && (vm.formevaluador2.apellido.$dirty || vm.formevaluador2.$submitted)}"><label for="inputLastName" translate="">Apellido</label> <input type="text" class="form-control" id="inputapellido" placeholder="{{\'Apellido\'|translate}}" ng-model="formulario.apellido" name="apellido" required=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.sexo.$invalid && (vm.formevaluador2.sexo.$dirty || vm.formevaluador2.$submitted)}"><label for="inputsexo" translate="">Sexo</label><ui-select ng-model="formulario.sexo" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="false" name="sexo" required=""><ui-select-match placeholder="{{\'Seleccione su Sexo\'|translate}}"><span translate="">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="sexo.label as sexo in sexos | filter: $select.search"><span translate="">{{sexo.label}}</span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.nacimiento.$invalid && (vm.formevaluador2.nacimiento.$dirty || vm.formevaluador2.$submitted)}"><label for="inputnacimiento" translate="">Fecha de Nacimiento</label><div class="row"><div class="col-sm-4"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.dia.$invalid && (vm.formevaluador2.dia.$dirty || vm.formevaluador2.$submitted)}"><ui-select ng-model="formulario.dia" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" name="dia" required=""><ui-select-match placeholder="{{\'D\xEDa\'|translate}}"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="dia.label as dia in dias | filter: $select.search"><span ng-bind-html="dia.label"></span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.mes.$invalid && (vm.formevaluador2.mes.$dirty || vm.formevaluador2.$submitted)}"><ui-select ng-model="formulario.mes" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" name="mes" required=""><ui-select-match placeholder="{{\'Mes\'|translate}}"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="mes.label as mes in meses | filter: $select.search"><span ng-bind-html="mes.label"></span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group has-feedback year-form" ng-class="{\'has-error\': vm.formevaluador2.year.$invalid && (vm.formevaluador2.year.$dirty || vm.formevaluador2.$submitted)}"><input type="number" class="form-control" id="inputyear" placeholder="{{\'A\xF1o\'|translate}}" ng-model="formulario.year" name="year" ng-min="1930" ng-max="2005" ng-pattern="onlyNumbers" required=""> <span class="min-text2">({{\'Entre\'|translate}} 1930 {{\'y\'|translate}} 2005)</span></div></div></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.email.$invalid && (vm.formevaluador2.email.$dirty || vm.formevaluador2.$submitted)}"><label for="inputEmail" translate="">Email</label> <input type="email" class="form-control" id="inputemail" placeholder="{{\'Email\'|translate}}" ng-model="formulario.email" name="email" required=""></div></div><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.pais.$invalid && (vm.formevaluador2.pais.$dirty || vm.formevaluador2.$submitted)}"><label for="inputpais" translate="">Pa\xEDs</label><ui-select ng-model="formulario.pais" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="true" name="pais" required="" ng-change="sacastates(formulario.pais.id,formulario.pais.phonecode)"><ui-select-match placeholder="{{\'Seleccione su Pa\xEDs\'|translate}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="pais as pais in countries | filter: $select.search"><span ng-bind-html="pais.name"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.region.$invalid && (vm.formevaluador2.region.$dirty || vm.formevaluador2.$submitted)}"><label for="inputregion" translate="">Regi\xF3n</label><ui-select ng-model="formulario.region" class="btn-group bootstrap-select form-control select-index" ng-disabled="!states" append-to-body="true" search-enabled="true" name="region" required="" ng-change="sacacities(formulario.region.id)"><ui-select-match placeholder="{{\'Seleccione su Regi\xF3n\'|translate}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="region as region in states | filter: $select.search"><span ng-bind-html="region.name"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.comuna.$invalid && (vm.formevaluador2.comuna.$dirty || vm.formevaluador2.$submitted)}"><label for="inputcomuna" translate="">Comuna</label><ui-select ng-model="formulario.comuna" class="btn-group bootstrap-select form-control select-index" append-to-body="true" search-enabled="true" name="comuna" ng-disabled="!cities" required=""><ui-select-match placeholder="{{\'Seleccione su Comuna\'|translate}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="comuna as comuna in cities | filter: $select.search"><span ng-bind-html="comuna.name"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.direccion.$invalid && (vm.formevaluador2.direccion.$dirty || vm.formevaluador2.$submitted)}"><label for="inputdireccion" translate="">Direcci\xF3n</label> <input type="text" class="form-control" id="inputdireccion" placeholder="{{\'Direcci\xF3n\'|translate}}" ng-model="formulario.direccion" name="direccion" required=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.telefono.$invalid && (vm.formevaluador2.telefono.$dirty || vm.formevaluador2.$submitted)}"><label for="inputTelefono" translate="">Tel\xE9fono</label><div class="input-group"><span class="input-group-addon input-group-addon-primary addon-left" id="basic-addon1">+{{selectedphonecode}}</span> <input type="number" class="form-control with-primary-addon" id="inputtelefono" placeholder="{{\'Tel\xE9fono\'|translate}}" ng-model="formulario.telefono" name="telefono" ng-pattern="onlyNumbers" required=""></div></div></div></div></form></ba-wizard-step><ba-wizard-step title="{{\'Enviar Formulario\'|translate}}" class="form-final" form="formevaluador3"><h4 translate="">Estos son los datos que ingresaste</h4><div class="row"><div class="col-sm-6"><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.email"><span class="label-form-final"><b>{{\'Email\'|translate}}:</b></span><span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.email"><span class="label-form-final"><b>{{\'Email\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.email}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error form-final-error" ng-show="!formulario.nombre"><span class="label-form-final"><b>{{\'Nombre\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.nombre"><span class="label-form-final"><b>{{\'Nombre\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.nombre}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.apellido"><span class="label-form-final"><b>{{\'Apellido\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.apellido"><span class="label-form-final"><b>{{\'Apellido\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.apellido}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.sexo"><span class="label-form-final"><b>{{\'Sexo\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.sexo"><span class="label-form-final"><b>{{\'Sexo\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.sexo|translate}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.telefono"><span class="label-form-final"><b>{{\'Tel\xE9fono\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.telefono"><span class="label-form-final"><b>{{\'Tel\xE9fono\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.telefono}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div></div><div class="col-sm-6"><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.pais"><span class="label-form-final"><b>{{\'Pa\xEDs\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.pais.name"><span class="label-form-final"><b>{{\'Pa\xEDs\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.pais.name}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.region"><span class="label-form-final"><b>{{\'Regi\xF3n\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.region.name"><span class="label-form-final"><b>{{\'Regi\xF3n\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.region.name}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.comuna.name"><span class="label-form-final"><b>{{\'Comuna\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.comuna.name"><span class="label-form-final"><b>{{\'Comuna\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.comuna.name}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.direccion"><span class="label-form-final"><b>{{\'Direcci\xF3n\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.direccion"><span class="label-form-final"><b>{{\'Direcci\xF3n\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.direccion}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div><div class="form-group"><p class="input-group form-final-error" ng-show="!formulario.dia || !formulario.mes || !formulario.year"><span class="label-form-final"><b>{{\'Fecha Nacimiento\'|translate}}:</b></span> <span class="dato-form-final" translate="">Por favor vuelva e ingrese este dato</span> <span class="input-group-btn"><button type="button" class="btn btn-danger btn-icon"><i class="ion-close-round"></i></button></span></p><p class="input-group form-final-correcto" ng-show="formulario.dia && formulario.mes && formulario.year"><span class="label-form-final"><b>{{\'Fecha Nacimiento\'|translate}}:</b></span> <span class="dato-form-final">{{formulario.dia}}-{{formulario.mes}}-{{formulario.year}}</span> <span class="input-group-btn"><button type="button" class="btn btn-success btn-icon"><i class="ion-checkmark-round"></i></button></span></p></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><h5>{{\'Si los datos est\xE1n correctos env\xEDalos\'|translate}}:</h5></div></div><div class="col-sm-6"><div class="form-group"><button type="button" class="btn btn-primary" ng-click="enviardatos(formulario)" ng-disabled="form-evaluador.$invalid || enviando" translate="">Enviar Datos</button><span ng-show="enviando"><i class="fa fa-spinner fa-pulse fa-fw"></i>{{\'Estamos procesando el ingreso\'|translate}}</span></div></div></div></ba-wizard-step></ba-wizard></div></div></div>');
$templateCache.put('app/pages/evaluados/editform.html','<div class="modal-content" ng-controller="FormEvaluadosCtrl as vm" ng-init="initedit()"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel" translate="">Editar Datos Cliente</h4></div><div class="modal-body"><div ba-panel="" ba-panel-title="Datos Personales" ba-panel-class="with-scroll panel-success"><form name="vm.formevaluador2" novalidate=""><div class="form-group row clearfix"><div class="col-sm-4"><label for="inputFirstName" class="control-label" translate="">Imagen de Perfil</label><div class="aviso-imagen warning" ng-show="errorimagen"><i class="ion-alert-circled"></i> {{errorimagen}}</div></div><div class="col-sm-8"><div class="userpic img-forms"><div class="userpic-wrapper"><img ng-src="http://apiintplus.rfit.cl/assets/img/perfiles/{{ viewevaluador.img_url }}" ngf-accept="\'image/*\'" ngf-max-size="300KB" ngf-resize-if="$width > 300 || $height > 300" ngf-resize="{width: 300, height: 300, quality: .8, type: \'image/jpeg\', ratio: \'1:1\', centerCrop: true, restoreExif: false}" ngf-select="uploadFiles($file, $invalidFiles)"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.nombre.$invalid && (vm.formevaluador2.nombre.$dirty || vm.formevaluador2.$submitted)}"><label for="inputFirstName" translate="">Nombre</label> <input type="text" class="form-control" id="inputnombre" placeholder="{{viewevaluador.nombre}}" ng-model="formulario.nombre" name="nombre"></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.apellido.$invalid && (vm.formevaluador2.apellido.$dirty || vm.formevaluador2.$submitted)}"><label for="inputLastName" translate="">Apellido</label> <input type="text" class="form-control" id="inputapellido" placeholder="{{viewevaluador.apellido}}" ng-model="formulario.apellido" name="apellido"></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.sexo.$invalid && (vm.formevaluador2.sexo.$dirty || vm.formevaluador2.$submitted)}"><label for="inputsexo" translate="">Sexo</label><ui-select ng-model="formulario.sexo" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="false" name="sexo"><ui-select-match placeholder="{{viewevaluador.sexo|translate}}"><span translate="">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="sexo.label as sexo in sexos | filter: $select.search"><span translate="">{{sexo.label}}</span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.email.$invalid && (vm.formevaluador2.email.$dirty || vm.formevaluador2.$submitted)}"><label for="inputEmail" translate="">Email</label> <input type="email" class="form-control" id="inputemail" placeholder="{{viewevaluador.email}}" ng-model="formulario.email" name="email" disabled=""></div><div class="form-group has-feedback nacimiento-nuevo" ng-class="{\'has-error\': vm.formevaluador2.nacimiento.$invalid && (vm.formevaluador2.nacimiento.$dirty || vm.formevaluador2.$submitted)}"><label for="inputnacimiento" translate="">Fecha de Nacimiento</label><div class="row"><div class="col-sm-4"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.dia.$invalid && (vm.formevaluador2.dia.$dirty || vm.formevaluador2.$submitted)}"><ui-select ng-model="formulario.dia" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" name="dia"><ui-select-match placeholder="{{viewevaluador.dia}}"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="dia.label as dia in dias | filter: $select.search"><span ng-bind-html="dia.label"></span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.mes.$invalid && (vm.formevaluador2.mes.$dirty || vm.formevaluador2.$submitted)}"><ui-select ng-model="formulario.mes" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" name="mes"><ui-select-match placeholder="{{viewevaluador.mes}}"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="mes.label as mes in meses | filter: $select.search"><span ng-bind-html="mes.label"></span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.year.$invalid && (vm.formevaluador2.year.$dirty || vm.formevaluador2.$submitted)}"><input type="number" class="form-control" id="inputyear" placeholder="{{viewevaluador.ano}}" ng-model="formulario.year" name="year" ng-min="1930" ng-max="2005" ng-pattern="onlyNumbers"> <span class="min-text2">({{\'Entre\'|translate}} 1930 {{\'y\'|translate}} 2005)</span></div></div></div></div></div><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.pais.$invalid && (vm.formevaluador2.pais.$dirty || vm.formevaluador2.$submitted)}"><label for="inputpais" translate="">Pa\xEDs</label><ui-select ng-model="formulario.pais" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="true" name="pais" required="" ng-change="sacastates(formulario.pais.id,formulario.pais.phonecode)"><ui-select-match placeholder="{{viewevaluador.pais}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="pais as pais in countries | filter: $select.search"><span ng-bind-html="pais.name"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.region.$invalid && (vm.formevaluador2.region.$dirty || vm.formevaluador2.$submitted)}"><label for="inputregion" translate="">Regi\xF3n</label><ui-select ng-model="formulario.region" class="btn-group bootstrap-select form-control select-index" ng-disabled="!states" append-to-body="true" search-enabled="false" name="region" required="" ng-change="sacacities(formulario.region.id)"><ui-select-match placeholder="{{viewevaluador.region}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="region as region in states | filter: $select.search"><span ng-bind-html="region.name"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.comuna.$invalid && (vm.formevaluador2.comuna.$dirty || vm.formevaluador2.$submitted)}"><label for="inputcomuna" translate="">Comuna</label><ui-select ng-model="formulario.comuna" class="btn-group bootstrap-select form-control select-index" append-to-body="true" search-enabled="false" name="comuna" ng-disabled="!cities" required=""><ui-select-match placeholder="{{viewevaluador.comuna}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="comuna as comuna in cities | filter: $select.search"><span ng-bind-html="comuna.name"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.direccion.$invalid && (vm.formevaluador2.direccion.$dirty || vm.formevaluador2.$submitted)}"><label for="inputdireccion" translate="">Direcci\xF3n</label> <input type="text" class="form-control" id="inputdireccion" placeholder="{{viewevaluador.direccion}}" ng-model="formulario.direccion" name="direccion"></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.telefono.$invalid && (vm.formevaluador2.telefono.$dirty || vm.formevaluador2.$submitted)}"><label for="inputTelefono" translate="">Tel\xE9fono</label><div class="input-group"><span class="input-group-addon input-group-addon-primary addon-left" id="basic-addon1">+{{selectedphonecode}}</span> <input type="number" class="form-control with-primary-addon" id="inputtelefono" placeholder="{{viewevaluador.telefono}}" ng-model="formulario.telefono" name="telefono" ng-pattern="onlyNumbers"></div></div></div></div></form><div class="form-group"><button type="button" class="btn btn-primary" ng-click="editarevaluado(formulario)" ng-disabled="form-evaluador.$invalid || enviando" translate="">Enviar Datos</button><span ng-show="enviando"><i class="fa fa-spinner fa-pulse fa-fw"></i>{{\'Estamos procesando el ingreso\'|translate}}</span></div></div></div></div>');
$templateCache.put('app/pages/evaluados/evaluados.html','<div ba-panel="" ba-panel-class="numero-page heading-widget" ba-panel-title="{{ \'Listado Evaluados Registrados\' | translate }}" data-ng-init="init()"><div class="horizontal-scroll"><div class="col-md-3"><div class="form-group select-page-size-wrap"><label>{{\'Filas por P\xE1gina\'|translate}}<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div></div><div class="col-md-6"><div class="alert bg-{{messagedata.type}}" ng-show="messagedata.message">{{messagedata.message|translate}}<p class="mensaje-errores" ng-repeat="error in messagedata.errors.error.message" ng-show="messagedata.errors">{{error|translate}}</p></div></div><div class="col-md-3"><button type="button" class="btn btn-primary btn-with-icon boton-agregar-smart" data-toggle="modal" ng-click="openmodal(\'app/pages/evaluados/addform.html\', \'lg\')"><i class="ion-plus-round"></i>{{ \'Agregar\' | translate }}</button></div><table class="table" st-table="datosmuestra" st-safe-src="datos"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="nombre" translate="">Nombre</th><th st-sort="apellido" translate="">Apellido</th><th st-sort="telefono" translate="">Telefono</th><th st-sort="email" translate="">Email</th><th translate="">Acci\xF3n</th></tr><tr><th></th><th><input st-search="nombre" placeholder="{{\'Filtrar Por Nombre\'|translate}}" class="input-sm form-control search-input" type="search"></th><th><input st-search="apellido" placeholder="{{\'Filtrar por Apellido\'|translate}}" class="input-sm form-control search-input" type="search"></th><th><input st-search="telefono" placeholder="{{\'Filtrar por Tel\xE9fono\'|translate}}" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" placeholder="{{\'Filtrar por Email\'|translate}}" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody ng-show="loading"><tr><td colspan="8" class="table-empty"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></td></tr></tbody><tbody ng-show="bool"><tr ng-repeat="dato in datosmuestra"><td>{{dato.ident}}</td><td>{{dato.nombre}}</td><td>{{dato.apellido}}</td><td>{{dato.telefono}}</td><td><a href="" class="email-link" ng-click="openmo(\'\',dato.nombre, dato.apellido, dato.id_usuario,\'\',\'\')">{{dato.email}}</a></td><td><button title="{{\'Ver M\xE1s\'|translate}}" type="button" class="btn btn-primary btn-icon btn-accion" data-toggle="modal" ng-click="ver(\'app/pages/evaluados/view.html\', \'lg\', dato.id_usuario)"><i class="ion-ios-paper-outline"></i></button><button title="{{\'Editar\'|translate}}" type="button" class="btn btn-warning btn-icon btn-accion" data-toggle="modal" ng-click="openmodal(\'app/pages/evaluados/editform.html\', \'lg\', dato.id_usuario)"><i class="ion-edit"></i></button><button title="{{\'Eliminar\'|translate}}" type="button" class="btn btn-danger btn-icon btn-accion" data-toggle="modal" ng-click="elimina(dato.id_usuario)"><i class="ion-trash-b"></i></button></td></tr></tbody><tbody ng-show="!bool"><tr><td colspan="8" class="table-empty"><h3 translate="">A\xFAn no hay datos para mostrar, ingresa los datos de tu primer evaluado ahora</h3><button type="button" class="btn btn-primary btn-with-icon" data-toggle="modal" ng-click="openmodal(\'app/pages/evaluados/addform.html\', \'lg\')"><i class="ion-plus-round"></i>{{\'Agregar Evaluado\'|translate}}</button></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/evaluados/view.html','<div class="modal-content" ng-controller="EvaluadoresPageCtrl"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel" translate="">Ficha Evaluado</h4></div><div class="modal-body"><div class="row"><div class="col-sm-4"><div class="form-group"><div class="userpic-wrapper"><img ng-src="http://apiintplus.rfit.cl/assets/img/perfiles/{{datoevaluado.img_url}}"></div></div></div><div class="col-sm-8"><div ba-panel="" ba-panel-title="{{\'Datos del usuario\'|translate}}" ba-panel-class="xsmall-panel light-text paneles panel-success"><div class="row"><div class="col-sm-6"><div class="form-group"><b>{{\'Nombre\'|translate}}:</b> {{datoevaluado.nombre}} {{datoevaluado.apellido}}</div><div class="form-group"><b>{{\'Sexo\'|translate}}:</b> {{datoevaluado.sexo|translate}}</div><div class="form-group"><b>{{\'Email\'|translate}}:</b> {{datoevaluado.email}}</div><div class="form-group"><b>{{\'Tel\xE9fono\'|translate}}:</b> +{{selectedphonecode}} {{datoevaluado.telefono}}</div><div class="form-group"><b>{{\'Edad\'|translate}}:</b> {{datoevaluado.edad}}</div></div><div class="col-sm-6"><div class="form-group"><b>{{\'Nacimiento\'|translate}}:</b> {{datoevaluado.nacimiento | date:\'dd-MM-yyyy\'}}</div><div class="form-group"><b>{{\'Pa\xEDs\'|translate}}:</b> {{datoevaluado.pais}}</div><div class="form-group"><b>{{\'Regi\xF3n\'|translate}}:</b> {{datoevaluado.region}}</div><div class="form-group"><b>{{\'Comuna\'|translate}}:</b> {{datoevaluado.comuna}}</div><div class="form-group"><b>{{\'Direcci\xF3n\'|translate}}:</b> {{datoevaluado.direccion}}</div></div></div></div></div></div><div class="modal-footer"></div></div></div>');
$templateCache.put('app/pages/login/auth.html','<main class="auth-main"><div class="auth-block"><h1 translate="">Ingresa a tu cuenta</h1><a href="#/registro" class="auth-link" translate="">No tienes cuenta? Haz click aqu\xED para crea tu cuenta en Rfit</a><div class="alert bg-{{messagedata.type}}" ng-show="messagedata.message">{{messagedata.message|translate}}<p class="mensaje-errores" ng-show="messagedata.errors">{{messagedata.errors|translate}}</p></div><form class="form-horizontal" ng-submit="logins()"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label" translate="">Email</label><div class="col-sm-10"><input type="email" ng-model="loginData.email" class="form-control" id="inputEmail3" placeholder="{{\'Email\'|translate}}"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label" translate="">Contrase\xF1a</label><div class="col-sm-10"><input type="password" ng-model="loginData.password" class="form-control" id="inputPassword3" placeholder="{{\'Contrase\xF1a\'|translate}}"></div></div><div class="form-group"><div class="col-sm-6"><button type="submit" class="btn btn-default" translate="">Ingresar</button></div><div class="col-sm-6"><a href="#/reestablecer" class="auth-link" translate="">Olvidaste tu contrase\xF1a?</a></div></div></form></div></main>');
$templateCache.put('app/pages/login/pass.html','<div class="modal-content" ng-controller="AuthCtrl as vm"><div class="modal-header"><h4 class="modal-title" id="myModalLabel" translate="">Definir Contrase\xF1a</h4></div><div class="modal-body"><div ba-panel="" ba-panel-title="{{\'Por favor ingrese su nueva contrase\xF1a" ba-panel-class="with-scroll panel-success"><div class="col-md-12"><div class="alert bg-{{messagedata.type}}" ng-show="messagedata.message">{{messagedata.message|translate}}<p class="mensaje-errores" ng-repeat="error in messagedata.errors.error.message" ng-show="messagedata.errors">{{error|translate}}</p></div></div><form name="vm.formevaluador2" novalidate=""><div class="row"><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.nombre.$invalid && (vm.formevaluador2.nombre.$dirty || vm.formevaluador2.$submitted)}"><label for="inputFirstName" translate="">Ingrese su Contrase\xF1a</label> <input type="{{passwordinput}}" class="form-control" id="inputnombre" placeholder="{{\'Contrase\xF1a\'|translate}}" ng-model="formulario.pass1" name="nombre" ng-change="compara(formulario)" required=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.apellido.$invalid && (vm.formevaluador2.apellido.$dirty || vm.formevaluador2.$submitted)}"><label for="inputLastName" translate="">Confirmar Contrase\xF1a</label><p class="input-group"><input type="{{passwordinput}}" class="form-control" id="inputapellido" placeholder="{{\'Confirmar Contrase\xF1a\'|translate}}" ng-model="formulario.pass2" name="apellido" ng-change="compara(formulario)" required=""> <span class="input-group-btn"><button type="button" title="{{\'Ver Contrase\xF1a\'|translate}}" class="btn btn-warning" ng-mousedown="verpass()" ng-mouseup="verpass()"><i class="ion-eye"></i></button></span></p></div></div><div class="col-sm-6"><div class="alert bg-warning modal-warning" ng-show="show"><i class="ion-alert-circled"></i> {{\'Las contrase\xF1as ingresadas no coinciden\'|translate}}.</div></div></div><button type="submit" class="btn btn-success" ng-click="enviapass(formulario)" translate="">Enviar</button></form></div></div></div>');
$templateCache.put('app/pages/maps/maps.html','<div class="widgets"><div class="row"><div class="col-md-12" ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div>');
$templateCache.put('app/pages/profile/profile.html','<div ba-panel="" ba-panel-class="profile-page" data-ng-init="init()"><div class="panel-content"><div class="progress-info" ng-show="false">Tu perfil 70% Complete</div><div class="progress" ng-show="false"><div class="progress-bar progress-bar-primary progress-bar-striped active" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style="width: 70%"></div></div><div class="alert bg-{{messagedata.type}}" ng-show="messagedata.message">{{messagedata.message|translate}}<p class="mensaje-errores" ng-repeat="error in messagedata.errors.error.message" ng-show="messagedata.errors">{{error|translate}}</p></div><h3 class="with-line" translate="">Informaci\xF3n Personal</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><div class="col-sm-4"><label for="inputFirstName" class="control-label" translate="">Imagen de Perfil</label><div class="aviso-imagen warning" ng-show="errorimagen"><i class="ion-alert-circled"></i> {{errorimagen|translate}}</div></div><div class="col-sm-8"><div class="userpic"><div class="userpic-wrapper"><img ng-src="http://apiintplus.rfit.cl/assets/img/perfiles/{{ datos.img_url }}" ngf-accept="\'image/*\'" ngf-max-size="5MB" ngf-resize-if="$width > 300 || $height > 300" ngf-resize="{width: 300, height: 300, quality: .7, type: \'image/jpeg\', centerCrop: true, restoreExif: false}" ngf-select="uploadFiles($file, $invalidFiles)"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <a href="" class="change-userpic" ng-click="uploadPicture()" translate="">Cambiar Foto de Perfil</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div></div><div class="col-md-6"></div></div><div class="row"><form name="formevaluador2" novalidate=""><div class="row"><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': formevaluador2.nombre.$invalid && (formevaluador2.nombre.$dirty || formevaluador2.$submitted || formevaluador2.$error.required)}"><label for="inputFirstName" translate="">Nombre</label> <input type="text" class="form-control" id="inputnombre" placeholder="{{datos.nombre}}" ng-model="formulario.nombre" name="nombre" ng-required="!datos.nombre"></div><div class="form-group has-feedback" ng-class="{\'has-error\': formevaluador2.apellido.$invalid && (formevaluador2.apellido.$dirty || formevaluador2.$submitted || formevaluador2.$error.required)}"><label for="inputLastName" translate="">Apellido</label> <input type="text" class="form-control" id="inputapellido" placeholder="{{datos.apellido}}" ng-model="formulario.apellido" name="apellido" ng-required="!datos.apellido"></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.pais.$invalid && (vm.formevaluador2.pais.$dirty || vm.formevaluador2.$submitted)}"><label for="inputpais" translate="">Pa\xEDs</label><ui-select ng-model="formulario.pais" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="true" name="pais" required="" ng-change="sacastates(formulario.pais.id,formulario.pais.phonecode)"><ui-select-match placeholder="{{datos.pais}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="pais as pais in countries | filter: $select.search"><span ng-bind-html="pais.name"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.region.$invalid && (vm.formevaluador2.region.$dirty || vm.formevaluador2.$submitted)}"><label for="inputregion" translate="">Regi\xF3n</label><ui-select ng-model="formulario.region" class="btn-group bootstrap-select form-control select-index" ng-disabled="!states" append-to-body="true" search-enabled="false" name="region" required="" ng-change="sacacities(formulario.region.id)"><ui-select-match placeholder="{{datos.region}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="region as region in states | filter: $select.search"><span ng-bind-html="region.name"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.formevaluador2.comuna.$invalid && (vm.formevaluador2.comuna.$dirty || vm.formevaluador2.$submitted)}"><label for="inputcomuna" translate="">Comuna</label><ui-select ng-model="formulario.comuna" class="btn-group bootstrap-select form-control select-index" append-to-body="true" search-enabled="false" name="comuna" ng-disabled="!cities" required=""><ui-select-match placeholder="{{datos.comuna}}"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="comuna as comuna in cities | filter: $select.search"><span ng-bind-html="comuna.name"></span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': formevaluador2.direccion.$invalid && (formevaluador2.direccion.$dirty || formevaluador2.$submitted || formevaluador2.$error.required)}"><label for="inputdireccion" translate="">Direcci\xF3n</label> <input type="text" class="form-control" id="inputdireccion" placeholder="{{datos.direccion}}" ng-model="formulario.direccion" name="direccion" ng-required="!datos.direccion"></div></div><div class="col-sm-6"><div class="form-group has-feedback" ng-class="{\'has-error\': formevaluador2.sexo.$invalid && (formevaluador2.sexo.$dirty || formevaluador2.$submitted || formevaluador2.$error.required)}"><label for="inputsexo" translate="">Sexo</label><ui-select ng-model="formulario.sexo" class="btn-group bootstrap-select form-control select-index" ng-disabled="false" append-to-body="true" search-enabled="false" name="sexo" ng-required="!datos.sexo"><ui-select-match placeholder="{{datos.sexo|translate}}"><span translate="">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="sexo.label as sexo in sexos | filter: $select.search"><span translate="">{{sexo.label}}</span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': formevaluador2.email.$invalid && (formevaluador2.email.$dirty || formevaluador2.$submitted || formevaluador2.$error.required)}"><label for="inputEmail" translate="">Email</label> <input type="email" class="form-control" id="inputemail" placeholder="{{currentUser.email}}" ng-model="formulario.email" name="email" ng-required="!datos.email" disabled=""></div><div class="form-group has-feedback" ng-class="{\'has-error\': formevaluador2.telefono.$invalid && (formevaluador2.telefono.$dirty || formevaluador2.$submitted || formevaluador2.$error.required)}"><label for="inputTelefono" translate="">Tel\xE9fono</label><div class="input-group"><input type="number" class="form-control with-primary-addon" id="inputtelefono" placeholder="{{datos.telefono}}" ng-model="formulario.telefono" name="telefono" ng-minlength="8" ng-maxlength="9" ng-pattern="onlyNumbers" ng-required="!datos.telefono"></div></div><div class="form-group has-feedback nacimiento-nuevo" ng-class="{\'has-error\': formevaluador2.nacimiento.$invalid && (formevaluador2.nacimiento.$dirty || formevaluador2.$submitted || formevaluador2.$error.required)}"><label for="inputnacimiento" translate="">Fecha de Nacimiento</label><div class="row"><div class="col-sm-4"><div class="form-group has-feedback" ng-class="{\'has-error\': formevaluador2.dia.$invalid && (formevaluador2.dia.$dirty || formevaluador2.$submitted || formevaluador2.$error.required)}"><ui-select ng-model="formulario.dia" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" name="dia" ng-required="!datos.nacimiento"><ui-select-match placeholder="{{datos.dia}}"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="dia.label as dia in dias | filter: $select.search"><span ng-bind-html="dia.label"></span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group has-feedback" ng-class="{\'has-error\': formevaluador2.mes.$invalid && (formevaluador2.mes.$dirty || formevaluador2.$submitted || formevaluador2.$error.required)}"><ui-select ng-model="formulario.mes" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" name="mes" ng-required="!datos.nacimiento"><ui-select-match placeholder="{{datos.mes}}"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="mes.label as mes in meses | filter: $select.search"><span ng-bind-html="mes.label"></span></ui-select-choices></ui-select></div></div><div class="col-sm-4"><div class="form-group has-feedback" ng-class="{\'has-error\': formevaluador2.year.$invalid && (formevaluador2.year.$dirty || formevaluador2.$submitted || formevaluador2.$error.required)}"><input type="number" class="form-control" id="inputyear" placeholder="{{datos.ano}}" ng-model="formulario.year" name="year" ng-min="1950" ng-max="2017" ng-pattern="onlyNumbers" ng-required="!datos.nacimiento"></div></div></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': formevaluador2.especialidad.$invalid && (formevaluador2.especialidad.$dirty || formevaluador2.$submitted || formevaluador2.$error.required)}" ng-show="currentUser.type != 2"><label for="inputespecialidad" translate="">Especialidad</label><ui-select ng-model="formulario.especialidad" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" name="especialidad"><ui-select-match placeholder="{{datos.especialidad|translate}}"><span translate="">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="especialidad.label as especialidad in especialidades | filter: $select.search"><span translate="">{{especialidad.label}}</span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': formevaluador2.trabajo.$invalid && (formevaluador2.trabajo.$dirty || formevaluador2.$submitted || formevaluador2.$error.required)}" ng-show="currentUser.type != 2"><label for="inputtrabajo" translate="">Trabajo</label><ui-select ng-model="formulario.trabajo" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false" name="trabajo"><ui-select-match placeholder="{{datos.trabajo|translate}}"><span translate="">{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="trabajo.label as trabajo in trabajos | filter: $select.search"><span translate="">{{trabajo.label}}</span></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="{\'has-error\': formevaluador2.empresa.$invalid && (formevaluador2.empresa.$dirty || formevaluador2.$submitted || formevaluador2.$error.required)}" ng-show="currentUser.type != 2 && formulario.trabajo == \'Dependiente\'"><label for="inputempresa" translate="">Empresa</label> <input type="text" class="form-control" id="inputempresa" placeholder="{{datos.empresa}}" ng-model="formulario.empresa" name="empresa"></div></div></div></form></div><button type="button" class="btn btn-primary" ng-click="enviardatosusuario(formulario)" ng-disabled="form-evaluador.$invalid"><i class="ion-android-checkmark-circle"></i> {{\'Actualizar Perfil\'|translate}}</button></div></div>');
$templateCache.put('app/pages/reestablecer/reestablecer.html','<main class="auth-main"><div class="auth-block"><h1 translate="">Reestablece tu contrase\xF1a</h1><div class="alert bg-{{messagedata.type}}" ng-show="messagedata.message">{{messagedata.message|translate}}<p class="mensaje-errores" ng-show="messagedata.errors">{{messagedata.errors|translate}}</p></div><form class="form-horizontal" ng-submit="reestablecer()"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label" translate="">Email</label><div class="col-sm-10"><input type="email" ng-model="loginData.email" class="form-control" id="inputEmail3" placeholder="{{\'Emai\'|translate}}l"></div></div><div class="form-group"><div class="col-sm-6"><button type="submit" class="btn btn-default" ng-disabled="!enviando" translate="">Reestablecer Contrase\xF1a</button><div ng-show="!enviando" class="text-center"><i class="fa fa-spinner fa-pulse fa-fw"></i>{{\'Estamos procesando\'|translate}}</div></div><div class="col-sm-6"><a href="#/login" class="forgot-pass" translate="">Volver</a></div></div></form></div></main>');
$templateCache.put('app/pages/registro/reg - copia.html','<main class="auth-main"><div class="auth-block"><h1>Registrate en Rfit</h1><div class="row"><div class="col-md-12"><div class="alert bg-{{messagedata.type}}" ng-show="messagedata.message">{{messagedata.message}}<p class="mensaje-errores" ng-repeat="error in messagedata.errors.error.message" ng-show="messagedata.errors">{{error}}</p></div></div></div><form class="form-horizontal" ng-submit="registra()"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="email" ng-model="registro.email" class="form-control" id="inputEmail3" placeholder="Email"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" ng-model="registro.password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-4"><button type="submit" class="btn btn-default btn-auth">Registrarse</button></div><div class="col-sm-6"><a href="#/login" class="auth-link">Ya tienes una cuenta? Ingresa!</a></div></div></form><div class="auth-sep"><span><span>or Sign up with one click</span></span></div><div class="al-share-auth"><ul class="al-share clearfix"><li><i class="socicon socicon-facebook" title="Share on Facebook"></i></li><li><i class="socicon socicon-twitter" title="Share on Twitter"></i></li><li><i class="socicon socicon-google" title="Share on Google Plus"></i></li></ul></div></div></main>');
$templateCache.put('app/pages/registro/reg.html','<main class="auth-main registro"><div class="auth-block"><uib-tabset class="panel-registro" active="$tabSetStatus.activeTab"><uib-tab heading="{{\'Registro como Profesional\'|translate}}" class="col-sm-6 tab-registro"><h1 translate="">Reg\xEDstrate como profesional de la salud f\xEDsica</h1><h4 class="text-center" translate="">Preparadores f\xEDsicos, nutricionistas, kinesi\xF3logos, etc.</h4><div class="row"><div class="col-md-12"><div class="alert bg-{{messagedata.type}}" ng-show="messagedata.message">{{messagedata.message|translate}}<p class="mensaje-errores" ng-repeat="error in messagedata.errors.error.message" ng-show="messagedata.errors">{{error[0]|translate}}</p></div></div></div><form class="form-horizontal" ng-submit="registra(registro.email,registro.password,0)"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label" translate="">Email</label><div class="col-sm-10"><input type="email" ng-model="registro.email" class="form-control" id="inputEmail3" placeholder="{{\'Email\'|translate}}"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label" translate="">Contrase\xF1a</label><div class="col-sm-10"><input type="password" ng-model="registro.password" class="form-control" id="inputPassword3" placeholder="{{\'Contrase\xF1a\'|translate}}"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-4"><button type="submit" class="btn btn-default btn-auth" ng-disabled="!enviando" translate="">Registrarse</button></div><div class="col-sm-6"><a href="#/login" class="auth-link" translate="">Ya tienes una cuenta? Ingresa!</a></div><div ng-show="!enviando" class="text-center"><i class="fa fa-spinner fa-pulse fa-fw"></i>{{\'Estamos registrando tu cuenta\'|translate}}</div></div></form></uib-tab><uib-tab heading="{{\'Registro como Cliente\'|translate}}" class="col-sm-6 tab-registro"><h1 translate="">Reg\xEDstrate como cliente</h1><h4 class="text-center" translate="">Reg\xEDstrate aqu\xED si necesitas que un profesional te eval\xFAe</h4><div class="row"><div class="col-md-12"><div class="alert bg-{{messagedata.type}}" ng-show="messagedata.message">{{messagedata.message|translate}}<p class="mensaje-errores" ng-repeat="error in messagedata.errors.error.message" ng-show="messagedata.errors">{{error|translate}}</p></div></div></div><form class="form-horizontal" ng-submit="registra(registro.emailcliente,registro.passwordcliente,2)"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label" translate="">Email</label><div class="col-sm-10"><input type="email" ng-model="registro.emailcliente" class="form-control" id="inputEmail3" placeholder="{{\'Email\'|translate}}"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label" translate="">Contrase\xF1a</label><div class="col-sm-10"><input type="password" ng-model="registro.passwordcliente" class="form-control" id="inputPassword3" placeholder="{{\'Contrase\xF1a\'|translate}}"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-4"><button type="submit" class="btn btn-default btn-auth" ng-disabled="!enviando" translate="">Registrarse</button></div><div class="col-sm-6"><a href="#/login" class="auth-link" translate="">Ya tienes una cuenta? Ingresa!</a></div><div ng-show="!enviando" class="text-center"><i class="fa fa-spinner fa-pulse fa-fw"></i>{{\'Estamos registrando tu cuenta\'|translate}}</div></div></form></uib-tab></uib-tabset></div></main>');
$templateCache.put('app/pages/charts/amCharts/charts.html','<div class="widgets"><div class="row"><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/barChart/barChart.html\'"></div></div><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/areaChart/areaChart.html\'"></div></div><div class="col-lg-4 col-md-12" ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/lineChart/lineChart.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Pie Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/pieChart/pieChart.html\'"></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Funnel Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/funnelChart/funnelChart.html\'"></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Combined bullet/column and line graphs with multiple value axes" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/combinedChart/combinedChart.html\'"></div></div></div></div>');
$templateCache.put('app/pages/charts/chartist/chartist.html','<section ng-controller="chartistCtrl" class="chartist"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Lines" ba-panel-class="with-scroll"><h5>Simple line chart</h5><div id="line-chart" class="ct-chart"></div><h5>Line chart with area</h5><div id="area-chart" class="ct-chart"></div><h5>Bi-polar line chart with area only</h5><div id="bi-chart" class="ct-chart"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><h5>Simple bar chart</h5><div id="simple-bar" class="ct-chart"></div><h5>Multi-line labels bar chart</h5><div id="multi-bar" class="ct-chart"></div><h5>Stacked bar chart</h5><div id="stacked-bar" class="ct-chart stacked-bar"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Pies & Donuts" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12 col-lg-4"><h5>Simple Pie</h5><div id="simple-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Pie with labels</h5><div id="label-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Donut</h5><div id="donut" class="ct-chart"></div></div></div></div></div></div></section>');
$templateCache.put('app/pages/charts/chartJs/chartJs.html','<div class="row"><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Pie" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="pie" class="chart chart-pie" chart-options="options" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Doughnut" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" chart-options="options" class="chart chart-doughnut" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Polar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="polar-area" class="chart chart-polar-area" chart-data="data" chart-options="options" chart-labels="labels" chart-click="changeData"></canvas></div></div></div></div><div class="row"><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Radar" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveLine" class="chart chart-radar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Bars" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveBars" class="chart chart-bar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div></div><div class="row"><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Radar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="radar" class="chart chart-radar" chart-series="series" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Line" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="line" class="chart chart-line" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-12" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="bar" class="chart chart-bar" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData" chart-update="updateC"></canvas></div></div></div></div>');
$templateCache.put('app/pages/charts/morris/morris.html','<section ng-controller="morrisCtrl"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div line-chart="" line-data="lineData" line-xkey="y" line-ykeys=\'["a", "b"]\' line-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div><div class="row"><div class="col-md-4"><div ba-panel="" ba-panel-title="Donut" ba-panel-class="with-scroll"><div donut-chart="" donut-data="donutData" donut-colors="colors" donut-formatter=\'"currency"\'></div></div></div><div class="col-md-8"><div ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div bar-chart="" bar-data="barData" bar-x="y" bar-y=\'["a", "b"]\' bar-labels=\'["Series A", "Series B"]\' bar-colors="colors"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div area-chart="" area-data="areaData" area-xkey="y" area-ykeys=\'["a", "b"]\' %="" area-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div></section>');
$templateCache.put('app/pages/components/mail/mail.html','<div class="row mail-client-container transparent"><div class="col-md-12"><div ba-panel="" ba-panel-class="xmedium-panel mail-panel"><div class="letter-layout"><div class="mail-navigation-container" ng-class="{\'expanded\' : !tabCtrl.navigationCollapsed}"><div class="text-center"><button type="button" ng-show="false" class="btn btn-default compose-button" ng-click="tabCtrl.showCompose(\'\',\'\',\'\')" translate="">Escribir</button></div><div ng-repeat="t in tabCtrl.tabs" ui-sref-active="active" class="mail-navigation" ui-sref="mail.label({label: t.label})" ng-click="selectTab(t.label)">{{t.name}}<span class="new-mails" ng-show="t.newMails">{{cantidadmensajes}}</span></div></div><ui-view></ui-view></div></div></div></div>');
$templateCache.put('app/pages/components/timeline/timeline.html','<div ba-panel=""><section id="cd-timeline" class="cd-container cssanimations" ng-controller="TimelineCtrl"><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Euro-Coin\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 1</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto, optio, dolorum provident rerum aut hic quasi placeat iure tempora laudantium ipsa ad debitis unde? Iste voluptatibus minus veritatis qui ut.</p><span class="cd-date">Jan 14</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Laptop-Signal\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 2</h5><p>Donec dapibus at leo eget volutpat. Praesent dolor tellus, ultricies venenatis molestie eu, luctus eget nibh. Curabitur ullamcorper eleifend nisl.</p><span class="cd-date">Jan 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Checklist\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 3</h5><p>Phasellus auctor tellus eget lacinia condimentum. Cum sociis natoque penatibus et magnis dis parturient montes.</p><span class="cd-date">Feb 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Boss-3\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 4</h5><p>Morbi fringilla in massa ac posuere. Fusce non sagittis massa, id accumsan odio. Nullam eget tempor est. Etiam eu felis eu purus aliquam tristique id quis nisl. Nam eros nibh, consequat sed pulvinar eu, ultrices ornare ligula. Aenean interdum sed nunc sed hendrerit.</p><span class="cd-date">Feb 20</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Online-Shopping\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 5</h5><p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Curabitur eget mattis metus. Nullam egestas eros metus, quis fringilla urna accumsan sed. Aliquam ultrices at arcu vitae tincidunt.</p><span class="cd-date">Feb 21</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Money-Increase\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 6</h5><p>Praesent bibendum ante mattis augue consectetur, ut commodo turpis consequat. Donec ligula eros, porta in iaculis vel, semper ac sem. Integer at mauris lorem.</p><span class="cd-date">Feb 23</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Vector\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 7</h5><p>Vivamus ut laoreet erat, vitae eleifend eros. Sed varius id tellus non lobortis. Sed dolor ante, cursus non scelerisque sed, euismod id eros.</p><span class="cd-date">Feb 24</span></div></div></section></div>');
$templateCache.put('app/pages/components/tree/tree.html','<div class="row" ng-controller="treeCtrl"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Action" ba-panel-class="with-scroll tree-panel"><div class="row"><div class="col-sm-4"><div class="control-side text-center"><div><button class="btn btn-primary" ng-click="addNewNode()">Add</button></div><div><button class="btn btn-primary" ng-click="collapse()">Collapse All</button></div><div><button class="btn btn-primary" ng-click="expand()">Expand All</button></div><div><button class="btn btn-primary" ng-click="refresh()">Refresh</button></div></div></div><div class="col-sm-8"><div js-tree="basicConfig" ng-model="treeData" should-apply="applyModelChanges()" tree="basicTree" tree-events="ready:readyCB"></div></div></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Drag & Drop" ba-panel-class="with-scroll tree-panel"><div js-tree="dragConfig" ng-model="dragData"></div></div></div></div>');
$templateCache.put('app/pages/dashboard/blurFeed/blurFeed.html','<div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message" ng-repeat="message in feed" ng-click="expandMessage(message)"><div class="message-icon" ng-if="message.type == \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"></div><div class="message-icon" ng-if="message.type != \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"> <span class="sub-photo-icon" ng-class="::message.type"></span></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::message.author }} {{ ::message.surname}}</span></div><div class="message-content line-clamp" ng-class="{\'line-clamp-2\' : !message.expanded}"><span ng-if="message.preview">{{message.header}}</span>{{::message.text}}</div><div class="preview" ng-show="message.expanded" ng-if="message.preview"><a href="{{::message.link}}" target="_blank"><img ng-src="{{ ::( message.preview | appImage )}}"></a></div><div ng-show="message.expanded" class="message-time"><div class="post-time">{{::message.time}}</div><div class="ago-time">{{::message.ago}}</div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardCalendar/dashboardCalendar.html','<div id="calendar" class="blurCalendar"></div>');
$templateCache.put('app/pages/dashboard/dashboardLineChart/dashboardLineChart.html','<div id="amchart"></div>');
$templateCache.put('app/pages/dashboard/dashboardMap/dashboardMap.html','<div id="amChartMap"></div>');
$templateCache.put('app/pages/dashboard/dashboardPieChart/dashboardPieChart.html','<div class="row pie-charts"><div class="pie-chart-item-container" ng-repeat="chart in charts"><div ba-panel=""><div class="pie-chart-item"><div class="chart" rel="{{ ::chart.color }}" data-percent="60"><span class="percent"></span></div><div class="description"><div>{{ ::chart.description }}</div><div class="description-stats">{{ ::chart.stats }}</div></div><i class="chart-icon i-{{ ::chart.icon }}"></i></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardTodo/dashboardTodo.html','<div class="task-todo-container" ng-class="{\'transparent\': transparent}"><input type="text" value="" class="form-control task-todo" placeholder="Task to do.." ng-keyup="addToDoItem($event)" ng-model="newTodoText"> <i ng-click="addToDoItem(\'\',true)" class="add-item-icon ion-plus-round"></i><div class="box-shadow-border"></div><ul class="todo-list" ui-sortable="" ng-model="todoList"><li ng-repeat="item in todoList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false"><div class="blur-container"><div class="blur-box"></div></div><i class="mark" style="background-color: {{::item.color}}"></i> <label class="todo-checkbox custom-checkbox custom-input-success"><input type="checkbox" ng-model="isChecked"> <span class="cut-with-dots">{{ item.text }}</span></label> <i class="remove-todo ion-ios-close-empty" ng-click="item.deleted = true"></i></li></ul></div>');
$templateCache.put('app/pages/dashboard/popularApp/popularApp.html','<div class="popular-app-img-container"><div class="popular-app-img"><img ng-src="{{::( \'app/my-app-logo.png\' | appImage )}}"> <span class="logo-text">Super&nbspApp</span></div></div><div class="popular-app-cost row"><div class="col-xs-9">Most Popular App</div><div class="col-xs-3 text-right">175$</div></div><div class="popular-app-info row"><div class="col-xs-4 text-left"><div class="info-label">Total Visits</div><div>47,512</div></div><div class="col-xs-4 text-center"><div class="info-label">New Visits</div><div>9,217</div></div><div class="col-xs-4 text-right"><div class="info-label">Sales</div><div>2,928</div></div></div>');
$templateCache.put('app/pages/dashboard/trafficChart/trafficChart.html','<div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="chart-area" width="280" height="280"></canvas><div class="traffic-text">1,900,128 <span>Views Total</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in doughnutData.labels" ng-init="i = $index; data = doughnutData.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">+{{data.percentage[i]}}%</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width: {{item.percentage}}%"></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/weather/weather.html','<div class="weather-wrapper"><div class="weather-main-info"><h5 class="city-date font-x1dot5"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class="weather-description font-x1dot5"><i class="font-x3 {{weatherIcons[weather.days[weather.current].icon]}}"></i><div class="weather-info">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class="weather-temp font-x1dot5"><i class="font-x2 ion-thermometer"></i><div class="weather-info" ng-switch="" on="units"><span ng-switch-when="metric">{{weather.days[weather.current].temp}} \xB0C | <a ng-click="switchUnits(\'imperial\')" href="">\xB0F</a></span> <span ng-switch-when="imperial">{{weather.days[weather.current].temp}} \xB0F | <a ng-click="switchUnits(\'metric\')" href="">\xB0C</a></span></div></div></div><div id="tempChart" class="temp-by-time"></div><div class="select-day"><div class="day" ng-repeat="day in weather.days" ng-click="switchDay($index)"><div><span class="font-x1dot25">{{day.temp}}</span></div><div><i class="weatherIcon font-x2 {{weatherIcons[day.icon]}}"></i> <span class="select-day-info">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/inputs.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Standard Fields" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/standardFields.html\'"></div></div><div ba-panel="" ba-panel-title="Tags Input" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/tagsInput/tagsInput.html\'"></div></div><div ba-panel="" ba-panel-title="Input Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/inputGroups.html\'"></div></div><div ba-panel="" ba-panel-title="Checkboxes & Radios" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/checkboxesRadios.html\'"></div></div><div ba-panel="" ba-panel-title="On/Off Switches" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/switches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Old On/Off Switches (Deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSwitches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Datepicker" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/datePickers/datePickers.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Validation States" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/validationStates.html\'"></div></div><div ba-panel="" ba-panel-title="Selects" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/select/select.html\'"></div></div><div ba-panel="" ba-panel-title="Old selects(deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSelect/select.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/layouts/layouts.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/inlineForm.html\'"></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/basicForm.html\'"></div></div><div ba-panel="" ba-panel-title="Horizontal Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/horizontalForm.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Form Without Labels" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/formWithoutLabels.html\'"></div></div><div ba-panel="" ba-panel-title="Block Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/blockForm.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/wizard/wizard.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Form Wizard" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Personal info" form="vm.personalInfoForm2"><form name="vm.personalInfoForm2" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.personalInfoForm2.username.$invalid && (vm.personalInfoForm2.username.$dirty || vm.personalInfoForm2.$submitted)}"><label for="exampleUsername1">Username</label> <input type="text" class="form-control" id="exampleUsername1" name="username" placeholder="Username" ng-model="vm.personalInfo.username" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm2.email.$invalid && (vm.personalInfoForm2.email.$dirty || vm.personalInfoForm2.$submitted)}"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" name="email" placeholder="Email" ng-model="vm.personalInfo.email" required=""> <span class="help-block error-block basic-block">Proper email required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm2.password.$invalid && (vm.personalInfoForm2.password.$dirty || vm.personalInfoForm2.$submitted)}"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" name="password" placeholder="Password" ng-model="vm.personalInfo.password" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': !vm.arePersonalInfoPasswordsEqual() && (vm.personalInfoForm2.confirmPassword.$dirty || vm.personalInfoForm2.$submitted)}"><label for="exampleInputConfirmPassword1">Confirm Password</label> <input type="password" class="form-control" id="exampleInputConfirmPassword1" name="confirmPassword" placeholder="Confirm Password" ng-model="vm.personalInfo.confirmPassword" required=""> <span class="help-block error-block basic-block">Passwords should match</span></div></div></div></form></ba-wizard-step><ba-wizard-step title="Product Info" form="vm.productInfoForm"><form name="vm.productInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.productInfoForm.productName.$invalid && (vm.productInfoForm.productName.$dirty || vm.productInfoForm.$submitted)}"><label for="productName">Product name</label> <input type="text" class="form-control" id="productName" name="productName" placeholder="Product name" ng-model="vm.productInfo.productName" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.productInfoForm.productId.$invalid && (vm.productInfoForm.productId.$dirty || vm.productInfoForm.$submitted)}"><label for="productId">Product id</label> <input type="text" class="form-control" id="productId" name="productId" placeholder="productId" ng-model="vm.productInfo.productId" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Category</label><select class="form-control" title="Category" selectpicker=""><option selected="">Electronics</option><option>Toys</option><option>Accessories</option></select></div></div></div></form></ba-wizard-step><ba-wizard-step title="Shipment" form="vm.addressForm"><form name="vm.addressForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addressForm.address.$invalid && (vm.addressForm.address.$dirty || vm.addressForm.$submitted)}"><label for="productName">Shipment address</label> <input type="text" class="form-control" id="address" name="address" placeholder="Shipment address" ng-model="vm.shipment.address" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Shipment method</label><select class="form-control" title="Category" selectpicker=""><option selected="">Fast & expensive</option><option>Cheap & free</option></select></div></div></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Save shipment info</span></label></div></form></ba-wizard-step><ba-wizard-step title="Finish"><form class="form-horizontal" name="vm.finishForm" novalidate="">Congratulations! You have successfully filled the form!</form></ba-wizard-step></ba-wizard></div></div></div></div>');
$templateCache.put('app/pages/maps/google-maps/google-maps.html','<div ba-panel="" ba-panel-title="Google Maps" class="viewport100"><div id="google-maps"></div></div>');
$templateCache.put('app/pages/maps/leaflet/leaflet.html','<div ba-panel="" ba-panel-title="Leaflet" class="viewport100"><div id="leaflet-map"></div></div>');
$templateCache.put('app/pages/maps/map-bubbles/map-bubbles.html','<div ba-panel="" ba-panel-title="Map with Bubbles" class="viewport100"><div id="map-bubbles"></div></div>');
$templateCache.put('app/pages/maps/map-lines/map-lines.html','<div ba-panel="" ba-panel-title="Line Map" class="viewport100"><div id="map-lines"></div></div>');
$templateCache.put('app/pages/tables/basic/tables.html','<div class="widgets"><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Hover Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/hoverRows.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Bordered Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/borderedTable.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Condensed Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/condensedTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Striped Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/stripedRows.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Contextual Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/contextualTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Responsive Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/responsiveTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/smart/tables.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Rows" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableRowTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Cells" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Smart Table With Filtering, Sorting And Pagination" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/smartTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/widgets/basicTable.html','<div class="horizontal-scroll"><table class="table"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Downloads</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">DAU</th><th class="table-arr"></th><th class="align-right">MAU</th><th class="table-arr"></th><th class="align-right">LTV</th><th class="table-arr"></th><th class="align-right">Users %</th><th class="table-arr"></th></tr></thead><tbody><tr><td><img src="img/chrome.svg" width="20" height="20"></td><td class="nowrap">Google Chrome</td><td class="align-right">10,392</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">3,822</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,214</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">899</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">7,098</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">178</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">45%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/firefox.svg" width="20" height="20"></td><td class="nowrap">Mozilla Firefox</td><td class="align-right">7,873</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">6,003</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,031</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">897</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">8,997</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">28%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/ie.svg" width="20" height="20"></td><td class="nowrap">Internet Explorer</td><td class="align-right">5,890</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,492</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">2,102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">27</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,039</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">99</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">17%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/safari.svg" width="20" height="20"></td><td class="nowrap">Safari</td><td class="align-right">4,001</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">2,039</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">1,001</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">104</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,983</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">209</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">14%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/opera.svg" width="20" height="20"></td><td class="nowrap">Opera</td><td class="align-right">1,833</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">983</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">83</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">19</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">1,099</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">103</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">5%</td><td class="table-arr"><i class="icon-up"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/borderedTable.html','<div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="align-right">Purchases</th><th class="align-right">%</th></tr></thead><tbody><tr ng-repeat="item in metricsTableData"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="align-right">{{item.purchases}}</td><td class="align-right">{{item.percent}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/condensedTable.html','<div class="horizontal-scroll"><table class="table table-condensed"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat="item in peopleTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><button class="status-button btn btn-xs btn-{{item.status}}">{{item.status}}</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/contextualTable.html','<table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class="primary"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr class="success"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr class="warning"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr class="danger"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr class="info"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableRowTable.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addUser()">Add row</button></div><table class="table table-bordered table-hover table-condensed"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat="user in users" class="editable-row"><td>{{$index}}</td><td><span editable-text="user.name" e-name="name" e-form="rowform" e-required="">{{ user.name || \'empty\' }}</span></td><td class="select-td"><span editable-select="user.status" e-name="status" e-form="rowform" e-selectpicker="" e-ng-options="s.value as s.text for s in statuses">{{ showStatus(user) }}</span></td><td class="select-td"><span editable-select="user.group" e-name="group" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.text for g in groups">{{ showGroup(user) }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == user"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUser($index)">Delete</button></div></td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableTable.html','<div class="horizontal-scroll"><table class="table table-hover" st-table="editableTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr></thead><tbody><tr ng-repeat="item in editableTableData" class="editable-tr-wrap"><td class="table-id">{{item.id}}</td><td><span editable-text="item.firstName" blur="cancel">{{item.firstName}}</span></td><td><span editable-text="item.lastName" blur="cancel">{{item.lastName}}</span></td><td><span editable-text="item.username" blur="cancel">{{item.username}}</span></td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><span editable-text="item.age" blur="cancel">{{item.age}}</span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="12" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/hoverRows.html','<div class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">%</th><th class="table-arr"></th></tr></thead><tbody><tr ng-repeat="item in metricsTableData" class="no-top-border"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }"></i></td><td class="align-right">{{item.purchases}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }"></i></td><td class="align-right">{{item.percent}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/responsiveTable.html','<div class="table-responsive"><table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/smartTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr><tr><th></th><th><input st-search="firstName" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastName" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" placeholder="Search Email" class="input-sm form-control search-input" type="search"></th><th><input st-search="age" placeholder="Search Age" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/stripedRows.html','<div class="vertical-scroll"><table class="table table-striped"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/alerts/alerts.html','<div class="widgets"><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info"><strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger"><strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Dismissible alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Links in alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read <a href="" class="alert-link">this important alert message</a>.</div><div class="alert bg-info"><strong>Heads up!</strong> This <a href="" class="alert-link">alert needs your attention</a>, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re <a href="" class="alert-link">not looking too good</a>.</div><div class="alert bg-danger"><strong>Oh snap!</strong> <a href="" class="alert-link">Change a few things up</a> and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Composite alerts" ba-panel-class="with-scroll"><div><div class="alert bg-warning"><h4>Warning!</h4><strong>Pay attention.</strong> Change a few things up and try submitting again.<div class="control-alert"><button type="button" class="btn btn-danger">Pay Attention</button> <button type="button" class="btn btn-primary">Ignore</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/buttons.html','<div class="widgets"><div class="row"><div class="col-md-3" ba-panel="" ba-panel-title="Flat Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Raised Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-raised">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-raised">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-raised">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-raised">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-raised">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Different sizes" ba-panel-class="with-scroll button-panel df-size-button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-mm">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-md">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-xm">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Disabled" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Icon Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/iconButtons.html\'"></div></div><div ba-panel="" ba-panel-title="Large Buttons" ba-panel-class="with-scroll large-buttons-panel"><div ng-include="\'app/pages/ui/buttons/widgets/largeButtons.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Button Dropdowns" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/dropdowns.html\'"></div></div><div ba-panel="" ba-panel-title="Button Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/buttonGroups.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Progress Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/progressButtons.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/grid/baseGrid.html','<h4 class="grid-h">Stacked to horizontal</h4><div class="row show-grid"><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div></div><div class="row show-grid"><div class="col-md-8"><div>.col-md-8</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-6"><div>.col-md-6</div></div><div class="col-md-6"><div>.col-md-6</div></div></div><h4 class="grid-h">Mobile and desktop</h4><div class="row show-grid"><div class="col-xs-12 col-md-8"><div>xs-12 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6"><div>.col-xs-6</div></div><div class="col-xs-6"><div>.col-xs-6</div></div></div><h4 class="grid-h">Mobile, tablet, desktop</h4><div class="row show-grid"><div class="col-xs-12 col-sm-6 col-md-8"><div>.col-xs-12 .col-sm-6 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>.col-xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div></div><h4 class="grid-h">Column wrapping</h4><div class="row show-grid"><div class="col-xs-9"><div>.col-xs-9</div></div><div class="col-xs-4"><div>.col-xs-4<br>Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one contiguous unit.</div></div><div class="col-xs-6"><div>.col-xs-6<br>Subsequent columns continue along the new line.</div></div></div><h4 class="grid-h">Responsive column resets</h4><div class="row show-grid"><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3<p>Resize your viewport or check it out on your phone for an example.</p></div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div></div><h4 class="grid-h">Offsetting columns</h4><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4 col-md-offset-4"><div>.col-md-4 .col-md-offset-4</div></div></div><div class="row show-grid"><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div></div><div class="row show-grid"><div class="col-md-6 col-md-offset-3"><div>.col-md-6 .col-md-offset-3</div></div></div><h4 class="grid-h">Grid options</h4><div class="table-responsive"><table class="table table-bordered table-striped"><thead><tr><th></th><th>Extra small devices <small>Phones (&lt;768px)</small></th><th>Small devices <small>Tablets (\u2265768px)</small></th><th>Medium devices <small>Desktops (\u2265992px)</small></th><th>Large devices <small>Desktops (\u22651200px)</small></th></tr></thead><tbody><tr><th class="text-nowrap" scope="row">Grid behavior</th><td>Horizontal at all times</td><td colspan="3">Collapsed to start, horizontal above breakpoints</td></tr><tr><th class="text-nowrap" scope="row">Container width</th><td>None (auto)</td><td>750px</td><td>970px</td><td>1170px</td></tr><tr><th class="text-nowrap" scope="row">Class prefix</th><td><code>.col-xs-</code></td><td><code>.col-sm-</code></td><td><code>.col-md-</code></td><td><code>.col-lg-</code></td></tr><tr><th class="text-nowrap" scope="row"># of columns</th><td colspan="4">12</td></tr><tr><th class="text-nowrap" scope="row">Column width</th><td class="text-muted">Auto</td><td>~62px</td><td>~81px</td><td>~97px</td></tr><tr><th class="text-nowrap" scope="row">Gutter width</th><td colspan="4">30px (15px on each side of a column)</td></tr><tr><th class="text-nowrap" scope="row">Nestable</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Offsets</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Column ordering</th><td colspan="4">Yes</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/grid/grid.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/grid/baseGrid.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/icons/icons.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Kameleon SVG Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleon.html"></div></div><div ba-panel="" ba-panel-title="Socicon" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/socicon.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Icons With Rounded Background" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleonRounded.html"></div></div><div ba-panel="" ba-panel-title="ionicons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/ionicons.html"></div></div><div ba-panel="" ba-panel-title="Font Awesome Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/fontAwesomeIcons.html"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/modals/modals.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Modals" ba-panel-class="with-scroll"><div class="modal-buttons clearfix"><button type="button" class="btn btn-primary" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'md\')">Default modal</button> <button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/largeModal.html\', \'lg\')">Large modal</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/smallModal.html\', \'sm\')">Small modal</button></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Message Modals" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/successModal.html\')">Success Message</button> <button type="button" class="btn btn-info" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/infoModal.html\')">Info Message</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/warningModal.html\')">Warning Message</button> <button type="button" class="btn btn-danger" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/dangerModal.html\')">Danger Message</button></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Notifications" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/modals/notifications/notifications.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Progress dialogs" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-info" data-toggle="modal" ng-click="openProgressDialog()">Progress dialog</button></div></div></div></div>');
$templateCache.put('app/pages/ui/notifications/notifications.html','<div ba-panel="" ba-panel-class="with-scroll notification-panel"><div class="row"><div class="col-md-3 col-sm-4"><div class="control"><label for="title">Title</label> <input ng-model="options.title" type="text" class="form-control" id="title" placeholder="Enter a title ..."></div><div class="control"><label for="message">Message</label> <textarea ng-model="options.msg" class="form-control" id="message" rows="3" placeholder="Enter a message ..."></textarea></div><div class="control-group"><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.closeButton" type="checkbox" id="closeButton"> <span>Close Button</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.allowHtml" type="checkbox" id="html"> <span>Allow html</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.progressBar" type="checkbox" id="progressBar"> <span>Progress bar</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventDuplicates" type="checkbox" id="preventDuplicates"> <span>Prevent duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventOpenDuplicates" type="checkbox" id="preventOpenDuplicates"> <span>Prevent open duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.tapToDismiss" type="checkbox" id="tapToDismiss"> <span>Tap to dismiss</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.newestOnTop" type="checkbox" id="newestOnTop"> <span>Newest on top</span></label></div></div></div><div class="col-md-2 col-sm-3 toastr-radio-setup"><div id="toastTypeGroup"><div class="controls radio-controls"><label class="radio-header">Toast Type</label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="success"><span>Success</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="info"><span>Info</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="warning"><span>Warning</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="error"><span>Error</span></label></div></div><div id="positionGroup"><div class="controls radio-controls"><label class="radio-header position-header">Position</label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-right"> <span>Top Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-right"> <span>Bottom Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-left"> <span>Bottom Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-left"> <span>Top Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-full-width"> <span>Top Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-full-width"> <span>Bottom Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-center"> <span>Top Center</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-center"> <span>Bottom Center</span></label></div></div></div><div class="col-md-2 col-sm-3"><div class="control"><label for="timeOut">Time out</label> <input type="text" class="form-control" id="timeOut" ng-model="options.timeOut" placeholder="ms"> <label class="sub-label" for="timeOut">If you set it to 0, it will stick</label></div><div class="control"><label for="extendedTimeOut">Extended time out</label> <input type="text" class="form-control" id="extendedTimeOut" ng-model="options.extendedTimeOut" placeholder="ms"></div><div class="control"><label for="maxOpened">Maximum number of toasts</label> <input type="text" class="form-control" id="maxOpened" ng-model="options.maxOpened" value="0"> <label for="maxOpened" class="sub-label">0 means no limit</label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.autoDismiss" type="checkbox" id="autoDismiss"> <span>Auto dismiss</span></label></div></div><div class="col-md-5 col-sm-12"><label>Result:</label><pre class="result-toastr" id="toastrOptions">{{optionsStr}}</pre></div></div><div class="row"><div class="col-md-12 button-row"><button ng-click="openToast()" class="btn btn-primary">Open Toast</button> <button ng-click="openRandomToast()" class="btn btn-primary">Random Toast</button> <button ng-click="clearToasts()" class="btn btn-danger">Clear Toasts</button> <button ng-click="clearLastToast()" class="btn btn-danger">Clear Last Toast</button></div></div></div>');
$templateCache.put('app/pages/ui/panels/panels.html','<h2>Default panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-class="xsmall-panel light-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ac mi erat. Phasellus placerat, elit a laoreet semper, enim ipsum ultricies orci, ac tincidunt tellus massa eu est. Nam non porta purus, sed facilisis justo. Nam pulvinar sagittis quam.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header" ba-panel-class="xsmall-panel light-text">Phasellus maximus venenatis augue, et vestibulum neque aliquam ut. Morbi mattis libero vitae vulputate dignissim. Praesent placerat, sem non dapibus cursus, lacus nisi blandit quam, vitae porttitor lectus lacus non turpis. Donec suscipit consequat tellus.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header & scroll" ba-panel-class="xsmall-panel with-scroll light-text"><p>Suspendisse nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Sed dapibus, purus vel hendrerit consectetur, lectus orci gravida massa, sed bibendum dui mauris et eros. Nulla dolor massa, posuere et dictum sit amet, dignissim quis odio. Fusce mollis finibus dignissim. Integer sodales augue erat. Pellentesque laoreet vestibulum urna at iaculis. Nulla libero augue, euismod at diam eget, aliquam condimentum ligula. Donec a leo eu est molestie lacinia hendrerit sed lorem. Duis id diam eu metus sodales consequat vel eu elit. Praesent dolor nibh, convallis eleifend feugiat a, finibus porttitor nibh. Ut non libero vel velit pulvinar scelerisque non vel lorem. Integer porta tempor nulla. Sed nibh erat, ultrices vel lorem eu, rutrum vehicula sem.</p><p>Donec nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum nec ligula egestas rhoncus. Sed dignissim, augue vel scelerisque vulputate, nisi ante posuere lorem, quis iaculis eros dolor eu nisl. Etiam sagittis, ipsum ac tempor iaculis, justo neque mattis ante, ac maximus sapien risus eu sapien. Morbi erat urna, varius et lectus vel, porta dictum orci. Duis bibendum euismod elit, et lobortis purus venenatis in. Mauris eget lacus enim. Cras quis sem et magna fringilla convallis. Proin hendrerit nulla vel gravida mollis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Vestibulum consectetur quis purus vel aliquam.</p></div></div></div><h2>Bootstrap panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-body"><p>A panel in bootstrap is a bordered box with some padding around its content.</p><p class="p-with-code">Panels are created with the <code>.panel</code> class, and content inside the panel has a <code>.panel-body</code> class. The <code>.panel-default .panel-primary .panel-danger</code> and other classes are used to style the color of the panel. See the next example on this page for more contextual classes.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-heading">Panel Heading</div><div class="panel-body"><p class="p-with-code">The <code>.panel-heading</code> class adds a heading to the panel.Easily add a heading container to your panel with .panel-heading. You may also include any <code>h1-h6</code> with a <code>.panel-title</code> class to add a pre-styled heading.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel"><div class="panel-body footer-panel"><p class="p-with-code">Wrap buttons or secondary text in <code>.panel-footer</code>. Note that panel footers do not inherit colors and borders when using contextual variations as they are not meant to be in the foreground.</p></div><div class="panel-footer">Panel Footer</div></div></div></div><h2>Panels with Contextual Classes</h2><div class="row"><div class="col-md-6 col-lg-4"><div class="panel panel-default contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-default class</div><div class="panel-body">To color the panel, use contextual classes. This is sample <code>.panel-default</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-primary contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-primary class</div><div class="panel-body">Sample <code>.panel-primary</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-success contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-success class</div><div class="panel-body">Sample <code>.panel-success</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-info contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-info class</div><div class="panel-body">Sample <code>.panel-info</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-warning contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-warning class</div><div class="panel-body">Sample <code>.panel-warning</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-danger contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-danger class</div><div class="panel-body">Sample <code>.panel-danger</code> panel</div></div></div></div><div class="row"><div class="col-md-12"><h2>Panel Group</h2><div class="panel-group"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 1</div><div class="panel-body"><p>To group many panels together, wrap a <code>&lt;div&gt;</code> with class <code>\r\n            .panel-group</code> around them.</p></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 2</div><div class="panel-body"><p>The <code>.panel-group</code> class clears the bottom-margin of each panel.</p></div></div></div></div></div>');
$templateCache.put('app/pages/ui/progressBars/progressBars.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/basic.html\'"></div></div><div ba-panel="" ba-panel-title="Striped" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/striped.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="With label" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/label.html\'"></div></div><div ba-panel="" ba-panel-title="Animated" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/animated.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Stacked" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/stacked.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/slider/slider.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ion Range Slider" ba-panel-class="with-scroll"><div class="slider-box"><h5>Basic</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="false"></ion-slider></div><div class="slider-box"><h5>With prefix</h5><ion-slider type="single" grid="true" min="100" max="1200" prefix="$" from="420" disable="false"></ion-slider></div><div class="slider-box"><h5>With postfix</h5><ion-slider type="single" grid="true" min="-90" max="90" postfix="\xB0" from="36" disable="false"></ion-slider></div><div class="slider-box"><h5>Two way range</h5><ion-slider type="double" grid="true" min="100" max="1200" from="420" to="900" disable="false"></ion-slider></div><div class="slider-box"><h5>With Steps</h5><ion-slider type="single" grid="true" min="0" max="1000" from="300" step="50" disable="false"></ion-slider></div><div class="slider-box"><h5>Decorating numbers</h5><ion-slider type="single" grid="true" min="0" max="1000000" from="300000" step="1000" prettify-separator="." prettify="true" disable="false"></ion-slider></div><div class="slider-box"><h5>Using custom values array</h5><ion-slider type="single" grid="true" from="5" step="1000" values="[\'January\', \'February\', \'March\', \'April\', \'May\', \'June\', \'July\', \'August\', \'September\', \'October\', \'November\', \'December\']" disable="false"></ion-slider></div><div class="slider-box"><h5>Disabled</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="true"></ion-slider></div></div></div></div>');
$templateCache.put('app/pages/ui/typography/typography.html','<div class="typography-document-samples row-fluid"><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll heading-widget" ba-panel-title="Text Size"><div class="section-block"><h1>H1. Heading 1</h1><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h2>H2. Heading 2</h2><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h3>H3. Heading 3</h3><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h4>H4. Heading 4</h4><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra,.</p></div><div class="section-block"><h5>H5. Heading 5</h5><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll more-text-widget" ba-panel-title="Some more text"><div class="section-block light-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis.</p></div><div class="section-block regular-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id.</p></div><div class="section-block upper-text bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullam-corper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block small-text"><p>Secondary text. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar,</p><p>lacinia scelerisque pharetra, placerat vestibulum eleifend</p><p>pellentesque, mi nam.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll lists-widget" ba-panel-title="Lists"><div class="section-block"><h5 class="list-header">Unordered list:</h5><ul class="blur"><li>Lorem ipsum dolor sit amet</li><li>\u0421lacinia scelerisque pharetra<ul><li>Dui rhoncus quisque integer lorem<ul><li>Libero iaculis vestibulum eu vitae</li></ul></li></ul></li><li>Nisl lectus nibh habitasse suspendisse ut</li><li><span>Posuere cursus hac, vestibulum wisi nulla bibendum</span></li></ul><h5 class="list-header">Ordered Lists:</h5><ol class="blur"><li><span>Eu non nec cursus quis mollis, amet quam nec</span></li><li><span>Et suspendisse, adipiscing fringilla ornare sit ligula sed</span><ol><li><span>Interdum et justo nulla</span><ol><li><span>Magna amet, suscipit suscipit non amet</span></li></ol></li></ol></li><li><span>Metus duis eu non eu ridiculus turpis</span></li><li><span>Neque egestas id fringilla consectetuer justo curabitur, wisi magna neque commodo volutpat</span></li></ol><div class="accent">Important text fragment. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</div></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll color-widget" ba-panel-title="Text Color"><div class="section-block red-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p></div><div class="section-block yellow-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula ut id elit. In sed ornare nulla.</p></div><div class="section-block links"><p>Lorem ipsum <a href="">dolor</a> sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis <a href="">ullamcorper</a> ligula sodales at. Nulla tellus elit, varius non commodo eget, <a href="">mattis</a> vel eros. In sed ornare nulla.</p></div><div class="section-block links"><p><a href="">Active link \u2014 #209e91</a></p><p class="hovered"><a href="">Hover link \u2014 #17857a</a></p></div></div></div></div><div class="row-fluid"><div class="col-lg-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="banner-column-panel"><div class="banner"><div class="large-banner-wrapper"><img ng-src="{{::( \'app/typography/banner.png\' | appImage )}}" alt=""></div><div class="banner-text-wrapper"><div class="banner-text"><h1>Simple Banner Text</h1><p>Lorem ipsum dolor sit amet</p><p>Odio amet viverra rutrum</p></div></div></div><div class="section"><h2>Columns</h2><div class="row"><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo03.png\' | appImage )}}" alt="" title=""></div><p>Vel elit, eros elementum, id lacinia, duis non ut ut tortor blandit. Mauris <a href="">dapibus</a> magna rutrum. Ornare neque suspendisse <a href="">phasellus wisi</a>, quam cras pede rutrum suspendisse, <a href="">felis amet eu</a>. Congue magna elit quisque quia, nullam justo sagittis, ante erat libero placerat, proin condimentum consectetuer lacus. Velit condimentum velit, sed penatibus arcu nulla.</p></div><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo01.png\' | appImage )}}" alt="" title=""></div><p>Et suspendisse, adipiscing fringilla ornare sit ligula sed, vel nam. Interdum et justo nulla, fermentum lobortis purus ut eu, duis nibh dolor massa tristique elementum, nibh iste potenti risus fusce aliquet fusce, ullamcorper debitis primis arcu tellus vestibulum ac.</p></div></div><div class="separator"></div><div class="row"><div class="col-sm-4"><h4>Column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo04.png\' | appImage )}}" alt=""></div><p>Eget augue, lacus erat ante egestas scelerisque aliquam, metus molestie leo in habitasse magna maecenas</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Yet another column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo05.png\' | appImage )}}" alt=""></div><p>Augue massa et parturient, suspendisse orci nec scelerisque sit, integer nam mauris pede consequat in velit</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Third column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo06.png\' | appImage )}}" alt=""></div><p>Eget turpis, tortor lobortis porttitor, vestibulum nullam vehicula aliquam</p><a href="" class="learn-more">Lean more</a></div></div><div class="separator"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/tabs/contextualAccordion.html','<uib-accordion><uib-accordion-group heading="Primary" panel-class="panel-primary bootstrap-panel accordion-panel">Primary <i class="ion-heart"></i></uib-accordion-group><uib-accordion-group heading="Success" panel-class="panel-success bootstrap-panel accordion-panel">Success <i class="ion-checkmark-round"></i></uib-accordion-group><uib-accordion-group heading="Info" panel-class="panel-info bootstrap-panel accordion-panel">Info <i class="ion-information-circled"></i></uib-accordion-group><uib-accordion-group heading="Warning" panel-class="panel-warning bootstrap-panel accordion-panel">Warning <i class="ion-alert"></i></uib-accordion-group><uib-accordion-group heading="Danger" panel-class="panel-danger bootstrap-panel accordion-panel">Danger <i class="ion-nuclear"></i></uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/mainTabs.html','<uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Start"><p>Take up one idea. Make that one idea your life--think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success.</p><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed. Similarly, when someone is failing, the tendency is to get on a downward spiral that can even become a self-fulfilling prophecy.</p><div class="text-center"><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Shop\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Programming\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Dna\' | kameleonImg )}}"></div></div><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Getting Done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab ng-init="$dropdownTabActive = 1" class="with-dropdown"><uib-tab-heading uib-dropdown=""><a uib-dropdown-toggle="" ng-click="$event.stopPropagation()">Dropdown tab <i class="caret"></i></a><ul class="dropdown-menu" uib-dropdown-menu=""><li><a ng-click="$dropdownTabActive = 1; $tabSetStatus.activeTab = 3">Tab 1</a></li><li><a ng-click="$dropdownTabActive = 2; $tabSetStatus.activeTab = 3">Tab 2</a></li></ul></uib-tab-heading><div ng-show="$dropdownTabActive == 1"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></div><div ng-show="$dropdownTabActive == 2"><p class="text-center"><button class="btn btn-danger">I\'m just a dummy button</button></p></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/ui/tabs/sampleAccordion.html','<uib-accordion><uib-accordion-group is-open="true" heading="Static Header, initially expanded" panel-class="bootstrap-panel accordion-panel panel-default">This content is straight in the template.</uib-accordion-group><uib-accordion-group heading="Dynamic Body Content" panel-class="bootstrap-panel accordion-panel panel-default"><p>The body of the uib-accordion group grows to fit the contents</p><button type="button" class="btn btn-primary btn-sm">Add Item</button></uib-accordion-group><uib-accordion-group heading="Custom template" panel-class="bootstrap-panel accordion-panel panel-default">Hello</uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading>I can have markup, too! <i class="fa pull-right ion-settings"></i></uib-accordion-heading>This is just some content to illustrate fancy headings.</uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/sideTabs.html','<div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-left"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Key\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div><div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-right"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Phone-Booth\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/ui/tabs/tabs.html','<div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel medium-panel"><div ng-include="\'app/pages/ui/tabs/mainTabs.html\'"></div></div></div><div class="col-md-6 tabset-group" ng-include="\'app/pages/ui/tabs/sideTabs.html\'"></div></div><div class="row accordions-row"><div class="col-md-6" ng-include="\'app/pages/ui/tabs/sampleAccordion.html\'"></div><div class="col-md-6" ng-include="\'app/pages/ui/tabs/contextualAccordion.html\'"></div></div></div>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar - copia.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop" ng-show="currentUser"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop" ng-show="currentUser"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-if="item.title == \'Panel Inicio\'" ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title | translate }}</span></a> <a ng-if="item.title == \'Mi Red\'" ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" class="al-sidebar-list-link" permission="" permission-only="[\'master\',\'admin\']"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title | translate }}</span></a> <a ng-if="item.title == \'Mis Clientes\'" ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" class="al-sidebar-list-link" permission="" permission-only="[\'master\',\'evaluador\',\'admin\']"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title | translate }}</span></a> <a ng-if="item.title == \'Mis Evaluaciones\'" ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title | translate }}</span></a></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><i class="ion-arrow-left-c"></i> {{\'Anterior\'|translate}}</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">{{\'Siguiente\'|translate}} <i class="ion-arrow-right-c"></i></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle | translate }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard" translate="PAGES_TITLES.HOME_GO"></a></li><li>{{ activePageTitle | translate }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix" data-ng-init="init()"><li ng-show="currentUser" uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>{{cantidadmensajes}}</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong translate="">Mensajes Recibidos</strong></div><div class="msg-list"><a class="clearfix" ng-repeat="msg in mensajes"><div class="img-area"><img class="photo-msg-item" ng-src="http://apiintplus.rfit.cl/assets/img/perfiles/{{msg.img_url}}"></div><div class="msg-area"><div>{{ msg.titulo }}</div><span>{{ msg.nombre }} {{ msg.apellido }} | {{\'Enviado\'|translate}}: {{msg.created_at | asDate | date:\'dd-MM-yyyy\'}}</span></div></a></div><a ui-sref="mail.label({label : \'recibidos\'})" translate="">Ir a mensajes</a></div></li><li uib-dropdown=""><a href="" class="msg" title="{{\'Seleccionar Lenguaje\'|translate}}" uib-dropdown-toggle=""><i class="fa fa-language"></i></a><div uib-dropdown-menu="" class="top-dropdown-menu small lang"><ul><li ng-click="set_lang(\'es\')" ng-class="{ \'selected-option-cst\':selectedlang == \'es\' }"><span>{{\'SELECTORS.BUTTON_LANG_ES\'|translate}}</span></li><li ng-click="set_lang(\'en\')" ng-class="{ \'selected-option-cst\':selectedlang == \'en\' }"><span>{{\'SELECTORS.BUTTON_LANG_EN\'|translate}}</span></li></ul></div></li><li ng-show="currentUser" uib-dropdown=""><a href="" class="msg" title="{{\'Seleccionar Sistema de Medida\'|translate}}" uib-dropdown-toggle=""><i class="fa fa-cog"></i></a><div uib-dropdown-menu="" class="top-dropdown-menu small lang metricsist"><ul><li ng-click="set_metric(\'mt\')" ng-class="{ \'selected-option-cst\':selectedmet == \'mt\' }"><span>{{\'SELECTORS.BUTTON_METRIC_METRIC\'|translate}}</span></li><li ng-click="set_metric(\'en\')" ng-class="{ \'selected-option-cst\':selectedmet == \'en\' }"><span>{{\'SELECTORS.BUTTON_METRIC_IMP\'|translate}}</span></li></ul></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix"><img ng-src="http://api.rfit.cl/assets/img/rfit/logomin.png"></a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="user-profile clearfix"><div class="al-user-profile" ng-show="currentUser" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img ng-src="http://apiintplus.rfit.cl/assets/img/perfiles/{{ currentUser.img_url }}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a href="#/perfil"><i class="fa fa-user"></i>{{\'Perfil\'|translate}}</a></li><li><a href="" class="signout" ng-click="logout()"><i class="fa fa-power-off"></i>{{\'Salir\'|translate}}</a></li></ul></div><msg-center></msg-center></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">SI</span> <span class="handle"></span> <span class="handle handle-off">NO</span></div></div></label>');
$templateCache.put('app/pages/charts/amCharts/areaChart/areaChart.html','<div id="areaChart" class="admin-chart" ng-controller="AreaChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/barChart/barChart.html','<div id="barChart" class="admin-chart" ng-controller="BarChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/combinedChart/combinedChart.html','<div id="zoomAxisChart" class="admin-chart" ng-controller="combinedChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/funnelChart/funnelChart.html','<div id="funnelChart" class="admin-chart" ng-controller="FunnelChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/ganttChart/ganttChart.html','<div id="gnattChart" class="admin-chart" ng-controller="ganttChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/lineChart/lineChart.html','<div id="lineChart" class="admin-chart" ng-controller="LineChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/pieChart/pieChart.html','<div id="pieChart" class="admin-chart" ng-controller="PieChartCtrl"></div>');
$templateCache.put('app/pages/components/mail/composeBox/compose.html','<div class="compose-header"><span translate="">Nuevo Mensaje</span> <span class="header-controls"><i ng-click="$dismiss()" class="ion-close-round"></i></span></div><div><input type="text" class="form-control compose-input default-color" placeholder="Para" ng-model="boxCtrl.to" required=""> <input type="text" class="form-control compose-input default-color {{malos}}" placeholder="Asunto" ng-model="boxCtrl.subject" required=""><div class="compose-container"><text-angular-toolbar ta-toolbar-class="toolbarMain" name="toolbarMain" ta-toolbar="[[\'h1\',\'h2\',\'h3\',\'bold\',\'italics\', \'underline\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\']]"></text-angular-toolbar><text-angular name="htmlcontent" class="{{maloso}}" ta-target-toolbars="toolbarMain,toolbarFooter" ng-model="boxCtrl.text" required=""></text-angular></div></div><div class="compose-footer clearfix"><button type="button" ng-click="enviar(boxCtrl)" class="btn btn-send" translate="">Enviar</button><text-angular-toolbar ta-toolbar-class="toolbarFooter" name="toolbarFooter" ta-toolbar="[[\'insertLink\', \'insertImage\', \'html\', \'quote\',\'insertVideo\']]"></text-angular-toolbar><div class="footer-controls"><i ng-click="$dismiss()" class="compose-footer-icon ion-android-delete"></i></div></div>');
$templateCache.put('app/pages/components/mail/detail/mailDetail.html','<div class="message-container" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="message"><div class="row"><div class="toggle-navigation-container detail-page"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><button ui-sref="mail.label({label : detailCtrl.label})" type="button" class="back-button btn btn-default btn-with-icon"><i class="ion-chevron-left"></i>{{\'Volver\'|translate}}</button></div><div class="person-info row"><div class="col-lg-4 col-md-12 no-padding"><img ng-src="http://apiintplus.rfit.cl/assets/img/perfiles/{{ detailCtrl.mail.img_url }}" class="human-picture"><div class="name"><h2 class="name-h">{{detailCtrl.mail.nombre}}</h2><h2 class="name-h second-name">{{detailCtrl.mail.apellido}}</h2><div><span class="mail-tag tag label {{detailCtrl.mail.tag}}">{{detailCtrl.mail.tag|translate}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info phone-email"><div><i class="ion-iphone"></i> <span class="phone">{{detailCtrl.mail.telefono}}</span></div><div><i class="ion-email"></i> <span class="email">{{detailCtrl.mail.email}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info position-address"><div><span class="position">{{detailCtrl.mail.especialidad|translate}}</span></div><div><span class="address">{{detailCtrl.mail.direccion}}, {{detailCtrl.mail.comuna}}, {{detailCtrl.mail.region}}</span></div></div></div></div><div class="row"></div><div class="line"></div><div class="message-details"><span class="subject">{{detailCtrl.mail.titulo}}</span> <span class="date">\u2022 {{detailCtrl.mail.created_at | date : \'h:mm a MMMM d \'}}</span></div><div class="line"></div><div ng-bind-html="detailCtrl.mail.mensaje" class="message-body"></div><div class="line"></div><div class="answer-container"><button type="button" class="btn btn-with-icon" ng-show="!oculta" ng-click="tabCtrl.showCompose(detailCtrl.mail.titulo,detailCtrl.mail.nombre, detailCtrl.mail.apellido, detailCtrl.mail.id_usuario_remitente,detailCtrl.mail.id_conversacion,\'\')"><i class="ion-reply"></i>{{\'Responder\'|translate}}</button> <button type="button" class="btn btn-with-icon" ng-click="borrar(detailCtrl.mail.id)"><i class="ion-android-delete"></i>{{\'Borrar\'|translate}}</button></div></div><div ng-show="!detailCtrl.mail"><h5 ng-class="text-center" translate="">Nada que mostrar</h5></div></div>');
$templateCache.put('app/pages/components/mail/list/mailList.html','<div class="side-message-navigation" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}" data-ng-init="init()"><div class="mail-messages-control side-message-navigation-item"><div class="toggle-navigation-container"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><button type="button" class="btn btn-icon refresh-button" ng-click="init()"><i class="ion-refresh"></i></button></div><div class="messages"><div class="text-center" ng-show="loading"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></div><div class="text-center" ng-show="!loading && !bool" translate="">No hay mensajes para mostrar</div><table ng-show="!loading"><tr ng-repeat="m in listCtrl.messages track by m.id" class="side-message-navigation-item little-human shineHover {{m.tag}}"><td class="estado-lista" ui-sref="mail.detail({id: m.id, label: listCtrl.label})"><div><span class="label label-primary">{{m.estado|translate}}</span></div></td><td class="photo-td" ui-sref="mail.detail({id: m.id, label: listCtrl.label})"><img ng-src="http://apiintplus.rfit.cl/assets/img/perfiles/{{ m.img_url }}" class="little-human-picture"></td><td ui-sref="mail.detail({id: m.id, label: listCtrl.label})"><div class="name-container"><div><span class="name">{{m.nombre}} {{m.apellido}}</span></div><div><span class="tag label label-primary {{m.tag}}">{{m.tag|translate}}</span></div></div></td><td ui-sref="mail.detail({id: m.id, label: listCtrl.label})"><div class="additional-info"><span class="subject">{{m.titulo}}</span></div></td><td ui-sref="mail.detail({id: m.id, label: listCtrl.label})"><div class="mail-body-part">{{m.mensaje | plainText}}</div></td><td class="date"><span>{{m.created_at | date : \'MMM d HH:mm\'}}</span></td></tr></table></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/checkboxesRadios.html','<div class="checkbox-demo-row"><div class="input-demo checkbox-demo row"><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span>Check 1</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox02" value="option2"> <span>Check 2</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Check 3</span></label></div></div><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Option 1</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> <span>Option 2</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> <span>Option3</span></label></div></div></div><div><div class="checkbox disabled"><label class="custom-checkbox nowrap"><input type="checkbox" value="" disabled=""> <span>Checkbox is disabled</span></label></div><div class="radio disabled"><label class="custom-radio nowrap"><input type="radio" name="optionsRadios" id="optionsRadios3" value="option3" disabled=""> <span>Disabled option</span></label></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/inputGroups.html','<div class="input-group"><span class="input-group-addon input-group-addon-primary addon-left" id="basic-addon1">@</span> <input type="text" class="form-control with-primary-addon" placeholder="Username" aria-describedby="basic-addon1"></div><div class="input-group"><input type="text" class="form-control with-warning-addon" placeholder="Recipient\'s username" aria-describedby="basic-addon2"> <span class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2">@example.com</span></div><div class="input-group"><span class="input-group-addon addon-left input-group-addon-success">$</span> <input type="text" class="form-control with-success-addon" aria-label="Amount (to the nearest dollar)"> <span class="input-group-addon addon-right input-group-addon-success">.00</span></div><div class="input-group"><input type="text" class="form-control with-danger-addon" placeholder="Search for..."> <span class="input-group-btn"><button class="btn btn-danger" type="button">Go!</button></span></div>');
$templateCache.put('app/pages/form/inputs/widgets/standardFields.html','<form><div class="form-group"><label for="input01">Text</label> <input type="text" class="form-control" id="input01" placeholder="Text"></div><div class="form-group"><label for="input02">Password</label> <input type="password" class="form-control" id="input02" placeholder="Password"></div><div class="form-group"><label for="input03">Rounded Corners</label> <input type="text" class="form-control form-control-rounded" id="input03" placeholder="Rounded Corners"></div><div class="form-group"><label for="input04">With help</label> <input type="text" class="form-control" id="input04" placeholder="With help"> <span class="help-block sub-little-text">A block of help text that breaks onto a new line and may extend beyond one line.</span></div><div class="form-group"><label for="input05">Disabled Input</label> <input type="text" class="form-control" id="input05" placeholder="Disabled Input" disabled=""></div><div class="form-group"><label for="textarea01">Textarea</label> <textarea placeholder="Default Input" class="form-control" id="textarea01"></textarea></div><div class="form-group"><input type="text" class="form-control input-sm" id="input2" placeholder="Small Input"></div><div class="form-group"><input type="text" class="form-control input-lg" id="input4" placeholder="Large Input"></div></form>');
$templateCache.put('app/pages/form/inputs/widgets/validationStates.html','<div class="form-group has-success"><label class="control-label" for="inputSuccess1">Input with success</label> <input type="text" class="form-control" id="inputSuccess1"></div><div class="form-group has-warning"><label class="control-label" for="inputWarning1">Input with warning</label> <input type="text" class="form-control" id="inputWarning1"></div><div class="form-group has-error"><label class="control-label" for="inputError1">Input with error</label> <input type="text" class="form-control" id="inputError1"></div><div class="has-success"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxSuccess" value="option1"> <span>Checkbox with success</span></label></div></div><div class="has-warning"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxWarning" value="option1"> <span>Checkbox with warning</span></label></div></div><div class="has-error"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxError" value="option1"> <span>Checkbox with error</span></label></div></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputSuccess2">Input with success</label> <input type="text" class="form-control" id="inputSuccess2" aria-describedby="inputSuccess2Status"> <i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputSuccess2Status" class="sr-only">(success)</span></div><div class="form-group has-warning has-feedback"><label class="control-label" for="inputWarning2">Input with warning</label> <input type="text" class="form-control" id="inputWarning2" aria-describedby="inputWarning2Status"> <i class="ion-alert-circled form-control-feedback" aria-hidden="true"></i> <span id="inputWarning2Status" class="sr-only">(warning)</span></div><div class="form-group has-error has-feedback"><label class="control-label" for="inputError2">Input with error</label> <input type="text" class="form-control" id="inputError2" aria-describedby="inputError2Status"> <i class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <span id="inputError2Status" class="sr-only">(error)</span></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputGroupSuccess1">Input group with success</label><div class="input-group"><span class="input-group-addon addon-left">@</span> <input type="text" class="form-control" id="inputGroupSuccess1" aria-describedby="inputGroupSuccess1Status"></div><i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputGroupSuccess1Status" class="sr-only">(success)</span></div>');
$templateCache.put('app/pages/form/layouts/widgets/basicForm.html','<form><div class="form-group"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" placeholder="Email"></div><div class="form-group"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Check me out</span></label></div><button type="submit" class="btn btn-danger">Submit</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/blockForm.html','<div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">First Name</label> <input type="text" class="form-control" id="inputFirstName" placeholder="First Name"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputLastName">Last Name</label> <input type="text" class="form-control" id="inputLastName" placeholder="Last Name"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">Email</label> <input type="email" class="form-control" id="inputEmail" placeholder="Email"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputWebsite">Website</label> <input type="text" class="form-control" id="inputWebsite" placeholder="Website"></div></div></div><button type="submit" class="btn btn-primary">Submit</button>');
$templateCache.put('app/pages/form/layouts/widgets/formWithoutLabels.html','<form><div class="form-group"><input type="text" class="form-control" placeholder="Recipients"></div><div class="form-group"><input type="text" class="form-control" placeholder="Subject"></div><div class="form-group"><textarea class="form-control" placeholder="Message"></textarea></div><button type="submit" class="btn btn-success">Send</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/horizontalForm.html','<form class="form-horizontal"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="email" class="form-control" id="inputEmail3" placeholder="Email"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-warning">Sign in</button></div></div></form>');
$templateCache.put('app/pages/form/layouts/widgets/inlineForm.html','<form class="row form-inline"><div class="form-group col-sm-3 col-xs-6"><input type="text" class="form-control" id="exampleInputName2" placeholder="Name"></div><div class="form-group col-sm-3 col-xs-6"><input type="email" class="form-control" id="exampleInputEmail2" placeholder="Email"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div><button type="submit" class="btn btn-primary">Send invitation</button></form>');
$templateCache.put('app/pages/ui/buttons/widgets/buttonGroups.html','<div class="btn-group-example"><div class="btn-group" role="group" aria-label="Basic example"><button type="button" class="btn btn-danger">Left</button> <button type="button" class="btn btn-danger">Middle</button> <button type="button" class="btn btn-danger">Right</button></div></div><div class="btn-toolbar-example"><div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups"><div class="btn-group" role="group" aria-label="First group"><button type="button" class="btn btn-primary">1</button> <button type="button" class="btn btn-primary">2</button> <button type="button" class="btn btn-primary">3</button> <button type="button" class="btn btn-primary">4</button></div><div class="btn-group" role="group" aria-label="Second group"><button type="button" class="btn btn-primary">5</button> <button type="button" class="btn btn-primary">6</button> <button type="button" class="btn btn-primary">7</button></div><div class="btn-group" role="group" aria-label="Third group"><button type="button" class="btn btn-primary">8</button></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttons.html','<div class="basic-btns"><div class="row"><div class="col-md-2"><h5>Default button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-sm">Small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-sm">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-sm">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-sm">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-sm">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-sm">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-xs">Extra small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-xs">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-xs">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-xs">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-xs">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-xs">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5>Disabled button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/dropdowns.html','<div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary" uib-dropdown-toggle="">Primary <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success" uib-dropdown-toggle="">Success <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info" uib-dropdown-toggle="">Info <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default" uib-dropdown-toggle="">Default <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning" uib-dropdown-toggle="">Warning <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger" uib-dropdown-toggle="">Danger <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div><h5 class="panel-subtitle">Split button dropdowns</h5><div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary">Primary</button> <button type="button" class="btn btn-primary" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success">Success</button> <button type="button" class="btn btn-success" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info">Info</button> <button type="button" class="btn btn-info" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default">Default</button> <button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning">Warning</button> <button type="button" class="btn btn-warning" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger">Danger</button> <button type="button" class="btn btn-danger" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/iconButtons.html','<ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-icon"><i class="ion-android-download"></i></button></li><li><button type="button" class="btn btn-default btn-icon"><i class="ion-stats-bars"></i></button></li><li><button type="button" class="btn btn-success btn-icon"><i class="ion-android-checkmark-circle"></i></button></li><li><button type="button" class="btn btn-info btn-icon"><i class="ion-information"></i></button></li><li><button type="button" class="btn btn-warning btn-icon"><i class="ion-android-warning"></i></button></li><li><button type="button" class="btn btn-danger btn-icon"><i class="ion-nuclear"></i></button></li></ul><h5 class="panel-subtitle">Buttons with icons</h5><ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-with-icon"><i class="ion-android-download"></i>Primary</button></li><li><button type="button" class="btn btn-default btn-with-icon"><i class="ion-stats-bars"></i>Default</button></li><li><button type="button" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Success</button></li><li><button type="button" class="btn btn-info btn-with-icon"><i class="ion-information"></i>Info</button></li><li><button type="button" class="btn btn-warning btn-with-icon"><i class="ion-android-warning"></i>Warning</button></li><li><button type="button" class="btn btn-danger btn-with-icon"><i class="ion-nuclear"></i>Danger</button></li></ul>');
$templateCache.put('app/pages/ui/buttons/widgets/largeButtons.html','<div class="row btns-row btns-same-width-lg"><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-primary btn-lg">Primary</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-success btn-lg">Success</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-info btn-lg">Info</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-default btn-lg">Default</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-warning btn-lg">Warning</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/progressButtons.html','<div class="progress-buttons-container text-center default-text"><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">fill horizontal</span> <button progress-button="progressFunction()" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">fill vertical</span> <button progress-button="progressFunction()" pb-direction="vertical" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink horizontal</span> <button progress-button="progressFunction()" pb-style="shrink" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink vertical</span> <button progress-button="progressFunction()" pb-style="shrink" pb-direction="vertical" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-bottom<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-bottom" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-top<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-top" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-down<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-down" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-up<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-up" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-back<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-back" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">flip-open<br>perspective</span> <button progress-button="progressFunction()" pb-style="flip-open" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">slide-down<br>horizontal</span> <button progress-button="progressFunction()" pb-style="slide-down" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">move-up<br>horizontal</span> <button progress-button="progressFunction()" pb-style="move-up" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6"><span class="button-title">top-line<br>horizontal</span> <button progress-button="progressFunction()" pb-style="top-line" class="btn btn-success">Submit</button></section><section class="col-md-6"><span class="button-title">lateral-lines<br>vertical</span> <button progress-button="progressFunction()" pb-style="lateral-lines" class="btn btn-info">Submit</button></section></div></div>');
$templateCache.put('app/pages/ui/icons/widgets/fontAwesomeIcons.html','<div class="row icons-list success awesomeIcons"><div class="col-xs-2" ng-repeat="icon in icons.fontAwesomeIcons"><i class="fa {{icon}}"></i></div></div><a href="http://fortawesome.github.io/Font-Awesome/icons/" target="_blank" class="see-all-icons">See all Font Awesome icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/ionicons.html','<div class="row icons-list primary"><div class="col-xs-2" ng-repeat="icon in icons.ionicons"><i class="{{icon}}"></i></div></div><a href="http://ionicons.com/" target="_blank" class="see-all-icons">See all ionicons icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleon.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonIcons"><div class="kameleon-icon"><img ng-src="{{:: (icon.img | kameleonImg )}}"><span>{{icon.name}}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleonRounded.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonRoundedIcons"><div class="kameleon-icon with-round-bg {{icon.color}}"><img ng-src="{{::( icon.img | kameleonImg )}}"><span>{{ icon.name }}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/socicon.html','<div class="row icons-list danger"><div class="col-xs-2" ng-repeat="icon in icons.socicon"><i class="socicon">{{ icon }}</i></div></div><a href="http://www.socicon.com/chart.php" target="_blank" class="see-all-icons">See all Socicon icons</a>');
$templateCache.put('app/pages/ui/modals/notifications/notifications.html','<div class="modal-buttons same-width clearfix" ng-controller="NotificationsCtrl"><button type="button" class="btn btn-success" ng-click="showSuccessMsg()">Success Notification</button> <button type="button" class="btn btn-info" ng-click="showInfoMsg()">Info Notification</button> <button type="button" class="btn btn-warning" ng-click="showWarningMsg()">Warning Notification</button> <button type="button" class="btn btn-danger" ng-click="showErrorMsg()">Danger Notification</button></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/basicModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Error</span></div><div class="modal-body text-center">Your information hasn\'t been saved!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/infoModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Information</span></div><div class="modal-body text-center">You\'ve got a new email!</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/largeModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/smallModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/successModal.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-checkmark modal-icon"></i><span>Success</span></div><div class="modal-body text-center">Your information has been saved successfully</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/warningModal.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>Warning</span></div><div class="modal-body text-center">Your computer is about to explode!</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/progressModal/progressModal.html','<div class="modal-content" ng-controller="ProgressModalCtrl"><div class="modal-body"><progress-bar-round></progress-bar-round></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/animated.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped active" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped active" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/basic.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/label.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">40% Complete (success)</div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">20% Complete</div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">60% Complete (warning)</div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">80% Complete (danger)</div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/stacked.html','<div class="progress"><div class="progress-bar progress-bar-success" style="width: 35%"><span class="sr-only">35% Complete (success)</span></div><div class="progress-bar progress-bar-warning progress-bar-striped" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div><div class="progress-bar progress-bar-danger" style="width: 10%"><span class="sr-only">10% Complete (danger)</span></div><div class="progress-bar progress-bar-info progress-bar-striped active" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/striped.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSelect/select.html','<div ng-controller="OldSelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><select class="form-control selectpicker" selectpicker="" title="Standard Select" ng-model="selectpickerVm.standardSelected" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"></select></div><div class="form-group"><select class="form-control selectpicker with-search" data-live-search="true" title="Select With Search" selectpicker="" ng-model="selectpickerVm.searchSelectedItem" ng-options="item as item.label for item in selectpickerVm.selectWithSearchItems"></select></div><div class="form-group"><select class="form-control selectpicker" title="Option Types" selectpicker=""><option>Standard option</option><option data-subtext="option subtext">Option with subtext</option><option disabled="">Disabled Option</option><option data-icon="glyphicon-heart">Option with cion</option></select></div><div class="form-group"><select class="form-control selectpicker" disabled="" title="Disabled Select" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Option Groups" selectpicker="" ng-model="selectpickerVm.groupedSelectedItem" ng-options="item as item.label group by item.group for item in selectpickerVm.groupedSelectItems"></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Divider" selectpicker=""><option>Group 1 - Option 1</option><option>Group 1 - Option 2</option><option data-divider="true"></option><option>Group 2 - Option 1</option><option>Group 2 - Option 2</option></select></div></div></div><div class="form-group"><select class="form-control" title="Multiple Select" multiple="" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="form-group"><select class="form-control" title="Multiple Select with Limit" multiple="" data-max-options="2" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems2" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Primary Select" data-style="btn-primary" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Success Select" data-style="btn-success" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Warning Select" data-style="btn-warning" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Info Select" data-style="btn-info" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Danger Select" data-style="btn-danger" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Inverse Select" data-style="btn-inverse" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/datePickers/datePickers.html','<div class="datepicker row"><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerCtrl"><h4>Inline</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><div class="uib-datepicker-wrap"><uib-datepicker ng-model="dt" datepicker-options="options"></uib-datepicker></div></div><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerpopupCtrl"><h4>Popup</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label>Format: <span class="muted-text">(manual alternate <em>{{altInputFormats[0]}}</em>)</span></label><select class="form-control" ng-model="format" ng-options="f for f in formats"><option></option></select></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSwitches/switch.html','<div ng-controller="OldSwitchPanelCtrl as switchPanelVm" class="switches clearfix"><switch color="primary" ng-model="switchPanelVm.switcherValues.primary"></switch><switch color="warning" ng-model="switchPanelVm.switcherValues.warning"></switch><switch color="danger" ng-model="switchPanelVm.switcherValues.danger"></switch><switch color="info" ng-model="switchPanelVm.switcherValues.info"></switch><switch color="success" ng-model="switchPanelVm.switcherValues.success"></switch></div>');
$templateCache.put('app/pages/form/inputs/widgets/select/select.html','<div class="ng-cloak" ng-controller="SelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><ui-select ng-model="selectpickerVm.selectedItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Standard Select"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="standardItem in selectpickerVm.standardSelectItems | filter: $select.search"><span ng-bind-html="standardItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.withSearchItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Search">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="withSearchItem in selectpickerVm.selectWithSearchItems | filter: $select.search"><span ng-bind-html="withSearchItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.disableItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Disabled Selection"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="disableItem in selectpickerVm.disableItems | filter: $select.search"><span ng-bind-html="disableItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="groupedItems in selectpickerVm.groupedSelectItems | groupSelectpickerOptions: {label: $select.search}" group-by="\'group\'"><span ng-bind-html="groupedItems.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedByItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups Function">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="groupedByItems in selectpickerVm.groupedBySelectItems | filter: $select.search" group-by="selectpickerVm.someGroupFn"><span ng-bind-html="groupedByItems.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select multiple="" ng-model="selectpickerVm.multipleItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control"><ui-select-match placeholder="Multiple Select">{{$item.label}}</ui-select-match><ui-select-choices repeat="multipleItem in selectpickerVm.multipleSelectItems | filter: $select.search">{{multipleItem.label}}</ui-select-choices></ui-select></div><div class="form-group"><div class="input-group"><ui-select multiple="" ng-model="selectpickerVm.withDeleteItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control form-control"><ui-select-match placeholder="Select With Clear Button">{{$item.label}}</ui-select-match><ui-select-choices repeat="withDeleteItem in selectpickerVm.withDeleteSelectItems | filter: $select.search">{{withDeleteItem.label}}</ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="enviardatos(selectpickerVm)" class="btn btn-danger"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/switches/switch.html','<div ng-controller="SwitchDemoPanelCtrl as vm"><ba-switcher switcher-style="primary" switcher-value="vm.switches.s1"></ba-switcher><ba-switcher switcher-style="success" switcher-value="vm.switches.s2"></ba-switcher><ba-switcher switcher-style="warning" switcher-value="vm.switches.s3"></ba-switcher><ba-switcher switcher-style="danger" switcher-value="vm.switches.s4"></ba-switcher><ba-switcher switcher-style="info" switcher-value="vm.switches.s5"></ba-switcher></div>');
$templateCache.put('app/pages/form/inputs/widgets/tagsInput/tagsInput.html','<div class="form-group"><div class="form-group"><input type="text" tag-input="primary" value="Amsterdam,Washington,Sydney,Beijing,Cairo" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="warning" value="Minsk,Prague,Vilnius,Warsaw" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="danger" value="London,Berlin,Paris,Rome,Munich" data-role="tagsinput" placeholder="Add Tag"></div></div>');}]);